// @ts-nocheck
/**
 * GENERATED FILE — do not edit.
 *
 * Produced by `packages/contracts/scripts/generate-validators.mjs` (Ajv standalone
 * code generation) from the schemas in `src/health.ts`, `src/session.ts`,
 * `src/errors.ts` and `src/ledger.ts`, under the strict options in
 * `src/strict-ajv.ts`.
 *
 * These validators are already compiled: the runtime calls them and never compiles
 * a schema, so the browser bundle needs no `'unsafe-eval'` in its content security
 * policy. Regenerate with `npm run generate` in `packages/contracts`;
 * `validator.test.ts` fails if this file is not exactly what that regenerate would
 * write.
 */
import __ajvRuntime0 from 'ajv/dist/runtime/ucs2length.js';
/**
 * Ajv emits its runtime helpers as `require("ajv/dist/runtime/<name>").default`.
 * Node's ESM interop resolves that import to the helper's `module.exports`, a
 * bundler that honours the `__esModule` marker resolves it to the function itself,
 * so unwrap only when there is something to unwrap.
 */
const __runtimeHelper = (mod) => (typeof mod === 'function' ? mod : mod.default);
export const validateHealthResponse = validate10;
const schema11 = { "$id": "https://saldo.local/schemas/health-response.json", "$schema": "http://json-schema.org/draft-07/schema#", "title": "HealthResponse", "type": "object", "additionalProperties": false, "required": ["status", "revision", "version", "database"], "properties": { "status": { "type": "string", "enum": ["ok"] }, "revision": { "type": "string", "minLength": 1, "maxLength": 120 }, "version": { "type": "string", "minLength": 1, "maxLength": 120 }, "database": { "type": "object", "additionalProperties": false, "required": ["reachable"], "properties": { "reachable": { "type": "boolean" }, "detail": { "type": "string", "maxLength": 200 } } } } };
const func2 = __runtimeHelper(__ajvRuntime0);
function validate10(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="https://saldo.local/schemas/health-response.json" */ ; let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.status === undefined) {
        const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property '" + "status" + "'" };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
    }
    if (data.revision === undefined) {
        const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property '" + "revision" + "'" };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    if (data.version === undefined) {
        const err2 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "version" }, message: "must have required property '" + "version" + "'" };
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
    }
    if (data.database === undefined) {
        const err3 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "database" }, message: "must have required property '" + "database" + "'" };
        if (vErrors === null) {
            vErrors = [err3];
        }
        else {
            vErrors.push(err3);
        }
        errors++;
    }
    for (const key0 in data) {
        if (!((((key0 === "status") || (key0 === "revision")) || (key0 === "version")) || (key0 === "database"))) {
            const err4 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
                vErrors = [err4];
            }
            else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    if (data.status !== undefined) {
        let data0 = data.status;
        if (typeof data0 !== "string") {
            const err5 = { instancePath: instancePath + "/status", schemaPath: "#/properties/status/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
                vErrors = [err5];
            }
            else {
                vErrors.push(err5);
            }
            errors++;
        }
        if (!(data0 === "ok")) {
            const err6 = { instancePath: instancePath + "/status", schemaPath: "#/properties/status/enum", keyword: "enum", params: { allowedValues: schema11.properties.status.enum }, message: "must be equal to one of the allowed values" };
            if (vErrors === null) {
                vErrors = [err6];
            }
            else {
                vErrors.push(err6);
            }
            errors++;
        }
    }
    if (data.revision !== undefined) {
        let data1 = data.revision;
        if (typeof data1 === "string") {
            if (func2(data1) > 120) {
                const err7 = { instancePath: instancePath + "/revision", schemaPath: "#/properties/revision/maxLength", keyword: "maxLength", params: { limit: 120 }, message: "must NOT have more than 120 characters" };
                if (vErrors === null) {
                    vErrors = [err7];
                }
                else {
                    vErrors.push(err7);
                }
                errors++;
            }
            if (func2(data1) < 1) {
                const err8 = { instancePath: instancePath + "/revision", schemaPath: "#/properties/revision/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                if (vErrors === null) {
                    vErrors = [err8];
                }
                else {
                    vErrors.push(err8);
                }
                errors++;
            }
        }
        else {
            const err9 = { instancePath: instancePath + "/revision", schemaPath: "#/properties/revision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
                vErrors = [err9];
            }
            else {
                vErrors.push(err9);
            }
            errors++;
        }
    }
    if (data.version !== undefined) {
        let data2 = data.version;
        if (typeof data2 === "string") {
            if (func2(data2) > 120) {
                const err10 = { instancePath: instancePath + "/version", schemaPath: "#/properties/version/maxLength", keyword: "maxLength", params: { limit: 120 }, message: "must NOT have more than 120 characters" };
                if (vErrors === null) {
                    vErrors = [err10];
                }
                else {
                    vErrors.push(err10);
                }
                errors++;
            }
            if (func2(data2) < 1) {
                const err11 = { instancePath: instancePath + "/version", schemaPath: "#/properties/version/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                if (vErrors === null) {
                    vErrors = [err11];
                }
                else {
                    vErrors.push(err11);
                }
                errors++;
            }
        }
        else {
            const err12 = { instancePath: instancePath + "/version", schemaPath: "#/properties/version/type", keyword: "type", params: { type: "string" }, message: "must be string" };
            if (vErrors === null) {
                vErrors = [err12];
            }
            else {
                vErrors.push(err12);
            }
            errors++;
        }
    }
    if (data.database !== undefined) {
        let data3 = data.database;
        if (data3 && typeof data3 == "object" && !Array.isArray(data3)) {
            if (data3.reachable === undefined) {
                const err13 = { instancePath: instancePath + "/database", schemaPath: "#/properties/database/required", keyword: "required", params: { missingProperty: "reachable" }, message: "must have required property '" + "reachable" + "'" };
                if (vErrors === null) {
                    vErrors = [err13];
                }
                else {
                    vErrors.push(err13);
                }
                errors++;
            }
            for (const key1 in data3) {
                if (!((key1 === "reachable") || (key1 === "detail"))) {
                    const err14 = { instancePath: instancePath + "/database", schemaPath: "#/properties/database/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err14];
                    }
                    else {
                        vErrors.push(err14);
                    }
                    errors++;
                }
            }
            if (data3.reachable !== undefined) {
                if (typeof data3.reachable !== "boolean") {
                    const err15 = { instancePath: instancePath + "/database/reachable", schemaPath: "#/properties/database/properties/reachable/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                    if (vErrors === null) {
                        vErrors = [err15];
                    }
                    else {
                        vErrors.push(err15);
                    }
                    errors++;
                }
            }
            if (data3.detail !== undefined) {
                let data5 = data3.detail;
                if (typeof data5 === "string") {
                    if (func2(data5) > 200) {
                        const err16 = { instancePath: instancePath + "/database/detail", schemaPath: "#/properties/database/properties/detail/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                        if (vErrors === null) {
                            vErrors = [err16];
                        }
                        else {
                            vErrors.push(err16);
                        }
                        errors++;
                    }
                }
                else {
                    const err17 = { instancePath: instancePath + "/database/detail", schemaPath: "#/properties/database/properties/detail/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err17];
                    }
                    else {
                        vErrors.push(err17);
                    }
                    errors++;
                }
            }
        }
        else {
            const err18 = { instancePath: instancePath + "/database", schemaPath: "#/properties/database/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err18];
            }
            else {
                vErrors.push(err18);
            }
            errors++;
        }
    }
}
else {
    const err19 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
        vErrors = [err19];
    }
    else {
        vErrors.push(err19);
    }
    errors++;
} validate10.errors = vErrors; return errors === 0; }
export const validateSessionState = validate11;
const schema12 = { "$id": "https://saldo.local/schemas/session-state.json", "$schema": "http://json-schema.org/draft-07/schema#", "title": "SessionState", "type": "object", "additionalProperties": false, "required": ["data"], "properties": { "data": { "type": "object", "additionalProperties": false, "required": ["authenticated", "csrfToken"], "properties": { "authenticated": { "type": "boolean" }, "owner": { "type": "object", "additionalProperties": false, "required": ["id"], "properties": { "id": { "type": "string", "minLength": 36, "maxLength": 36, "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } } }, "csrfToken": { "type": "string", "minLength": 16, "maxLength": 512 } } } } };
const pattern0 = new RegExp("^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$", "u");
function validate11(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="https://saldo.local/schemas/session-state.json" */ ; let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.data === undefined) {
        const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property '" + "data" + "'" };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
    }
    for (const key0 in data) {
        if (!(key0 === "data")) {
            const err1 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
    }
    if (data.data !== undefined) {
        let data0 = data.data;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.authenticated === undefined) {
                const err2 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "authenticated" }, message: "must have required property '" + "authenticated" + "'" };
                if (vErrors === null) {
                    vErrors = [err2];
                }
                else {
                    vErrors.push(err2);
                }
                errors++;
            }
            if (data0.csrfToken === undefined) {
                const err3 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "csrfToken" }, message: "must have required property '" + "csrfToken" + "'" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
            for (const key1 in data0) {
                if (!(((key1 === "authenticated") || (key1 === "owner")) || (key1 === "csrfToken"))) {
                    const err4 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
            }
            if (data0.authenticated !== undefined) {
                if (typeof data0.authenticated !== "boolean") {
                    const err5 = { instancePath: instancePath + "/data/authenticated", schemaPath: "#/properties/data/properties/authenticated/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
            }
            if (data0.owner !== undefined) {
                let data2 = data0.owner;
                if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                    if (data2.id === undefined) {
                        const err6 = { instancePath: instancePath + "/data/owner", schemaPath: "#/properties/data/properties/owner/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property '" + "id" + "'" };
                        if (vErrors === null) {
                            vErrors = [err6];
                        }
                        else {
                            vErrors.push(err6);
                        }
                        errors++;
                    }
                    for (const key2 in data2) {
                        if (!(key2 === "id")) {
                            const err7 = { instancePath: instancePath + "/data/owner", schemaPath: "#/properties/data/properties/owner/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                                vErrors = [err7];
                            }
                            else {
                                vErrors.push(err7);
                            }
                            errors++;
                        }
                    }
                    if (data2.id !== undefined) {
                        let data3 = data2.id;
                        if (typeof data3 === "string") {
                            if (func2(data3) > 36) {
                                const err8 = { instancePath: instancePath + "/data/owner/id", schemaPath: "#/properties/data/properties/owner/properties/id/maxLength", keyword: "maxLength", params: { limit: 36 }, message: "must NOT have more than 36 characters" };
                                if (vErrors === null) {
                                    vErrors = [err8];
                                }
                                else {
                                    vErrors.push(err8);
                                }
                                errors++;
                            }
                            if (func2(data3) < 36) {
                                const err9 = { instancePath: instancePath + "/data/owner/id", schemaPath: "#/properties/data/properties/owner/properties/id/minLength", keyword: "minLength", params: { limit: 36 }, message: "must NOT have fewer than 36 characters" };
                                if (vErrors === null) {
                                    vErrors = [err9];
                                }
                                else {
                                    vErrors.push(err9);
                                }
                                errors++;
                            }
                            if (!pattern0.test(data3)) {
                                const err10 = { instancePath: instancePath + "/data/owner/id", schemaPath: "#/properties/data/properties/owner/properties/id/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err10];
                                }
                                else {
                                    vErrors.push(err10);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err11 = { instancePath: instancePath + "/data/owner/id", schemaPath: "#/properties/data/properties/owner/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err11];
                            }
                            else {
                                vErrors.push(err11);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err12 = { instancePath: instancePath + "/data/owner", schemaPath: "#/properties/data/properties/owner/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                        vErrors = [err12];
                    }
                    else {
                        vErrors.push(err12);
                    }
                    errors++;
                }
            }
            if (data0.csrfToken !== undefined) {
                let data4 = data0.csrfToken;
                if (typeof data4 === "string") {
                    if (func2(data4) > 512) {
                        const err13 = { instancePath: instancePath + "/data/csrfToken", schemaPath: "#/properties/data/properties/csrfToken/maxLength", keyword: "maxLength", params: { limit: 512 }, message: "must NOT have more than 512 characters" };
                        if (vErrors === null) {
                            vErrors = [err13];
                        }
                        else {
                            vErrors.push(err13);
                        }
                        errors++;
                    }
                    if (func2(data4) < 16) {
                        const err14 = { instancePath: instancePath + "/data/csrfToken", schemaPath: "#/properties/data/properties/csrfToken/minLength", keyword: "minLength", params: { limit: 16 }, message: "must NOT have fewer than 16 characters" };
                        if (vErrors === null) {
                            vErrors = [err14];
                        }
                        else {
                            vErrors.push(err14);
                        }
                        errors++;
                    }
                }
                else {
                    const err15 = { instancePath: instancePath + "/data/csrfToken", schemaPath: "#/properties/data/properties/csrfToken/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err15];
                    }
                    else {
                        vErrors.push(err15);
                    }
                    errors++;
                }
            }
        }
        else {
            const err16 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err16];
            }
            else {
                vErrors.push(err16);
            }
            errors++;
        }
    }
}
else {
    const err17 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
        vErrors = [err17];
    }
    else {
        vErrors.push(err17);
    }
    errors++;
} validate11.errors = vErrors; return errors === 0; }
export const validateErrorEnvelope = validate12;
const schema13 = { "$id": "https://saldo.local/schemas/error-envelope.json", "$schema": "http://json-schema.org/draft-07/schema#", "title": "ErrorEnvelope", "type": "object", "additionalProperties": false, "required": ["error"], "properties": { "error": { "type": "object", "additionalProperties": false, "required": ["code", "message", "fieldErrors", "requestId", "retryable"], "properties": { "code": { "type": "string", "minLength": 1, "maxLength": 64 }, "message": { "type": "string", "minLength": 1, "maxLength": 200 }, "fieldErrors": { "type": "array", "maxItems": 16, "items": { "type": "object", "additionalProperties": false, "required": ["path", "code"], "properties": { "path": { "type": "string", "maxLength": 200 }, "code": { "type": "string", "maxLength": 64 } } } }, "requestId": { "type": "string", "minLength": 1, "maxLength": 64 }, "retryable": { "type": "boolean" } } } } };
function validate12(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="https://saldo.local/schemas/error-envelope.json" */ ; let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.error === undefined) {
        const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "error" }, message: "must have required property '" + "error" + "'" };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
    }
    for (const key0 in data) {
        if (!(key0 === "error")) {
            const err1 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
    }
    if (data.error !== undefined) {
        let data0 = data.error;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.code === undefined) {
                const err2 = { instancePath: instancePath + "/error", schemaPath: "#/properties/error/required", keyword: "required", params: { missingProperty: "code" }, message: "must have required property '" + "code" + "'" };
                if (vErrors === null) {
                    vErrors = [err2];
                }
                else {
                    vErrors.push(err2);
                }
                errors++;
            }
            if (data0.message === undefined) {
                const err3 = { instancePath: instancePath + "/error", schemaPath: "#/properties/error/required", keyword: "required", params: { missingProperty: "message" }, message: "must have required property '" + "message" + "'" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
            if (data0.fieldErrors === undefined) {
                const err4 = { instancePath: instancePath + "/error", schemaPath: "#/properties/error/required", keyword: "required", params: { missingProperty: "fieldErrors" }, message: "must have required property '" + "fieldErrors" + "'" };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
            if (data0.requestId === undefined) {
                const err5 = { instancePath: instancePath + "/error", schemaPath: "#/properties/error/required", keyword: "required", params: { missingProperty: "requestId" }, message: "must have required property '" + "requestId" + "'" };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
            }
            if (data0.retryable === undefined) {
                const err6 = { instancePath: instancePath + "/error", schemaPath: "#/properties/error/required", keyword: "required", params: { missingProperty: "retryable" }, message: "must have required property '" + "retryable" + "'" };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
            }
            for (const key1 in data0) {
                if (!(((((key1 === "code") || (key1 === "message")) || (key1 === "fieldErrors")) || (key1 === "requestId")) || (key1 === "retryable"))) {
                    const err7 = { instancePath: instancePath + "/error", schemaPath: "#/properties/error/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err7];
                    }
                    else {
                        vErrors.push(err7);
                    }
                    errors++;
                }
            }
            if (data0.code !== undefined) {
                let data1 = data0.code;
                if (typeof data1 === "string") {
                    if (func2(data1) > 64) {
                        const err8 = { instancePath: instancePath + "/error/code", schemaPath: "#/properties/error/properties/code/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err8];
                        }
                        else {
                            vErrors.push(err8);
                        }
                        errors++;
                    }
                    if (func2(data1) < 1) {
                        const err9 = { instancePath: instancePath + "/error/code", schemaPath: "#/properties/error/properties/code/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err9];
                        }
                        else {
                            vErrors.push(err9);
                        }
                        errors++;
                    }
                }
                else {
                    const err10 = { instancePath: instancePath + "/error/code", schemaPath: "#/properties/error/properties/code/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err10];
                    }
                    else {
                        vErrors.push(err10);
                    }
                    errors++;
                }
            }
            if (data0.message !== undefined) {
                let data2 = data0.message;
                if (typeof data2 === "string") {
                    if (func2(data2) > 200) {
                        const err11 = { instancePath: instancePath + "/error/message", schemaPath: "#/properties/error/properties/message/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                        if (vErrors === null) {
                            vErrors = [err11];
                        }
                        else {
                            vErrors.push(err11);
                        }
                        errors++;
                    }
                    if (func2(data2) < 1) {
                        const err12 = { instancePath: instancePath + "/error/message", schemaPath: "#/properties/error/properties/message/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err12];
                        }
                        else {
                            vErrors.push(err12);
                        }
                        errors++;
                    }
                }
                else {
                    const err13 = { instancePath: instancePath + "/error/message", schemaPath: "#/properties/error/properties/message/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err13];
                    }
                    else {
                        vErrors.push(err13);
                    }
                    errors++;
                }
            }
            if (data0.fieldErrors !== undefined) {
                let data3 = data0.fieldErrors;
                if (Array.isArray(data3)) {
                    if (data3.length > 16) {
                        const err14 = { instancePath: instancePath + "/error/fieldErrors", schemaPath: "#/properties/error/properties/fieldErrors/maxItems", keyword: "maxItems", params: { limit: 16 }, message: "must NOT have more than 16 items" };
                        if (vErrors === null) {
                            vErrors = [err14];
                        }
                        else {
                            vErrors.push(err14);
                        }
                        errors++;
                    }
                    const len0 = data3.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                        let data4 = data3[i0];
                        if (data4 && typeof data4 == "object" && !Array.isArray(data4)) {
                            if (data4.path === undefined) {
                                const err15 = { instancePath: instancePath + "/error/fieldErrors/" + i0, schemaPath: "#/properties/error/properties/fieldErrors/items/required", keyword: "required", params: { missingProperty: "path" }, message: "must have required property '" + "path" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err15];
                                }
                                else {
                                    vErrors.push(err15);
                                }
                                errors++;
                            }
                            if (data4.code === undefined) {
                                const err16 = { instancePath: instancePath + "/error/fieldErrors/" + i0, schemaPath: "#/properties/error/properties/fieldErrors/items/required", keyword: "required", params: { missingProperty: "code" }, message: "must have required property '" + "code" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err16];
                                }
                                else {
                                    vErrors.push(err16);
                                }
                                errors++;
                            }
                            for (const key2 in data4) {
                                if (!((key2 === "path") || (key2 === "code"))) {
                                    const err17 = { instancePath: instancePath + "/error/fieldErrors/" + i0, schemaPath: "#/properties/error/properties/fieldErrors/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                                    if (vErrors === null) {
                                        vErrors = [err17];
                                    }
                                    else {
                                        vErrors.push(err17);
                                    }
                                    errors++;
                                }
                            }
                            if (data4.path !== undefined) {
                                let data5 = data4.path;
                                if (typeof data5 === "string") {
                                    if (func2(data5) > 200) {
                                        const err18 = { instancePath: instancePath + "/error/fieldErrors/" + i0 + "/path", schemaPath: "#/properties/error/properties/fieldErrors/items/properties/path/maxLength", keyword: "maxLength", params: { limit: 200 }, message: "must NOT have more than 200 characters" };
                                        if (vErrors === null) {
                                            vErrors = [err18];
                                        }
                                        else {
                                            vErrors.push(err18);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err19 = { instancePath: instancePath + "/error/fieldErrors/" + i0 + "/path", schemaPath: "#/properties/error/properties/fieldErrors/items/properties/path/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err19];
                                    }
                                    else {
                                        vErrors.push(err19);
                                    }
                                    errors++;
                                }
                            }
                            if (data4.code !== undefined) {
                                let data6 = data4.code;
                                if (typeof data6 === "string") {
                                    if (func2(data6) > 64) {
                                        const err20 = { instancePath: instancePath + "/error/fieldErrors/" + i0 + "/code", schemaPath: "#/properties/error/properties/fieldErrors/items/properties/code/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                                        if (vErrors === null) {
                                            vErrors = [err20];
                                        }
                                        else {
                                            vErrors.push(err20);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err21 = { instancePath: instancePath + "/error/fieldErrors/" + i0 + "/code", schemaPath: "#/properties/error/properties/fieldErrors/items/properties/code/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err21];
                                    }
                                    else {
                                        vErrors.push(err21);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err22 = { instancePath: instancePath + "/error/fieldErrors/" + i0, schemaPath: "#/properties/error/properties/fieldErrors/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                                vErrors = [err22];
                            }
                            else {
                                vErrors.push(err22);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err23 = { instancePath: instancePath + "/error/fieldErrors", schemaPath: "#/properties/error/properties/fieldErrors/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err23];
                    }
                    else {
                        vErrors.push(err23);
                    }
                    errors++;
                }
            }
            if (data0.requestId !== undefined) {
                let data7 = data0.requestId;
                if (typeof data7 === "string") {
                    if (func2(data7) > 64) {
                        const err24 = { instancePath: instancePath + "/error/requestId", schemaPath: "#/properties/error/properties/requestId/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err24];
                        }
                        else {
                            vErrors.push(err24);
                        }
                        errors++;
                    }
                    if (func2(data7) < 1) {
                        const err25 = { instancePath: instancePath + "/error/requestId", schemaPath: "#/properties/error/properties/requestId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err25];
                        }
                        else {
                            vErrors.push(err25);
                        }
                        errors++;
                    }
                }
                else {
                    const err26 = { instancePath: instancePath + "/error/requestId", schemaPath: "#/properties/error/properties/requestId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err26];
                    }
                    else {
                        vErrors.push(err26);
                    }
                    errors++;
                }
            }
            if (data0.retryable !== undefined) {
                if (typeof data0.retryable !== "boolean") {
                    const err27 = { instancePath: instancePath + "/error/retryable", schemaPath: "#/properties/error/properties/retryable/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                    if (vErrors === null) {
                        vErrors = [err27];
                    }
                    else {
                        vErrors.push(err27);
                    }
                    errors++;
                }
            }
        }
        else {
            const err28 = { instancePath: instancePath + "/error", schemaPath: "#/properties/error/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err28];
            }
            else {
                vErrors.push(err28);
            }
            errors++;
        }
    }
}
else {
    const err29 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
        vErrors = [err29];
    }
    else {
        vErrors.push(err29);
    }
    errors++;
} validate12.errors = vErrors; return errors === 0; }
export const validateLedgerAccountEnvelope = validate13;
const schema14 = { "$id": "https://saldo.local/schemas/ledger-account-envelope.json", "$schema": "http://json-schema.org/draft-07/schema#", "title": "LedgerAccountEnvelope", "type": "object", "additionalProperties": false, "required": ["data", "meta"], "properties": { "data": { "type": "object", "additionalProperties": false, "required": ["id", "name", "currency", "kind", "archived", "revision", "balance"], "properties": { "id": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "name": { "type": "string", "minLength": 1, "maxLength": 120 }, "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "kind": { "type": "string", "enum": ["cash", "card"] }, "archived": { "type": "boolean" }, "revision": { "type": "string", "pattern": "^[1-9][0-9]*$" }, "balance": { "type": "object", "additionalProperties": false, "required": ["currency", "minorUnits", "negative"], "properties": { "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "minorUnits": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "negative": { "type": "boolean" } } } } }, "meta": { "type": "object", "additionalProperties": false, "required": ["requestId", "asOf", "businessToday", "timeZone", "dataRevision"], "properties": { "requestId": { "type": "string", "minLength": 1, "maxLength": 64 }, "asOf": { "type": "string", "minLength": 1, "maxLength": 64 }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "timeZone": { "type": "string", "minLength": 1, "maxLength": 64 }, "dataRevision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } } } };
const pattern2 = new RegExp("^[1-9][0-9]*$", "u");
const pattern3 = new RegExp("^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$", "u");
const pattern4 = new RegExp("^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$", "u");
function validate13(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="https://saldo.local/schemas/ledger-account-envelope.json" */ ; let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.data === undefined) {
        const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property '" + "data" + "'" };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
    }
    if (data.meta === undefined) {
        const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "meta" }, message: "must have required property '" + "meta" + "'" };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    for (const key0 in data) {
        if (!((key0 === "data") || (key0 === "meta"))) {
            const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.data !== undefined) {
        let data0 = data.data;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.id === undefined) {
                const err3 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property '" + "id" + "'" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
            if (data0.name === undefined) {
                const err4 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "name" }, message: "must have required property '" + "name" + "'" };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
            if (data0.currency === undefined) {
                const err5 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
            }
            if (data0.kind === undefined) {
                const err6 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "kind" }, message: "must have required property '" + "kind" + "'" };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
            }
            if (data0.archived === undefined) {
                const err7 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "archived" }, message: "must have required property '" + "archived" + "'" };
                if (vErrors === null) {
                    vErrors = [err7];
                }
                else {
                    vErrors.push(err7);
                }
                errors++;
            }
            if (data0.revision === undefined) {
                const err8 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property '" + "revision" + "'" };
                if (vErrors === null) {
                    vErrors = [err8];
                }
                else {
                    vErrors.push(err8);
                }
                errors++;
            }
            if (data0.balance === undefined) {
                const err9 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "balance" }, message: "must have required property '" + "balance" + "'" };
                if (vErrors === null) {
                    vErrors = [err9];
                }
                else {
                    vErrors.push(err9);
                }
                errors++;
            }
            for (const key1 in data0) {
                if (!(((((((key1 === "id") || (key1 === "name")) || (key1 === "currency")) || (key1 === "kind")) || (key1 === "archived")) || (key1 === "revision")) || (key1 === "balance"))) {
                    const err10 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err10];
                    }
                    else {
                        vErrors.push(err10);
                    }
                    errors++;
                }
            }
            if (data0.id !== undefined) {
                let data1 = data0.id;
                if (typeof data1 === "string") {
                    if (!pattern0.test(data1)) {
                        const err11 = { instancePath: instancePath + "/data/id", schemaPath: "#/properties/data/properties/id/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err11];
                        }
                        else {
                            vErrors.push(err11);
                        }
                        errors++;
                    }
                }
                else {
                    const err12 = { instancePath: instancePath + "/data/id", schemaPath: "#/properties/data/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err12];
                    }
                    else {
                        vErrors.push(err12);
                    }
                    errors++;
                }
            }
            if (data0.name !== undefined) {
                let data2 = data0.name;
                if (typeof data2 === "string") {
                    if (func2(data2) > 120) {
                        const err13 = { instancePath: instancePath + "/data/name", schemaPath: "#/properties/data/properties/name/maxLength", keyword: "maxLength", params: { limit: 120 }, message: "must NOT have more than 120 characters" };
                        if (vErrors === null) {
                            vErrors = [err13];
                        }
                        else {
                            vErrors.push(err13);
                        }
                        errors++;
                    }
                    if (func2(data2) < 1) {
                        const err14 = { instancePath: instancePath + "/data/name", schemaPath: "#/properties/data/properties/name/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err14];
                        }
                        else {
                            vErrors.push(err14);
                        }
                        errors++;
                    }
                }
                else {
                    const err15 = { instancePath: instancePath + "/data/name", schemaPath: "#/properties/data/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err15];
                    }
                    else {
                        vErrors.push(err15);
                    }
                    errors++;
                }
            }
            if (data0.currency !== undefined) {
                let data3 = data0.currency;
                if (typeof data3 !== "string") {
                    const err16 = { instancePath: instancePath + "/data/currency", schemaPath: "#/properties/data/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err16];
                    }
                    else {
                        vErrors.push(err16);
                    }
                    errors++;
                }
                if (!(((data3 === "BRL") || (data3 === "CAD")) || (data3 === "USD"))) {
                    const err17 = { instancePath: instancePath + "/data/currency", schemaPath: "#/properties/data/properties/currency/enum", keyword: "enum", params: { allowedValues: schema14.properties.data.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err17];
                    }
                    else {
                        vErrors.push(err17);
                    }
                    errors++;
                }
            }
            if (data0.kind !== undefined) {
                let data4 = data0.kind;
                if (typeof data4 !== "string") {
                    const err18 = { instancePath: instancePath + "/data/kind", schemaPath: "#/properties/data/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err18];
                    }
                    else {
                        vErrors.push(err18);
                    }
                    errors++;
                }
                if (!((data4 === "cash") || (data4 === "card"))) {
                    const err19 = { instancePath: instancePath + "/data/kind", schemaPath: "#/properties/data/properties/kind/enum", keyword: "enum", params: { allowedValues: schema14.properties.data.properties.kind.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err19];
                    }
                    else {
                        vErrors.push(err19);
                    }
                    errors++;
                }
            }
            if (data0.archived !== undefined) {
                if (typeof data0.archived !== "boolean") {
                    const err20 = { instancePath: instancePath + "/data/archived", schemaPath: "#/properties/data/properties/archived/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                    if (vErrors === null) {
                        vErrors = [err20];
                    }
                    else {
                        vErrors.push(err20);
                    }
                    errors++;
                }
            }
            if (data0.revision !== undefined) {
                let data6 = data0.revision;
                if (typeof data6 === "string") {
                    if (!pattern2.test(data6)) {
                        const err21 = { instancePath: instancePath + "/data/revision", schemaPath: "#/properties/data/properties/revision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err21];
                        }
                        else {
                            vErrors.push(err21);
                        }
                        errors++;
                    }
                }
                else {
                    const err22 = { instancePath: instancePath + "/data/revision", schemaPath: "#/properties/data/properties/revision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err22];
                    }
                    else {
                        vErrors.push(err22);
                    }
                    errors++;
                }
            }
            if (data0.balance !== undefined) {
                let data7 = data0.balance;
                if (data7 && typeof data7 == "object" && !Array.isArray(data7)) {
                    if (data7.currency === undefined) {
                        const err23 = { instancePath: instancePath + "/data/balance", schemaPath: "#/properties/data/properties/balance/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                        if (vErrors === null) {
                            vErrors = [err23];
                        }
                        else {
                            vErrors.push(err23);
                        }
                        errors++;
                    }
                    if (data7.minorUnits === undefined) {
                        const err24 = { instancePath: instancePath + "/data/balance", schemaPath: "#/properties/data/properties/balance/required", keyword: "required", params: { missingProperty: "minorUnits" }, message: "must have required property '" + "minorUnits" + "'" };
                        if (vErrors === null) {
                            vErrors = [err24];
                        }
                        else {
                            vErrors.push(err24);
                        }
                        errors++;
                    }
                    if (data7.negative === undefined) {
                        const err25 = { instancePath: instancePath + "/data/balance", schemaPath: "#/properties/data/properties/balance/required", keyword: "required", params: { missingProperty: "negative" }, message: "must have required property '" + "negative" + "'" };
                        if (vErrors === null) {
                            vErrors = [err25];
                        }
                        else {
                            vErrors.push(err25);
                        }
                        errors++;
                    }
                    for (const key2 in data7) {
                        if (!(((key2 === "currency") || (key2 === "minorUnits")) || (key2 === "negative"))) {
                            const err26 = { instancePath: instancePath + "/data/balance", schemaPath: "#/properties/data/properties/balance/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                                vErrors = [err26];
                            }
                            else {
                                vErrors.push(err26);
                            }
                            errors++;
                        }
                    }
                    if (data7.currency !== undefined) {
                        let data8 = data7.currency;
                        if (typeof data8 !== "string") {
                            const err27 = { instancePath: instancePath + "/data/balance/currency", schemaPath: "#/properties/data/properties/balance/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err27];
                            }
                            else {
                                vErrors.push(err27);
                            }
                            errors++;
                        }
                        if (!(((data8 === "BRL") || (data8 === "CAD")) || (data8 === "USD"))) {
                            const err28 = { instancePath: instancePath + "/data/balance/currency", schemaPath: "#/properties/data/properties/balance/properties/currency/enum", keyword: "enum", params: { allowedValues: schema14.properties.data.properties.balance.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                                vErrors = [err28];
                            }
                            else {
                                vErrors.push(err28);
                            }
                            errors++;
                        }
                    }
                    if (data7.minorUnits !== undefined) {
                        let data9 = data7.minorUnits;
                        if (typeof data9 === "string") {
                            if (!pattern3.test(data9)) {
                                const err29 = { instancePath: instancePath + "/data/balance/minorUnits", schemaPath: "#/properties/data/properties/balance/properties/minorUnits/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err29];
                                }
                                else {
                                    vErrors.push(err29);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err30 = { instancePath: instancePath + "/data/balance/minorUnits", schemaPath: "#/properties/data/properties/balance/properties/minorUnits/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err30];
                            }
                            else {
                                vErrors.push(err30);
                            }
                            errors++;
                        }
                    }
                    if (data7.negative !== undefined) {
                        if (typeof data7.negative !== "boolean") {
                            const err31 = { instancePath: instancePath + "/data/balance/negative", schemaPath: "#/properties/data/properties/balance/properties/negative/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                                vErrors = [err31];
                            }
                            else {
                                vErrors.push(err31);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err32 = { instancePath: instancePath + "/data/balance", schemaPath: "#/properties/data/properties/balance/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                        vErrors = [err32];
                    }
                    else {
                        vErrors.push(err32);
                    }
                    errors++;
                }
            }
        }
        else {
            const err33 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err33];
            }
            else {
                vErrors.push(err33);
            }
            errors++;
        }
    }
    if (data.meta !== undefined) {
        let data11 = data.meta;
        if (data11 && typeof data11 == "object" && !Array.isArray(data11)) {
            if (data11.requestId === undefined) {
                const err34 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "requestId" }, message: "must have required property '" + "requestId" + "'" };
                if (vErrors === null) {
                    vErrors = [err34];
                }
                else {
                    vErrors.push(err34);
                }
                errors++;
            }
            if (data11.asOf === undefined) {
                const err35 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "asOf" }, message: "must have required property '" + "asOf" + "'" };
                if (vErrors === null) {
                    vErrors = [err35];
                }
                else {
                    vErrors.push(err35);
                }
                errors++;
            }
            if (data11.businessToday === undefined) {
                const err36 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err36];
                }
                else {
                    vErrors.push(err36);
                }
                errors++;
            }
            if (data11.timeZone === undefined) {
                const err37 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "timeZone" }, message: "must have required property '" + "timeZone" + "'" };
                if (vErrors === null) {
                    vErrors = [err37];
                }
                else {
                    vErrors.push(err37);
                }
                errors++;
            }
            if (data11.dataRevision === undefined) {
                const err38 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "dataRevision" }, message: "must have required property '" + "dataRevision" + "'" };
                if (vErrors === null) {
                    vErrors = [err38];
                }
                else {
                    vErrors.push(err38);
                }
                errors++;
            }
            for (const key3 in data11) {
                if (!(((((key3 === "requestId") || (key3 === "asOf")) || (key3 === "businessToday")) || (key3 === "timeZone")) || (key3 === "dataRevision"))) {
                    const err39 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err39];
                    }
                    else {
                        vErrors.push(err39);
                    }
                    errors++;
                }
            }
            if (data11.requestId !== undefined) {
                let data12 = data11.requestId;
                if (typeof data12 === "string") {
                    if (func2(data12) > 64) {
                        const err40 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err40];
                        }
                        else {
                            vErrors.push(err40);
                        }
                        errors++;
                    }
                    if (func2(data12) < 1) {
                        const err41 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err41];
                        }
                        else {
                            vErrors.push(err41);
                        }
                        errors++;
                    }
                }
                else {
                    const err42 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err42];
                    }
                    else {
                        vErrors.push(err42);
                    }
                    errors++;
                }
            }
            if (data11.asOf !== undefined) {
                let data13 = data11.asOf;
                if (typeof data13 === "string") {
                    if (func2(data13) > 64) {
                        const err43 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err43];
                        }
                        else {
                            vErrors.push(err43);
                        }
                        errors++;
                    }
                    if (func2(data13) < 1) {
                        const err44 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err44];
                        }
                        else {
                            vErrors.push(err44);
                        }
                        errors++;
                    }
                }
                else {
                    const err45 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err45];
                    }
                    else {
                        vErrors.push(err45);
                    }
                    errors++;
                }
            }
            if (data11.businessToday !== undefined) {
                let data14 = data11.businessToday;
                if (typeof data14 === "string") {
                    if (!pattern4.test(data14)) {
                        const err46 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err46];
                        }
                        else {
                            vErrors.push(err46);
                        }
                        errors++;
                    }
                }
                else {
                    const err47 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err47];
                    }
                    else {
                        vErrors.push(err47);
                    }
                    errors++;
                }
            }
            if (data11.timeZone !== undefined) {
                let data15 = data11.timeZone;
                if (typeof data15 === "string") {
                    if (func2(data15) > 64) {
                        const err48 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err48];
                        }
                        else {
                            vErrors.push(err48);
                        }
                        errors++;
                    }
                    if (func2(data15) < 1) {
                        const err49 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err49];
                        }
                        else {
                            vErrors.push(err49);
                        }
                        errors++;
                    }
                }
                else {
                    const err50 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err50];
                    }
                    else {
                        vErrors.push(err50);
                    }
                    errors++;
                }
            }
            if (data11.dataRevision !== undefined) {
                let data16 = data11.dataRevision;
                if (typeof data16 === "string") {
                    if (!pattern2.test(data16)) {
                        const err51 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err51];
                        }
                        else {
                            vErrors.push(err51);
                        }
                        errors++;
                    }
                }
                else {
                    const err52 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err52];
                    }
                    else {
                        vErrors.push(err52);
                    }
                    errors++;
                }
            }
        }
        else {
            const err53 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err53];
            }
            else {
                vErrors.push(err53);
            }
            errors++;
        }
    }
}
else {
    const err54 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
        vErrors = [err54];
    }
    else {
        vErrors.push(err54);
    }
    errors++;
} validate13.errors = vErrors; return errors === 0; }
export const validateLedgerAccountsEnvelope = validate14;
const schema15 = { "$id": "https://saldo.local/schemas/ledger-accounts-envelope.json", "$schema": "http://json-schema.org/draft-07/schema#", "title": "LedgerAccountsEnvelope", "type": "object", "additionalProperties": false, "required": ["data", "meta"], "properties": { "data": { "type": "object", "additionalProperties": false, "required": ["accounts"], "properties": { "accounts": { "type": "array", "maxItems": 500, "items": { "type": "object", "additionalProperties": false, "required": ["id", "name", "currency", "kind", "archived", "revision", "balance"], "properties": { "id": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "name": { "type": "string", "minLength": 1, "maxLength": 120 }, "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "kind": { "type": "string", "enum": ["cash", "card"] }, "archived": { "type": "boolean" }, "revision": { "type": "string", "pattern": "^[1-9][0-9]*$" }, "balance": { "type": "object", "additionalProperties": false, "required": ["currency", "minorUnits", "negative"], "properties": { "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "minorUnits": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "negative": { "type": "boolean" } } } } } } } }, "meta": { "type": "object", "additionalProperties": false, "required": ["requestId", "asOf", "businessToday", "timeZone", "dataRevision"], "properties": { "requestId": { "type": "string", "minLength": 1, "maxLength": 64 }, "asOf": { "type": "string", "minLength": 1, "maxLength": 64 }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "timeZone": { "type": "string", "minLength": 1, "maxLength": 64 }, "dataRevision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } } } };
function validate14(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="https://saldo.local/schemas/ledger-accounts-envelope.json" */ ; let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.data === undefined) {
        const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property '" + "data" + "'" };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
    }
    if (data.meta === undefined) {
        const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "meta" }, message: "must have required property '" + "meta" + "'" };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    for (const key0 in data) {
        if (!((key0 === "data") || (key0 === "meta"))) {
            const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.data !== undefined) {
        let data0 = data.data;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.accounts === undefined) {
                const err3 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "accounts" }, message: "must have required property '" + "accounts" + "'" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
            for (const key1 in data0) {
                if (!(key1 === "accounts")) {
                    const err4 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
            }
            if (data0.accounts !== undefined) {
                let data1 = data0.accounts;
                if (Array.isArray(data1)) {
                    if (data1.length > 500) {
                        const err5 = { instancePath: instancePath + "/data/accounts", schemaPath: "#/properties/data/properties/accounts/maxItems", keyword: "maxItems", params: { limit: 500 }, message: "must NOT have more than 500 items" };
                        if (vErrors === null) {
                            vErrors = [err5];
                        }
                        else {
                            vErrors.push(err5);
                        }
                        errors++;
                    }
                    const len0 = data1.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                        let data2 = data1[i0];
                        if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                            if (data2.id === undefined) {
                                const err6 = { instancePath: instancePath + "/data/accounts/" + i0, schemaPath: "#/properties/data/properties/accounts/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property '" + "id" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err6];
                                }
                                else {
                                    vErrors.push(err6);
                                }
                                errors++;
                            }
                            if (data2.name === undefined) {
                                const err7 = { instancePath: instancePath + "/data/accounts/" + i0, schemaPath: "#/properties/data/properties/accounts/items/required", keyword: "required", params: { missingProperty: "name" }, message: "must have required property '" + "name" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err7];
                                }
                                else {
                                    vErrors.push(err7);
                                }
                                errors++;
                            }
                            if (data2.currency === undefined) {
                                const err8 = { instancePath: instancePath + "/data/accounts/" + i0, schemaPath: "#/properties/data/properties/accounts/items/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err8];
                                }
                                else {
                                    vErrors.push(err8);
                                }
                                errors++;
                            }
                            if (data2.kind === undefined) {
                                const err9 = { instancePath: instancePath + "/data/accounts/" + i0, schemaPath: "#/properties/data/properties/accounts/items/required", keyword: "required", params: { missingProperty: "kind" }, message: "must have required property '" + "kind" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err9];
                                }
                                else {
                                    vErrors.push(err9);
                                }
                                errors++;
                            }
                            if (data2.archived === undefined) {
                                const err10 = { instancePath: instancePath + "/data/accounts/" + i0, schemaPath: "#/properties/data/properties/accounts/items/required", keyword: "required", params: { missingProperty: "archived" }, message: "must have required property '" + "archived" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err10];
                                }
                                else {
                                    vErrors.push(err10);
                                }
                                errors++;
                            }
                            if (data2.revision === undefined) {
                                const err11 = { instancePath: instancePath + "/data/accounts/" + i0, schemaPath: "#/properties/data/properties/accounts/items/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property '" + "revision" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err11];
                                }
                                else {
                                    vErrors.push(err11);
                                }
                                errors++;
                            }
                            if (data2.balance === undefined) {
                                const err12 = { instancePath: instancePath + "/data/accounts/" + i0, schemaPath: "#/properties/data/properties/accounts/items/required", keyword: "required", params: { missingProperty: "balance" }, message: "must have required property '" + "balance" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err12];
                                }
                                else {
                                    vErrors.push(err12);
                                }
                                errors++;
                            }
                            for (const key2 in data2) {
                                if (!(((((((key2 === "id") || (key2 === "name")) || (key2 === "currency")) || (key2 === "kind")) || (key2 === "archived")) || (key2 === "revision")) || (key2 === "balance"))) {
                                    const err13 = { instancePath: instancePath + "/data/accounts/" + i0, schemaPath: "#/properties/data/properties/accounts/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                                    if (vErrors === null) {
                                        vErrors = [err13];
                                    }
                                    else {
                                        vErrors.push(err13);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.id !== undefined) {
                                let data3 = data2.id;
                                if (typeof data3 === "string") {
                                    if (!pattern0.test(data3)) {
                                        const err14 = { instancePath: instancePath + "/data/accounts/" + i0 + "/id", schemaPath: "#/properties/data/properties/accounts/items/properties/id/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err14];
                                        }
                                        else {
                                            vErrors.push(err14);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err15 = { instancePath: instancePath + "/data/accounts/" + i0 + "/id", schemaPath: "#/properties/data/properties/accounts/items/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err15];
                                    }
                                    else {
                                        vErrors.push(err15);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.name !== undefined) {
                                let data4 = data2.name;
                                if (typeof data4 === "string") {
                                    if (func2(data4) > 120) {
                                        const err16 = { instancePath: instancePath + "/data/accounts/" + i0 + "/name", schemaPath: "#/properties/data/properties/accounts/items/properties/name/maxLength", keyword: "maxLength", params: { limit: 120 }, message: "must NOT have more than 120 characters" };
                                        if (vErrors === null) {
                                            vErrors = [err16];
                                        }
                                        else {
                                            vErrors.push(err16);
                                        }
                                        errors++;
                                    }
                                    if (func2(data4) < 1) {
                                        const err17 = { instancePath: instancePath + "/data/accounts/" + i0 + "/name", schemaPath: "#/properties/data/properties/accounts/items/properties/name/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                        if (vErrors === null) {
                                            vErrors = [err17];
                                        }
                                        else {
                                            vErrors.push(err17);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err18 = { instancePath: instancePath + "/data/accounts/" + i0 + "/name", schemaPath: "#/properties/data/properties/accounts/items/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err18];
                                    }
                                    else {
                                        vErrors.push(err18);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.currency !== undefined) {
                                let data5 = data2.currency;
                                if (typeof data5 !== "string") {
                                    const err19 = { instancePath: instancePath + "/data/accounts/" + i0 + "/currency", schemaPath: "#/properties/data/properties/accounts/items/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err19];
                                    }
                                    else {
                                        vErrors.push(err19);
                                    }
                                    errors++;
                                }
                                if (!(((data5 === "BRL") || (data5 === "CAD")) || (data5 === "USD"))) {
                                    const err20 = { instancePath: instancePath + "/data/accounts/" + i0 + "/currency", schemaPath: "#/properties/data/properties/accounts/items/properties/currency/enum", keyword: "enum", params: { allowedValues: schema15.properties.data.properties.accounts.items.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err20];
                                    }
                                    else {
                                        vErrors.push(err20);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.kind !== undefined) {
                                let data6 = data2.kind;
                                if (typeof data6 !== "string") {
                                    const err21 = { instancePath: instancePath + "/data/accounts/" + i0 + "/kind", schemaPath: "#/properties/data/properties/accounts/items/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err21];
                                    }
                                    else {
                                        vErrors.push(err21);
                                    }
                                    errors++;
                                }
                                if (!((data6 === "cash") || (data6 === "card"))) {
                                    const err22 = { instancePath: instancePath + "/data/accounts/" + i0 + "/kind", schemaPath: "#/properties/data/properties/accounts/items/properties/kind/enum", keyword: "enum", params: { allowedValues: schema15.properties.data.properties.accounts.items.properties.kind.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err22];
                                    }
                                    else {
                                        vErrors.push(err22);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.archived !== undefined) {
                                if (typeof data2.archived !== "boolean") {
                                    const err23 = { instancePath: instancePath + "/data/accounts/" + i0 + "/archived", schemaPath: "#/properties/data/properties/accounts/items/properties/archived/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                    if (vErrors === null) {
                                        vErrors = [err23];
                                    }
                                    else {
                                        vErrors.push(err23);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.revision !== undefined) {
                                let data8 = data2.revision;
                                if (typeof data8 === "string") {
                                    if (!pattern2.test(data8)) {
                                        const err24 = { instancePath: instancePath + "/data/accounts/" + i0 + "/revision", schemaPath: "#/properties/data/properties/accounts/items/properties/revision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err24];
                                        }
                                        else {
                                            vErrors.push(err24);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err25 = { instancePath: instancePath + "/data/accounts/" + i0 + "/revision", schemaPath: "#/properties/data/properties/accounts/items/properties/revision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err25];
                                    }
                                    else {
                                        vErrors.push(err25);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.balance !== undefined) {
                                let data9 = data2.balance;
                                if (data9 && typeof data9 == "object" && !Array.isArray(data9)) {
                                    if (data9.currency === undefined) {
                                        const err26 = { instancePath: instancePath + "/data/accounts/" + i0 + "/balance", schemaPath: "#/properties/data/properties/accounts/items/properties/balance/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                                        if (vErrors === null) {
                                            vErrors = [err26];
                                        }
                                        else {
                                            vErrors.push(err26);
                                        }
                                        errors++;
                                    }
                                    if (data9.minorUnits === undefined) {
                                        const err27 = { instancePath: instancePath + "/data/accounts/" + i0 + "/balance", schemaPath: "#/properties/data/properties/accounts/items/properties/balance/required", keyword: "required", params: { missingProperty: "minorUnits" }, message: "must have required property '" + "minorUnits" + "'" };
                                        if (vErrors === null) {
                                            vErrors = [err27];
                                        }
                                        else {
                                            vErrors.push(err27);
                                        }
                                        errors++;
                                    }
                                    if (data9.negative === undefined) {
                                        const err28 = { instancePath: instancePath + "/data/accounts/" + i0 + "/balance", schemaPath: "#/properties/data/properties/accounts/items/properties/balance/required", keyword: "required", params: { missingProperty: "negative" }, message: "must have required property '" + "negative" + "'" };
                                        if (vErrors === null) {
                                            vErrors = [err28];
                                        }
                                        else {
                                            vErrors.push(err28);
                                        }
                                        errors++;
                                    }
                                    for (const key3 in data9) {
                                        if (!(((key3 === "currency") || (key3 === "minorUnits")) || (key3 === "negative"))) {
                                            const err29 = { instancePath: instancePath + "/data/accounts/" + i0 + "/balance", schemaPath: "#/properties/data/properties/accounts/items/properties/balance/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                                            if (vErrors === null) {
                                                vErrors = [err29];
                                            }
                                            else {
                                                vErrors.push(err29);
                                            }
                                            errors++;
                                        }
                                    }
                                    if (data9.currency !== undefined) {
                                        let data10 = data9.currency;
                                        if (typeof data10 !== "string") {
                                            const err30 = { instancePath: instancePath + "/data/accounts/" + i0 + "/balance/currency", schemaPath: "#/properties/data/properties/accounts/items/properties/balance/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                            if (vErrors === null) {
                                                vErrors = [err30];
                                            }
                                            else {
                                                vErrors.push(err30);
                                            }
                                            errors++;
                                        }
                                        if (!(((data10 === "BRL") || (data10 === "CAD")) || (data10 === "USD"))) {
                                            const err31 = { instancePath: instancePath + "/data/accounts/" + i0 + "/balance/currency", schemaPath: "#/properties/data/properties/accounts/items/properties/balance/properties/currency/enum", keyword: "enum", params: { allowedValues: schema15.properties.data.properties.accounts.items.properties.balance.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                                            if (vErrors === null) {
                                                vErrors = [err31];
                                            }
                                            else {
                                                vErrors.push(err31);
                                            }
                                            errors++;
                                        }
                                    }
                                    if (data9.minorUnits !== undefined) {
                                        let data11 = data9.minorUnits;
                                        if (typeof data11 === "string") {
                                            if (!pattern3.test(data11)) {
                                                const err32 = { instancePath: instancePath + "/data/accounts/" + i0 + "/balance/minorUnits", schemaPath: "#/properties/data/properties/accounts/items/properties/balance/properties/minorUnits/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                                if (vErrors === null) {
                                                    vErrors = [err32];
                                                }
                                                else {
                                                    vErrors.push(err32);
                                                }
                                                errors++;
                                            }
                                        }
                                        else {
                                            const err33 = { instancePath: instancePath + "/data/accounts/" + i0 + "/balance/minorUnits", schemaPath: "#/properties/data/properties/accounts/items/properties/balance/properties/minorUnits/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                            if (vErrors === null) {
                                                vErrors = [err33];
                                            }
                                            else {
                                                vErrors.push(err33);
                                            }
                                            errors++;
                                        }
                                    }
                                    if (data9.negative !== undefined) {
                                        if (typeof data9.negative !== "boolean") {
                                            const err34 = { instancePath: instancePath + "/data/accounts/" + i0 + "/balance/negative", schemaPath: "#/properties/data/properties/accounts/items/properties/balance/properties/negative/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                            if (vErrors === null) {
                                                vErrors = [err34];
                                            }
                                            else {
                                                vErrors.push(err34);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                                else {
                                    const err35 = { instancePath: instancePath + "/data/accounts/" + i0 + "/balance", schemaPath: "#/properties/data/properties/accounts/items/properties/balance/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                    if (vErrors === null) {
                                        vErrors = [err35];
                                    }
                                    else {
                                        vErrors.push(err35);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err36 = { instancePath: instancePath + "/data/accounts/" + i0, schemaPath: "#/properties/data/properties/accounts/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                                vErrors = [err36];
                            }
                            else {
                                vErrors.push(err36);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err37 = { instancePath: instancePath + "/data/accounts", schemaPath: "#/properties/data/properties/accounts/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err37];
                    }
                    else {
                        vErrors.push(err37);
                    }
                    errors++;
                }
            }
        }
        else {
            const err38 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err38];
            }
            else {
                vErrors.push(err38);
            }
            errors++;
        }
    }
    if (data.meta !== undefined) {
        let data13 = data.meta;
        if (data13 && typeof data13 == "object" && !Array.isArray(data13)) {
            if (data13.requestId === undefined) {
                const err39 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "requestId" }, message: "must have required property '" + "requestId" + "'" };
                if (vErrors === null) {
                    vErrors = [err39];
                }
                else {
                    vErrors.push(err39);
                }
                errors++;
            }
            if (data13.asOf === undefined) {
                const err40 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "asOf" }, message: "must have required property '" + "asOf" + "'" };
                if (vErrors === null) {
                    vErrors = [err40];
                }
                else {
                    vErrors.push(err40);
                }
                errors++;
            }
            if (data13.businessToday === undefined) {
                const err41 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err41];
                }
                else {
                    vErrors.push(err41);
                }
                errors++;
            }
            if (data13.timeZone === undefined) {
                const err42 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "timeZone" }, message: "must have required property '" + "timeZone" + "'" };
                if (vErrors === null) {
                    vErrors = [err42];
                }
                else {
                    vErrors.push(err42);
                }
                errors++;
            }
            if (data13.dataRevision === undefined) {
                const err43 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "dataRevision" }, message: "must have required property '" + "dataRevision" + "'" };
                if (vErrors === null) {
                    vErrors = [err43];
                }
                else {
                    vErrors.push(err43);
                }
                errors++;
            }
            for (const key4 in data13) {
                if (!(((((key4 === "requestId") || (key4 === "asOf")) || (key4 === "businessToday")) || (key4 === "timeZone")) || (key4 === "dataRevision"))) {
                    const err44 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key4 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err44];
                    }
                    else {
                        vErrors.push(err44);
                    }
                    errors++;
                }
            }
            if (data13.requestId !== undefined) {
                let data14 = data13.requestId;
                if (typeof data14 === "string") {
                    if (func2(data14) > 64) {
                        const err45 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err45];
                        }
                        else {
                            vErrors.push(err45);
                        }
                        errors++;
                    }
                    if (func2(data14) < 1) {
                        const err46 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err46];
                        }
                        else {
                            vErrors.push(err46);
                        }
                        errors++;
                    }
                }
                else {
                    const err47 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err47];
                    }
                    else {
                        vErrors.push(err47);
                    }
                    errors++;
                }
            }
            if (data13.asOf !== undefined) {
                let data15 = data13.asOf;
                if (typeof data15 === "string") {
                    if (func2(data15) > 64) {
                        const err48 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err48];
                        }
                        else {
                            vErrors.push(err48);
                        }
                        errors++;
                    }
                    if (func2(data15) < 1) {
                        const err49 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err49];
                        }
                        else {
                            vErrors.push(err49);
                        }
                        errors++;
                    }
                }
                else {
                    const err50 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err50];
                    }
                    else {
                        vErrors.push(err50);
                    }
                    errors++;
                }
            }
            if (data13.businessToday !== undefined) {
                let data16 = data13.businessToday;
                if (typeof data16 === "string") {
                    if (!pattern4.test(data16)) {
                        const err51 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err51];
                        }
                        else {
                            vErrors.push(err51);
                        }
                        errors++;
                    }
                }
                else {
                    const err52 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err52];
                    }
                    else {
                        vErrors.push(err52);
                    }
                    errors++;
                }
            }
            if (data13.timeZone !== undefined) {
                let data17 = data13.timeZone;
                if (typeof data17 === "string") {
                    if (func2(data17) > 64) {
                        const err53 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err53];
                        }
                        else {
                            vErrors.push(err53);
                        }
                        errors++;
                    }
                    if (func2(data17) < 1) {
                        const err54 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err54];
                        }
                        else {
                            vErrors.push(err54);
                        }
                        errors++;
                    }
                }
                else {
                    const err55 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err55];
                    }
                    else {
                        vErrors.push(err55);
                    }
                    errors++;
                }
            }
            if (data13.dataRevision !== undefined) {
                let data18 = data13.dataRevision;
                if (typeof data18 === "string") {
                    if (!pattern2.test(data18)) {
                        const err56 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err56];
                        }
                        else {
                            vErrors.push(err56);
                        }
                        errors++;
                    }
                }
                else {
                    const err57 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err57];
                    }
                    else {
                        vErrors.push(err57);
                    }
                    errors++;
                }
            }
        }
        else {
            const err58 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err58];
            }
            else {
                vErrors.push(err58);
            }
            errors++;
        }
    }
}
else {
    const err59 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
        vErrors = [err59];
    }
    else {
        vErrors.push(err59);
    }
    errors++;
} validate14.errors = vErrors; return errors === 0; }
export const validateLedgerEntryEnvelope = validate15;
const schema16 = { "$id": "https://saldo.local/schemas/ledger-entry-envelope.json", "$schema": "http://json-schema.org/draft-07/schema#", "title": "LedgerEntryEnvelope", "type": "object", "additionalProperties": false, "required": ["data", "meta"], "properties": { "data": { "type": "object", "additionalProperties": false, "required": ["id", "accountId", "type", "signedMinor", "currency", "description", "transactionDate", "dueDate", "paid", "revision", "effectiveDate", "installmentGroupId", "installmentOrdinal", "transferStatus", "categoryId", "canceled"], "properties": { "id": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "accountId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "type": { "type": "string", "enum": ["income", "expense", "opening", "transfer"] }, "signedMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "description": { "type": "string", "minLength": 1, "maxLength": 500 }, "transactionDate": { "type": ["string", "null"], "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "dueDate": { "type": ["string", "null"], "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "paid": { "type": ["boolean", "null"] }, "revision": { "type": "string", "pattern": "^[1-9][0-9]*$" }, "effectiveDate": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "installmentGroupId": { "type": ["string", "null"], "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "installmentOrdinal": { "type": ["integer", "null"], "minimum": 1, "maximum": 120 }, "transferStatus": { "type": ["string", "null"], "enum": ["planned", "completed", null] }, "categoryId": { "type": ["string", "null"], "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "canceled": { "type": "boolean" } } }, "meta": { "type": "object", "additionalProperties": false, "required": ["requestId", "asOf", "businessToday", "timeZone", "dataRevision"], "properties": { "requestId": { "type": "string", "minLength": 1, "maxLength": 64 }, "asOf": { "type": "string", "minLength": 1, "maxLength": 64 }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "timeZone": { "type": "string", "minLength": 1, "maxLength": 64 }, "dataRevision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } } } };
const func35 = Object.prototype.hasOwnProperty;
function validate15(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="https://saldo.local/schemas/ledger-entry-envelope.json" */ ; let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.data === undefined) {
        const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property '" + "data" + "'" };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
    }
    if (data.meta === undefined) {
        const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "meta" }, message: "must have required property '" + "meta" + "'" };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    for (const key0 in data) {
        if (!((key0 === "data") || (key0 === "meta"))) {
            const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.data !== undefined) {
        let data0 = data.data;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.id === undefined) {
                const err3 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property '" + "id" + "'" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
            if (data0.accountId === undefined) {
                const err4 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "accountId" }, message: "must have required property '" + "accountId" + "'" };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
            if (data0.type === undefined) {
                const err5 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "type" }, message: "must have required property '" + "type" + "'" };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
            }
            if (data0.signedMinor === undefined) {
                const err6 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "signedMinor" }, message: "must have required property '" + "signedMinor" + "'" };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
            }
            if (data0.currency === undefined) {
                const err7 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                if (vErrors === null) {
                    vErrors = [err7];
                }
                else {
                    vErrors.push(err7);
                }
                errors++;
            }
            if (data0.description === undefined) {
                const err8 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "description" }, message: "must have required property '" + "description" + "'" };
                if (vErrors === null) {
                    vErrors = [err8];
                }
                else {
                    vErrors.push(err8);
                }
                errors++;
            }
            if (data0.transactionDate === undefined) {
                const err9 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "transactionDate" }, message: "must have required property '" + "transactionDate" + "'" };
                if (vErrors === null) {
                    vErrors = [err9];
                }
                else {
                    vErrors.push(err9);
                }
                errors++;
            }
            if (data0.dueDate === undefined) {
                const err10 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "dueDate" }, message: "must have required property '" + "dueDate" + "'" };
                if (vErrors === null) {
                    vErrors = [err10];
                }
                else {
                    vErrors.push(err10);
                }
                errors++;
            }
            if (data0.paid === undefined) {
                const err11 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "paid" }, message: "must have required property '" + "paid" + "'" };
                if (vErrors === null) {
                    vErrors = [err11];
                }
                else {
                    vErrors.push(err11);
                }
                errors++;
            }
            if (data0.revision === undefined) {
                const err12 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property '" + "revision" + "'" };
                if (vErrors === null) {
                    vErrors = [err12];
                }
                else {
                    vErrors.push(err12);
                }
                errors++;
            }
            if (data0.effectiveDate === undefined) {
                const err13 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "effectiveDate" }, message: "must have required property '" + "effectiveDate" + "'" };
                if (vErrors === null) {
                    vErrors = [err13];
                }
                else {
                    vErrors.push(err13);
                }
                errors++;
            }
            if (data0.installmentGroupId === undefined) {
                const err14 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "installmentGroupId" }, message: "must have required property '" + "installmentGroupId" + "'" };
                if (vErrors === null) {
                    vErrors = [err14];
                }
                else {
                    vErrors.push(err14);
                }
                errors++;
            }
            if (data0.installmentOrdinal === undefined) {
                const err15 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "installmentOrdinal" }, message: "must have required property '" + "installmentOrdinal" + "'" };
                if (vErrors === null) {
                    vErrors = [err15];
                }
                else {
                    vErrors.push(err15);
                }
                errors++;
            }
            if (data0.transferStatus === undefined) {
                const err16 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "transferStatus" }, message: "must have required property '" + "transferStatus" + "'" };
                if (vErrors === null) {
                    vErrors = [err16];
                }
                else {
                    vErrors.push(err16);
                }
                errors++;
            }
            if (data0.categoryId === undefined) {
                const err17 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "categoryId" }, message: "must have required property '" + "categoryId" + "'" };
                if (vErrors === null) {
                    vErrors = [err17];
                }
                else {
                    vErrors.push(err17);
                }
                errors++;
            }
            if (data0.canceled === undefined) {
                const err18 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "canceled" }, message: "must have required property '" + "canceled" + "'" };
                if (vErrors === null) {
                    vErrors = [err18];
                }
                else {
                    vErrors.push(err18);
                }
                errors++;
            }
            for (const key1 in data0) {
                if (!(func35.call(schema16.properties.data.properties, key1))) {
                    const err19 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err19];
                    }
                    else {
                        vErrors.push(err19);
                    }
                    errors++;
                }
            }
            if (data0.id !== undefined) {
                let data1 = data0.id;
                if (typeof data1 === "string") {
                    if (!pattern0.test(data1)) {
                        const err20 = { instancePath: instancePath + "/data/id", schemaPath: "#/properties/data/properties/id/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err20];
                        }
                        else {
                            vErrors.push(err20);
                        }
                        errors++;
                    }
                }
                else {
                    const err21 = { instancePath: instancePath + "/data/id", schemaPath: "#/properties/data/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err21];
                    }
                    else {
                        vErrors.push(err21);
                    }
                    errors++;
                }
            }
            if (data0.accountId !== undefined) {
                let data2 = data0.accountId;
                if (typeof data2 === "string") {
                    if (!pattern0.test(data2)) {
                        const err22 = { instancePath: instancePath + "/data/accountId", schemaPath: "#/properties/data/properties/accountId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err22];
                        }
                        else {
                            vErrors.push(err22);
                        }
                        errors++;
                    }
                }
                else {
                    const err23 = { instancePath: instancePath + "/data/accountId", schemaPath: "#/properties/data/properties/accountId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err23];
                    }
                    else {
                        vErrors.push(err23);
                    }
                    errors++;
                }
            }
            if (data0.type !== undefined) {
                let data3 = data0.type;
                if (typeof data3 !== "string") {
                    const err24 = { instancePath: instancePath + "/data/type", schemaPath: "#/properties/data/properties/type/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err24];
                    }
                    else {
                        vErrors.push(err24);
                    }
                    errors++;
                }
                if (!((((data3 === "income") || (data3 === "expense")) || (data3 === "opening")) || (data3 === "transfer"))) {
                    const err25 = { instancePath: instancePath + "/data/type", schemaPath: "#/properties/data/properties/type/enum", keyword: "enum", params: { allowedValues: schema16.properties.data.properties.type.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err25];
                    }
                    else {
                        vErrors.push(err25);
                    }
                    errors++;
                }
            }
            if (data0.signedMinor !== undefined) {
                let data4 = data0.signedMinor;
                if (typeof data4 === "string") {
                    if (!pattern3.test(data4)) {
                        const err26 = { instancePath: instancePath + "/data/signedMinor", schemaPath: "#/properties/data/properties/signedMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err26];
                        }
                        else {
                            vErrors.push(err26);
                        }
                        errors++;
                    }
                }
                else {
                    const err27 = { instancePath: instancePath + "/data/signedMinor", schemaPath: "#/properties/data/properties/signedMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err27];
                    }
                    else {
                        vErrors.push(err27);
                    }
                    errors++;
                }
            }
            if (data0.currency !== undefined) {
                let data5 = data0.currency;
                if (typeof data5 !== "string") {
                    const err28 = { instancePath: instancePath + "/data/currency", schemaPath: "#/properties/data/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err28];
                    }
                    else {
                        vErrors.push(err28);
                    }
                    errors++;
                }
                if (!(((data5 === "BRL") || (data5 === "CAD")) || (data5 === "USD"))) {
                    const err29 = { instancePath: instancePath + "/data/currency", schemaPath: "#/properties/data/properties/currency/enum", keyword: "enum", params: { allowedValues: schema16.properties.data.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err29];
                    }
                    else {
                        vErrors.push(err29);
                    }
                    errors++;
                }
            }
            if (data0.description !== undefined) {
                let data6 = data0.description;
                if (typeof data6 === "string") {
                    if (func2(data6) > 500) {
                        const err30 = { instancePath: instancePath + "/data/description", schemaPath: "#/properties/data/properties/description/maxLength", keyword: "maxLength", params: { limit: 500 }, message: "must NOT have more than 500 characters" };
                        if (vErrors === null) {
                            vErrors = [err30];
                        }
                        else {
                            vErrors.push(err30);
                        }
                        errors++;
                    }
                    if (func2(data6) < 1) {
                        const err31 = { instancePath: instancePath + "/data/description", schemaPath: "#/properties/data/properties/description/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err31];
                        }
                        else {
                            vErrors.push(err31);
                        }
                        errors++;
                    }
                }
                else {
                    const err32 = { instancePath: instancePath + "/data/description", schemaPath: "#/properties/data/properties/description/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err32];
                    }
                    else {
                        vErrors.push(err32);
                    }
                    errors++;
                }
            }
            if (data0.transactionDate !== undefined) {
                let data7 = data0.transactionDate;
                if ((typeof data7 !== "string") && (data7 !== null)) {
                    const err33 = { instancePath: instancePath + "/data/transactionDate", schemaPath: "#/properties/data/properties/transactionDate/type", keyword: "type", params: { type: schema16.properties.data.properties.transactionDate.type }, message: "must be string,null" };
                    if (vErrors === null) {
                        vErrors = [err33];
                    }
                    else {
                        vErrors.push(err33);
                    }
                    errors++;
                }
                if (typeof data7 === "string") {
                    if (!pattern4.test(data7)) {
                        const err34 = { instancePath: instancePath + "/data/transactionDate", schemaPath: "#/properties/data/properties/transactionDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err34];
                        }
                        else {
                            vErrors.push(err34);
                        }
                        errors++;
                    }
                }
            }
            if (data0.dueDate !== undefined) {
                let data8 = data0.dueDate;
                if ((typeof data8 !== "string") && (data8 !== null)) {
                    const err35 = { instancePath: instancePath + "/data/dueDate", schemaPath: "#/properties/data/properties/dueDate/type", keyword: "type", params: { type: schema16.properties.data.properties.dueDate.type }, message: "must be string,null" };
                    if (vErrors === null) {
                        vErrors = [err35];
                    }
                    else {
                        vErrors.push(err35);
                    }
                    errors++;
                }
                if (typeof data8 === "string") {
                    if (!pattern4.test(data8)) {
                        const err36 = { instancePath: instancePath + "/data/dueDate", schemaPath: "#/properties/data/properties/dueDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err36];
                        }
                        else {
                            vErrors.push(err36);
                        }
                        errors++;
                    }
                }
            }
            if (data0.paid !== undefined) {
                let data9 = data0.paid;
                if ((typeof data9 !== "boolean") && (data9 !== null)) {
                    const err37 = { instancePath: instancePath + "/data/paid", schemaPath: "#/properties/data/properties/paid/type", keyword: "type", params: { type: schema16.properties.data.properties.paid.type }, message: "must be boolean,null" };
                    if (vErrors === null) {
                        vErrors = [err37];
                    }
                    else {
                        vErrors.push(err37);
                    }
                    errors++;
                }
            }
            if (data0.revision !== undefined) {
                let data10 = data0.revision;
                if (typeof data10 === "string") {
                    if (!pattern2.test(data10)) {
                        const err38 = { instancePath: instancePath + "/data/revision", schemaPath: "#/properties/data/properties/revision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err38];
                        }
                        else {
                            vErrors.push(err38);
                        }
                        errors++;
                    }
                }
                else {
                    const err39 = { instancePath: instancePath + "/data/revision", schemaPath: "#/properties/data/properties/revision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err39];
                    }
                    else {
                        vErrors.push(err39);
                    }
                    errors++;
                }
            }
            if (data0.effectiveDate !== undefined) {
                let data11 = data0.effectiveDate;
                if (typeof data11 === "string") {
                    if (!pattern4.test(data11)) {
                        const err40 = { instancePath: instancePath + "/data/effectiveDate", schemaPath: "#/properties/data/properties/effectiveDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err40];
                        }
                        else {
                            vErrors.push(err40);
                        }
                        errors++;
                    }
                }
                else {
                    const err41 = { instancePath: instancePath + "/data/effectiveDate", schemaPath: "#/properties/data/properties/effectiveDate/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err41];
                    }
                    else {
                        vErrors.push(err41);
                    }
                    errors++;
                }
            }
            if (data0.installmentGroupId !== undefined) {
                let data12 = data0.installmentGroupId;
                if ((typeof data12 !== "string") && (data12 !== null)) {
                    const err42 = { instancePath: instancePath + "/data/installmentGroupId", schemaPath: "#/properties/data/properties/installmentGroupId/type", keyword: "type", params: { type: schema16.properties.data.properties.installmentGroupId.type }, message: "must be string,null" };
                    if (vErrors === null) {
                        vErrors = [err42];
                    }
                    else {
                        vErrors.push(err42);
                    }
                    errors++;
                }
                if (typeof data12 === "string") {
                    if (!pattern0.test(data12)) {
                        const err43 = { instancePath: instancePath + "/data/installmentGroupId", schemaPath: "#/properties/data/properties/installmentGroupId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err43];
                        }
                        else {
                            vErrors.push(err43);
                        }
                        errors++;
                    }
                }
            }
            if (data0.installmentOrdinal !== undefined) {
                let data13 = data0.installmentOrdinal;
                if ((!(((typeof data13 == "number") && (!(data13 % 1) && !isNaN(data13))) && (isFinite(data13)))) && (data13 !== null)) {
                    const err44 = { instancePath: instancePath + "/data/installmentOrdinal", schemaPath: "#/properties/data/properties/installmentOrdinal/type", keyword: "type", params: { type: schema16.properties.data.properties.installmentOrdinal.type }, message: "must be integer,null" };
                    if (vErrors === null) {
                        vErrors = [err44];
                    }
                    else {
                        vErrors.push(err44);
                    }
                    errors++;
                }
                if ((typeof data13 == "number") && (isFinite(data13))) {
                    if (data13 > 120 || isNaN(data13)) {
                        const err45 = { instancePath: instancePath + "/data/installmentOrdinal", schemaPath: "#/properties/data/properties/installmentOrdinal/maximum", keyword: "maximum", params: { comparison: "<=", limit: 120 }, message: "must be <= 120" };
                        if (vErrors === null) {
                            vErrors = [err45];
                        }
                        else {
                            vErrors.push(err45);
                        }
                        errors++;
                    }
                    if (data13 < 1 || isNaN(data13)) {
                        const err46 = { instancePath: instancePath + "/data/installmentOrdinal", schemaPath: "#/properties/data/properties/installmentOrdinal/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                        if (vErrors === null) {
                            vErrors = [err46];
                        }
                        else {
                            vErrors.push(err46);
                        }
                        errors++;
                    }
                }
            }
            if (data0.transferStatus !== undefined) {
                let data14 = data0.transferStatus;
                if ((typeof data14 !== "string") && (data14 !== null)) {
                    const err47 = { instancePath: instancePath + "/data/transferStatus", schemaPath: "#/properties/data/properties/transferStatus/type", keyword: "type", params: { type: schema16.properties.data.properties.transferStatus.type }, message: "must be string,null" };
                    if (vErrors === null) {
                        vErrors = [err47];
                    }
                    else {
                        vErrors.push(err47);
                    }
                    errors++;
                }
                if (!(((data14 === "planned") || (data14 === "completed")) || (data14 === null))) {
                    const err48 = { instancePath: instancePath + "/data/transferStatus", schemaPath: "#/properties/data/properties/transferStatus/enum", keyword: "enum", params: { allowedValues: schema16.properties.data.properties.transferStatus.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err48];
                    }
                    else {
                        vErrors.push(err48);
                    }
                    errors++;
                }
            }
            if (data0.categoryId !== undefined) {
                let data15 = data0.categoryId;
                if ((typeof data15 !== "string") && (data15 !== null)) {
                    const err49 = { instancePath: instancePath + "/data/categoryId", schemaPath: "#/properties/data/properties/categoryId/type", keyword: "type", params: { type: schema16.properties.data.properties.categoryId.type }, message: "must be string,null" };
                    if (vErrors === null) {
                        vErrors = [err49];
                    }
                    else {
                        vErrors.push(err49);
                    }
                    errors++;
                }
                if (typeof data15 === "string") {
                    if (!pattern0.test(data15)) {
                        const err50 = { instancePath: instancePath + "/data/categoryId", schemaPath: "#/properties/data/properties/categoryId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err50];
                        }
                        else {
                            vErrors.push(err50);
                        }
                        errors++;
                    }
                }
            }
            if (data0.canceled !== undefined) {
                if (typeof data0.canceled !== "boolean") {
                    const err51 = { instancePath: instancePath + "/data/canceled", schemaPath: "#/properties/data/properties/canceled/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                    if (vErrors === null) {
                        vErrors = [err51];
                    }
                    else {
                        vErrors.push(err51);
                    }
                    errors++;
                }
            }
        }
        else {
            const err52 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err52];
            }
            else {
                vErrors.push(err52);
            }
            errors++;
        }
    }
    if (data.meta !== undefined) {
        let data17 = data.meta;
        if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
            if (data17.requestId === undefined) {
                const err53 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "requestId" }, message: "must have required property '" + "requestId" + "'" };
                if (vErrors === null) {
                    vErrors = [err53];
                }
                else {
                    vErrors.push(err53);
                }
                errors++;
            }
            if (data17.asOf === undefined) {
                const err54 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "asOf" }, message: "must have required property '" + "asOf" + "'" };
                if (vErrors === null) {
                    vErrors = [err54];
                }
                else {
                    vErrors.push(err54);
                }
                errors++;
            }
            if (data17.businessToday === undefined) {
                const err55 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err55];
                }
                else {
                    vErrors.push(err55);
                }
                errors++;
            }
            if (data17.timeZone === undefined) {
                const err56 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "timeZone" }, message: "must have required property '" + "timeZone" + "'" };
                if (vErrors === null) {
                    vErrors = [err56];
                }
                else {
                    vErrors.push(err56);
                }
                errors++;
            }
            if (data17.dataRevision === undefined) {
                const err57 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "dataRevision" }, message: "must have required property '" + "dataRevision" + "'" };
                if (vErrors === null) {
                    vErrors = [err57];
                }
                else {
                    vErrors.push(err57);
                }
                errors++;
            }
            for (const key2 in data17) {
                if (!(((((key2 === "requestId") || (key2 === "asOf")) || (key2 === "businessToday")) || (key2 === "timeZone")) || (key2 === "dataRevision"))) {
                    const err58 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err58];
                    }
                    else {
                        vErrors.push(err58);
                    }
                    errors++;
                }
            }
            if (data17.requestId !== undefined) {
                let data18 = data17.requestId;
                if (typeof data18 === "string") {
                    if (func2(data18) > 64) {
                        const err59 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err59];
                        }
                        else {
                            vErrors.push(err59);
                        }
                        errors++;
                    }
                    if (func2(data18) < 1) {
                        const err60 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err60];
                        }
                        else {
                            vErrors.push(err60);
                        }
                        errors++;
                    }
                }
                else {
                    const err61 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err61];
                    }
                    else {
                        vErrors.push(err61);
                    }
                    errors++;
                }
            }
            if (data17.asOf !== undefined) {
                let data19 = data17.asOf;
                if (typeof data19 === "string") {
                    if (func2(data19) > 64) {
                        const err62 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err62];
                        }
                        else {
                            vErrors.push(err62);
                        }
                        errors++;
                    }
                    if (func2(data19) < 1) {
                        const err63 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err63];
                        }
                        else {
                            vErrors.push(err63);
                        }
                        errors++;
                    }
                }
                else {
                    const err64 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err64];
                    }
                    else {
                        vErrors.push(err64);
                    }
                    errors++;
                }
            }
            if (data17.businessToday !== undefined) {
                let data20 = data17.businessToday;
                if (typeof data20 === "string") {
                    if (!pattern4.test(data20)) {
                        const err65 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err65];
                        }
                        else {
                            vErrors.push(err65);
                        }
                        errors++;
                    }
                }
                else {
                    const err66 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err66];
                    }
                    else {
                        vErrors.push(err66);
                    }
                    errors++;
                }
            }
            if (data17.timeZone !== undefined) {
                let data21 = data17.timeZone;
                if (typeof data21 === "string") {
                    if (func2(data21) > 64) {
                        const err67 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err67];
                        }
                        else {
                            vErrors.push(err67);
                        }
                        errors++;
                    }
                    if (func2(data21) < 1) {
                        const err68 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err68];
                        }
                        else {
                            vErrors.push(err68);
                        }
                        errors++;
                    }
                }
                else {
                    const err69 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err69];
                    }
                    else {
                        vErrors.push(err69);
                    }
                    errors++;
                }
            }
            if (data17.dataRevision !== undefined) {
                let data22 = data17.dataRevision;
                if (typeof data22 === "string") {
                    if (!pattern2.test(data22)) {
                        const err70 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err70];
                        }
                        else {
                            vErrors.push(err70);
                        }
                        errors++;
                    }
                }
                else {
                    const err71 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err71];
                    }
                    else {
                        vErrors.push(err71);
                    }
                    errors++;
                }
            }
        }
        else {
            const err72 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err72];
            }
            else {
                vErrors.push(err72);
            }
            errors++;
        }
    }
}
else {
    const err73 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
        vErrors = [err73];
    }
    else {
        vErrors.push(err73);
    }
    errors++;
} validate15.errors = vErrors; return errors === 0; }
export const validateLedgerEntriesEnvelope = validate16;
const schema17 = { "$id": "https://saldo.local/schemas/ledger-entries-envelope.json", "$schema": "http://json-schema.org/draft-07/schema#", "title": "LedgerEntriesEnvelope", "type": "object", "additionalProperties": false, "required": ["data", "meta"], "properties": { "data": { "type": "object", "additionalProperties": false, "required": ["entries"], "properties": { "entries": { "type": "array", "maxItems": 200, "items": { "type": "object", "additionalProperties": false, "required": ["id", "accountId", "type", "signedMinor", "currency", "description", "transactionDate", "dueDate", "paid", "revision", "effectiveDate", "installmentGroupId", "installmentOrdinal", "transferStatus", "categoryId", "canceled"], "properties": { "id": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "accountId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "type": { "type": "string", "enum": ["income", "expense", "opening", "transfer"] }, "signedMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "description": { "type": "string", "minLength": 1, "maxLength": 500 }, "transactionDate": { "type": ["string", "null"], "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "dueDate": { "type": ["string", "null"], "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "paid": { "type": ["boolean", "null"] }, "revision": { "type": "string", "pattern": "^[1-9][0-9]*$" }, "effectiveDate": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "installmentGroupId": { "type": ["string", "null"], "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "installmentOrdinal": { "type": ["integer", "null"], "minimum": 1, "maximum": 120 }, "transferStatus": { "type": ["string", "null"], "enum": ["planned", "completed", null] }, "categoryId": { "type": ["string", "null"], "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "canceled": { "type": "boolean" } } } } } }, "meta": { "type": "object", "additionalProperties": false, "required": ["requestId", "asOf", "businessToday", "timeZone", "dataRevision"], "properties": { "requestId": { "type": "string", "minLength": 1, "maxLength": 64 }, "asOf": { "type": "string", "minLength": 1, "maxLength": 64 }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "timeZone": { "type": "string", "minLength": 1, "maxLength": 64 }, "dataRevision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } } } };
function validate16(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="https://saldo.local/schemas/ledger-entries-envelope.json" */ ; let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.data === undefined) {
        const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property '" + "data" + "'" };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
    }
    if (data.meta === undefined) {
        const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "meta" }, message: "must have required property '" + "meta" + "'" };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    for (const key0 in data) {
        if (!((key0 === "data") || (key0 === "meta"))) {
            const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.data !== undefined) {
        let data0 = data.data;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.entries === undefined) {
                const err3 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "entries" }, message: "must have required property '" + "entries" + "'" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
            for (const key1 in data0) {
                if (!(key1 === "entries")) {
                    const err4 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
            }
            if (data0.entries !== undefined) {
                let data1 = data0.entries;
                if (Array.isArray(data1)) {
                    if (data1.length > 200) {
                        const err5 = { instancePath: instancePath + "/data/entries", schemaPath: "#/properties/data/properties/entries/maxItems", keyword: "maxItems", params: { limit: 200 }, message: "must NOT have more than 200 items" };
                        if (vErrors === null) {
                            vErrors = [err5];
                        }
                        else {
                            vErrors.push(err5);
                        }
                        errors++;
                    }
                    const len0 = data1.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                        let data2 = data1[i0];
                        if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                            if (data2.id === undefined) {
                                const err6 = { instancePath: instancePath + "/data/entries/" + i0, schemaPath: "#/properties/data/properties/entries/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property '" + "id" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err6];
                                }
                                else {
                                    vErrors.push(err6);
                                }
                                errors++;
                            }
                            if (data2.accountId === undefined) {
                                const err7 = { instancePath: instancePath + "/data/entries/" + i0, schemaPath: "#/properties/data/properties/entries/items/required", keyword: "required", params: { missingProperty: "accountId" }, message: "must have required property '" + "accountId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err7];
                                }
                                else {
                                    vErrors.push(err7);
                                }
                                errors++;
                            }
                            if (data2.type === undefined) {
                                const err8 = { instancePath: instancePath + "/data/entries/" + i0, schemaPath: "#/properties/data/properties/entries/items/required", keyword: "required", params: { missingProperty: "type" }, message: "must have required property '" + "type" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err8];
                                }
                                else {
                                    vErrors.push(err8);
                                }
                                errors++;
                            }
                            if (data2.signedMinor === undefined) {
                                const err9 = { instancePath: instancePath + "/data/entries/" + i0, schemaPath: "#/properties/data/properties/entries/items/required", keyword: "required", params: { missingProperty: "signedMinor" }, message: "must have required property '" + "signedMinor" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err9];
                                }
                                else {
                                    vErrors.push(err9);
                                }
                                errors++;
                            }
                            if (data2.currency === undefined) {
                                const err10 = { instancePath: instancePath + "/data/entries/" + i0, schemaPath: "#/properties/data/properties/entries/items/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err10];
                                }
                                else {
                                    vErrors.push(err10);
                                }
                                errors++;
                            }
                            if (data2.description === undefined) {
                                const err11 = { instancePath: instancePath + "/data/entries/" + i0, schemaPath: "#/properties/data/properties/entries/items/required", keyword: "required", params: { missingProperty: "description" }, message: "must have required property '" + "description" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err11];
                                }
                                else {
                                    vErrors.push(err11);
                                }
                                errors++;
                            }
                            if (data2.transactionDate === undefined) {
                                const err12 = { instancePath: instancePath + "/data/entries/" + i0, schemaPath: "#/properties/data/properties/entries/items/required", keyword: "required", params: { missingProperty: "transactionDate" }, message: "must have required property '" + "transactionDate" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err12];
                                }
                                else {
                                    vErrors.push(err12);
                                }
                                errors++;
                            }
                            if (data2.dueDate === undefined) {
                                const err13 = { instancePath: instancePath + "/data/entries/" + i0, schemaPath: "#/properties/data/properties/entries/items/required", keyword: "required", params: { missingProperty: "dueDate" }, message: "must have required property '" + "dueDate" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err13];
                                }
                                else {
                                    vErrors.push(err13);
                                }
                                errors++;
                            }
                            if (data2.paid === undefined) {
                                const err14 = { instancePath: instancePath + "/data/entries/" + i0, schemaPath: "#/properties/data/properties/entries/items/required", keyword: "required", params: { missingProperty: "paid" }, message: "must have required property '" + "paid" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err14];
                                }
                                else {
                                    vErrors.push(err14);
                                }
                                errors++;
                            }
                            if (data2.revision === undefined) {
                                const err15 = { instancePath: instancePath + "/data/entries/" + i0, schemaPath: "#/properties/data/properties/entries/items/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property '" + "revision" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err15];
                                }
                                else {
                                    vErrors.push(err15);
                                }
                                errors++;
                            }
                            if (data2.effectiveDate === undefined) {
                                const err16 = { instancePath: instancePath + "/data/entries/" + i0, schemaPath: "#/properties/data/properties/entries/items/required", keyword: "required", params: { missingProperty: "effectiveDate" }, message: "must have required property '" + "effectiveDate" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err16];
                                }
                                else {
                                    vErrors.push(err16);
                                }
                                errors++;
                            }
                            if (data2.installmentGroupId === undefined) {
                                const err17 = { instancePath: instancePath + "/data/entries/" + i0, schemaPath: "#/properties/data/properties/entries/items/required", keyword: "required", params: { missingProperty: "installmentGroupId" }, message: "must have required property '" + "installmentGroupId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err17];
                                }
                                else {
                                    vErrors.push(err17);
                                }
                                errors++;
                            }
                            if (data2.installmentOrdinal === undefined) {
                                const err18 = { instancePath: instancePath + "/data/entries/" + i0, schemaPath: "#/properties/data/properties/entries/items/required", keyword: "required", params: { missingProperty: "installmentOrdinal" }, message: "must have required property '" + "installmentOrdinal" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err18];
                                }
                                else {
                                    vErrors.push(err18);
                                }
                                errors++;
                            }
                            if (data2.transferStatus === undefined) {
                                const err19 = { instancePath: instancePath + "/data/entries/" + i0, schemaPath: "#/properties/data/properties/entries/items/required", keyword: "required", params: { missingProperty: "transferStatus" }, message: "must have required property '" + "transferStatus" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err19];
                                }
                                else {
                                    vErrors.push(err19);
                                }
                                errors++;
                            }
                            if (data2.categoryId === undefined) {
                                const err20 = { instancePath: instancePath + "/data/entries/" + i0, schemaPath: "#/properties/data/properties/entries/items/required", keyword: "required", params: { missingProperty: "categoryId" }, message: "must have required property '" + "categoryId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err20];
                                }
                                else {
                                    vErrors.push(err20);
                                }
                                errors++;
                            }
                            if (data2.canceled === undefined) {
                                const err21 = { instancePath: instancePath + "/data/entries/" + i0, schemaPath: "#/properties/data/properties/entries/items/required", keyword: "required", params: { missingProperty: "canceled" }, message: "must have required property '" + "canceled" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err21];
                                }
                                else {
                                    vErrors.push(err21);
                                }
                                errors++;
                            }
                            for (const key2 in data2) {
                                if (!(func35.call(schema17.properties.data.properties.entries.items.properties, key2))) {
                                    const err22 = { instancePath: instancePath + "/data/entries/" + i0, schemaPath: "#/properties/data/properties/entries/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                                    if (vErrors === null) {
                                        vErrors = [err22];
                                    }
                                    else {
                                        vErrors.push(err22);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.id !== undefined) {
                                let data3 = data2.id;
                                if (typeof data3 === "string") {
                                    if (!pattern0.test(data3)) {
                                        const err23 = { instancePath: instancePath + "/data/entries/" + i0 + "/id", schemaPath: "#/properties/data/properties/entries/items/properties/id/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err23];
                                        }
                                        else {
                                            vErrors.push(err23);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err24 = { instancePath: instancePath + "/data/entries/" + i0 + "/id", schemaPath: "#/properties/data/properties/entries/items/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err24];
                                    }
                                    else {
                                        vErrors.push(err24);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.accountId !== undefined) {
                                let data4 = data2.accountId;
                                if (typeof data4 === "string") {
                                    if (!pattern0.test(data4)) {
                                        const err25 = { instancePath: instancePath + "/data/entries/" + i0 + "/accountId", schemaPath: "#/properties/data/properties/entries/items/properties/accountId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err25];
                                        }
                                        else {
                                            vErrors.push(err25);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err26 = { instancePath: instancePath + "/data/entries/" + i0 + "/accountId", schemaPath: "#/properties/data/properties/entries/items/properties/accountId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err26];
                                    }
                                    else {
                                        vErrors.push(err26);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.type !== undefined) {
                                let data5 = data2.type;
                                if (typeof data5 !== "string") {
                                    const err27 = { instancePath: instancePath + "/data/entries/" + i0 + "/type", schemaPath: "#/properties/data/properties/entries/items/properties/type/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err27];
                                    }
                                    else {
                                        vErrors.push(err27);
                                    }
                                    errors++;
                                }
                                if (!((((data5 === "income") || (data5 === "expense")) || (data5 === "opening")) || (data5 === "transfer"))) {
                                    const err28 = { instancePath: instancePath + "/data/entries/" + i0 + "/type", schemaPath: "#/properties/data/properties/entries/items/properties/type/enum", keyword: "enum", params: { allowedValues: schema17.properties.data.properties.entries.items.properties.type.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err28];
                                    }
                                    else {
                                        vErrors.push(err28);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.signedMinor !== undefined) {
                                let data6 = data2.signedMinor;
                                if (typeof data6 === "string") {
                                    if (!pattern3.test(data6)) {
                                        const err29 = { instancePath: instancePath + "/data/entries/" + i0 + "/signedMinor", schemaPath: "#/properties/data/properties/entries/items/properties/signedMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err29];
                                        }
                                        else {
                                            vErrors.push(err29);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err30 = { instancePath: instancePath + "/data/entries/" + i0 + "/signedMinor", schemaPath: "#/properties/data/properties/entries/items/properties/signedMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err30];
                                    }
                                    else {
                                        vErrors.push(err30);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.currency !== undefined) {
                                let data7 = data2.currency;
                                if (typeof data7 !== "string") {
                                    const err31 = { instancePath: instancePath + "/data/entries/" + i0 + "/currency", schemaPath: "#/properties/data/properties/entries/items/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err31];
                                    }
                                    else {
                                        vErrors.push(err31);
                                    }
                                    errors++;
                                }
                                if (!(((data7 === "BRL") || (data7 === "CAD")) || (data7 === "USD"))) {
                                    const err32 = { instancePath: instancePath + "/data/entries/" + i0 + "/currency", schemaPath: "#/properties/data/properties/entries/items/properties/currency/enum", keyword: "enum", params: { allowedValues: schema17.properties.data.properties.entries.items.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err32];
                                    }
                                    else {
                                        vErrors.push(err32);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.description !== undefined) {
                                let data8 = data2.description;
                                if (typeof data8 === "string") {
                                    if (func2(data8) > 500) {
                                        const err33 = { instancePath: instancePath + "/data/entries/" + i0 + "/description", schemaPath: "#/properties/data/properties/entries/items/properties/description/maxLength", keyword: "maxLength", params: { limit: 500 }, message: "must NOT have more than 500 characters" };
                                        if (vErrors === null) {
                                            vErrors = [err33];
                                        }
                                        else {
                                            vErrors.push(err33);
                                        }
                                        errors++;
                                    }
                                    if (func2(data8) < 1) {
                                        const err34 = { instancePath: instancePath + "/data/entries/" + i0 + "/description", schemaPath: "#/properties/data/properties/entries/items/properties/description/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                        if (vErrors === null) {
                                            vErrors = [err34];
                                        }
                                        else {
                                            vErrors.push(err34);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err35 = { instancePath: instancePath + "/data/entries/" + i0 + "/description", schemaPath: "#/properties/data/properties/entries/items/properties/description/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err35];
                                    }
                                    else {
                                        vErrors.push(err35);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.transactionDate !== undefined) {
                                let data9 = data2.transactionDate;
                                if ((typeof data9 !== "string") && (data9 !== null)) {
                                    const err36 = { instancePath: instancePath + "/data/entries/" + i0 + "/transactionDate", schemaPath: "#/properties/data/properties/entries/items/properties/transactionDate/type", keyword: "type", params: { type: schema17.properties.data.properties.entries.items.properties.transactionDate.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err36];
                                    }
                                    else {
                                        vErrors.push(err36);
                                    }
                                    errors++;
                                }
                                if (typeof data9 === "string") {
                                    if (!pattern4.test(data9)) {
                                        const err37 = { instancePath: instancePath + "/data/entries/" + i0 + "/transactionDate", schemaPath: "#/properties/data/properties/entries/items/properties/transactionDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err37];
                                        }
                                        else {
                                            vErrors.push(err37);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data2.dueDate !== undefined) {
                                let data10 = data2.dueDate;
                                if ((typeof data10 !== "string") && (data10 !== null)) {
                                    const err38 = { instancePath: instancePath + "/data/entries/" + i0 + "/dueDate", schemaPath: "#/properties/data/properties/entries/items/properties/dueDate/type", keyword: "type", params: { type: schema17.properties.data.properties.entries.items.properties.dueDate.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err38];
                                    }
                                    else {
                                        vErrors.push(err38);
                                    }
                                    errors++;
                                }
                                if (typeof data10 === "string") {
                                    if (!pattern4.test(data10)) {
                                        const err39 = { instancePath: instancePath + "/data/entries/" + i0 + "/dueDate", schemaPath: "#/properties/data/properties/entries/items/properties/dueDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err39];
                                        }
                                        else {
                                            vErrors.push(err39);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data2.paid !== undefined) {
                                let data11 = data2.paid;
                                if ((typeof data11 !== "boolean") && (data11 !== null)) {
                                    const err40 = { instancePath: instancePath + "/data/entries/" + i0 + "/paid", schemaPath: "#/properties/data/properties/entries/items/properties/paid/type", keyword: "type", params: { type: schema17.properties.data.properties.entries.items.properties.paid.type }, message: "must be boolean,null" };
                                    if (vErrors === null) {
                                        vErrors = [err40];
                                    }
                                    else {
                                        vErrors.push(err40);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.revision !== undefined) {
                                let data12 = data2.revision;
                                if (typeof data12 === "string") {
                                    if (!pattern2.test(data12)) {
                                        const err41 = { instancePath: instancePath + "/data/entries/" + i0 + "/revision", schemaPath: "#/properties/data/properties/entries/items/properties/revision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err41];
                                        }
                                        else {
                                            vErrors.push(err41);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err42 = { instancePath: instancePath + "/data/entries/" + i0 + "/revision", schemaPath: "#/properties/data/properties/entries/items/properties/revision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err42];
                                    }
                                    else {
                                        vErrors.push(err42);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.effectiveDate !== undefined) {
                                let data13 = data2.effectiveDate;
                                if (typeof data13 === "string") {
                                    if (!pattern4.test(data13)) {
                                        const err43 = { instancePath: instancePath + "/data/entries/" + i0 + "/effectiveDate", schemaPath: "#/properties/data/properties/entries/items/properties/effectiveDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err43];
                                        }
                                        else {
                                            vErrors.push(err43);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err44 = { instancePath: instancePath + "/data/entries/" + i0 + "/effectiveDate", schemaPath: "#/properties/data/properties/entries/items/properties/effectiveDate/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err44];
                                    }
                                    else {
                                        vErrors.push(err44);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.installmentGroupId !== undefined) {
                                let data14 = data2.installmentGroupId;
                                if ((typeof data14 !== "string") && (data14 !== null)) {
                                    const err45 = { instancePath: instancePath + "/data/entries/" + i0 + "/installmentGroupId", schemaPath: "#/properties/data/properties/entries/items/properties/installmentGroupId/type", keyword: "type", params: { type: schema17.properties.data.properties.entries.items.properties.installmentGroupId.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err45];
                                    }
                                    else {
                                        vErrors.push(err45);
                                    }
                                    errors++;
                                }
                                if (typeof data14 === "string") {
                                    if (!pattern0.test(data14)) {
                                        const err46 = { instancePath: instancePath + "/data/entries/" + i0 + "/installmentGroupId", schemaPath: "#/properties/data/properties/entries/items/properties/installmentGroupId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err46];
                                        }
                                        else {
                                            vErrors.push(err46);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data2.installmentOrdinal !== undefined) {
                                let data15 = data2.installmentOrdinal;
                                if ((!(((typeof data15 == "number") && (!(data15 % 1) && !isNaN(data15))) && (isFinite(data15)))) && (data15 !== null)) {
                                    const err47 = { instancePath: instancePath + "/data/entries/" + i0 + "/installmentOrdinal", schemaPath: "#/properties/data/properties/entries/items/properties/installmentOrdinal/type", keyword: "type", params: { type: schema17.properties.data.properties.entries.items.properties.installmentOrdinal.type }, message: "must be integer,null" };
                                    if (vErrors === null) {
                                        vErrors = [err47];
                                    }
                                    else {
                                        vErrors.push(err47);
                                    }
                                    errors++;
                                }
                                if ((typeof data15 == "number") && (isFinite(data15))) {
                                    if (data15 > 120 || isNaN(data15)) {
                                        const err48 = { instancePath: instancePath + "/data/entries/" + i0 + "/installmentOrdinal", schemaPath: "#/properties/data/properties/entries/items/properties/installmentOrdinal/maximum", keyword: "maximum", params: { comparison: "<=", limit: 120 }, message: "must be <= 120" };
                                        if (vErrors === null) {
                                            vErrors = [err48];
                                        }
                                        else {
                                            vErrors.push(err48);
                                        }
                                        errors++;
                                    }
                                    if (data15 < 1 || isNaN(data15)) {
                                        const err49 = { instancePath: instancePath + "/data/entries/" + i0 + "/installmentOrdinal", schemaPath: "#/properties/data/properties/entries/items/properties/installmentOrdinal/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                                        if (vErrors === null) {
                                            vErrors = [err49];
                                        }
                                        else {
                                            vErrors.push(err49);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data2.transferStatus !== undefined) {
                                let data16 = data2.transferStatus;
                                if ((typeof data16 !== "string") && (data16 !== null)) {
                                    const err50 = { instancePath: instancePath + "/data/entries/" + i0 + "/transferStatus", schemaPath: "#/properties/data/properties/entries/items/properties/transferStatus/type", keyword: "type", params: { type: schema17.properties.data.properties.entries.items.properties.transferStatus.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err50];
                                    }
                                    else {
                                        vErrors.push(err50);
                                    }
                                    errors++;
                                }
                                if (!(((data16 === "planned") || (data16 === "completed")) || (data16 === null))) {
                                    const err51 = { instancePath: instancePath + "/data/entries/" + i0 + "/transferStatus", schemaPath: "#/properties/data/properties/entries/items/properties/transferStatus/enum", keyword: "enum", params: { allowedValues: schema17.properties.data.properties.entries.items.properties.transferStatus.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err51];
                                    }
                                    else {
                                        vErrors.push(err51);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.categoryId !== undefined) {
                                let data17 = data2.categoryId;
                                if ((typeof data17 !== "string") && (data17 !== null)) {
                                    const err52 = { instancePath: instancePath + "/data/entries/" + i0 + "/categoryId", schemaPath: "#/properties/data/properties/entries/items/properties/categoryId/type", keyword: "type", params: { type: schema17.properties.data.properties.entries.items.properties.categoryId.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err52];
                                    }
                                    else {
                                        vErrors.push(err52);
                                    }
                                    errors++;
                                }
                                if (typeof data17 === "string") {
                                    if (!pattern0.test(data17)) {
                                        const err53 = { instancePath: instancePath + "/data/entries/" + i0 + "/categoryId", schemaPath: "#/properties/data/properties/entries/items/properties/categoryId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err53];
                                        }
                                        else {
                                            vErrors.push(err53);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data2.canceled !== undefined) {
                                if (typeof data2.canceled !== "boolean") {
                                    const err54 = { instancePath: instancePath + "/data/entries/" + i0 + "/canceled", schemaPath: "#/properties/data/properties/entries/items/properties/canceled/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                    if (vErrors === null) {
                                        vErrors = [err54];
                                    }
                                    else {
                                        vErrors.push(err54);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err55 = { instancePath: instancePath + "/data/entries/" + i0, schemaPath: "#/properties/data/properties/entries/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                                vErrors = [err55];
                            }
                            else {
                                vErrors.push(err55);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err56 = { instancePath: instancePath + "/data/entries", schemaPath: "#/properties/data/properties/entries/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err56];
                    }
                    else {
                        vErrors.push(err56);
                    }
                    errors++;
                }
            }
        }
        else {
            const err57 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err57];
            }
            else {
                vErrors.push(err57);
            }
            errors++;
        }
    }
    if (data.meta !== undefined) {
        let data19 = data.meta;
        if (data19 && typeof data19 == "object" && !Array.isArray(data19)) {
            if (data19.requestId === undefined) {
                const err58 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "requestId" }, message: "must have required property '" + "requestId" + "'" };
                if (vErrors === null) {
                    vErrors = [err58];
                }
                else {
                    vErrors.push(err58);
                }
                errors++;
            }
            if (data19.asOf === undefined) {
                const err59 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "asOf" }, message: "must have required property '" + "asOf" + "'" };
                if (vErrors === null) {
                    vErrors = [err59];
                }
                else {
                    vErrors.push(err59);
                }
                errors++;
            }
            if (data19.businessToday === undefined) {
                const err60 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err60];
                }
                else {
                    vErrors.push(err60);
                }
                errors++;
            }
            if (data19.timeZone === undefined) {
                const err61 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "timeZone" }, message: "must have required property '" + "timeZone" + "'" };
                if (vErrors === null) {
                    vErrors = [err61];
                }
                else {
                    vErrors.push(err61);
                }
                errors++;
            }
            if (data19.dataRevision === undefined) {
                const err62 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "dataRevision" }, message: "must have required property '" + "dataRevision" + "'" };
                if (vErrors === null) {
                    vErrors = [err62];
                }
                else {
                    vErrors.push(err62);
                }
                errors++;
            }
            for (const key3 in data19) {
                if (!(((((key3 === "requestId") || (key3 === "asOf")) || (key3 === "businessToday")) || (key3 === "timeZone")) || (key3 === "dataRevision"))) {
                    const err63 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err63];
                    }
                    else {
                        vErrors.push(err63);
                    }
                    errors++;
                }
            }
            if (data19.requestId !== undefined) {
                let data20 = data19.requestId;
                if (typeof data20 === "string") {
                    if (func2(data20) > 64) {
                        const err64 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err64];
                        }
                        else {
                            vErrors.push(err64);
                        }
                        errors++;
                    }
                    if (func2(data20) < 1) {
                        const err65 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err65];
                        }
                        else {
                            vErrors.push(err65);
                        }
                        errors++;
                    }
                }
                else {
                    const err66 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err66];
                    }
                    else {
                        vErrors.push(err66);
                    }
                    errors++;
                }
            }
            if (data19.asOf !== undefined) {
                let data21 = data19.asOf;
                if (typeof data21 === "string") {
                    if (func2(data21) > 64) {
                        const err67 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err67];
                        }
                        else {
                            vErrors.push(err67);
                        }
                        errors++;
                    }
                    if (func2(data21) < 1) {
                        const err68 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err68];
                        }
                        else {
                            vErrors.push(err68);
                        }
                        errors++;
                    }
                }
                else {
                    const err69 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err69];
                    }
                    else {
                        vErrors.push(err69);
                    }
                    errors++;
                }
            }
            if (data19.businessToday !== undefined) {
                let data22 = data19.businessToday;
                if (typeof data22 === "string") {
                    if (!pattern4.test(data22)) {
                        const err70 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err70];
                        }
                        else {
                            vErrors.push(err70);
                        }
                        errors++;
                    }
                }
                else {
                    const err71 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err71];
                    }
                    else {
                        vErrors.push(err71);
                    }
                    errors++;
                }
            }
            if (data19.timeZone !== undefined) {
                let data23 = data19.timeZone;
                if (typeof data23 === "string") {
                    if (func2(data23) > 64) {
                        const err72 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err72];
                        }
                        else {
                            vErrors.push(err72);
                        }
                        errors++;
                    }
                    if (func2(data23) < 1) {
                        const err73 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err73];
                        }
                        else {
                            vErrors.push(err73);
                        }
                        errors++;
                    }
                }
                else {
                    const err74 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err74];
                    }
                    else {
                        vErrors.push(err74);
                    }
                    errors++;
                }
            }
            if (data19.dataRevision !== undefined) {
                let data24 = data19.dataRevision;
                if (typeof data24 === "string") {
                    if (!pattern2.test(data24)) {
                        const err75 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err75];
                        }
                        else {
                            vErrors.push(err75);
                        }
                        errors++;
                    }
                }
                else {
                    const err76 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err76];
                    }
                    else {
                        vErrors.push(err76);
                    }
                    errors++;
                }
            }
        }
        else {
            const err77 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err77];
            }
            else {
                vErrors.push(err77);
            }
            errors++;
        }
    }
}
else {
    const err78 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
        vErrors = [err78];
    }
    else {
        vErrors.push(err78);
    }
    errors++;
} validate16.errors = vErrors; return errors === 0; }
export const validateLedgerInstallmentGroupEnvelope = validate17;
const schema18 = { "$id": "https://saldo.local/schemas/ledger-installment-group-envelope.json", "$schema": "http://json-schema.org/draft-07/schema#", "title": "LedgerInstallmentGroupEnvelope", "type": "object", "additionalProperties": false, "required": ["data", "meta"], "properties": { "data": { "type": "object", "additionalProperties": false, "required": ["id", "defaultAccountId", "currency", "revision", "scheduledCount", "activeCount", "total", "members"], "properties": { "id": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "defaultAccountId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "revision": { "type": "string", "pattern": "^[1-9][0-9]*$" }, "scheduledCount": { "type": "integer", "minimum": 1, "maximum": 120 }, "activeCount": { "type": "integer", "minimum": 0, "maximum": 120 }, "total": { "type": "object", "additionalProperties": false, "required": ["currency", "minorUnits"], "properties": { "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "minorUnits": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" } } }, "members": { "type": "array", "maxItems": 120, "items": { "type": "object", "additionalProperties": false, "required": ["entryId", "ordinal", "dueDate", "signedMinor", "currency", "accountId", "revision", "state"], "properties": { "entryId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "ordinal": { "type": "integer", "minimum": 1, "maximum": 120 }, "dueDate": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "signedMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "accountId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "revision": { "type": "string", "pattern": "^[1-9][0-9]*$" }, "state": { "type": "string", "enum": ["pending", "future", "paid", "effective", "deleted"] } } } } } }, "meta": { "type": "object", "additionalProperties": false, "required": ["requestId", "asOf", "businessToday", "timeZone", "dataRevision"], "properties": { "requestId": { "type": "string", "minLength": 1, "maxLength": 64 }, "asOf": { "type": "string", "minLength": 1, "maxLength": 64 }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "timeZone": { "type": "string", "minLength": 1, "maxLength": 64 }, "dataRevision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } } } };
function validate17(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="https://saldo.local/schemas/ledger-installment-group-envelope.json" */ ; let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.data === undefined) {
        const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property '" + "data" + "'" };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
    }
    if (data.meta === undefined) {
        const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "meta" }, message: "must have required property '" + "meta" + "'" };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    for (const key0 in data) {
        if (!((key0 === "data") || (key0 === "meta"))) {
            const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.data !== undefined) {
        let data0 = data.data;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.id === undefined) {
                const err3 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property '" + "id" + "'" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
            if (data0.defaultAccountId === undefined) {
                const err4 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "defaultAccountId" }, message: "must have required property '" + "defaultAccountId" + "'" };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
            if (data0.currency === undefined) {
                const err5 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
            }
            if (data0.revision === undefined) {
                const err6 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property '" + "revision" + "'" };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
            }
            if (data0.scheduledCount === undefined) {
                const err7 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "scheduledCount" }, message: "must have required property '" + "scheduledCount" + "'" };
                if (vErrors === null) {
                    vErrors = [err7];
                }
                else {
                    vErrors.push(err7);
                }
                errors++;
            }
            if (data0.activeCount === undefined) {
                const err8 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "activeCount" }, message: "must have required property '" + "activeCount" + "'" };
                if (vErrors === null) {
                    vErrors = [err8];
                }
                else {
                    vErrors.push(err8);
                }
                errors++;
            }
            if (data0.total === undefined) {
                const err9 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "total" }, message: "must have required property '" + "total" + "'" };
                if (vErrors === null) {
                    vErrors = [err9];
                }
                else {
                    vErrors.push(err9);
                }
                errors++;
            }
            if (data0.members === undefined) {
                const err10 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "members" }, message: "must have required property '" + "members" + "'" };
                if (vErrors === null) {
                    vErrors = [err10];
                }
                else {
                    vErrors.push(err10);
                }
                errors++;
            }
            for (const key1 in data0) {
                if (!((((((((key1 === "id") || (key1 === "defaultAccountId")) || (key1 === "currency")) || (key1 === "revision")) || (key1 === "scheduledCount")) || (key1 === "activeCount")) || (key1 === "total")) || (key1 === "members"))) {
                    const err11 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err11];
                    }
                    else {
                        vErrors.push(err11);
                    }
                    errors++;
                }
            }
            if (data0.id !== undefined) {
                let data1 = data0.id;
                if (typeof data1 === "string") {
                    if (!pattern0.test(data1)) {
                        const err12 = { instancePath: instancePath + "/data/id", schemaPath: "#/properties/data/properties/id/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err12];
                        }
                        else {
                            vErrors.push(err12);
                        }
                        errors++;
                    }
                }
                else {
                    const err13 = { instancePath: instancePath + "/data/id", schemaPath: "#/properties/data/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err13];
                    }
                    else {
                        vErrors.push(err13);
                    }
                    errors++;
                }
            }
            if (data0.defaultAccountId !== undefined) {
                let data2 = data0.defaultAccountId;
                if (typeof data2 === "string") {
                    if (!pattern0.test(data2)) {
                        const err14 = { instancePath: instancePath + "/data/defaultAccountId", schemaPath: "#/properties/data/properties/defaultAccountId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err14];
                        }
                        else {
                            vErrors.push(err14);
                        }
                        errors++;
                    }
                }
                else {
                    const err15 = { instancePath: instancePath + "/data/defaultAccountId", schemaPath: "#/properties/data/properties/defaultAccountId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err15];
                    }
                    else {
                        vErrors.push(err15);
                    }
                    errors++;
                }
            }
            if (data0.currency !== undefined) {
                let data3 = data0.currency;
                if (typeof data3 !== "string") {
                    const err16 = { instancePath: instancePath + "/data/currency", schemaPath: "#/properties/data/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err16];
                    }
                    else {
                        vErrors.push(err16);
                    }
                    errors++;
                }
                if (!(((data3 === "BRL") || (data3 === "CAD")) || (data3 === "USD"))) {
                    const err17 = { instancePath: instancePath + "/data/currency", schemaPath: "#/properties/data/properties/currency/enum", keyword: "enum", params: { allowedValues: schema18.properties.data.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err17];
                    }
                    else {
                        vErrors.push(err17);
                    }
                    errors++;
                }
            }
            if (data0.revision !== undefined) {
                let data4 = data0.revision;
                if (typeof data4 === "string") {
                    if (!pattern2.test(data4)) {
                        const err18 = { instancePath: instancePath + "/data/revision", schemaPath: "#/properties/data/properties/revision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err18];
                        }
                        else {
                            vErrors.push(err18);
                        }
                        errors++;
                    }
                }
                else {
                    const err19 = { instancePath: instancePath + "/data/revision", schemaPath: "#/properties/data/properties/revision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err19];
                    }
                    else {
                        vErrors.push(err19);
                    }
                    errors++;
                }
            }
            if (data0.scheduledCount !== undefined) {
                let data5 = data0.scheduledCount;
                if (!(((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5))) && (isFinite(data5)))) {
                    const err20 = { instancePath: instancePath + "/data/scheduledCount", schemaPath: "#/properties/data/properties/scheduledCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                        vErrors = [err20];
                    }
                    else {
                        vErrors.push(err20);
                    }
                    errors++;
                }
                if ((typeof data5 == "number") && (isFinite(data5))) {
                    if (data5 > 120 || isNaN(data5)) {
                        const err21 = { instancePath: instancePath + "/data/scheduledCount", schemaPath: "#/properties/data/properties/scheduledCount/maximum", keyword: "maximum", params: { comparison: "<=", limit: 120 }, message: "must be <= 120" };
                        if (vErrors === null) {
                            vErrors = [err21];
                        }
                        else {
                            vErrors.push(err21);
                        }
                        errors++;
                    }
                    if (data5 < 1 || isNaN(data5)) {
                        const err22 = { instancePath: instancePath + "/data/scheduledCount", schemaPath: "#/properties/data/properties/scheduledCount/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                        if (vErrors === null) {
                            vErrors = [err22];
                        }
                        else {
                            vErrors.push(err22);
                        }
                        errors++;
                    }
                }
            }
            if (data0.activeCount !== undefined) {
                let data6 = data0.activeCount;
                if (!(((typeof data6 == "number") && (!(data6 % 1) && !isNaN(data6))) && (isFinite(data6)))) {
                    const err23 = { instancePath: instancePath + "/data/activeCount", schemaPath: "#/properties/data/properties/activeCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                        vErrors = [err23];
                    }
                    else {
                        vErrors.push(err23);
                    }
                    errors++;
                }
                if ((typeof data6 == "number") && (isFinite(data6))) {
                    if (data6 > 120 || isNaN(data6)) {
                        const err24 = { instancePath: instancePath + "/data/activeCount", schemaPath: "#/properties/data/properties/activeCount/maximum", keyword: "maximum", params: { comparison: "<=", limit: 120 }, message: "must be <= 120" };
                        if (vErrors === null) {
                            vErrors = [err24];
                        }
                        else {
                            vErrors.push(err24);
                        }
                        errors++;
                    }
                    if (data6 < 0 || isNaN(data6)) {
                        const err25 = { instancePath: instancePath + "/data/activeCount", schemaPath: "#/properties/data/properties/activeCount/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                        if (vErrors === null) {
                            vErrors = [err25];
                        }
                        else {
                            vErrors.push(err25);
                        }
                        errors++;
                    }
                }
            }
            if (data0.total !== undefined) {
                let data7 = data0.total;
                if (data7 && typeof data7 == "object" && !Array.isArray(data7)) {
                    if (data7.currency === undefined) {
                        const err26 = { instancePath: instancePath + "/data/total", schemaPath: "#/properties/data/properties/total/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                        if (vErrors === null) {
                            vErrors = [err26];
                        }
                        else {
                            vErrors.push(err26);
                        }
                        errors++;
                    }
                    if (data7.minorUnits === undefined) {
                        const err27 = { instancePath: instancePath + "/data/total", schemaPath: "#/properties/data/properties/total/required", keyword: "required", params: { missingProperty: "minorUnits" }, message: "must have required property '" + "minorUnits" + "'" };
                        if (vErrors === null) {
                            vErrors = [err27];
                        }
                        else {
                            vErrors.push(err27);
                        }
                        errors++;
                    }
                    for (const key2 in data7) {
                        if (!((key2 === "currency") || (key2 === "minorUnits"))) {
                            const err28 = { instancePath: instancePath + "/data/total", schemaPath: "#/properties/data/properties/total/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                                vErrors = [err28];
                            }
                            else {
                                vErrors.push(err28);
                            }
                            errors++;
                        }
                    }
                    if (data7.currency !== undefined) {
                        let data8 = data7.currency;
                        if (typeof data8 !== "string") {
                            const err29 = { instancePath: instancePath + "/data/total/currency", schemaPath: "#/properties/data/properties/total/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err29];
                            }
                            else {
                                vErrors.push(err29);
                            }
                            errors++;
                        }
                        if (!(((data8 === "BRL") || (data8 === "CAD")) || (data8 === "USD"))) {
                            const err30 = { instancePath: instancePath + "/data/total/currency", schemaPath: "#/properties/data/properties/total/properties/currency/enum", keyword: "enum", params: { allowedValues: schema18.properties.data.properties.total.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                                vErrors = [err30];
                            }
                            else {
                                vErrors.push(err30);
                            }
                            errors++;
                        }
                    }
                    if (data7.minorUnits !== undefined) {
                        let data9 = data7.minorUnits;
                        if (typeof data9 === "string") {
                            if (!pattern3.test(data9)) {
                                const err31 = { instancePath: instancePath + "/data/total/minorUnits", schemaPath: "#/properties/data/properties/total/properties/minorUnits/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err31];
                                }
                                else {
                                    vErrors.push(err31);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err32 = { instancePath: instancePath + "/data/total/minorUnits", schemaPath: "#/properties/data/properties/total/properties/minorUnits/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err32];
                            }
                            else {
                                vErrors.push(err32);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err33 = { instancePath: instancePath + "/data/total", schemaPath: "#/properties/data/properties/total/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                        vErrors = [err33];
                    }
                    else {
                        vErrors.push(err33);
                    }
                    errors++;
                }
            }
            if (data0.members !== undefined) {
                let data10 = data0.members;
                if (Array.isArray(data10)) {
                    if (data10.length > 120) {
                        const err34 = { instancePath: instancePath + "/data/members", schemaPath: "#/properties/data/properties/members/maxItems", keyword: "maxItems", params: { limit: 120 }, message: "must NOT have more than 120 items" };
                        if (vErrors === null) {
                            vErrors = [err34];
                        }
                        else {
                            vErrors.push(err34);
                        }
                        errors++;
                    }
                    const len0 = data10.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                        let data11 = data10[i0];
                        if (data11 && typeof data11 == "object" && !Array.isArray(data11)) {
                            if (data11.entryId === undefined) {
                                const err35 = { instancePath: instancePath + "/data/members/" + i0, schemaPath: "#/properties/data/properties/members/items/required", keyword: "required", params: { missingProperty: "entryId" }, message: "must have required property '" + "entryId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err35];
                                }
                                else {
                                    vErrors.push(err35);
                                }
                                errors++;
                            }
                            if (data11.ordinal === undefined) {
                                const err36 = { instancePath: instancePath + "/data/members/" + i0, schemaPath: "#/properties/data/properties/members/items/required", keyword: "required", params: { missingProperty: "ordinal" }, message: "must have required property '" + "ordinal" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err36];
                                }
                                else {
                                    vErrors.push(err36);
                                }
                                errors++;
                            }
                            if (data11.dueDate === undefined) {
                                const err37 = { instancePath: instancePath + "/data/members/" + i0, schemaPath: "#/properties/data/properties/members/items/required", keyword: "required", params: { missingProperty: "dueDate" }, message: "must have required property '" + "dueDate" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err37];
                                }
                                else {
                                    vErrors.push(err37);
                                }
                                errors++;
                            }
                            if (data11.signedMinor === undefined) {
                                const err38 = { instancePath: instancePath + "/data/members/" + i0, schemaPath: "#/properties/data/properties/members/items/required", keyword: "required", params: { missingProperty: "signedMinor" }, message: "must have required property '" + "signedMinor" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err38];
                                }
                                else {
                                    vErrors.push(err38);
                                }
                                errors++;
                            }
                            if (data11.currency === undefined) {
                                const err39 = { instancePath: instancePath + "/data/members/" + i0, schemaPath: "#/properties/data/properties/members/items/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err39];
                                }
                                else {
                                    vErrors.push(err39);
                                }
                                errors++;
                            }
                            if (data11.accountId === undefined) {
                                const err40 = { instancePath: instancePath + "/data/members/" + i0, schemaPath: "#/properties/data/properties/members/items/required", keyword: "required", params: { missingProperty: "accountId" }, message: "must have required property '" + "accountId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err40];
                                }
                                else {
                                    vErrors.push(err40);
                                }
                                errors++;
                            }
                            if (data11.revision === undefined) {
                                const err41 = { instancePath: instancePath + "/data/members/" + i0, schemaPath: "#/properties/data/properties/members/items/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property '" + "revision" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err41];
                                }
                                else {
                                    vErrors.push(err41);
                                }
                                errors++;
                            }
                            if (data11.state === undefined) {
                                const err42 = { instancePath: instancePath + "/data/members/" + i0, schemaPath: "#/properties/data/properties/members/items/required", keyword: "required", params: { missingProperty: "state" }, message: "must have required property '" + "state" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err42];
                                }
                                else {
                                    vErrors.push(err42);
                                }
                                errors++;
                            }
                            for (const key3 in data11) {
                                if (!((((((((key3 === "entryId") || (key3 === "ordinal")) || (key3 === "dueDate")) || (key3 === "signedMinor")) || (key3 === "currency")) || (key3 === "accountId")) || (key3 === "revision")) || (key3 === "state"))) {
                                    const err43 = { instancePath: instancePath + "/data/members/" + i0, schemaPath: "#/properties/data/properties/members/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                                    if (vErrors === null) {
                                        vErrors = [err43];
                                    }
                                    else {
                                        vErrors.push(err43);
                                    }
                                    errors++;
                                }
                            }
                            if (data11.entryId !== undefined) {
                                let data12 = data11.entryId;
                                if (typeof data12 === "string") {
                                    if (!pattern0.test(data12)) {
                                        const err44 = { instancePath: instancePath + "/data/members/" + i0 + "/entryId", schemaPath: "#/properties/data/properties/members/items/properties/entryId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err44];
                                        }
                                        else {
                                            vErrors.push(err44);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err45 = { instancePath: instancePath + "/data/members/" + i0 + "/entryId", schemaPath: "#/properties/data/properties/members/items/properties/entryId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err45];
                                    }
                                    else {
                                        vErrors.push(err45);
                                    }
                                    errors++;
                                }
                            }
                            if (data11.ordinal !== undefined) {
                                let data13 = data11.ordinal;
                                if (!(((typeof data13 == "number") && (!(data13 % 1) && !isNaN(data13))) && (isFinite(data13)))) {
                                    const err46 = { instancePath: instancePath + "/data/members/" + i0 + "/ordinal", schemaPath: "#/properties/data/properties/members/items/properties/ordinal/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                    if (vErrors === null) {
                                        vErrors = [err46];
                                    }
                                    else {
                                        vErrors.push(err46);
                                    }
                                    errors++;
                                }
                                if ((typeof data13 == "number") && (isFinite(data13))) {
                                    if (data13 > 120 || isNaN(data13)) {
                                        const err47 = { instancePath: instancePath + "/data/members/" + i0 + "/ordinal", schemaPath: "#/properties/data/properties/members/items/properties/ordinal/maximum", keyword: "maximum", params: { comparison: "<=", limit: 120 }, message: "must be <= 120" };
                                        if (vErrors === null) {
                                            vErrors = [err47];
                                        }
                                        else {
                                            vErrors.push(err47);
                                        }
                                        errors++;
                                    }
                                    if (data13 < 1 || isNaN(data13)) {
                                        const err48 = { instancePath: instancePath + "/data/members/" + i0 + "/ordinal", schemaPath: "#/properties/data/properties/members/items/properties/ordinal/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                                        if (vErrors === null) {
                                            vErrors = [err48];
                                        }
                                        else {
                                            vErrors.push(err48);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data11.dueDate !== undefined) {
                                let data14 = data11.dueDate;
                                if (typeof data14 === "string") {
                                    if (!pattern4.test(data14)) {
                                        const err49 = { instancePath: instancePath + "/data/members/" + i0 + "/dueDate", schemaPath: "#/properties/data/properties/members/items/properties/dueDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err49];
                                        }
                                        else {
                                            vErrors.push(err49);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err50 = { instancePath: instancePath + "/data/members/" + i0 + "/dueDate", schemaPath: "#/properties/data/properties/members/items/properties/dueDate/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err50];
                                    }
                                    else {
                                        vErrors.push(err50);
                                    }
                                    errors++;
                                }
                            }
                            if (data11.signedMinor !== undefined) {
                                let data15 = data11.signedMinor;
                                if (typeof data15 === "string") {
                                    if (!pattern3.test(data15)) {
                                        const err51 = { instancePath: instancePath + "/data/members/" + i0 + "/signedMinor", schemaPath: "#/properties/data/properties/members/items/properties/signedMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err51];
                                        }
                                        else {
                                            vErrors.push(err51);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err52 = { instancePath: instancePath + "/data/members/" + i0 + "/signedMinor", schemaPath: "#/properties/data/properties/members/items/properties/signedMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err52];
                                    }
                                    else {
                                        vErrors.push(err52);
                                    }
                                    errors++;
                                }
                            }
                            if (data11.currency !== undefined) {
                                let data16 = data11.currency;
                                if (typeof data16 !== "string") {
                                    const err53 = { instancePath: instancePath + "/data/members/" + i0 + "/currency", schemaPath: "#/properties/data/properties/members/items/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err53];
                                    }
                                    else {
                                        vErrors.push(err53);
                                    }
                                    errors++;
                                }
                                if (!(((data16 === "BRL") || (data16 === "CAD")) || (data16 === "USD"))) {
                                    const err54 = { instancePath: instancePath + "/data/members/" + i0 + "/currency", schemaPath: "#/properties/data/properties/members/items/properties/currency/enum", keyword: "enum", params: { allowedValues: schema18.properties.data.properties.members.items.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err54];
                                    }
                                    else {
                                        vErrors.push(err54);
                                    }
                                    errors++;
                                }
                            }
                            if (data11.accountId !== undefined) {
                                let data17 = data11.accountId;
                                if (typeof data17 === "string") {
                                    if (!pattern0.test(data17)) {
                                        const err55 = { instancePath: instancePath + "/data/members/" + i0 + "/accountId", schemaPath: "#/properties/data/properties/members/items/properties/accountId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err55];
                                        }
                                        else {
                                            vErrors.push(err55);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err56 = { instancePath: instancePath + "/data/members/" + i0 + "/accountId", schemaPath: "#/properties/data/properties/members/items/properties/accountId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err56];
                                    }
                                    else {
                                        vErrors.push(err56);
                                    }
                                    errors++;
                                }
                            }
                            if (data11.revision !== undefined) {
                                let data18 = data11.revision;
                                if (typeof data18 === "string") {
                                    if (!pattern2.test(data18)) {
                                        const err57 = { instancePath: instancePath + "/data/members/" + i0 + "/revision", schemaPath: "#/properties/data/properties/members/items/properties/revision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err57];
                                        }
                                        else {
                                            vErrors.push(err57);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err58 = { instancePath: instancePath + "/data/members/" + i0 + "/revision", schemaPath: "#/properties/data/properties/members/items/properties/revision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err58];
                                    }
                                    else {
                                        vErrors.push(err58);
                                    }
                                    errors++;
                                }
                            }
                            if (data11.state !== undefined) {
                                let data19 = data11.state;
                                if (typeof data19 !== "string") {
                                    const err59 = { instancePath: instancePath + "/data/members/" + i0 + "/state", schemaPath: "#/properties/data/properties/members/items/properties/state/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err59];
                                    }
                                    else {
                                        vErrors.push(err59);
                                    }
                                    errors++;
                                }
                                if (!(((((data19 === "pending") || (data19 === "future")) || (data19 === "paid")) || (data19 === "effective")) || (data19 === "deleted"))) {
                                    const err60 = { instancePath: instancePath + "/data/members/" + i0 + "/state", schemaPath: "#/properties/data/properties/members/items/properties/state/enum", keyword: "enum", params: { allowedValues: schema18.properties.data.properties.members.items.properties.state.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err60];
                                    }
                                    else {
                                        vErrors.push(err60);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err61 = { instancePath: instancePath + "/data/members/" + i0, schemaPath: "#/properties/data/properties/members/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                                vErrors = [err61];
                            }
                            else {
                                vErrors.push(err61);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err62 = { instancePath: instancePath + "/data/members", schemaPath: "#/properties/data/properties/members/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err62];
                    }
                    else {
                        vErrors.push(err62);
                    }
                    errors++;
                }
            }
        }
        else {
            const err63 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err63];
            }
            else {
                vErrors.push(err63);
            }
            errors++;
        }
    }
    if (data.meta !== undefined) {
        let data20 = data.meta;
        if (data20 && typeof data20 == "object" && !Array.isArray(data20)) {
            if (data20.requestId === undefined) {
                const err64 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "requestId" }, message: "must have required property '" + "requestId" + "'" };
                if (vErrors === null) {
                    vErrors = [err64];
                }
                else {
                    vErrors.push(err64);
                }
                errors++;
            }
            if (data20.asOf === undefined) {
                const err65 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "asOf" }, message: "must have required property '" + "asOf" + "'" };
                if (vErrors === null) {
                    vErrors = [err65];
                }
                else {
                    vErrors.push(err65);
                }
                errors++;
            }
            if (data20.businessToday === undefined) {
                const err66 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err66];
                }
                else {
                    vErrors.push(err66);
                }
                errors++;
            }
            if (data20.timeZone === undefined) {
                const err67 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "timeZone" }, message: "must have required property '" + "timeZone" + "'" };
                if (vErrors === null) {
                    vErrors = [err67];
                }
                else {
                    vErrors.push(err67);
                }
                errors++;
            }
            if (data20.dataRevision === undefined) {
                const err68 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "dataRevision" }, message: "must have required property '" + "dataRevision" + "'" };
                if (vErrors === null) {
                    vErrors = [err68];
                }
                else {
                    vErrors.push(err68);
                }
                errors++;
            }
            for (const key4 in data20) {
                if (!(((((key4 === "requestId") || (key4 === "asOf")) || (key4 === "businessToday")) || (key4 === "timeZone")) || (key4 === "dataRevision"))) {
                    const err69 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key4 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err69];
                    }
                    else {
                        vErrors.push(err69);
                    }
                    errors++;
                }
            }
            if (data20.requestId !== undefined) {
                let data21 = data20.requestId;
                if (typeof data21 === "string") {
                    if (func2(data21) > 64) {
                        const err70 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err70];
                        }
                        else {
                            vErrors.push(err70);
                        }
                        errors++;
                    }
                    if (func2(data21) < 1) {
                        const err71 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err71];
                        }
                        else {
                            vErrors.push(err71);
                        }
                        errors++;
                    }
                }
                else {
                    const err72 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err72];
                    }
                    else {
                        vErrors.push(err72);
                    }
                    errors++;
                }
            }
            if (data20.asOf !== undefined) {
                let data22 = data20.asOf;
                if (typeof data22 === "string") {
                    if (func2(data22) > 64) {
                        const err73 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err73];
                        }
                        else {
                            vErrors.push(err73);
                        }
                        errors++;
                    }
                    if (func2(data22) < 1) {
                        const err74 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err74];
                        }
                        else {
                            vErrors.push(err74);
                        }
                        errors++;
                    }
                }
                else {
                    const err75 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err75];
                    }
                    else {
                        vErrors.push(err75);
                    }
                    errors++;
                }
            }
            if (data20.businessToday !== undefined) {
                let data23 = data20.businessToday;
                if (typeof data23 === "string") {
                    if (!pattern4.test(data23)) {
                        const err76 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err76];
                        }
                        else {
                            vErrors.push(err76);
                        }
                        errors++;
                    }
                }
                else {
                    const err77 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err77];
                    }
                    else {
                        vErrors.push(err77);
                    }
                    errors++;
                }
            }
            if (data20.timeZone !== undefined) {
                let data24 = data20.timeZone;
                if (typeof data24 === "string") {
                    if (func2(data24) > 64) {
                        const err78 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err78];
                        }
                        else {
                            vErrors.push(err78);
                        }
                        errors++;
                    }
                    if (func2(data24) < 1) {
                        const err79 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err79];
                        }
                        else {
                            vErrors.push(err79);
                        }
                        errors++;
                    }
                }
                else {
                    const err80 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err80];
                    }
                    else {
                        vErrors.push(err80);
                    }
                    errors++;
                }
            }
            if (data20.dataRevision !== undefined) {
                let data25 = data20.dataRevision;
                if (typeof data25 === "string") {
                    if (!pattern2.test(data25)) {
                        const err81 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err81];
                        }
                        else {
                            vErrors.push(err81);
                        }
                        errors++;
                    }
                }
                else {
                    const err82 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err82];
                    }
                    else {
                        vErrors.push(err82);
                    }
                    errors++;
                }
            }
        }
        else {
            const err83 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err83];
            }
            else {
                vErrors.push(err83);
            }
            errors++;
        }
    }
}
else {
    const err84 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
        vErrors = [err84];
    }
    else {
        vErrors.push(err84);
    }
    errors++;
} validate17.errors = vErrors; return errors === 0; }
export const validateLedgerMutationPreviewEnvelope = validate18;
const schema19 = { "$id": "https://saldo.local/schemas/ledger-mutation-preview-envelope.json", "$schema": "http://json-schema.org/draft-07/schema#", "title": "LedgerMutationPreviewEnvelope", "type": "object", "additionalProperties": false, "required": ["data", "meta"], "properties": { "data": { "type": "object", "additionalProperties": false, "required": ["id", "action", "groupId", "revision", "businessToday", "expiresAt", "scheduledCount", "activeCount", "total", "members", "affectedEntryIds", "excluded"], "properties": { "id": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "action": { "type": "string", "enum": ["installments.create", "installments.edit", "installments.delete"] }, "groupId": { "type": ["string", "null"], "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "revision": { "type": ["string", "null"], "pattern": "^[1-9][0-9]*$" }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "expiresAt": { "type": "string", "minLength": 1, "maxLength": 64 }, "scheduledCount": { "type": "integer", "minimum": 0, "maximum": 120 }, "activeCount": { "type": "integer", "minimum": 0, "maximum": 120 }, "total": { "type": "object", "additionalProperties": false, "required": ["currency", "minorUnits"], "properties": { "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "minorUnits": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" } } }, "members": { "type": "array", "maxItems": 120, "items": { "type": "object", "additionalProperties": false, "required": ["ordinal", "dueDate", "signedMinor", "currency", "accountId"], "properties": { "ordinal": { "type": "integer", "minimum": 1, "maximum": 120 }, "dueDate": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "signedMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "accountId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "entryId": { "type": ["string", "null"], "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } } } }, "affectedEntryIds": { "type": "array", "maxItems": 120, "items": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } }, "excluded": { "type": "array", "maxItems": 120, "items": { "type": "object", "additionalProperties": false, "required": ["entryId", "reason"], "properties": { "entryId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "reason": { "type": "string", "enum": ["earlier", "paid-cash", "card-effective", "already-deleted"] } } } } } }, "meta": { "type": "object", "additionalProperties": false, "required": ["requestId", "asOf", "businessToday", "timeZone", "dataRevision"], "properties": { "requestId": { "type": "string", "minLength": 1, "maxLength": 64 }, "asOf": { "type": "string", "minLength": 1, "maxLength": 64 }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "timeZone": { "type": "string", "minLength": 1, "maxLength": 64 }, "dataRevision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } } } };
function validate18(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="https://saldo.local/schemas/ledger-mutation-preview-envelope.json" */ ; let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.data === undefined) {
        const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property '" + "data" + "'" };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
    }
    if (data.meta === undefined) {
        const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "meta" }, message: "must have required property '" + "meta" + "'" };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    for (const key0 in data) {
        if (!((key0 === "data") || (key0 === "meta"))) {
            const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.data !== undefined) {
        let data0 = data.data;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.id === undefined) {
                const err3 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property '" + "id" + "'" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
            if (data0.action === undefined) {
                const err4 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "action" }, message: "must have required property '" + "action" + "'" };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
            if (data0.groupId === undefined) {
                const err5 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "groupId" }, message: "must have required property '" + "groupId" + "'" };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
            }
            if (data0.revision === undefined) {
                const err6 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property '" + "revision" + "'" };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
            }
            if (data0.businessToday === undefined) {
                const err7 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err7];
                }
                else {
                    vErrors.push(err7);
                }
                errors++;
            }
            if (data0.expiresAt === undefined) {
                const err8 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "expiresAt" }, message: "must have required property '" + "expiresAt" + "'" };
                if (vErrors === null) {
                    vErrors = [err8];
                }
                else {
                    vErrors.push(err8);
                }
                errors++;
            }
            if (data0.scheduledCount === undefined) {
                const err9 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "scheduledCount" }, message: "must have required property '" + "scheduledCount" + "'" };
                if (vErrors === null) {
                    vErrors = [err9];
                }
                else {
                    vErrors.push(err9);
                }
                errors++;
            }
            if (data0.activeCount === undefined) {
                const err10 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "activeCount" }, message: "must have required property '" + "activeCount" + "'" };
                if (vErrors === null) {
                    vErrors = [err10];
                }
                else {
                    vErrors.push(err10);
                }
                errors++;
            }
            if (data0.total === undefined) {
                const err11 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "total" }, message: "must have required property '" + "total" + "'" };
                if (vErrors === null) {
                    vErrors = [err11];
                }
                else {
                    vErrors.push(err11);
                }
                errors++;
            }
            if (data0.members === undefined) {
                const err12 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "members" }, message: "must have required property '" + "members" + "'" };
                if (vErrors === null) {
                    vErrors = [err12];
                }
                else {
                    vErrors.push(err12);
                }
                errors++;
            }
            if (data0.affectedEntryIds === undefined) {
                const err13 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "affectedEntryIds" }, message: "must have required property '" + "affectedEntryIds" + "'" };
                if (vErrors === null) {
                    vErrors = [err13];
                }
                else {
                    vErrors.push(err13);
                }
                errors++;
            }
            if (data0.excluded === undefined) {
                const err14 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "excluded" }, message: "must have required property '" + "excluded" + "'" };
                if (vErrors === null) {
                    vErrors = [err14];
                }
                else {
                    vErrors.push(err14);
                }
                errors++;
            }
            for (const key1 in data0) {
                if (!(func35.call(schema19.properties.data.properties, key1))) {
                    const err15 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err15];
                    }
                    else {
                        vErrors.push(err15);
                    }
                    errors++;
                }
            }
            if (data0.id !== undefined) {
                let data1 = data0.id;
                if (typeof data1 === "string") {
                    if (!pattern0.test(data1)) {
                        const err16 = { instancePath: instancePath + "/data/id", schemaPath: "#/properties/data/properties/id/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err16];
                        }
                        else {
                            vErrors.push(err16);
                        }
                        errors++;
                    }
                }
                else {
                    const err17 = { instancePath: instancePath + "/data/id", schemaPath: "#/properties/data/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err17];
                    }
                    else {
                        vErrors.push(err17);
                    }
                    errors++;
                }
            }
            if (data0.action !== undefined) {
                let data2 = data0.action;
                if (typeof data2 !== "string") {
                    const err18 = { instancePath: instancePath + "/data/action", schemaPath: "#/properties/data/properties/action/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err18];
                    }
                    else {
                        vErrors.push(err18);
                    }
                    errors++;
                }
                if (!(((data2 === "installments.create") || (data2 === "installments.edit")) || (data2 === "installments.delete"))) {
                    const err19 = { instancePath: instancePath + "/data/action", schemaPath: "#/properties/data/properties/action/enum", keyword: "enum", params: { allowedValues: schema19.properties.data.properties.action.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err19];
                    }
                    else {
                        vErrors.push(err19);
                    }
                    errors++;
                }
            }
            if (data0.groupId !== undefined) {
                let data3 = data0.groupId;
                if ((typeof data3 !== "string") && (data3 !== null)) {
                    const err20 = { instancePath: instancePath + "/data/groupId", schemaPath: "#/properties/data/properties/groupId/type", keyword: "type", params: { type: schema19.properties.data.properties.groupId.type }, message: "must be string,null" };
                    if (vErrors === null) {
                        vErrors = [err20];
                    }
                    else {
                        vErrors.push(err20);
                    }
                    errors++;
                }
                if (typeof data3 === "string") {
                    if (!pattern0.test(data3)) {
                        const err21 = { instancePath: instancePath + "/data/groupId", schemaPath: "#/properties/data/properties/groupId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err21];
                        }
                        else {
                            vErrors.push(err21);
                        }
                        errors++;
                    }
                }
            }
            if (data0.revision !== undefined) {
                let data4 = data0.revision;
                if ((typeof data4 !== "string") && (data4 !== null)) {
                    const err22 = { instancePath: instancePath + "/data/revision", schemaPath: "#/properties/data/properties/revision/type", keyword: "type", params: { type: schema19.properties.data.properties.revision.type }, message: "must be string,null" };
                    if (vErrors === null) {
                        vErrors = [err22];
                    }
                    else {
                        vErrors.push(err22);
                    }
                    errors++;
                }
                if (typeof data4 === "string") {
                    if (!pattern2.test(data4)) {
                        const err23 = { instancePath: instancePath + "/data/revision", schemaPath: "#/properties/data/properties/revision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err23];
                        }
                        else {
                            vErrors.push(err23);
                        }
                        errors++;
                    }
                }
            }
            if (data0.businessToday !== undefined) {
                let data5 = data0.businessToday;
                if (typeof data5 === "string") {
                    if (!pattern4.test(data5)) {
                        const err24 = { instancePath: instancePath + "/data/businessToday", schemaPath: "#/properties/data/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err24];
                        }
                        else {
                            vErrors.push(err24);
                        }
                        errors++;
                    }
                }
                else {
                    const err25 = { instancePath: instancePath + "/data/businessToday", schemaPath: "#/properties/data/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err25];
                    }
                    else {
                        vErrors.push(err25);
                    }
                    errors++;
                }
            }
            if (data0.expiresAt !== undefined) {
                let data6 = data0.expiresAt;
                if (typeof data6 === "string") {
                    if (func2(data6) > 64) {
                        const err26 = { instancePath: instancePath + "/data/expiresAt", schemaPath: "#/properties/data/properties/expiresAt/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err26];
                        }
                        else {
                            vErrors.push(err26);
                        }
                        errors++;
                    }
                    if (func2(data6) < 1) {
                        const err27 = { instancePath: instancePath + "/data/expiresAt", schemaPath: "#/properties/data/properties/expiresAt/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err27];
                        }
                        else {
                            vErrors.push(err27);
                        }
                        errors++;
                    }
                }
                else {
                    const err28 = { instancePath: instancePath + "/data/expiresAt", schemaPath: "#/properties/data/properties/expiresAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err28];
                    }
                    else {
                        vErrors.push(err28);
                    }
                    errors++;
                }
            }
            if (data0.scheduledCount !== undefined) {
                let data7 = data0.scheduledCount;
                if (!(((typeof data7 == "number") && (!(data7 % 1) && !isNaN(data7))) && (isFinite(data7)))) {
                    const err29 = { instancePath: instancePath + "/data/scheduledCount", schemaPath: "#/properties/data/properties/scheduledCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                        vErrors = [err29];
                    }
                    else {
                        vErrors.push(err29);
                    }
                    errors++;
                }
                if ((typeof data7 == "number") && (isFinite(data7))) {
                    if (data7 > 120 || isNaN(data7)) {
                        const err30 = { instancePath: instancePath + "/data/scheduledCount", schemaPath: "#/properties/data/properties/scheduledCount/maximum", keyword: "maximum", params: { comparison: "<=", limit: 120 }, message: "must be <= 120" };
                        if (vErrors === null) {
                            vErrors = [err30];
                        }
                        else {
                            vErrors.push(err30);
                        }
                        errors++;
                    }
                    if (data7 < 0 || isNaN(data7)) {
                        const err31 = { instancePath: instancePath + "/data/scheduledCount", schemaPath: "#/properties/data/properties/scheduledCount/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                        if (vErrors === null) {
                            vErrors = [err31];
                        }
                        else {
                            vErrors.push(err31);
                        }
                        errors++;
                    }
                }
            }
            if (data0.activeCount !== undefined) {
                let data8 = data0.activeCount;
                if (!(((typeof data8 == "number") && (!(data8 % 1) && !isNaN(data8))) && (isFinite(data8)))) {
                    const err32 = { instancePath: instancePath + "/data/activeCount", schemaPath: "#/properties/data/properties/activeCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                        vErrors = [err32];
                    }
                    else {
                        vErrors.push(err32);
                    }
                    errors++;
                }
                if ((typeof data8 == "number") && (isFinite(data8))) {
                    if (data8 > 120 || isNaN(data8)) {
                        const err33 = { instancePath: instancePath + "/data/activeCount", schemaPath: "#/properties/data/properties/activeCount/maximum", keyword: "maximum", params: { comparison: "<=", limit: 120 }, message: "must be <= 120" };
                        if (vErrors === null) {
                            vErrors = [err33];
                        }
                        else {
                            vErrors.push(err33);
                        }
                        errors++;
                    }
                    if (data8 < 0 || isNaN(data8)) {
                        const err34 = { instancePath: instancePath + "/data/activeCount", schemaPath: "#/properties/data/properties/activeCount/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                        if (vErrors === null) {
                            vErrors = [err34];
                        }
                        else {
                            vErrors.push(err34);
                        }
                        errors++;
                    }
                }
            }
            if (data0.total !== undefined) {
                let data9 = data0.total;
                if (data9 && typeof data9 == "object" && !Array.isArray(data9)) {
                    if (data9.currency === undefined) {
                        const err35 = { instancePath: instancePath + "/data/total", schemaPath: "#/properties/data/properties/total/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                        if (vErrors === null) {
                            vErrors = [err35];
                        }
                        else {
                            vErrors.push(err35);
                        }
                        errors++;
                    }
                    if (data9.minorUnits === undefined) {
                        const err36 = { instancePath: instancePath + "/data/total", schemaPath: "#/properties/data/properties/total/required", keyword: "required", params: { missingProperty: "minorUnits" }, message: "must have required property '" + "minorUnits" + "'" };
                        if (vErrors === null) {
                            vErrors = [err36];
                        }
                        else {
                            vErrors.push(err36);
                        }
                        errors++;
                    }
                    for (const key2 in data9) {
                        if (!((key2 === "currency") || (key2 === "minorUnits"))) {
                            const err37 = { instancePath: instancePath + "/data/total", schemaPath: "#/properties/data/properties/total/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                                vErrors = [err37];
                            }
                            else {
                                vErrors.push(err37);
                            }
                            errors++;
                        }
                    }
                    if (data9.currency !== undefined) {
                        let data10 = data9.currency;
                        if (typeof data10 !== "string") {
                            const err38 = { instancePath: instancePath + "/data/total/currency", schemaPath: "#/properties/data/properties/total/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err38];
                            }
                            else {
                                vErrors.push(err38);
                            }
                            errors++;
                        }
                        if (!(((data10 === "BRL") || (data10 === "CAD")) || (data10 === "USD"))) {
                            const err39 = { instancePath: instancePath + "/data/total/currency", schemaPath: "#/properties/data/properties/total/properties/currency/enum", keyword: "enum", params: { allowedValues: schema19.properties.data.properties.total.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                                vErrors = [err39];
                            }
                            else {
                                vErrors.push(err39);
                            }
                            errors++;
                        }
                    }
                    if (data9.minorUnits !== undefined) {
                        let data11 = data9.minorUnits;
                        if (typeof data11 === "string") {
                            if (!pattern3.test(data11)) {
                                const err40 = { instancePath: instancePath + "/data/total/minorUnits", schemaPath: "#/properties/data/properties/total/properties/minorUnits/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err40];
                                }
                                else {
                                    vErrors.push(err40);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err41 = { instancePath: instancePath + "/data/total/minorUnits", schemaPath: "#/properties/data/properties/total/properties/minorUnits/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err41];
                            }
                            else {
                                vErrors.push(err41);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err42 = { instancePath: instancePath + "/data/total", schemaPath: "#/properties/data/properties/total/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                        vErrors = [err42];
                    }
                    else {
                        vErrors.push(err42);
                    }
                    errors++;
                }
            }
            if (data0.members !== undefined) {
                let data12 = data0.members;
                if (Array.isArray(data12)) {
                    if (data12.length > 120) {
                        const err43 = { instancePath: instancePath + "/data/members", schemaPath: "#/properties/data/properties/members/maxItems", keyword: "maxItems", params: { limit: 120 }, message: "must NOT have more than 120 items" };
                        if (vErrors === null) {
                            vErrors = [err43];
                        }
                        else {
                            vErrors.push(err43);
                        }
                        errors++;
                    }
                    const len0 = data12.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                        let data13 = data12[i0];
                        if (data13 && typeof data13 == "object" && !Array.isArray(data13)) {
                            if (data13.ordinal === undefined) {
                                const err44 = { instancePath: instancePath + "/data/members/" + i0, schemaPath: "#/properties/data/properties/members/items/required", keyword: "required", params: { missingProperty: "ordinal" }, message: "must have required property '" + "ordinal" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err44];
                                }
                                else {
                                    vErrors.push(err44);
                                }
                                errors++;
                            }
                            if (data13.dueDate === undefined) {
                                const err45 = { instancePath: instancePath + "/data/members/" + i0, schemaPath: "#/properties/data/properties/members/items/required", keyword: "required", params: { missingProperty: "dueDate" }, message: "must have required property '" + "dueDate" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err45];
                                }
                                else {
                                    vErrors.push(err45);
                                }
                                errors++;
                            }
                            if (data13.signedMinor === undefined) {
                                const err46 = { instancePath: instancePath + "/data/members/" + i0, schemaPath: "#/properties/data/properties/members/items/required", keyword: "required", params: { missingProperty: "signedMinor" }, message: "must have required property '" + "signedMinor" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err46];
                                }
                                else {
                                    vErrors.push(err46);
                                }
                                errors++;
                            }
                            if (data13.currency === undefined) {
                                const err47 = { instancePath: instancePath + "/data/members/" + i0, schemaPath: "#/properties/data/properties/members/items/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err47];
                                }
                                else {
                                    vErrors.push(err47);
                                }
                                errors++;
                            }
                            if (data13.accountId === undefined) {
                                const err48 = { instancePath: instancePath + "/data/members/" + i0, schemaPath: "#/properties/data/properties/members/items/required", keyword: "required", params: { missingProperty: "accountId" }, message: "must have required property '" + "accountId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err48];
                                }
                                else {
                                    vErrors.push(err48);
                                }
                                errors++;
                            }
                            for (const key3 in data13) {
                                if (!((((((key3 === "ordinal") || (key3 === "dueDate")) || (key3 === "signedMinor")) || (key3 === "currency")) || (key3 === "accountId")) || (key3 === "entryId"))) {
                                    const err49 = { instancePath: instancePath + "/data/members/" + i0, schemaPath: "#/properties/data/properties/members/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                                    if (vErrors === null) {
                                        vErrors = [err49];
                                    }
                                    else {
                                        vErrors.push(err49);
                                    }
                                    errors++;
                                }
                            }
                            if (data13.ordinal !== undefined) {
                                let data14 = data13.ordinal;
                                if (!(((typeof data14 == "number") && (!(data14 % 1) && !isNaN(data14))) && (isFinite(data14)))) {
                                    const err50 = { instancePath: instancePath + "/data/members/" + i0 + "/ordinal", schemaPath: "#/properties/data/properties/members/items/properties/ordinal/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                    if (vErrors === null) {
                                        vErrors = [err50];
                                    }
                                    else {
                                        vErrors.push(err50);
                                    }
                                    errors++;
                                }
                                if ((typeof data14 == "number") && (isFinite(data14))) {
                                    if (data14 > 120 || isNaN(data14)) {
                                        const err51 = { instancePath: instancePath + "/data/members/" + i0 + "/ordinal", schemaPath: "#/properties/data/properties/members/items/properties/ordinal/maximum", keyword: "maximum", params: { comparison: "<=", limit: 120 }, message: "must be <= 120" };
                                        if (vErrors === null) {
                                            vErrors = [err51];
                                        }
                                        else {
                                            vErrors.push(err51);
                                        }
                                        errors++;
                                    }
                                    if (data14 < 1 || isNaN(data14)) {
                                        const err52 = { instancePath: instancePath + "/data/members/" + i0 + "/ordinal", schemaPath: "#/properties/data/properties/members/items/properties/ordinal/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                                        if (vErrors === null) {
                                            vErrors = [err52];
                                        }
                                        else {
                                            vErrors.push(err52);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data13.dueDate !== undefined) {
                                let data15 = data13.dueDate;
                                if (typeof data15 === "string") {
                                    if (!pattern4.test(data15)) {
                                        const err53 = { instancePath: instancePath + "/data/members/" + i0 + "/dueDate", schemaPath: "#/properties/data/properties/members/items/properties/dueDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err53];
                                        }
                                        else {
                                            vErrors.push(err53);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err54 = { instancePath: instancePath + "/data/members/" + i0 + "/dueDate", schemaPath: "#/properties/data/properties/members/items/properties/dueDate/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err54];
                                    }
                                    else {
                                        vErrors.push(err54);
                                    }
                                    errors++;
                                }
                            }
                            if (data13.signedMinor !== undefined) {
                                let data16 = data13.signedMinor;
                                if (typeof data16 === "string") {
                                    if (!pattern3.test(data16)) {
                                        const err55 = { instancePath: instancePath + "/data/members/" + i0 + "/signedMinor", schemaPath: "#/properties/data/properties/members/items/properties/signedMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err55];
                                        }
                                        else {
                                            vErrors.push(err55);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err56 = { instancePath: instancePath + "/data/members/" + i0 + "/signedMinor", schemaPath: "#/properties/data/properties/members/items/properties/signedMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err56];
                                    }
                                    else {
                                        vErrors.push(err56);
                                    }
                                    errors++;
                                }
                            }
                            if (data13.currency !== undefined) {
                                let data17 = data13.currency;
                                if (typeof data17 !== "string") {
                                    const err57 = { instancePath: instancePath + "/data/members/" + i0 + "/currency", schemaPath: "#/properties/data/properties/members/items/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err57];
                                    }
                                    else {
                                        vErrors.push(err57);
                                    }
                                    errors++;
                                }
                                if (!(((data17 === "BRL") || (data17 === "CAD")) || (data17 === "USD"))) {
                                    const err58 = { instancePath: instancePath + "/data/members/" + i0 + "/currency", schemaPath: "#/properties/data/properties/members/items/properties/currency/enum", keyword: "enum", params: { allowedValues: schema19.properties.data.properties.members.items.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err58];
                                    }
                                    else {
                                        vErrors.push(err58);
                                    }
                                    errors++;
                                }
                            }
                            if (data13.accountId !== undefined) {
                                let data18 = data13.accountId;
                                if (typeof data18 === "string") {
                                    if (!pattern0.test(data18)) {
                                        const err59 = { instancePath: instancePath + "/data/members/" + i0 + "/accountId", schemaPath: "#/properties/data/properties/members/items/properties/accountId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err59];
                                        }
                                        else {
                                            vErrors.push(err59);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err60 = { instancePath: instancePath + "/data/members/" + i0 + "/accountId", schemaPath: "#/properties/data/properties/members/items/properties/accountId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err60];
                                    }
                                    else {
                                        vErrors.push(err60);
                                    }
                                    errors++;
                                }
                            }
                            if (data13.entryId !== undefined) {
                                let data19 = data13.entryId;
                                if ((typeof data19 !== "string") && (data19 !== null)) {
                                    const err61 = { instancePath: instancePath + "/data/members/" + i0 + "/entryId", schemaPath: "#/properties/data/properties/members/items/properties/entryId/type", keyword: "type", params: { type: schema19.properties.data.properties.members.items.properties.entryId.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err61];
                                    }
                                    else {
                                        vErrors.push(err61);
                                    }
                                    errors++;
                                }
                                if (typeof data19 === "string") {
                                    if (!pattern0.test(data19)) {
                                        const err62 = { instancePath: instancePath + "/data/members/" + i0 + "/entryId", schemaPath: "#/properties/data/properties/members/items/properties/entryId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err62];
                                        }
                                        else {
                                            vErrors.push(err62);
                                        }
                                        errors++;
                                    }
                                }
                            }
                        }
                        else {
                            const err63 = { instancePath: instancePath + "/data/members/" + i0, schemaPath: "#/properties/data/properties/members/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                                vErrors = [err63];
                            }
                            else {
                                vErrors.push(err63);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err64 = { instancePath: instancePath + "/data/members", schemaPath: "#/properties/data/properties/members/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err64];
                    }
                    else {
                        vErrors.push(err64);
                    }
                    errors++;
                }
            }
            if (data0.affectedEntryIds !== undefined) {
                let data20 = data0.affectedEntryIds;
                if (Array.isArray(data20)) {
                    if (data20.length > 120) {
                        const err65 = { instancePath: instancePath + "/data/affectedEntryIds", schemaPath: "#/properties/data/properties/affectedEntryIds/maxItems", keyword: "maxItems", params: { limit: 120 }, message: "must NOT have more than 120 items" };
                        if (vErrors === null) {
                            vErrors = [err65];
                        }
                        else {
                            vErrors.push(err65);
                        }
                        errors++;
                    }
                    const len1 = data20.length;
                    for (let i1 = 0; i1 < len1; i1++) {
                        let data21 = data20[i1];
                        if (typeof data21 === "string") {
                            if (!pattern0.test(data21)) {
                                const err66 = { instancePath: instancePath + "/data/affectedEntryIds/" + i1, schemaPath: "#/properties/data/properties/affectedEntryIds/items/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err66];
                                }
                                else {
                                    vErrors.push(err66);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err67 = { instancePath: instancePath + "/data/affectedEntryIds/" + i1, schemaPath: "#/properties/data/properties/affectedEntryIds/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err67];
                            }
                            else {
                                vErrors.push(err67);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err68 = { instancePath: instancePath + "/data/affectedEntryIds", schemaPath: "#/properties/data/properties/affectedEntryIds/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err68];
                    }
                    else {
                        vErrors.push(err68);
                    }
                    errors++;
                }
            }
            if (data0.excluded !== undefined) {
                let data22 = data0.excluded;
                if (Array.isArray(data22)) {
                    if (data22.length > 120) {
                        const err69 = { instancePath: instancePath + "/data/excluded", schemaPath: "#/properties/data/properties/excluded/maxItems", keyword: "maxItems", params: { limit: 120 }, message: "must NOT have more than 120 items" };
                        if (vErrors === null) {
                            vErrors = [err69];
                        }
                        else {
                            vErrors.push(err69);
                        }
                        errors++;
                    }
                    const len2 = data22.length;
                    for (let i2 = 0; i2 < len2; i2++) {
                        let data23 = data22[i2];
                        if (data23 && typeof data23 == "object" && !Array.isArray(data23)) {
                            if (data23.entryId === undefined) {
                                const err70 = { instancePath: instancePath + "/data/excluded/" + i2, schemaPath: "#/properties/data/properties/excluded/items/required", keyword: "required", params: { missingProperty: "entryId" }, message: "must have required property '" + "entryId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err70];
                                }
                                else {
                                    vErrors.push(err70);
                                }
                                errors++;
                            }
                            if (data23.reason === undefined) {
                                const err71 = { instancePath: instancePath + "/data/excluded/" + i2, schemaPath: "#/properties/data/properties/excluded/items/required", keyword: "required", params: { missingProperty: "reason" }, message: "must have required property '" + "reason" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err71];
                                }
                                else {
                                    vErrors.push(err71);
                                }
                                errors++;
                            }
                            for (const key4 in data23) {
                                if (!((key4 === "entryId") || (key4 === "reason"))) {
                                    const err72 = { instancePath: instancePath + "/data/excluded/" + i2, schemaPath: "#/properties/data/properties/excluded/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key4 }, message: "must NOT have additional properties" };
                                    if (vErrors === null) {
                                        vErrors = [err72];
                                    }
                                    else {
                                        vErrors.push(err72);
                                    }
                                    errors++;
                                }
                            }
                            if (data23.entryId !== undefined) {
                                let data24 = data23.entryId;
                                if (typeof data24 === "string") {
                                    if (!pattern0.test(data24)) {
                                        const err73 = { instancePath: instancePath + "/data/excluded/" + i2 + "/entryId", schemaPath: "#/properties/data/properties/excluded/items/properties/entryId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err73];
                                        }
                                        else {
                                            vErrors.push(err73);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err74 = { instancePath: instancePath + "/data/excluded/" + i2 + "/entryId", schemaPath: "#/properties/data/properties/excluded/items/properties/entryId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err74];
                                    }
                                    else {
                                        vErrors.push(err74);
                                    }
                                    errors++;
                                }
                            }
                            if (data23.reason !== undefined) {
                                let data25 = data23.reason;
                                if (typeof data25 !== "string") {
                                    const err75 = { instancePath: instancePath + "/data/excluded/" + i2 + "/reason", schemaPath: "#/properties/data/properties/excluded/items/properties/reason/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err75];
                                    }
                                    else {
                                        vErrors.push(err75);
                                    }
                                    errors++;
                                }
                                if (!((((data25 === "earlier") || (data25 === "paid-cash")) || (data25 === "card-effective")) || (data25 === "already-deleted"))) {
                                    const err76 = { instancePath: instancePath + "/data/excluded/" + i2 + "/reason", schemaPath: "#/properties/data/properties/excluded/items/properties/reason/enum", keyword: "enum", params: { allowedValues: schema19.properties.data.properties.excluded.items.properties.reason.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err76];
                                    }
                                    else {
                                        vErrors.push(err76);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err77 = { instancePath: instancePath + "/data/excluded/" + i2, schemaPath: "#/properties/data/properties/excluded/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                                vErrors = [err77];
                            }
                            else {
                                vErrors.push(err77);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err78 = { instancePath: instancePath + "/data/excluded", schemaPath: "#/properties/data/properties/excluded/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err78];
                    }
                    else {
                        vErrors.push(err78);
                    }
                    errors++;
                }
            }
        }
        else {
            const err79 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err79];
            }
            else {
                vErrors.push(err79);
            }
            errors++;
        }
    }
    if (data.meta !== undefined) {
        let data26 = data.meta;
        if (data26 && typeof data26 == "object" && !Array.isArray(data26)) {
            if (data26.requestId === undefined) {
                const err80 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "requestId" }, message: "must have required property '" + "requestId" + "'" };
                if (vErrors === null) {
                    vErrors = [err80];
                }
                else {
                    vErrors.push(err80);
                }
                errors++;
            }
            if (data26.asOf === undefined) {
                const err81 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "asOf" }, message: "must have required property '" + "asOf" + "'" };
                if (vErrors === null) {
                    vErrors = [err81];
                }
                else {
                    vErrors.push(err81);
                }
                errors++;
            }
            if (data26.businessToday === undefined) {
                const err82 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err82];
                }
                else {
                    vErrors.push(err82);
                }
                errors++;
            }
            if (data26.timeZone === undefined) {
                const err83 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "timeZone" }, message: "must have required property '" + "timeZone" + "'" };
                if (vErrors === null) {
                    vErrors = [err83];
                }
                else {
                    vErrors.push(err83);
                }
                errors++;
            }
            if (data26.dataRevision === undefined) {
                const err84 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "dataRevision" }, message: "must have required property '" + "dataRevision" + "'" };
                if (vErrors === null) {
                    vErrors = [err84];
                }
                else {
                    vErrors.push(err84);
                }
                errors++;
            }
            for (const key5 in data26) {
                if (!(((((key5 === "requestId") || (key5 === "asOf")) || (key5 === "businessToday")) || (key5 === "timeZone")) || (key5 === "dataRevision"))) {
                    const err85 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key5 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err85];
                    }
                    else {
                        vErrors.push(err85);
                    }
                    errors++;
                }
            }
            if (data26.requestId !== undefined) {
                let data27 = data26.requestId;
                if (typeof data27 === "string") {
                    if (func2(data27) > 64) {
                        const err86 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err86];
                        }
                        else {
                            vErrors.push(err86);
                        }
                        errors++;
                    }
                    if (func2(data27) < 1) {
                        const err87 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err87];
                        }
                        else {
                            vErrors.push(err87);
                        }
                        errors++;
                    }
                }
                else {
                    const err88 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err88];
                    }
                    else {
                        vErrors.push(err88);
                    }
                    errors++;
                }
            }
            if (data26.asOf !== undefined) {
                let data28 = data26.asOf;
                if (typeof data28 === "string") {
                    if (func2(data28) > 64) {
                        const err89 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err89];
                        }
                        else {
                            vErrors.push(err89);
                        }
                        errors++;
                    }
                    if (func2(data28) < 1) {
                        const err90 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err90];
                        }
                        else {
                            vErrors.push(err90);
                        }
                        errors++;
                    }
                }
                else {
                    const err91 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err91];
                    }
                    else {
                        vErrors.push(err91);
                    }
                    errors++;
                }
            }
            if (data26.businessToday !== undefined) {
                let data29 = data26.businessToday;
                if (typeof data29 === "string") {
                    if (!pattern4.test(data29)) {
                        const err92 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err92];
                        }
                        else {
                            vErrors.push(err92);
                        }
                        errors++;
                    }
                }
                else {
                    const err93 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err93];
                    }
                    else {
                        vErrors.push(err93);
                    }
                    errors++;
                }
            }
            if (data26.timeZone !== undefined) {
                let data30 = data26.timeZone;
                if (typeof data30 === "string") {
                    if (func2(data30) > 64) {
                        const err94 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err94];
                        }
                        else {
                            vErrors.push(err94);
                        }
                        errors++;
                    }
                    if (func2(data30) < 1) {
                        const err95 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err95];
                        }
                        else {
                            vErrors.push(err95);
                        }
                        errors++;
                    }
                }
                else {
                    const err96 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err96];
                    }
                    else {
                        vErrors.push(err96);
                    }
                    errors++;
                }
            }
            if (data26.dataRevision !== undefined) {
                let data31 = data26.dataRevision;
                if (typeof data31 === "string") {
                    if (!pattern2.test(data31)) {
                        const err97 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err97];
                        }
                        else {
                            vErrors.push(err97);
                        }
                        errors++;
                    }
                }
                else {
                    const err98 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err98];
                    }
                    else {
                        vErrors.push(err98);
                    }
                    errors++;
                }
            }
        }
        else {
            const err99 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err99];
            }
            else {
                vErrors.push(err99);
            }
            errors++;
        }
    }
}
else {
    const err100 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
        vErrors = [err100];
    }
    else {
        vErrors.push(err100);
    }
    errors++;
} validate18.errors = vErrors; return errors === 0; }
export const validateLedgerTransferEnvelope = validate19;
const schema20 = { "$id": "https://saldo.local/schemas/ledger-transfer-envelope.json", "$schema": "http://json-schema.org/draft-07/schema#", "title": "LedgerTransferEnvelope", "type": "object", "additionalProperties": false, "required": ["data", "meta"], "properties": { "data": { "type": "object", "additionalProperties": false, "required": ["id", "status", "transferDate", "description", "currency", "revision", "canceled", "legs"], "properties": { "id": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "status": { "type": "string", "enum": ["planned", "completed"] }, "transferDate": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "description": { "type": "string", "minLength": 1, "maxLength": 500 }, "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "revision": { "type": "string", "pattern": "^[1-9][0-9]*$" }, "canceled": { "type": "boolean" }, "fx": { "type": "object", "additionalProperties": false, "required": ["inputMode", "sourceCurrency", "destinationCurrency", "directionLabel", "suppliedRate", "rateCoefficient", "rateScale", "displayRate", "displayRateApproximate"], "properties": { "inputMode": { "type": "string", "enum": ["rate", "destination"] }, "sourceCurrency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "destinationCurrency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "directionLabel": { "type": "string", "minLength": 1, "maxLength": 32 }, "suppliedRate": { "type": ["string", "null"], "pattern": "^(?:0|[1-9][0-9]{0,11})(?:\\.[0-9]{1,12})?$" }, "rateCoefficient": { "type": ["string", "null"], "pattern": "^[1-9][0-9]{0,23}$" }, "rateScale": { "type": ["integer", "null"], "minimum": 0, "maximum": 12 }, "displayRate": { "type": "string", "pattern": "^[0-9]+\\.[0-9]{6}$" }, "displayRateApproximate": { "type": "boolean" } } }, "legs": { "type": "array", "maxItems": 2, "minItems": 2, "items": { "type": "object", "additionalProperties": false, "required": ["entryId", "accountId", "accountKind", "side", "signedMinor", "currency", "revision"], "properties": { "entryId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "accountId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "accountKind": { "type": "string", "enum": ["cash", "card"] }, "side": { "type": "string", "enum": ["outgoing", "incoming"] }, "signedMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "revision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } } } } }, "meta": { "type": "object", "additionalProperties": false, "required": ["requestId", "asOf", "businessToday", "timeZone", "dataRevision"], "properties": { "requestId": { "type": "string", "minLength": 1, "maxLength": 64 }, "asOf": { "type": "string", "minLength": 1, "maxLength": 64 }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "timeZone": { "type": "string", "minLength": 1, "maxLength": 64 }, "dataRevision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } } } };
const pattern60 = new RegExp("^(?:0|[1-9][0-9]{0,11})(?:\\.[0-9]{1,12})?$", "u");
const pattern61 = new RegExp("^[1-9][0-9]{0,23}$", "u");
const pattern62 = new RegExp("^[0-9]+\\.[0-9]{6}$", "u");
function validate19(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="https://saldo.local/schemas/ledger-transfer-envelope.json" */ ; let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.data === undefined) {
        const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property '" + "data" + "'" };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
    }
    if (data.meta === undefined) {
        const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "meta" }, message: "must have required property '" + "meta" + "'" };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    for (const key0 in data) {
        if (!((key0 === "data") || (key0 === "meta"))) {
            const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.data !== undefined) {
        let data0 = data.data;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.id === undefined) {
                const err3 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property '" + "id" + "'" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
            if (data0.status === undefined) {
                const err4 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property '" + "status" + "'" };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
            if (data0.transferDate === undefined) {
                const err5 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "transferDate" }, message: "must have required property '" + "transferDate" + "'" };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
            }
            if (data0.description === undefined) {
                const err6 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "description" }, message: "must have required property '" + "description" + "'" };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
            }
            if (data0.currency === undefined) {
                const err7 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                if (vErrors === null) {
                    vErrors = [err7];
                }
                else {
                    vErrors.push(err7);
                }
                errors++;
            }
            if (data0.revision === undefined) {
                const err8 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property '" + "revision" + "'" };
                if (vErrors === null) {
                    vErrors = [err8];
                }
                else {
                    vErrors.push(err8);
                }
                errors++;
            }
            if (data0.canceled === undefined) {
                const err9 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "canceled" }, message: "must have required property '" + "canceled" + "'" };
                if (vErrors === null) {
                    vErrors = [err9];
                }
                else {
                    vErrors.push(err9);
                }
                errors++;
            }
            if (data0.legs === undefined) {
                const err10 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "legs" }, message: "must have required property '" + "legs" + "'" };
                if (vErrors === null) {
                    vErrors = [err10];
                }
                else {
                    vErrors.push(err10);
                }
                errors++;
            }
            for (const key1 in data0) {
                if (!(func35.call(schema20.properties.data.properties, key1))) {
                    const err11 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err11];
                    }
                    else {
                        vErrors.push(err11);
                    }
                    errors++;
                }
            }
            if (data0.id !== undefined) {
                let data1 = data0.id;
                if (typeof data1 === "string") {
                    if (!pattern0.test(data1)) {
                        const err12 = { instancePath: instancePath + "/data/id", schemaPath: "#/properties/data/properties/id/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err12];
                        }
                        else {
                            vErrors.push(err12);
                        }
                        errors++;
                    }
                }
                else {
                    const err13 = { instancePath: instancePath + "/data/id", schemaPath: "#/properties/data/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err13];
                    }
                    else {
                        vErrors.push(err13);
                    }
                    errors++;
                }
            }
            if (data0.status !== undefined) {
                let data2 = data0.status;
                if (typeof data2 !== "string") {
                    const err14 = { instancePath: instancePath + "/data/status", schemaPath: "#/properties/data/properties/status/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err14];
                    }
                    else {
                        vErrors.push(err14);
                    }
                    errors++;
                }
                if (!((data2 === "planned") || (data2 === "completed"))) {
                    const err15 = { instancePath: instancePath + "/data/status", schemaPath: "#/properties/data/properties/status/enum", keyword: "enum", params: { allowedValues: schema20.properties.data.properties.status.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err15];
                    }
                    else {
                        vErrors.push(err15);
                    }
                    errors++;
                }
            }
            if (data0.transferDate !== undefined) {
                let data3 = data0.transferDate;
                if (typeof data3 === "string") {
                    if (!pattern4.test(data3)) {
                        const err16 = { instancePath: instancePath + "/data/transferDate", schemaPath: "#/properties/data/properties/transferDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err16];
                        }
                        else {
                            vErrors.push(err16);
                        }
                        errors++;
                    }
                }
                else {
                    const err17 = { instancePath: instancePath + "/data/transferDate", schemaPath: "#/properties/data/properties/transferDate/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err17];
                    }
                    else {
                        vErrors.push(err17);
                    }
                    errors++;
                }
            }
            if (data0.description !== undefined) {
                let data4 = data0.description;
                if (typeof data4 === "string") {
                    if (func2(data4) > 500) {
                        const err18 = { instancePath: instancePath + "/data/description", schemaPath: "#/properties/data/properties/description/maxLength", keyword: "maxLength", params: { limit: 500 }, message: "must NOT have more than 500 characters" };
                        if (vErrors === null) {
                            vErrors = [err18];
                        }
                        else {
                            vErrors.push(err18);
                        }
                        errors++;
                    }
                    if (func2(data4) < 1) {
                        const err19 = { instancePath: instancePath + "/data/description", schemaPath: "#/properties/data/properties/description/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err19];
                        }
                        else {
                            vErrors.push(err19);
                        }
                        errors++;
                    }
                }
                else {
                    const err20 = { instancePath: instancePath + "/data/description", schemaPath: "#/properties/data/properties/description/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err20];
                    }
                    else {
                        vErrors.push(err20);
                    }
                    errors++;
                }
            }
            if (data0.currency !== undefined) {
                let data5 = data0.currency;
                if (typeof data5 !== "string") {
                    const err21 = { instancePath: instancePath + "/data/currency", schemaPath: "#/properties/data/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err21];
                    }
                    else {
                        vErrors.push(err21);
                    }
                    errors++;
                }
                if (!(((data5 === "BRL") || (data5 === "CAD")) || (data5 === "USD"))) {
                    const err22 = { instancePath: instancePath + "/data/currency", schemaPath: "#/properties/data/properties/currency/enum", keyword: "enum", params: { allowedValues: schema20.properties.data.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err22];
                    }
                    else {
                        vErrors.push(err22);
                    }
                    errors++;
                }
            }
            if (data0.revision !== undefined) {
                let data6 = data0.revision;
                if (typeof data6 === "string") {
                    if (!pattern2.test(data6)) {
                        const err23 = { instancePath: instancePath + "/data/revision", schemaPath: "#/properties/data/properties/revision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err23];
                        }
                        else {
                            vErrors.push(err23);
                        }
                        errors++;
                    }
                }
                else {
                    const err24 = { instancePath: instancePath + "/data/revision", schemaPath: "#/properties/data/properties/revision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err24];
                    }
                    else {
                        vErrors.push(err24);
                    }
                    errors++;
                }
            }
            if (data0.canceled !== undefined) {
                if (typeof data0.canceled !== "boolean") {
                    const err25 = { instancePath: instancePath + "/data/canceled", schemaPath: "#/properties/data/properties/canceled/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                    if (vErrors === null) {
                        vErrors = [err25];
                    }
                    else {
                        vErrors.push(err25);
                    }
                    errors++;
                }
            }
            if (data0.fx !== undefined) {
                let data8 = data0.fx;
                if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
                    if (data8.inputMode === undefined) {
                        const err26 = { instancePath: instancePath + "/data/fx", schemaPath: "#/properties/data/properties/fx/required", keyword: "required", params: { missingProperty: "inputMode" }, message: "must have required property '" + "inputMode" + "'" };
                        if (vErrors === null) {
                            vErrors = [err26];
                        }
                        else {
                            vErrors.push(err26);
                        }
                        errors++;
                    }
                    if (data8.sourceCurrency === undefined) {
                        const err27 = { instancePath: instancePath + "/data/fx", schemaPath: "#/properties/data/properties/fx/required", keyword: "required", params: { missingProperty: "sourceCurrency" }, message: "must have required property '" + "sourceCurrency" + "'" };
                        if (vErrors === null) {
                            vErrors = [err27];
                        }
                        else {
                            vErrors.push(err27);
                        }
                        errors++;
                    }
                    if (data8.destinationCurrency === undefined) {
                        const err28 = { instancePath: instancePath + "/data/fx", schemaPath: "#/properties/data/properties/fx/required", keyword: "required", params: { missingProperty: "destinationCurrency" }, message: "must have required property '" + "destinationCurrency" + "'" };
                        if (vErrors === null) {
                            vErrors = [err28];
                        }
                        else {
                            vErrors.push(err28);
                        }
                        errors++;
                    }
                    if (data8.directionLabel === undefined) {
                        const err29 = { instancePath: instancePath + "/data/fx", schemaPath: "#/properties/data/properties/fx/required", keyword: "required", params: { missingProperty: "directionLabel" }, message: "must have required property '" + "directionLabel" + "'" };
                        if (vErrors === null) {
                            vErrors = [err29];
                        }
                        else {
                            vErrors.push(err29);
                        }
                        errors++;
                    }
                    if (data8.suppliedRate === undefined) {
                        const err30 = { instancePath: instancePath + "/data/fx", schemaPath: "#/properties/data/properties/fx/required", keyword: "required", params: { missingProperty: "suppliedRate" }, message: "must have required property '" + "suppliedRate" + "'" };
                        if (vErrors === null) {
                            vErrors = [err30];
                        }
                        else {
                            vErrors.push(err30);
                        }
                        errors++;
                    }
                    if (data8.rateCoefficient === undefined) {
                        const err31 = { instancePath: instancePath + "/data/fx", schemaPath: "#/properties/data/properties/fx/required", keyword: "required", params: { missingProperty: "rateCoefficient" }, message: "must have required property '" + "rateCoefficient" + "'" };
                        if (vErrors === null) {
                            vErrors = [err31];
                        }
                        else {
                            vErrors.push(err31);
                        }
                        errors++;
                    }
                    if (data8.rateScale === undefined) {
                        const err32 = { instancePath: instancePath + "/data/fx", schemaPath: "#/properties/data/properties/fx/required", keyword: "required", params: { missingProperty: "rateScale" }, message: "must have required property '" + "rateScale" + "'" };
                        if (vErrors === null) {
                            vErrors = [err32];
                        }
                        else {
                            vErrors.push(err32);
                        }
                        errors++;
                    }
                    if (data8.displayRate === undefined) {
                        const err33 = { instancePath: instancePath + "/data/fx", schemaPath: "#/properties/data/properties/fx/required", keyword: "required", params: { missingProperty: "displayRate" }, message: "must have required property '" + "displayRate" + "'" };
                        if (vErrors === null) {
                            vErrors = [err33];
                        }
                        else {
                            vErrors.push(err33);
                        }
                        errors++;
                    }
                    if (data8.displayRateApproximate === undefined) {
                        const err34 = { instancePath: instancePath + "/data/fx", schemaPath: "#/properties/data/properties/fx/required", keyword: "required", params: { missingProperty: "displayRateApproximate" }, message: "must have required property '" + "displayRateApproximate" + "'" };
                        if (vErrors === null) {
                            vErrors = [err34];
                        }
                        else {
                            vErrors.push(err34);
                        }
                        errors++;
                    }
                    for (const key2 in data8) {
                        if (!(func35.call(schema20.properties.data.properties.fx.properties, key2))) {
                            const err35 = { instancePath: instancePath + "/data/fx", schemaPath: "#/properties/data/properties/fx/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                                vErrors = [err35];
                            }
                            else {
                                vErrors.push(err35);
                            }
                            errors++;
                        }
                    }
                    if (data8.inputMode !== undefined) {
                        let data9 = data8.inputMode;
                        if (typeof data9 !== "string") {
                            const err36 = { instancePath: instancePath + "/data/fx/inputMode", schemaPath: "#/properties/data/properties/fx/properties/inputMode/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err36];
                            }
                            else {
                                vErrors.push(err36);
                            }
                            errors++;
                        }
                        if (!((data9 === "rate") || (data9 === "destination"))) {
                            const err37 = { instancePath: instancePath + "/data/fx/inputMode", schemaPath: "#/properties/data/properties/fx/properties/inputMode/enum", keyword: "enum", params: { allowedValues: schema20.properties.data.properties.fx.properties.inputMode.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                                vErrors = [err37];
                            }
                            else {
                                vErrors.push(err37);
                            }
                            errors++;
                        }
                    }
                    if (data8.sourceCurrency !== undefined) {
                        let data10 = data8.sourceCurrency;
                        if (typeof data10 !== "string") {
                            const err38 = { instancePath: instancePath + "/data/fx/sourceCurrency", schemaPath: "#/properties/data/properties/fx/properties/sourceCurrency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err38];
                            }
                            else {
                                vErrors.push(err38);
                            }
                            errors++;
                        }
                        if (!(((data10 === "BRL") || (data10 === "CAD")) || (data10 === "USD"))) {
                            const err39 = { instancePath: instancePath + "/data/fx/sourceCurrency", schemaPath: "#/properties/data/properties/fx/properties/sourceCurrency/enum", keyword: "enum", params: { allowedValues: schema20.properties.data.properties.fx.properties.sourceCurrency.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                                vErrors = [err39];
                            }
                            else {
                                vErrors.push(err39);
                            }
                            errors++;
                        }
                    }
                    if (data8.destinationCurrency !== undefined) {
                        let data11 = data8.destinationCurrency;
                        if (typeof data11 !== "string") {
                            const err40 = { instancePath: instancePath + "/data/fx/destinationCurrency", schemaPath: "#/properties/data/properties/fx/properties/destinationCurrency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err40];
                            }
                            else {
                                vErrors.push(err40);
                            }
                            errors++;
                        }
                        if (!(((data11 === "BRL") || (data11 === "CAD")) || (data11 === "USD"))) {
                            const err41 = { instancePath: instancePath + "/data/fx/destinationCurrency", schemaPath: "#/properties/data/properties/fx/properties/destinationCurrency/enum", keyword: "enum", params: { allowedValues: schema20.properties.data.properties.fx.properties.destinationCurrency.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                                vErrors = [err41];
                            }
                            else {
                                vErrors.push(err41);
                            }
                            errors++;
                        }
                    }
                    if (data8.directionLabel !== undefined) {
                        let data12 = data8.directionLabel;
                        if (typeof data12 === "string") {
                            if (func2(data12) > 32) {
                                const err42 = { instancePath: instancePath + "/data/fx/directionLabel", schemaPath: "#/properties/data/properties/fx/properties/directionLabel/maxLength", keyword: "maxLength", params: { limit: 32 }, message: "must NOT have more than 32 characters" };
                                if (vErrors === null) {
                                    vErrors = [err42];
                                }
                                else {
                                    vErrors.push(err42);
                                }
                                errors++;
                            }
                            if (func2(data12) < 1) {
                                const err43 = { instancePath: instancePath + "/data/fx/directionLabel", schemaPath: "#/properties/data/properties/fx/properties/directionLabel/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                if (vErrors === null) {
                                    vErrors = [err43];
                                }
                                else {
                                    vErrors.push(err43);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err44 = { instancePath: instancePath + "/data/fx/directionLabel", schemaPath: "#/properties/data/properties/fx/properties/directionLabel/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err44];
                            }
                            else {
                                vErrors.push(err44);
                            }
                            errors++;
                        }
                    }
                    if (data8.suppliedRate !== undefined) {
                        let data13 = data8.suppliedRate;
                        if ((typeof data13 !== "string") && (data13 !== null)) {
                            const err45 = { instancePath: instancePath + "/data/fx/suppliedRate", schemaPath: "#/properties/data/properties/fx/properties/suppliedRate/type", keyword: "type", params: { type: schema20.properties.data.properties.fx.properties.suppliedRate.type }, message: "must be string,null" };
                            if (vErrors === null) {
                                vErrors = [err45];
                            }
                            else {
                                vErrors.push(err45);
                            }
                            errors++;
                        }
                        if (typeof data13 === "string") {
                            if (!pattern60.test(data13)) {
                                const err46 = { instancePath: instancePath + "/data/fx/suppliedRate", schemaPath: "#/properties/data/properties/fx/properties/suppliedRate/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]{0,11})(?:\\.[0-9]{1,12})?$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]{0,11})(?:\\.[0-9]{1,12})?$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err46];
                                }
                                else {
                                    vErrors.push(err46);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data8.rateCoefficient !== undefined) {
                        let data14 = data8.rateCoefficient;
                        if ((typeof data14 !== "string") && (data14 !== null)) {
                            const err47 = { instancePath: instancePath + "/data/fx/rateCoefficient", schemaPath: "#/properties/data/properties/fx/properties/rateCoefficient/type", keyword: "type", params: { type: schema20.properties.data.properties.fx.properties.rateCoefficient.type }, message: "must be string,null" };
                            if (vErrors === null) {
                                vErrors = [err47];
                            }
                            else {
                                vErrors.push(err47);
                            }
                            errors++;
                        }
                        if (typeof data14 === "string") {
                            if (!pattern61.test(data14)) {
                                const err48 = { instancePath: instancePath + "/data/fx/rateCoefficient", schemaPath: "#/properties/data/properties/fx/properties/rateCoefficient/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]{0,23}$" }, message: "must match pattern \"" + "^[1-9][0-9]{0,23}$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err48];
                                }
                                else {
                                    vErrors.push(err48);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data8.rateScale !== undefined) {
                        let data15 = data8.rateScale;
                        if ((!(((typeof data15 == "number") && (!(data15 % 1) && !isNaN(data15))) && (isFinite(data15)))) && (data15 !== null)) {
                            const err49 = { instancePath: instancePath + "/data/fx/rateScale", schemaPath: "#/properties/data/properties/fx/properties/rateScale/type", keyword: "type", params: { type: schema20.properties.data.properties.fx.properties.rateScale.type }, message: "must be integer,null" };
                            if (vErrors === null) {
                                vErrors = [err49];
                            }
                            else {
                                vErrors.push(err49);
                            }
                            errors++;
                        }
                        if ((typeof data15 == "number") && (isFinite(data15))) {
                            if (data15 > 12 || isNaN(data15)) {
                                const err50 = { instancePath: instancePath + "/data/fx/rateScale", schemaPath: "#/properties/data/properties/fx/properties/rateScale/maximum", keyword: "maximum", params: { comparison: "<=", limit: 12 }, message: "must be <= 12" };
                                if (vErrors === null) {
                                    vErrors = [err50];
                                }
                                else {
                                    vErrors.push(err50);
                                }
                                errors++;
                            }
                            if (data15 < 0 || isNaN(data15)) {
                                const err51 = { instancePath: instancePath + "/data/fx/rateScale", schemaPath: "#/properties/data/properties/fx/properties/rateScale/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                                if (vErrors === null) {
                                    vErrors = [err51];
                                }
                                else {
                                    vErrors.push(err51);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data8.displayRate !== undefined) {
                        let data16 = data8.displayRate;
                        if (typeof data16 === "string") {
                            if (!pattern62.test(data16)) {
                                const err52 = { instancePath: instancePath + "/data/fx/displayRate", schemaPath: "#/properties/data/properties/fx/properties/displayRate/pattern", keyword: "pattern", params: { pattern: "^[0-9]+\\.[0-9]{6}$" }, message: "must match pattern \"" + "^[0-9]+\\.[0-9]{6}$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err52];
                                }
                                else {
                                    vErrors.push(err52);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err53 = { instancePath: instancePath + "/data/fx/displayRate", schemaPath: "#/properties/data/properties/fx/properties/displayRate/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err53];
                            }
                            else {
                                vErrors.push(err53);
                            }
                            errors++;
                        }
                    }
                    if (data8.displayRateApproximate !== undefined) {
                        if (typeof data8.displayRateApproximate !== "boolean") {
                            const err54 = { instancePath: instancePath + "/data/fx/displayRateApproximate", schemaPath: "#/properties/data/properties/fx/properties/displayRateApproximate/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                                vErrors = [err54];
                            }
                            else {
                                vErrors.push(err54);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err55 = { instancePath: instancePath + "/data/fx", schemaPath: "#/properties/data/properties/fx/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                        vErrors = [err55];
                    }
                    else {
                        vErrors.push(err55);
                    }
                    errors++;
                }
            }
            if (data0.legs !== undefined) {
                let data18 = data0.legs;
                if (Array.isArray(data18)) {
                    if (data18.length > 2) {
                        const err56 = { instancePath: instancePath + "/data/legs", schemaPath: "#/properties/data/properties/legs/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" };
                        if (vErrors === null) {
                            vErrors = [err56];
                        }
                        else {
                            vErrors.push(err56);
                        }
                        errors++;
                    }
                    if (data18.length < 2) {
                        const err57 = { instancePath: instancePath + "/data/legs", schemaPath: "#/properties/data/properties/legs/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" };
                        if (vErrors === null) {
                            vErrors = [err57];
                        }
                        else {
                            vErrors.push(err57);
                        }
                        errors++;
                    }
                    const len0 = data18.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                        let data19 = data18[i0];
                        if (data19 && typeof data19 == "object" && !Array.isArray(data19)) {
                            if (data19.entryId === undefined) {
                                const err58 = { instancePath: instancePath + "/data/legs/" + i0, schemaPath: "#/properties/data/properties/legs/items/required", keyword: "required", params: { missingProperty: "entryId" }, message: "must have required property '" + "entryId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err58];
                                }
                                else {
                                    vErrors.push(err58);
                                }
                                errors++;
                            }
                            if (data19.accountId === undefined) {
                                const err59 = { instancePath: instancePath + "/data/legs/" + i0, schemaPath: "#/properties/data/properties/legs/items/required", keyword: "required", params: { missingProperty: "accountId" }, message: "must have required property '" + "accountId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err59];
                                }
                                else {
                                    vErrors.push(err59);
                                }
                                errors++;
                            }
                            if (data19.accountKind === undefined) {
                                const err60 = { instancePath: instancePath + "/data/legs/" + i0, schemaPath: "#/properties/data/properties/legs/items/required", keyword: "required", params: { missingProperty: "accountKind" }, message: "must have required property '" + "accountKind" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err60];
                                }
                                else {
                                    vErrors.push(err60);
                                }
                                errors++;
                            }
                            if (data19.side === undefined) {
                                const err61 = { instancePath: instancePath + "/data/legs/" + i0, schemaPath: "#/properties/data/properties/legs/items/required", keyword: "required", params: { missingProperty: "side" }, message: "must have required property '" + "side" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err61];
                                }
                                else {
                                    vErrors.push(err61);
                                }
                                errors++;
                            }
                            if (data19.signedMinor === undefined) {
                                const err62 = { instancePath: instancePath + "/data/legs/" + i0, schemaPath: "#/properties/data/properties/legs/items/required", keyword: "required", params: { missingProperty: "signedMinor" }, message: "must have required property '" + "signedMinor" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err62];
                                }
                                else {
                                    vErrors.push(err62);
                                }
                                errors++;
                            }
                            if (data19.currency === undefined) {
                                const err63 = { instancePath: instancePath + "/data/legs/" + i0, schemaPath: "#/properties/data/properties/legs/items/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err63];
                                }
                                else {
                                    vErrors.push(err63);
                                }
                                errors++;
                            }
                            if (data19.revision === undefined) {
                                const err64 = { instancePath: instancePath + "/data/legs/" + i0, schemaPath: "#/properties/data/properties/legs/items/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property '" + "revision" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err64];
                                }
                                else {
                                    vErrors.push(err64);
                                }
                                errors++;
                            }
                            for (const key3 in data19) {
                                if (!(((((((key3 === "entryId") || (key3 === "accountId")) || (key3 === "accountKind")) || (key3 === "side")) || (key3 === "signedMinor")) || (key3 === "currency")) || (key3 === "revision"))) {
                                    const err65 = { instancePath: instancePath + "/data/legs/" + i0, schemaPath: "#/properties/data/properties/legs/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                                    if (vErrors === null) {
                                        vErrors = [err65];
                                    }
                                    else {
                                        vErrors.push(err65);
                                    }
                                    errors++;
                                }
                            }
                            if (data19.entryId !== undefined) {
                                let data20 = data19.entryId;
                                if (typeof data20 === "string") {
                                    if (!pattern0.test(data20)) {
                                        const err66 = { instancePath: instancePath + "/data/legs/" + i0 + "/entryId", schemaPath: "#/properties/data/properties/legs/items/properties/entryId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err66];
                                        }
                                        else {
                                            vErrors.push(err66);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err67 = { instancePath: instancePath + "/data/legs/" + i0 + "/entryId", schemaPath: "#/properties/data/properties/legs/items/properties/entryId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err67];
                                    }
                                    else {
                                        vErrors.push(err67);
                                    }
                                    errors++;
                                }
                            }
                            if (data19.accountId !== undefined) {
                                let data21 = data19.accountId;
                                if (typeof data21 === "string") {
                                    if (!pattern0.test(data21)) {
                                        const err68 = { instancePath: instancePath + "/data/legs/" + i0 + "/accountId", schemaPath: "#/properties/data/properties/legs/items/properties/accountId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err68];
                                        }
                                        else {
                                            vErrors.push(err68);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err69 = { instancePath: instancePath + "/data/legs/" + i0 + "/accountId", schemaPath: "#/properties/data/properties/legs/items/properties/accountId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err69];
                                    }
                                    else {
                                        vErrors.push(err69);
                                    }
                                    errors++;
                                }
                            }
                            if (data19.accountKind !== undefined) {
                                let data22 = data19.accountKind;
                                if (typeof data22 !== "string") {
                                    const err70 = { instancePath: instancePath + "/data/legs/" + i0 + "/accountKind", schemaPath: "#/properties/data/properties/legs/items/properties/accountKind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err70];
                                    }
                                    else {
                                        vErrors.push(err70);
                                    }
                                    errors++;
                                }
                                if (!((data22 === "cash") || (data22 === "card"))) {
                                    const err71 = { instancePath: instancePath + "/data/legs/" + i0 + "/accountKind", schemaPath: "#/properties/data/properties/legs/items/properties/accountKind/enum", keyword: "enum", params: { allowedValues: schema20.properties.data.properties.legs.items.properties.accountKind.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err71];
                                    }
                                    else {
                                        vErrors.push(err71);
                                    }
                                    errors++;
                                }
                            }
                            if (data19.side !== undefined) {
                                let data23 = data19.side;
                                if (typeof data23 !== "string") {
                                    const err72 = { instancePath: instancePath + "/data/legs/" + i0 + "/side", schemaPath: "#/properties/data/properties/legs/items/properties/side/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err72];
                                    }
                                    else {
                                        vErrors.push(err72);
                                    }
                                    errors++;
                                }
                                if (!((data23 === "outgoing") || (data23 === "incoming"))) {
                                    const err73 = { instancePath: instancePath + "/data/legs/" + i0 + "/side", schemaPath: "#/properties/data/properties/legs/items/properties/side/enum", keyword: "enum", params: { allowedValues: schema20.properties.data.properties.legs.items.properties.side.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err73];
                                    }
                                    else {
                                        vErrors.push(err73);
                                    }
                                    errors++;
                                }
                            }
                            if (data19.signedMinor !== undefined) {
                                let data24 = data19.signedMinor;
                                if (typeof data24 === "string") {
                                    if (!pattern3.test(data24)) {
                                        const err74 = { instancePath: instancePath + "/data/legs/" + i0 + "/signedMinor", schemaPath: "#/properties/data/properties/legs/items/properties/signedMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err74];
                                        }
                                        else {
                                            vErrors.push(err74);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err75 = { instancePath: instancePath + "/data/legs/" + i0 + "/signedMinor", schemaPath: "#/properties/data/properties/legs/items/properties/signedMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err75];
                                    }
                                    else {
                                        vErrors.push(err75);
                                    }
                                    errors++;
                                }
                            }
                            if (data19.currency !== undefined) {
                                let data25 = data19.currency;
                                if (typeof data25 !== "string") {
                                    const err76 = { instancePath: instancePath + "/data/legs/" + i0 + "/currency", schemaPath: "#/properties/data/properties/legs/items/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err76];
                                    }
                                    else {
                                        vErrors.push(err76);
                                    }
                                    errors++;
                                }
                                if (!(((data25 === "BRL") || (data25 === "CAD")) || (data25 === "USD"))) {
                                    const err77 = { instancePath: instancePath + "/data/legs/" + i0 + "/currency", schemaPath: "#/properties/data/properties/legs/items/properties/currency/enum", keyword: "enum", params: { allowedValues: schema20.properties.data.properties.legs.items.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err77];
                                    }
                                    else {
                                        vErrors.push(err77);
                                    }
                                    errors++;
                                }
                            }
                            if (data19.revision !== undefined) {
                                let data26 = data19.revision;
                                if (typeof data26 === "string") {
                                    if (!pattern2.test(data26)) {
                                        const err78 = { instancePath: instancePath + "/data/legs/" + i0 + "/revision", schemaPath: "#/properties/data/properties/legs/items/properties/revision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err78];
                                        }
                                        else {
                                            vErrors.push(err78);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err79 = { instancePath: instancePath + "/data/legs/" + i0 + "/revision", schemaPath: "#/properties/data/properties/legs/items/properties/revision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err79];
                                    }
                                    else {
                                        vErrors.push(err79);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err80 = { instancePath: instancePath + "/data/legs/" + i0, schemaPath: "#/properties/data/properties/legs/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                                vErrors = [err80];
                            }
                            else {
                                vErrors.push(err80);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err81 = { instancePath: instancePath + "/data/legs", schemaPath: "#/properties/data/properties/legs/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err81];
                    }
                    else {
                        vErrors.push(err81);
                    }
                    errors++;
                }
            }
        }
        else {
            const err82 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err82];
            }
            else {
                vErrors.push(err82);
            }
            errors++;
        }
    }
    if (data.meta !== undefined) {
        let data27 = data.meta;
        if (data27 && typeof data27 == "object" && !Array.isArray(data27)) {
            if (data27.requestId === undefined) {
                const err83 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "requestId" }, message: "must have required property '" + "requestId" + "'" };
                if (vErrors === null) {
                    vErrors = [err83];
                }
                else {
                    vErrors.push(err83);
                }
                errors++;
            }
            if (data27.asOf === undefined) {
                const err84 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "asOf" }, message: "must have required property '" + "asOf" + "'" };
                if (vErrors === null) {
                    vErrors = [err84];
                }
                else {
                    vErrors.push(err84);
                }
                errors++;
            }
            if (data27.businessToday === undefined) {
                const err85 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err85];
                }
                else {
                    vErrors.push(err85);
                }
                errors++;
            }
            if (data27.timeZone === undefined) {
                const err86 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "timeZone" }, message: "must have required property '" + "timeZone" + "'" };
                if (vErrors === null) {
                    vErrors = [err86];
                }
                else {
                    vErrors.push(err86);
                }
                errors++;
            }
            if (data27.dataRevision === undefined) {
                const err87 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "dataRevision" }, message: "must have required property '" + "dataRevision" + "'" };
                if (vErrors === null) {
                    vErrors = [err87];
                }
                else {
                    vErrors.push(err87);
                }
                errors++;
            }
            for (const key4 in data27) {
                if (!(((((key4 === "requestId") || (key4 === "asOf")) || (key4 === "businessToday")) || (key4 === "timeZone")) || (key4 === "dataRevision"))) {
                    const err88 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key4 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err88];
                    }
                    else {
                        vErrors.push(err88);
                    }
                    errors++;
                }
            }
            if (data27.requestId !== undefined) {
                let data28 = data27.requestId;
                if (typeof data28 === "string") {
                    if (func2(data28) > 64) {
                        const err89 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err89];
                        }
                        else {
                            vErrors.push(err89);
                        }
                        errors++;
                    }
                    if (func2(data28) < 1) {
                        const err90 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err90];
                        }
                        else {
                            vErrors.push(err90);
                        }
                        errors++;
                    }
                }
                else {
                    const err91 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err91];
                    }
                    else {
                        vErrors.push(err91);
                    }
                    errors++;
                }
            }
            if (data27.asOf !== undefined) {
                let data29 = data27.asOf;
                if (typeof data29 === "string") {
                    if (func2(data29) > 64) {
                        const err92 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err92];
                        }
                        else {
                            vErrors.push(err92);
                        }
                        errors++;
                    }
                    if (func2(data29) < 1) {
                        const err93 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err93];
                        }
                        else {
                            vErrors.push(err93);
                        }
                        errors++;
                    }
                }
                else {
                    const err94 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err94];
                    }
                    else {
                        vErrors.push(err94);
                    }
                    errors++;
                }
            }
            if (data27.businessToday !== undefined) {
                let data30 = data27.businessToday;
                if (typeof data30 === "string") {
                    if (!pattern4.test(data30)) {
                        const err95 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err95];
                        }
                        else {
                            vErrors.push(err95);
                        }
                        errors++;
                    }
                }
                else {
                    const err96 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err96];
                    }
                    else {
                        vErrors.push(err96);
                    }
                    errors++;
                }
            }
            if (data27.timeZone !== undefined) {
                let data31 = data27.timeZone;
                if (typeof data31 === "string") {
                    if (func2(data31) > 64) {
                        const err97 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err97];
                        }
                        else {
                            vErrors.push(err97);
                        }
                        errors++;
                    }
                    if (func2(data31) < 1) {
                        const err98 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err98];
                        }
                        else {
                            vErrors.push(err98);
                        }
                        errors++;
                    }
                }
                else {
                    const err99 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err99];
                    }
                    else {
                        vErrors.push(err99);
                    }
                    errors++;
                }
            }
            if (data27.dataRevision !== undefined) {
                let data32 = data27.dataRevision;
                if (typeof data32 === "string") {
                    if (!pattern2.test(data32)) {
                        const err100 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err100];
                        }
                        else {
                            vErrors.push(err100);
                        }
                        errors++;
                    }
                }
                else {
                    const err101 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err101];
                    }
                    else {
                        vErrors.push(err101);
                    }
                    errors++;
                }
            }
        }
        else {
            const err102 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err102];
            }
            else {
                vErrors.push(err102);
            }
            errors++;
        }
    }
}
else {
    const err103 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
        vErrors = [err103];
    }
    else {
        vErrors.push(err103);
    }
    errors++;
} validate19.errors = vErrors; return errors === 0; }
export const validateLedgerTransfersEnvelope = validate20;
const schema21 = { "$id": "https://saldo.local/schemas/ledger-transfers-envelope.json", "$schema": "http://json-schema.org/draft-07/schema#", "title": "LedgerTransfersEnvelope", "type": "object", "additionalProperties": false, "required": ["data", "meta"], "properties": { "data": { "type": "object", "additionalProperties": false, "required": ["transfers"], "properties": { "transfers": { "type": "array", "maxItems": 200, "items": { "type": "object", "additionalProperties": false, "required": ["id", "status", "transferDate", "description", "currency", "revision", "canceled", "legs"], "properties": { "id": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "status": { "type": "string", "enum": ["planned", "completed"] }, "transferDate": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "description": { "type": "string", "minLength": 1, "maxLength": 500 }, "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "revision": { "type": "string", "pattern": "^[1-9][0-9]*$" }, "canceled": { "type": "boolean" }, "fx": { "type": "object", "additionalProperties": false, "required": ["inputMode", "sourceCurrency", "destinationCurrency", "directionLabel", "suppliedRate", "rateCoefficient", "rateScale", "displayRate", "displayRateApproximate"], "properties": { "inputMode": { "type": "string", "enum": ["rate", "destination"] }, "sourceCurrency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "destinationCurrency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "directionLabel": { "type": "string", "minLength": 1, "maxLength": 32 }, "suppliedRate": { "type": ["string", "null"], "pattern": "^(?:0|[1-9][0-9]{0,11})(?:\\.[0-9]{1,12})?$" }, "rateCoefficient": { "type": ["string", "null"], "pattern": "^[1-9][0-9]{0,23}$" }, "rateScale": { "type": ["integer", "null"], "minimum": 0, "maximum": 12 }, "displayRate": { "type": "string", "pattern": "^[0-9]+\\.[0-9]{6}$" }, "displayRateApproximate": { "type": "boolean" } } }, "legs": { "type": "array", "maxItems": 2, "minItems": 2, "items": { "type": "object", "additionalProperties": false, "required": ["entryId", "accountId", "accountKind", "side", "signedMinor", "currency", "revision"], "properties": { "entryId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "accountId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "accountKind": { "type": "string", "enum": ["cash", "card"] }, "side": { "type": "string", "enum": ["outgoing", "incoming"] }, "signedMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "revision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } } } } } } } }, "meta": { "type": "object", "additionalProperties": false, "required": ["requestId", "asOf", "businessToday", "timeZone", "dataRevision"], "properties": { "requestId": { "type": "string", "minLength": 1, "maxLength": 64 }, "asOf": { "type": "string", "minLength": 1, "maxLength": 64 }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "timeZone": { "type": "string", "minLength": 1, "maxLength": 64 }, "dataRevision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } } } };
function validate20(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="https://saldo.local/schemas/ledger-transfers-envelope.json" */ ; let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.data === undefined) {
        const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property '" + "data" + "'" };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
    }
    if (data.meta === undefined) {
        const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "meta" }, message: "must have required property '" + "meta" + "'" };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    for (const key0 in data) {
        if (!((key0 === "data") || (key0 === "meta"))) {
            const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.data !== undefined) {
        let data0 = data.data;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.transfers === undefined) {
                const err3 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "transfers" }, message: "must have required property '" + "transfers" + "'" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
            for (const key1 in data0) {
                if (!(key1 === "transfers")) {
                    const err4 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
            }
            if (data0.transfers !== undefined) {
                let data1 = data0.transfers;
                if (Array.isArray(data1)) {
                    if (data1.length > 200) {
                        const err5 = { instancePath: instancePath + "/data/transfers", schemaPath: "#/properties/data/properties/transfers/maxItems", keyword: "maxItems", params: { limit: 200 }, message: "must NOT have more than 200 items" };
                        if (vErrors === null) {
                            vErrors = [err5];
                        }
                        else {
                            vErrors.push(err5);
                        }
                        errors++;
                    }
                    const len0 = data1.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                        let data2 = data1[i0];
                        if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                            if (data2.id === undefined) {
                                const err6 = { instancePath: instancePath + "/data/transfers/" + i0, schemaPath: "#/properties/data/properties/transfers/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property '" + "id" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err6];
                                }
                                else {
                                    vErrors.push(err6);
                                }
                                errors++;
                            }
                            if (data2.status === undefined) {
                                const err7 = { instancePath: instancePath + "/data/transfers/" + i0, schemaPath: "#/properties/data/properties/transfers/items/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property '" + "status" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err7];
                                }
                                else {
                                    vErrors.push(err7);
                                }
                                errors++;
                            }
                            if (data2.transferDate === undefined) {
                                const err8 = { instancePath: instancePath + "/data/transfers/" + i0, schemaPath: "#/properties/data/properties/transfers/items/required", keyword: "required", params: { missingProperty: "transferDate" }, message: "must have required property '" + "transferDate" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err8];
                                }
                                else {
                                    vErrors.push(err8);
                                }
                                errors++;
                            }
                            if (data2.description === undefined) {
                                const err9 = { instancePath: instancePath + "/data/transfers/" + i0, schemaPath: "#/properties/data/properties/transfers/items/required", keyword: "required", params: { missingProperty: "description" }, message: "must have required property '" + "description" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err9];
                                }
                                else {
                                    vErrors.push(err9);
                                }
                                errors++;
                            }
                            if (data2.currency === undefined) {
                                const err10 = { instancePath: instancePath + "/data/transfers/" + i0, schemaPath: "#/properties/data/properties/transfers/items/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err10];
                                }
                                else {
                                    vErrors.push(err10);
                                }
                                errors++;
                            }
                            if (data2.revision === undefined) {
                                const err11 = { instancePath: instancePath + "/data/transfers/" + i0, schemaPath: "#/properties/data/properties/transfers/items/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property '" + "revision" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err11];
                                }
                                else {
                                    vErrors.push(err11);
                                }
                                errors++;
                            }
                            if (data2.canceled === undefined) {
                                const err12 = { instancePath: instancePath + "/data/transfers/" + i0, schemaPath: "#/properties/data/properties/transfers/items/required", keyword: "required", params: { missingProperty: "canceled" }, message: "must have required property '" + "canceled" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err12];
                                }
                                else {
                                    vErrors.push(err12);
                                }
                                errors++;
                            }
                            if (data2.legs === undefined) {
                                const err13 = { instancePath: instancePath + "/data/transfers/" + i0, schemaPath: "#/properties/data/properties/transfers/items/required", keyword: "required", params: { missingProperty: "legs" }, message: "must have required property '" + "legs" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err13];
                                }
                                else {
                                    vErrors.push(err13);
                                }
                                errors++;
                            }
                            for (const key2 in data2) {
                                if (!(func35.call(schema21.properties.data.properties.transfers.items.properties, key2))) {
                                    const err14 = { instancePath: instancePath + "/data/transfers/" + i0, schemaPath: "#/properties/data/properties/transfers/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                                    if (vErrors === null) {
                                        vErrors = [err14];
                                    }
                                    else {
                                        vErrors.push(err14);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.id !== undefined) {
                                let data3 = data2.id;
                                if (typeof data3 === "string") {
                                    if (!pattern0.test(data3)) {
                                        const err15 = { instancePath: instancePath + "/data/transfers/" + i0 + "/id", schemaPath: "#/properties/data/properties/transfers/items/properties/id/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err15];
                                        }
                                        else {
                                            vErrors.push(err15);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err16 = { instancePath: instancePath + "/data/transfers/" + i0 + "/id", schemaPath: "#/properties/data/properties/transfers/items/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err16];
                                    }
                                    else {
                                        vErrors.push(err16);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.status !== undefined) {
                                let data4 = data2.status;
                                if (typeof data4 !== "string") {
                                    const err17 = { instancePath: instancePath + "/data/transfers/" + i0 + "/status", schemaPath: "#/properties/data/properties/transfers/items/properties/status/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err17];
                                    }
                                    else {
                                        vErrors.push(err17);
                                    }
                                    errors++;
                                }
                                if (!((data4 === "planned") || (data4 === "completed"))) {
                                    const err18 = { instancePath: instancePath + "/data/transfers/" + i0 + "/status", schemaPath: "#/properties/data/properties/transfers/items/properties/status/enum", keyword: "enum", params: { allowedValues: schema21.properties.data.properties.transfers.items.properties.status.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err18];
                                    }
                                    else {
                                        vErrors.push(err18);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.transferDate !== undefined) {
                                let data5 = data2.transferDate;
                                if (typeof data5 === "string") {
                                    if (!pattern4.test(data5)) {
                                        const err19 = { instancePath: instancePath + "/data/transfers/" + i0 + "/transferDate", schemaPath: "#/properties/data/properties/transfers/items/properties/transferDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err19];
                                        }
                                        else {
                                            vErrors.push(err19);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err20 = { instancePath: instancePath + "/data/transfers/" + i0 + "/transferDate", schemaPath: "#/properties/data/properties/transfers/items/properties/transferDate/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err20];
                                    }
                                    else {
                                        vErrors.push(err20);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.description !== undefined) {
                                let data6 = data2.description;
                                if (typeof data6 === "string") {
                                    if (func2(data6) > 500) {
                                        const err21 = { instancePath: instancePath + "/data/transfers/" + i0 + "/description", schemaPath: "#/properties/data/properties/transfers/items/properties/description/maxLength", keyword: "maxLength", params: { limit: 500 }, message: "must NOT have more than 500 characters" };
                                        if (vErrors === null) {
                                            vErrors = [err21];
                                        }
                                        else {
                                            vErrors.push(err21);
                                        }
                                        errors++;
                                    }
                                    if (func2(data6) < 1) {
                                        const err22 = { instancePath: instancePath + "/data/transfers/" + i0 + "/description", schemaPath: "#/properties/data/properties/transfers/items/properties/description/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                        if (vErrors === null) {
                                            vErrors = [err22];
                                        }
                                        else {
                                            vErrors.push(err22);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err23 = { instancePath: instancePath + "/data/transfers/" + i0 + "/description", schemaPath: "#/properties/data/properties/transfers/items/properties/description/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err23];
                                    }
                                    else {
                                        vErrors.push(err23);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.currency !== undefined) {
                                let data7 = data2.currency;
                                if (typeof data7 !== "string") {
                                    const err24 = { instancePath: instancePath + "/data/transfers/" + i0 + "/currency", schemaPath: "#/properties/data/properties/transfers/items/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err24];
                                    }
                                    else {
                                        vErrors.push(err24);
                                    }
                                    errors++;
                                }
                                if (!(((data7 === "BRL") || (data7 === "CAD")) || (data7 === "USD"))) {
                                    const err25 = { instancePath: instancePath + "/data/transfers/" + i0 + "/currency", schemaPath: "#/properties/data/properties/transfers/items/properties/currency/enum", keyword: "enum", params: { allowedValues: schema21.properties.data.properties.transfers.items.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err25];
                                    }
                                    else {
                                        vErrors.push(err25);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.revision !== undefined) {
                                let data8 = data2.revision;
                                if (typeof data8 === "string") {
                                    if (!pattern2.test(data8)) {
                                        const err26 = { instancePath: instancePath + "/data/transfers/" + i0 + "/revision", schemaPath: "#/properties/data/properties/transfers/items/properties/revision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err26];
                                        }
                                        else {
                                            vErrors.push(err26);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err27 = { instancePath: instancePath + "/data/transfers/" + i0 + "/revision", schemaPath: "#/properties/data/properties/transfers/items/properties/revision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err27];
                                    }
                                    else {
                                        vErrors.push(err27);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.canceled !== undefined) {
                                if (typeof data2.canceled !== "boolean") {
                                    const err28 = { instancePath: instancePath + "/data/transfers/" + i0 + "/canceled", schemaPath: "#/properties/data/properties/transfers/items/properties/canceled/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                    if (vErrors === null) {
                                        vErrors = [err28];
                                    }
                                    else {
                                        vErrors.push(err28);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.fx !== undefined) {
                                let data10 = data2.fx;
                                if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
                                    if (data10.inputMode === undefined) {
                                        const err29 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/required", keyword: "required", params: { missingProperty: "inputMode" }, message: "must have required property '" + "inputMode" + "'" };
                                        if (vErrors === null) {
                                            vErrors = [err29];
                                        }
                                        else {
                                            vErrors.push(err29);
                                        }
                                        errors++;
                                    }
                                    if (data10.sourceCurrency === undefined) {
                                        const err30 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/required", keyword: "required", params: { missingProperty: "sourceCurrency" }, message: "must have required property '" + "sourceCurrency" + "'" };
                                        if (vErrors === null) {
                                            vErrors = [err30];
                                        }
                                        else {
                                            vErrors.push(err30);
                                        }
                                        errors++;
                                    }
                                    if (data10.destinationCurrency === undefined) {
                                        const err31 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/required", keyword: "required", params: { missingProperty: "destinationCurrency" }, message: "must have required property '" + "destinationCurrency" + "'" };
                                        if (vErrors === null) {
                                            vErrors = [err31];
                                        }
                                        else {
                                            vErrors.push(err31);
                                        }
                                        errors++;
                                    }
                                    if (data10.directionLabel === undefined) {
                                        const err32 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/required", keyword: "required", params: { missingProperty: "directionLabel" }, message: "must have required property '" + "directionLabel" + "'" };
                                        if (vErrors === null) {
                                            vErrors = [err32];
                                        }
                                        else {
                                            vErrors.push(err32);
                                        }
                                        errors++;
                                    }
                                    if (data10.suppliedRate === undefined) {
                                        const err33 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/required", keyword: "required", params: { missingProperty: "suppliedRate" }, message: "must have required property '" + "suppliedRate" + "'" };
                                        if (vErrors === null) {
                                            vErrors = [err33];
                                        }
                                        else {
                                            vErrors.push(err33);
                                        }
                                        errors++;
                                    }
                                    if (data10.rateCoefficient === undefined) {
                                        const err34 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/required", keyword: "required", params: { missingProperty: "rateCoefficient" }, message: "must have required property '" + "rateCoefficient" + "'" };
                                        if (vErrors === null) {
                                            vErrors = [err34];
                                        }
                                        else {
                                            vErrors.push(err34);
                                        }
                                        errors++;
                                    }
                                    if (data10.rateScale === undefined) {
                                        const err35 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/required", keyword: "required", params: { missingProperty: "rateScale" }, message: "must have required property '" + "rateScale" + "'" };
                                        if (vErrors === null) {
                                            vErrors = [err35];
                                        }
                                        else {
                                            vErrors.push(err35);
                                        }
                                        errors++;
                                    }
                                    if (data10.displayRate === undefined) {
                                        const err36 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/required", keyword: "required", params: { missingProperty: "displayRate" }, message: "must have required property '" + "displayRate" + "'" };
                                        if (vErrors === null) {
                                            vErrors = [err36];
                                        }
                                        else {
                                            vErrors.push(err36);
                                        }
                                        errors++;
                                    }
                                    if (data10.displayRateApproximate === undefined) {
                                        const err37 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/required", keyword: "required", params: { missingProperty: "displayRateApproximate" }, message: "must have required property '" + "displayRateApproximate" + "'" };
                                        if (vErrors === null) {
                                            vErrors = [err37];
                                        }
                                        else {
                                            vErrors.push(err37);
                                        }
                                        errors++;
                                    }
                                    for (const key3 in data10) {
                                        if (!(func35.call(schema21.properties.data.properties.transfers.items.properties.fx.properties, key3))) {
                                            const err38 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                                            if (vErrors === null) {
                                                vErrors = [err38];
                                            }
                                            else {
                                                vErrors.push(err38);
                                            }
                                            errors++;
                                        }
                                    }
                                    if (data10.inputMode !== undefined) {
                                        let data11 = data10.inputMode;
                                        if (typeof data11 !== "string") {
                                            const err39 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx/inputMode", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/properties/inputMode/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                            if (vErrors === null) {
                                                vErrors = [err39];
                                            }
                                            else {
                                                vErrors.push(err39);
                                            }
                                            errors++;
                                        }
                                        if (!((data11 === "rate") || (data11 === "destination"))) {
                                            const err40 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx/inputMode", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/properties/inputMode/enum", keyword: "enum", params: { allowedValues: schema21.properties.data.properties.transfers.items.properties.fx.properties.inputMode.enum }, message: "must be equal to one of the allowed values" };
                                            if (vErrors === null) {
                                                vErrors = [err40];
                                            }
                                            else {
                                                vErrors.push(err40);
                                            }
                                            errors++;
                                        }
                                    }
                                    if (data10.sourceCurrency !== undefined) {
                                        let data12 = data10.sourceCurrency;
                                        if (typeof data12 !== "string") {
                                            const err41 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx/sourceCurrency", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/properties/sourceCurrency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                            if (vErrors === null) {
                                                vErrors = [err41];
                                            }
                                            else {
                                                vErrors.push(err41);
                                            }
                                            errors++;
                                        }
                                        if (!(((data12 === "BRL") || (data12 === "CAD")) || (data12 === "USD"))) {
                                            const err42 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx/sourceCurrency", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/properties/sourceCurrency/enum", keyword: "enum", params: { allowedValues: schema21.properties.data.properties.transfers.items.properties.fx.properties.sourceCurrency.enum }, message: "must be equal to one of the allowed values" };
                                            if (vErrors === null) {
                                                vErrors = [err42];
                                            }
                                            else {
                                                vErrors.push(err42);
                                            }
                                            errors++;
                                        }
                                    }
                                    if (data10.destinationCurrency !== undefined) {
                                        let data13 = data10.destinationCurrency;
                                        if (typeof data13 !== "string") {
                                            const err43 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx/destinationCurrency", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/properties/destinationCurrency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                            if (vErrors === null) {
                                                vErrors = [err43];
                                            }
                                            else {
                                                vErrors.push(err43);
                                            }
                                            errors++;
                                        }
                                        if (!(((data13 === "BRL") || (data13 === "CAD")) || (data13 === "USD"))) {
                                            const err44 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx/destinationCurrency", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/properties/destinationCurrency/enum", keyword: "enum", params: { allowedValues: schema21.properties.data.properties.transfers.items.properties.fx.properties.destinationCurrency.enum }, message: "must be equal to one of the allowed values" };
                                            if (vErrors === null) {
                                                vErrors = [err44];
                                            }
                                            else {
                                                vErrors.push(err44);
                                            }
                                            errors++;
                                        }
                                    }
                                    if (data10.directionLabel !== undefined) {
                                        let data14 = data10.directionLabel;
                                        if (typeof data14 === "string") {
                                            if (func2(data14) > 32) {
                                                const err45 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx/directionLabel", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/properties/directionLabel/maxLength", keyword: "maxLength", params: { limit: 32 }, message: "must NOT have more than 32 characters" };
                                                if (vErrors === null) {
                                                    vErrors = [err45];
                                                }
                                                else {
                                                    vErrors.push(err45);
                                                }
                                                errors++;
                                            }
                                            if (func2(data14) < 1) {
                                                const err46 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx/directionLabel", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/properties/directionLabel/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                                if (vErrors === null) {
                                                    vErrors = [err46];
                                                }
                                                else {
                                                    vErrors.push(err46);
                                                }
                                                errors++;
                                            }
                                        }
                                        else {
                                            const err47 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx/directionLabel", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/properties/directionLabel/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                            if (vErrors === null) {
                                                vErrors = [err47];
                                            }
                                            else {
                                                vErrors.push(err47);
                                            }
                                            errors++;
                                        }
                                    }
                                    if (data10.suppliedRate !== undefined) {
                                        let data15 = data10.suppliedRate;
                                        if ((typeof data15 !== "string") && (data15 !== null)) {
                                            const err48 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx/suppliedRate", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/properties/suppliedRate/type", keyword: "type", params: { type: schema21.properties.data.properties.transfers.items.properties.fx.properties.suppliedRate.type }, message: "must be string,null" };
                                            if (vErrors === null) {
                                                vErrors = [err48];
                                            }
                                            else {
                                                vErrors.push(err48);
                                            }
                                            errors++;
                                        }
                                        if (typeof data15 === "string") {
                                            if (!pattern60.test(data15)) {
                                                const err49 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx/suppliedRate", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/properties/suppliedRate/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]{0,11})(?:\\.[0-9]{1,12})?$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]{0,11})(?:\\.[0-9]{1,12})?$" + "\"" };
                                                if (vErrors === null) {
                                                    vErrors = [err49];
                                                }
                                                else {
                                                    vErrors.push(err49);
                                                }
                                                errors++;
                                            }
                                        }
                                    }
                                    if (data10.rateCoefficient !== undefined) {
                                        let data16 = data10.rateCoefficient;
                                        if ((typeof data16 !== "string") && (data16 !== null)) {
                                            const err50 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx/rateCoefficient", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/properties/rateCoefficient/type", keyword: "type", params: { type: schema21.properties.data.properties.transfers.items.properties.fx.properties.rateCoefficient.type }, message: "must be string,null" };
                                            if (vErrors === null) {
                                                vErrors = [err50];
                                            }
                                            else {
                                                vErrors.push(err50);
                                            }
                                            errors++;
                                        }
                                        if (typeof data16 === "string") {
                                            if (!pattern61.test(data16)) {
                                                const err51 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx/rateCoefficient", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/properties/rateCoefficient/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]{0,23}$" }, message: "must match pattern \"" + "^[1-9][0-9]{0,23}$" + "\"" };
                                                if (vErrors === null) {
                                                    vErrors = [err51];
                                                }
                                                else {
                                                    vErrors.push(err51);
                                                }
                                                errors++;
                                            }
                                        }
                                    }
                                    if (data10.rateScale !== undefined) {
                                        let data17 = data10.rateScale;
                                        if ((!(((typeof data17 == "number") && (!(data17 % 1) && !isNaN(data17))) && (isFinite(data17)))) && (data17 !== null)) {
                                            const err52 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx/rateScale", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/properties/rateScale/type", keyword: "type", params: { type: schema21.properties.data.properties.transfers.items.properties.fx.properties.rateScale.type }, message: "must be integer,null" };
                                            if (vErrors === null) {
                                                vErrors = [err52];
                                            }
                                            else {
                                                vErrors.push(err52);
                                            }
                                            errors++;
                                        }
                                        if ((typeof data17 == "number") && (isFinite(data17))) {
                                            if (data17 > 12 || isNaN(data17)) {
                                                const err53 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx/rateScale", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/properties/rateScale/maximum", keyword: "maximum", params: { comparison: "<=", limit: 12 }, message: "must be <= 12" };
                                                if (vErrors === null) {
                                                    vErrors = [err53];
                                                }
                                                else {
                                                    vErrors.push(err53);
                                                }
                                                errors++;
                                            }
                                            if (data17 < 0 || isNaN(data17)) {
                                                const err54 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx/rateScale", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/properties/rateScale/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                                                if (vErrors === null) {
                                                    vErrors = [err54];
                                                }
                                                else {
                                                    vErrors.push(err54);
                                                }
                                                errors++;
                                            }
                                        }
                                    }
                                    if (data10.displayRate !== undefined) {
                                        let data18 = data10.displayRate;
                                        if (typeof data18 === "string") {
                                            if (!pattern62.test(data18)) {
                                                const err55 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx/displayRate", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/properties/displayRate/pattern", keyword: "pattern", params: { pattern: "^[0-9]+\\.[0-9]{6}$" }, message: "must match pattern \"" + "^[0-9]+\\.[0-9]{6}$" + "\"" };
                                                if (vErrors === null) {
                                                    vErrors = [err55];
                                                }
                                                else {
                                                    vErrors.push(err55);
                                                }
                                                errors++;
                                            }
                                        }
                                        else {
                                            const err56 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx/displayRate", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/properties/displayRate/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                            if (vErrors === null) {
                                                vErrors = [err56];
                                            }
                                            else {
                                                vErrors.push(err56);
                                            }
                                            errors++;
                                        }
                                    }
                                    if (data10.displayRateApproximate !== undefined) {
                                        if (typeof data10.displayRateApproximate !== "boolean") {
                                            const err57 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx/displayRateApproximate", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/properties/displayRateApproximate/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                            if (vErrors === null) {
                                                vErrors = [err57];
                                            }
                                            else {
                                                vErrors.push(err57);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                                else {
                                    const err58 = { instancePath: instancePath + "/data/transfers/" + i0 + "/fx", schemaPath: "#/properties/data/properties/transfers/items/properties/fx/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                    if (vErrors === null) {
                                        vErrors = [err58];
                                    }
                                    else {
                                        vErrors.push(err58);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.legs !== undefined) {
                                let data20 = data2.legs;
                                if (Array.isArray(data20)) {
                                    if (data20.length > 2) {
                                        const err59 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs", schemaPath: "#/properties/data/properties/transfers/items/properties/legs/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" };
                                        if (vErrors === null) {
                                            vErrors = [err59];
                                        }
                                        else {
                                            vErrors.push(err59);
                                        }
                                        errors++;
                                    }
                                    if (data20.length < 2) {
                                        const err60 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs", schemaPath: "#/properties/data/properties/transfers/items/properties/legs/minItems", keyword: "minItems", params: { limit: 2 }, message: "must NOT have fewer than 2 items" };
                                        if (vErrors === null) {
                                            vErrors = [err60];
                                        }
                                        else {
                                            vErrors.push(err60);
                                        }
                                        errors++;
                                    }
                                    const len1 = data20.length;
                                    for (let i1 = 0; i1 < len1; i1++) {
                                        let data21 = data20[i1];
                                        if (data21 && typeof data21 == "object" && !Array.isArray(data21)) {
                                            if (data21.entryId === undefined) {
                                                const err61 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs/" + i1, schemaPath: "#/properties/data/properties/transfers/items/properties/legs/items/required", keyword: "required", params: { missingProperty: "entryId" }, message: "must have required property '" + "entryId" + "'" };
                                                if (vErrors === null) {
                                                    vErrors = [err61];
                                                }
                                                else {
                                                    vErrors.push(err61);
                                                }
                                                errors++;
                                            }
                                            if (data21.accountId === undefined) {
                                                const err62 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs/" + i1, schemaPath: "#/properties/data/properties/transfers/items/properties/legs/items/required", keyword: "required", params: { missingProperty: "accountId" }, message: "must have required property '" + "accountId" + "'" };
                                                if (vErrors === null) {
                                                    vErrors = [err62];
                                                }
                                                else {
                                                    vErrors.push(err62);
                                                }
                                                errors++;
                                            }
                                            if (data21.accountKind === undefined) {
                                                const err63 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs/" + i1, schemaPath: "#/properties/data/properties/transfers/items/properties/legs/items/required", keyword: "required", params: { missingProperty: "accountKind" }, message: "must have required property '" + "accountKind" + "'" };
                                                if (vErrors === null) {
                                                    vErrors = [err63];
                                                }
                                                else {
                                                    vErrors.push(err63);
                                                }
                                                errors++;
                                            }
                                            if (data21.side === undefined) {
                                                const err64 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs/" + i1, schemaPath: "#/properties/data/properties/transfers/items/properties/legs/items/required", keyword: "required", params: { missingProperty: "side" }, message: "must have required property '" + "side" + "'" };
                                                if (vErrors === null) {
                                                    vErrors = [err64];
                                                }
                                                else {
                                                    vErrors.push(err64);
                                                }
                                                errors++;
                                            }
                                            if (data21.signedMinor === undefined) {
                                                const err65 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs/" + i1, schemaPath: "#/properties/data/properties/transfers/items/properties/legs/items/required", keyword: "required", params: { missingProperty: "signedMinor" }, message: "must have required property '" + "signedMinor" + "'" };
                                                if (vErrors === null) {
                                                    vErrors = [err65];
                                                }
                                                else {
                                                    vErrors.push(err65);
                                                }
                                                errors++;
                                            }
                                            if (data21.currency === undefined) {
                                                const err66 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs/" + i1, schemaPath: "#/properties/data/properties/transfers/items/properties/legs/items/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                                                if (vErrors === null) {
                                                    vErrors = [err66];
                                                }
                                                else {
                                                    vErrors.push(err66);
                                                }
                                                errors++;
                                            }
                                            if (data21.revision === undefined) {
                                                const err67 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs/" + i1, schemaPath: "#/properties/data/properties/transfers/items/properties/legs/items/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property '" + "revision" + "'" };
                                                if (vErrors === null) {
                                                    vErrors = [err67];
                                                }
                                                else {
                                                    vErrors.push(err67);
                                                }
                                                errors++;
                                            }
                                            for (const key4 in data21) {
                                                if (!(((((((key4 === "entryId") || (key4 === "accountId")) || (key4 === "accountKind")) || (key4 === "side")) || (key4 === "signedMinor")) || (key4 === "currency")) || (key4 === "revision"))) {
                                                    const err68 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs/" + i1, schemaPath: "#/properties/data/properties/transfers/items/properties/legs/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key4 }, message: "must NOT have additional properties" };
                                                    if (vErrors === null) {
                                                        vErrors = [err68];
                                                    }
                                                    else {
                                                        vErrors.push(err68);
                                                    }
                                                    errors++;
                                                }
                                            }
                                            if (data21.entryId !== undefined) {
                                                let data22 = data21.entryId;
                                                if (typeof data22 === "string") {
                                                    if (!pattern0.test(data22)) {
                                                        const err69 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs/" + i1 + "/entryId", schemaPath: "#/properties/data/properties/transfers/items/properties/legs/items/properties/entryId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                                        if (vErrors === null) {
                                                            vErrors = [err69];
                                                        }
                                                        else {
                                                            vErrors.push(err69);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                else {
                                                    const err70 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs/" + i1 + "/entryId", schemaPath: "#/properties/data/properties/transfers/items/properties/legs/items/properties/entryId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                        vErrors = [err70];
                                                    }
                                                    else {
                                                        vErrors.push(err70);
                                                    }
                                                    errors++;
                                                }
                                            }
                                            if (data21.accountId !== undefined) {
                                                let data23 = data21.accountId;
                                                if (typeof data23 === "string") {
                                                    if (!pattern0.test(data23)) {
                                                        const err71 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs/" + i1 + "/accountId", schemaPath: "#/properties/data/properties/transfers/items/properties/legs/items/properties/accountId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                                        if (vErrors === null) {
                                                            vErrors = [err71];
                                                        }
                                                        else {
                                                            vErrors.push(err71);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                else {
                                                    const err72 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs/" + i1 + "/accountId", schemaPath: "#/properties/data/properties/transfers/items/properties/legs/items/properties/accountId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                        vErrors = [err72];
                                                    }
                                                    else {
                                                        vErrors.push(err72);
                                                    }
                                                    errors++;
                                                }
                                            }
                                            if (data21.accountKind !== undefined) {
                                                let data24 = data21.accountKind;
                                                if (typeof data24 !== "string") {
                                                    const err73 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs/" + i1 + "/accountKind", schemaPath: "#/properties/data/properties/transfers/items/properties/legs/items/properties/accountKind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                        vErrors = [err73];
                                                    }
                                                    else {
                                                        vErrors.push(err73);
                                                    }
                                                    errors++;
                                                }
                                                if (!((data24 === "cash") || (data24 === "card"))) {
                                                    const err74 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs/" + i1 + "/accountKind", schemaPath: "#/properties/data/properties/transfers/items/properties/legs/items/properties/accountKind/enum", keyword: "enum", params: { allowedValues: schema21.properties.data.properties.transfers.items.properties.legs.items.properties.accountKind.enum }, message: "must be equal to one of the allowed values" };
                                                    if (vErrors === null) {
                                                        vErrors = [err74];
                                                    }
                                                    else {
                                                        vErrors.push(err74);
                                                    }
                                                    errors++;
                                                }
                                            }
                                            if (data21.side !== undefined) {
                                                let data25 = data21.side;
                                                if (typeof data25 !== "string") {
                                                    const err75 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs/" + i1 + "/side", schemaPath: "#/properties/data/properties/transfers/items/properties/legs/items/properties/side/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                        vErrors = [err75];
                                                    }
                                                    else {
                                                        vErrors.push(err75);
                                                    }
                                                    errors++;
                                                }
                                                if (!((data25 === "outgoing") || (data25 === "incoming"))) {
                                                    const err76 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs/" + i1 + "/side", schemaPath: "#/properties/data/properties/transfers/items/properties/legs/items/properties/side/enum", keyword: "enum", params: { allowedValues: schema21.properties.data.properties.transfers.items.properties.legs.items.properties.side.enum }, message: "must be equal to one of the allowed values" };
                                                    if (vErrors === null) {
                                                        vErrors = [err76];
                                                    }
                                                    else {
                                                        vErrors.push(err76);
                                                    }
                                                    errors++;
                                                }
                                            }
                                            if (data21.signedMinor !== undefined) {
                                                let data26 = data21.signedMinor;
                                                if (typeof data26 === "string") {
                                                    if (!pattern3.test(data26)) {
                                                        const err77 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs/" + i1 + "/signedMinor", schemaPath: "#/properties/data/properties/transfers/items/properties/legs/items/properties/signedMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                                        if (vErrors === null) {
                                                            vErrors = [err77];
                                                        }
                                                        else {
                                                            vErrors.push(err77);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                else {
                                                    const err78 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs/" + i1 + "/signedMinor", schemaPath: "#/properties/data/properties/transfers/items/properties/legs/items/properties/signedMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                        vErrors = [err78];
                                                    }
                                                    else {
                                                        vErrors.push(err78);
                                                    }
                                                    errors++;
                                                }
                                            }
                                            if (data21.currency !== undefined) {
                                                let data27 = data21.currency;
                                                if (typeof data27 !== "string") {
                                                    const err79 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs/" + i1 + "/currency", schemaPath: "#/properties/data/properties/transfers/items/properties/legs/items/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                        vErrors = [err79];
                                                    }
                                                    else {
                                                        vErrors.push(err79);
                                                    }
                                                    errors++;
                                                }
                                                if (!(((data27 === "BRL") || (data27 === "CAD")) || (data27 === "USD"))) {
                                                    const err80 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs/" + i1 + "/currency", schemaPath: "#/properties/data/properties/transfers/items/properties/legs/items/properties/currency/enum", keyword: "enum", params: { allowedValues: schema21.properties.data.properties.transfers.items.properties.legs.items.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                                                    if (vErrors === null) {
                                                        vErrors = [err80];
                                                    }
                                                    else {
                                                        vErrors.push(err80);
                                                    }
                                                    errors++;
                                                }
                                            }
                                            if (data21.revision !== undefined) {
                                                let data28 = data21.revision;
                                                if (typeof data28 === "string") {
                                                    if (!pattern2.test(data28)) {
                                                        const err81 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs/" + i1 + "/revision", schemaPath: "#/properties/data/properties/transfers/items/properties/legs/items/properties/revision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                                                        if (vErrors === null) {
                                                            vErrors = [err81];
                                                        }
                                                        else {
                                                            vErrors.push(err81);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                else {
                                                    const err82 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs/" + i1 + "/revision", schemaPath: "#/properties/data/properties/transfers/items/properties/legs/items/properties/revision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                        vErrors = [err82];
                                                    }
                                                    else {
                                                        vErrors.push(err82);
                                                    }
                                                    errors++;
                                                }
                                            }
                                        }
                                        else {
                                            const err83 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs/" + i1, schemaPath: "#/properties/data/properties/transfers/items/properties/legs/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                            if (vErrors === null) {
                                                vErrors = [err83];
                                            }
                                            else {
                                                vErrors.push(err83);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                                else {
                                    const err84 = { instancePath: instancePath + "/data/transfers/" + i0 + "/legs", schemaPath: "#/properties/data/properties/transfers/items/properties/legs/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                                    if (vErrors === null) {
                                        vErrors = [err84];
                                    }
                                    else {
                                        vErrors.push(err84);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err85 = { instancePath: instancePath + "/data/transfers/" + i0, schemaPath: "#/properties/data/properties/transfers/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                                vErrors = [err85];
                            }
                            else {
                                vErrors.push(err85);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err86 = { instancePath: instancePath + "/data/transfers", schemaPath: "#/properties/data/properties/transfers/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err86];
                    }
                    else {
                        vErrors.push(err86);
                    }
                    errors++;
                }
            }
        }
        else {
            const err87 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err87];
            }
            else {
                vErrors.push(err87);
            }
            errors++;
        }
    }
    if (data.meta !== undefined) {
        let data29 = data.meta;
        if (data29 && typeof data29 == "object" && !Array.isArray(data29)) {
            if (data29.requestId === undefined) {
                const err88 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "requestId" }, message: "must have required property '" + "requestId" + "'" };
                if (vErrors === null) {
                    vErrors = [err88];
                }
                else {
                    vErrors.push(err88);
                }
                errors++;
            }
            if (data29.asOf === undefined) {
                const err89 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "asOf" }, message: "must have required property '" + "asOf" + "'" };
                if (vErrors === null) {
                    vErrors = [err89];
                }
                else {
                    vErrors.push(err89);
                }
                errors++;
            }
            if (data29.businessToday === undefined) {
                const err90 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err90];
                }
                else {
                    vErrors.push(err90);
                }
                errors++;
            }
            if (data29.timeZone === undefined) {
                const err91 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "timeZone" }, message: "must have required property '" + "timeZone" + "'" };
                if (vErrors === null) {
                    vErrors = [err91];
                }
                else {
                    vErrors.push(err91);
                }
                errors++;
            }
            if (data29.dataRevision === undefined) {
                const err92 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "dataRevision" }, message: "must have required property '" + "dataRevision" + "'" };
                if (vErrors === null) {
                    vErrors = [err92];
                }
                else {
                    vErrors.push(err92);
                }
                errors++;
            }
            for (const key5 in data29) {
                if (!(((((key5 === "requestId") || (key5 === "asOf")) || (key5 === "businessToday")) || (key5 === "timeZone")) || (key5 === "dataRevision"))) {
                    const err93 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key5 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err93];
                    }
                    else {
                        vErrors.push(err93);
                    }
                    errors++;
                }
            }
            if (data29.requestId !== undefined) {
                let data30 = data29.requestId;
                if (typeof data30 === "string") {
                    if (func2(data30) > 64) {
                        const err94 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err94];
                        }
                        else {
                            vErrors.push(err94);
                        }
                        errors++;
                    }
                    if (func2(data30) < 1) {
                        const err95 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err95];
                        }
                        else {
                            vErrors.push(err95);
                        }
                        errors++;
                    }
                }
                else {
                    const err96 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err96];
                    }
                    else {
                        vErrors.push(err96);
                    }
                    errors++;
                }
            }
            if (data29.asOf !== undefined) {
                let data31 = data29.asOf;
                if (typeof data31 === "string") {
                    if (func2(data31) > 64) {
                        const err97 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err97];
                        }
                        else {
                            vErrors.push(err97);
                        }
                        errors++;
                    }
                    if (func2(data31) < 1) {
                        const err98 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err98];
                        }
                        else {
                            vErrors.push(err98);
                        }
                        errors++;
                    }
                }
                else {
                    const err99 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err99];
                    }
                    else {
                        vErrors.push(err99);
                    }
                    errors++;
                }
            }
            if (data29.businessToday !== undefined) {
                let data32 = data29.businessToday;
                if (typeof data32 === "string") {
                    if (!pattern4.test(data32)) {
                        const err100 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err100];
                        }
                        else {
                            vErrors.push(err100);
                        }
                        errors++;
                    }
                }
                else {
                    const err101 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err101];
                    }
                    else {
                        vErrors.push(err101);
                    }
                    errors++;
                }
            }
            if (data29.timeZone !== undefined) {
                let data33 = data29.timeZone;
                if (typeof data33 === "string") {
                    if (func2(data33) > 64) {
                        const err102 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err102];
                        }
                        else {
                            vErrors.push(err102);
                        }
                        errors++;
                    }
                    if (func2(data33) < 1) {
                        const err103 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err103];
                        }
                        else {
                            vErrors.push(err103);
                        }
                        errors++;
                    }
                }
                else {
                    const err104 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err104];
                    }
                    else {
                        vErrors.push(err104);
                    }
                    errors++;
                }
            }
            if (data29.dataRevision !== undefined) {
                let data34 = data29.dataRevision;
                if (typeof data34 === "string") {
                    if (!pattern2.test(data34)) {
                        const err105 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err105];
                        }
                        else {
                            vErrors.push(err105);
                        }
                        errors++;
                    }
                }
                else {
                    const err106 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err106];
                    }
                    else {
                        vErrors.push(err106);
                    }
                    errors++;
                }
            }
        }
        else {
            const err107 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err107];
            }
            else {
                vErrors.push(err107);
            }
            errors++;
        }
    }
}
else {
    const err108 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
        vErrors = [err108];
    }
    else {
        vErrors.push(err108);
    }
    errors++;
} validate20.errors = vErrors; return errors === 0; }
export const validateLedgerTransferPreviewEnvelope = validate21;
const schema22 = { "$id": "https://saldo.local/schemas/ledger-transfer-preview-envelope.json", "$schema": "http://json-schema.org/draft-07/schema#", "title": "LedgerTransferPreviewEnvelope", "type": "object", "additionalProperties": false, "required": ["data", "meta"], "properties": { "data": { "type": "object", "additionalProperties": false, "required": ["id", "action", "transferId", "revision", "businessToday", "expiresAt", "status", "transferDate", "description", "currency", "canceled", "legs", "affectedEntryIds"], "properties": { "id": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "action": { "type": "string", "enum": ["transfer.create", "transfer.fxCreate", "transfer.update", "transfer.complete", "transfer.delete"] }, "transferId": { "type": ["string", "null"], "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "revision": { "type": ["string", "null"], "pattern": "^[1-9][0-9]*$" }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "expiresAt": { "type": "string", "minLength": 1, "maxLength": 64 }, "status": { "type": "string", "enum": ["planned", "completed"] }, "transferDate": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "description": { "type": "string", "minLength": 1, "maxLength": 500 }, "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "canceled": { "type": "boolean" }, "fx": { "type": "object", "additionalProperties": false, "required": ["inputMode", "sourceCurrency", "destinationCurrency", "directionLabel", "suppliedRate", "rateCoefficient", "rateScale", "displayRate", "displayRateApproximate"], "properties": { "inputMode": { "type": "string", "enum": ["rate", "destination"] }, "sourceCurrency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "destinationCurrency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "directionLabel": { "type": "string", "minLength": 1, "maxLength": 32 }, "suppliedRate": { "type": ["string", "null"], "pattern": "^(?:0|[1-9][0-9]{0,11})(?:\\.[0-9]{1,12})?$" }, "rateCoefficient": { "type": ["string", "null"], "pattern": "^[1-9][0-9]{0,23}$" }, "rateScale": { "type": ["integer", "null"], "minimum": 0, "maximum": 12 }, "displayRate": { "type": "string", "pattern": "^[0-9]+\\.[0-9]{6}$" }, "displayRateApproximate": { "type": "boolean" } } }, "legs": { "type": "array", "maxItems": 2, "items": { "type": "object", "additionalProperties": false, "required": ["accountId", "accountKind", "side", "signedMinor", "currency"], "properties": { "accountId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "accountKind": { "type": "string", "enum": ["cash", "card"] }, "side": { "type": "string", "enum": ["outgoing", "incoming"] }, "signedMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "entryId": { "type": ["string", "null"], "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } } } }, "affectedEntryIds": { "type": "array", "maxItems": 2, "items": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } } } }, "meta": { "type": "object", "additionalProperties": false, "required": ["requestId", "asOf", "businessToday", "timeZone", "dataRevision"], "properties": { "requestId": { "type": "string", "minLength": 1, "maxLength": 64 }, "asOf": { "type": "string", "minLength": 1, "maxLength": 64 }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "timeZone": { "type": "string", "minLength": 1, "maxLength": 64 }, "dataRevision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } } } };
function validate21(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="https://saldo.local/schemas/ledger-transfer-preview-envelope.json" */ ; let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.data === undefined) {
        const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property '" + "data" + "'" };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
    }
    if (data.meta === undefined) {
        const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "meta" }, message: "must have required property '" + "meta" + "'" };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    for (const key0 in data) {
        if (!((key0 === "data") || (key0 === "meta"))) {
            const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.data !== undefined) {
        let data0 = data.data;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.id === undefined) {
                const err3 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property '" + "id" + "'" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
            if (data0.action === undefined) {
                const err4 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "action" }, message: "must have required property '" + "action" + "'" };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
            if (data0.transferId === undefined) {
                const err5 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "transferId" }, message: "must have required property '" + "transferId" + "'" };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
            }
            if (data0.revision === undefined) {
                const err6 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property '" + "revision" + "'" };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
            }
            if (data0.businessToday === undefined) {
                const err7 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err7];
                }
                else {
                    vErrors.push(err7);
                }
                errors++;
            }
            if (data0.expiresAt === undefined) {
                const err8 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "expiresAt" }, message: "must have required property '" + "expiresAt" + "'" };
                if (vErrors === null) {
                    vErrors = [err8];
                }
                else {
                    vErrors.push(err8);
                }
                errors++;
            }
            if (data0.status === undefined) {
                const err9 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property '" + "status" + "'" };
                if (vErrors === null) {
                    vErrors = [err9];
                }
                else {
                    vErrors.push(err9);
                }
                errors++;
            }
            if (data0.transferDate === undefined) {
                const err10 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "transferDate" }, message: "must have required property '" + "transferDate" + "'" };
                if (vErrors === null) {
                    vErrors = [err10];
                }
                else {
                    vErrors.push(err10);
                }
                errors++;
            }
            if (data0.description === undefined) {
                const err11 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "description" }, message: "must have required property '" + "description" + "'" };
                if (vErrors === null) {
                    vErrors = [err11];
                }
                else {
                    vErrors.push(err11);
                }
                errors++;
            }
            if (data0.currency === undefined) {
                const err12 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                if (vErrors === null) {
                    vErrors = [err12];
                }
                else {
                    vErrors.push(err12);
                }
                errors++;
            }
            if (data0.canceled === undefined) {
                const err13 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "canceled" }, message: "must have required property '" + "canceled" + "'" };
                if (vErrors === null) {
                    vErrors = [err13];
                }
                else {
                    vErrors.push(err13);
                }
                errors++;
            }
            if (data0.legs === undefined) {
                const err14 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "legs" }, message: "must have required property '" + "legs" + "'" };
                if (vErrors === null) {
                    vErrors = [err14];
                }
                else {
                    vErrors.push(err14);
                }
                errors++;
            }
            if (data0.affectedEntryIds === undefined) {
                const err15 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "affectedEntryIds" }, message: "must have required property '" + "affectedEntryIds" + "'" };
                if (vErrors === null) {
                    vErrors = [err15];
                }
                else {
                    vErrors.push(err15);
                }
                errors++;
            }
            for (const key1 in data0) {
                if (!(func35.call(schema22.properties.data.properties, key1))) {
                    const err16 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err16];
                    }
                    else {
                        vErrors.push(err16);
                    }
                    errors++;
                }
            }
            if (data0.id !== undefined) {
                let data1 = data0.id;
                if (typeof data1 === "string") {
                    if (!pattern0.test(data1)) {
                        const err17 = { instancePath: instancePath + "/data/id", schemaPath: "#/properties/data/properties/id/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err17];
                        }
                        else {
                            vErrors.push(err17);
                        }
                        errors++;
                    }
                }
                else {
                    const err18 = { instancePath: instancePath + "/data/id", schemaPath: "#/properties/data/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err18];
                    }
                    else {
                        vErrors.push(err18);
                    }
                    errors++;
                }
            }
            if (data0.action !== undefined) {
                let data2 = data0.action;
                if (typeof data2 !== "string") {
                    const err19 = { instancePath: instancePath + "/data/action", schemaPath: "#/properties/data/properties/action/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err19];
                    }
                    else {
                        vErrors.push(err19);
                    }
                    errors++;
                }
                if (!(((((data2 === "transfer.create") || (data2 === "transfer.fxCreate")) || (data2 === "transfer.update")) || (data2 === "transfer.complete")) || (data2 === "transfer.delete"))) {
                    const err20 = { instancePath: instancePath + "/data/action", schemaPath: "#/properties/data/properties/action/enum", keyword: "enum", params: { allowedValues: schema22.properties.data.properties.action.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err20];
                    }
                    else {
                        vErrors.push(err20);
                    }
                    errors++;
                }
            }
            if (data0.transferId !== undefined) {
                let data3 = data0.transferId;
                if ((typeof data3 !== "string") && (data3 !== null)) {
                    const err21 = { instancePath: instancePath + "/data/transferId", schemaPath: "#/properties/data/properties/transferId/type", keyword: "type", params: { type: schema22.properties.data.properties.transferId.type }, message: "must be string,null" };
                    if (vErrors === null) {
                        vErrors = [err21];
                    }
                    else {
                        vErrors.push(err21);
                    }
                    errors++;
                }
                if (typeof data3 === "string") {
                    if (!pattern0.test(data3)) {
                        const err22 = { instancePath: instancePath + "/data/transferId", schemaPath: "#/properties/data/properties/transferId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err22];
                        }
                        else {
                            vErrors.push(err22);
                        }
                        errors++;
                    }
                }
            }
            if (data0.revision !== undefined) {
                let data4 = data0.revision;
                if ((typeof data4 !== "string") && (data4 !== null)) {
                    const err23 = { instancePath: instancePath + "/data/revision", schemaPath: "#/properties/data/properties/revision/type", keyword: "type", params: { type: schema22.properties.data.properties.revision.type }, message: "must be string,null" };
                    if (vErrors === null) {
                        vErrors = [err23];
                    }
                    else {
                        vErrors.push(err23);
                    }
                    errors++;
                }
                if (typeof data4 === "string") {
                    if (!pattern2.test(data4)) {
                        const err24 = { instancePath: instancePath + "/data/revision", schemaPath: "#/properties/data/properties/revision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err24];
                        }
                        else {
                            vErrors.push(err24);
                        }
                        errors++;
                    }
                }
            }
            if (data0.businessToday !== undefined) {
                let data5 = data0.businessToday;
                if (typeof data5 === "string") {
                    if (!pattern4.test(data5)) {
                        const err25 = { instancePath: instancePath + "/data/businessToday", schemaPath: "#/properties/data/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err25];
                        }
                        else {
                            vErrors.push(err25);
                        }
                        errors++;
                    }
                }
                else {
                    const err26 = { instancePath: instancePath + "/data/businessToday", schemaPath: "#/properties/data/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err26];
                    }
                    else {
                        vErrors.push(err26);
                    }
                    errors++;
                }
            }
            if (data0.expiresAt !== undefined) {
                let data6 = data0.expiresAt;
                if (typeof data6 === "string") {
                    if (func2(data6) > 64) {
                        const err27 = { instancePath: instancePath + "/data/expiresAt", schemaPath: "#/properties/data/properties/expiresAt/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err27];
                        }
                        else {
                            vErrors.push(err27);
                        }
                        errors++;
                    }
                    if (func2(data6) < 1) {
                        const err28 = { instancePath: instancePath + "/data/expiresAt", schemaPath: "#/properties/data/properties/expiresAt/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err28];
                        }
                        else {
                            vErrors.push(err28);
                        }
                        errors++;
                    }
                }
                else {
                    const err29 = { instancePath: instancePath + "/data/expiresAt", schemaPath: "#/properties/data/properties/expiresAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err29];
                    }
                    else {
                        vErrors.push(err29);
                    }
                    errors++;
                }
            }
            if (data0.status !== undefined) {
                let data7 = data0.status;
                if (typeof data7 !== "string") {
                    const err30 = { instancePath: instancePath + "/data/status", schemaPath: "#/properties/data/properties/status/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err30];
                    }
                    else {
                        vErrors.push(err30);
                    }
                    errors++;
                }
                if (!((data7 === "planned") || (data7 === "completed"))) {
                    const err31 = { instancePath: instancePath + "/data/status", schemaPath: "#/properties/data/properties/status/enum", keyword: "enum", params: { allowedValues: schema22.properties.data.properties.status.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err31];
                    }
                    else {
                        vErrors.push(err31);
                    }
                    errors++;
                }
            }
            if (data0.transferDate !== undefined) {
                let data8 = data0.transferDate;
                if (typeof data8 === "string") {
                    if (!pattern4.test(data8)) {
                        const err32 = { instancePath: instancePath + "/data/transferDate", schemaPath: "#/properties/data/properties/transferDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err32];
                        }
                        else {
                            vErrors.push(err32);
                        }
                        errors++;
                    }
                }
                else {
                    const err33 = { instancePath: instancePath + "/data/transferDate", schemaPath: "#/properties/data/properties/transferDate/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err33];
                    }
                    else {
                        vErrors.push(err33);
                    }
                    errors++;
                }
            }
            if (data0.description !== undefined) {
                let data9 = data0.description;
                if (typeof data9 === "string") {
                    if (func2(data9) > 500) {
                        const err34 = { instancePath: instancePath + "/data/description", schemaPath: "#/properties/data/properties/description/maxLength", keyword: "maxLength", params: { limit: 500 }, message: "must NOT have more than 500 characters" };
                        if (vErrors === null) {
                            vErrors = [err34];
                        }
                        else {
                            vErrors.push(err34);
                        }
                        errors++;
                    }
                    if (func2(data9) < 1) {
                        const err35 = { instancePath: instancePath + "/data/description", schemaPath: "#/properties/data/properties/description/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err35];
                        }
                        else {
                            vErrors.push(err35);
                        }
                        errors++;
                    }
                }
                else {
                    const err36 = { instancePath: instancePath + "/data/description", schemaPath: "#/properties/data/properties/description/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err36];
                    }
                    else {
                        vErrors.push(err36);
                    }
                    errors++;
                }
            }
            if (data0.currency !== undefined) {
                let data10 = data0.currency;
                if (typeof data10 !== "string") {
                    const err37 = { instancePath: instancePath + "/data/currency", schemaPath: "#/properties/data/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err37];
                    }
                    else {
                        vErrors.push(err37);
                    }
                    errors++;
                }
                if (!(((data10 === "BRL") || (data10 === "CAD")) || (data10 === "USD"))) {
                    const err38 = { instancePath: instancePath + "/data/currency", schemaPath: "#/properties/data/properties/currency/enum", keyword: "enum", params: { allowedValues: schema22.properties.data.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err38];
                    }
                    else {
                        vErrors.push(err38);
                    }
                    errors++;
                }
            }
            if (data0.canceled !== undefined) {
                if (typeof data0.canceled !== "boolean") {
                    const err39 = { instancePath: instancePath + "/data/canceled", schemaPath: "#/properties/data/properties/canceled/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                    if (vErrors === null) {
                        vErrors = [err39];
                    }
                    else {
                        vErrors.push(err39);
                    }
                    errors++;
                }
            }
            if (data0.fx !== undefined) {
                let data12 = data0.fx;
                if (data12 && typeof data12 == "object" && !Array.isArray(data12)) {
                    if (data12.inputMode === undefined) {
                        const err40 = { instancePath: instancePath + "/data/fx", schemaPath: "#/properties/data/properties/fx/required", keyword: "required", params: { missingProperty: "inputMode" }, message: "must have required property '" + "inputMode" + "'" };
                        if (vErrors === null) {
                            vErrors = [err40];
                        }
                        else {
                            vErrors.push(err40);
                        }
                        errors++;
                    }
                    if (data12.sourceCurrency === undefined) {
                        const err41 = { instancePath: instancePath + "/data/fx", schemaPath: "#/properties/data/properties/fx/required", keyword: "required", params: { missingProperty: "sourceCurrency" }, message: "must have required property '" + "sourceCurrency" + "'" };
                        if (vErrors === null) {
                            vErrors = [err41];
                        }
                        else {
                            vErrors.push(err41);
                        }
                        errors++;
                    }
                    if (data12.destinationCurrency === undefined) {
                        const err42 = { instancePath: instancePath + "/data/fx", schemaPath: "#/properties/data/properties/fx/required", keyword: "required", params: { missingProperty: "destinationCurrency" }, message: "must have required property '" + "destinationCurrency" + "'" };
                        if (vErrors === null) {
                            vErrors = [err42];
                        }
                        else {
                            vErrors.push(err42);
                        }
                        errors++;
                    }
                    if (data12.directionLabel === undefined) {
                        const err43 = { instancePath: instancePath + "/data/fx", schemaPath: "#/properties/data/properties/fx/required", keyword: "required", params: { missingProperty: "directionLabel" }, message: "must have required property '" + "directionLabel" + "'" };
                        if (vErrors === null) {
                            vErrors = [err43];
                        }
                        else {
                            vErrors.push(err43);
                        }
                        errors++;
                    }
                    if (data12.suppliedRate === undefined) {
                        const err44 = { instancePath: instancePath + "/data/fx", schemaPath: "#/properties/data/properties/fx/required", keyword: "required", params: { missingProperty: "suppliedRate" }, message: "must have required property '" + "suppliedRate" + "'" };
                        if (vErrors === null) {
                            vErrors = [err44];
                        }
                        else {
                            vErrors.push(err44);
                        }
                        errors++;
                    }
                    if (data12.rateCoefficient === undefined) {
                        const err45 = { instancePath: instancePath + "/data/fx", schemaPath: "#/properties/data/properties/fx/required", keyword: "required", params: { missingProperty: "rateCoefficient" }, message: "must have required property '" + "rateCoefficient" + "'" };
                        if (vErrors === null) {
                            vErrors = [err45];
                        }
                        else {
                            vErrors.push(err45);
                        }
                        errors++;
                    }
                    if (data12.rateScale === undefined) {
                        const err46 = { instancePath: instancePath + "/data/fx", schemaPath: "#/properties/data/properties/fx/required", keyword: "required", params: { missingProperty: "rateScale" }, message: "must have required property '" + "rateScale" + "'" };
                        if (vErrors === null) {
                            vErrors = [err46];
                        }
                        else {
                            vErrors.push(err46);
                        }
                        errors++;
                    }
                    if (data12.displayRate === undefined) {
                        const err47 = { instancePath: instancePath + "/data/fx", schemaPath: "#/properties/data/properties/fx/required", keyword: "required", params: { missingProperty: "displayRate" }, message: "must have required property '" + "displayRate" + "'" };
                        if (vErrors === null) {
                            vErrors = [err47];
                        }
                        else {
                            vErrors.push(err47);
                        }
                        errors++;
                    }
                    if (data12.displayRateApproximate === undefined) {
                        const err48 = { instancePath: instancePath + "/data/fx", schemaPath: "#/properties/data/properties/fx/required", keyword: "required", params: { missingProperty: "displayRateApproximate" }, message: "must have required property '" + "displayRateApproximate" + "'" };
                        if (vErrors === null) {
                            vErrors = [err48];
                        }
                        else {
                            vErrors.push(err48);
                        }
                        errors++;
                    }
                    for (const key2 in data12) {
                        if (!(func35.call(schema22.properties.data.properties.fx.properties, key2))) {
                            const err49 = { instancePath: instancePath + "/data/fx", schemaPath: "#/properties/data/properties/fx/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                                vErrors = [err49];
                            }
                            else {
                                vErrors.push(err49);
                            }
                            errors++;
                        }
                    }
                    if (data12.inputMode !== undefined) {
                        let data13 = data12.inputMode;
                        if (typeof data13 !== "string") {
                            const err50 = { instancePath: instancePath + "/data/fx/inputMode", schemaPath: "#/properties/data/properties/fx/properties/inputMode/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err50];
                            }
                            else {
                                vErrors.push(err50);
                            }
                            errors++;
                        }
                        if (!((data13 === "rate") || (data13 === "destination"))) {
                            const err51 = { instancePath: instancePath + "/data/fx/inputMode", schemaPath: "#/properties/data/properties/fx/properties/inputMode/enum", keyword: "enum", params: { allowedValues: schema22.properties.data.properties.fx.properties.inputMode.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                                vErrors = [err51];
                            }
                            else {
                                vErrors.push(err51);
                            }
                            errors++;
                        }
                    }
                    if (data12.sourceCurrency !== undefined) {
                        let data14 = data12.sourceCurrency;
                        if (typeof data14 !== "string") {
                            const err52 = { instancePath: instancePath + "/data/fx/sourceCurrency", schemaPath: "#/properties/data/properties/fx/properties/sourceCurrency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err52];
                            }
                            else {
                                vErrors.push(err52);
                            }
                            errors++;
                        }
                        if (!(((data14 === "BRL") || (data14 === "CAD")) || (data14 === "USD"))) {
                            const err53 = { instancePath: instancePath + "/data/fx/sourceCurrency", schemaPath: "#/properties/data/properties/fx/properties/sourceCurrency/enum", keyword: "enum", params: { allowedValues: schema22.properties.data.properties.fx.properties.sourceCurrency.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                                vErrors = [err53];
                            }
                            else {
                                vErrors.push(err53);
                            }
                            errors++;
                        }
                    }
                    if (data12.destinationCurrency !== undefined) {
                        let data15 = data12.destinationCurrency;
                        if (typeof data15 !== "string") {
                            const err54 = { instancePath: instancePath + "/data/fx/destinationCurrency", schemaPath: "#/properties/data/properties/fx/properties/destinationCurrency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err54];
                            }
                            else {
                                vErrors.push(err54);
                            }
                            errors++;
                        }
                        if (!(((data15 === "BRL") || (data15 === "CAD")) || (data15 === "USD"))) {
                            const err55 = { instancePath: instancePath + "/data/fx/destinationCurrency", schemaPath: "#/properties/data/properties/fx/properties/destinationCurrency/enum", keyword: "enum", params: { allowedValues: schema22.properties.data.properties.fx.properties.destinationCurrency.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                                vErrors = [err55];
                            }
                            else {
                                vErrors.push(err55);
                            }
                            errors++;
                        }
                    }
                    if (data12.directionLabel !== undefined) {
                        let data16 = data12.directionLabel;
                        if (typeof data16 === "string") {
                            if (func2(data16) > 32) {
                                const err56 = { instancePath: instancePath + "/data/fx/directionLabel", schemaPath: "#/properties/data/properties/fx/properties/directionLabel/maxLength", keyword: "maxLength", params: { limit: 32 }, message: "must NOT have more than 32 characters" };
                                if (vErrors === null) {
                                    vErrors = [err56];
                                }
                                else {
                                    vErrors.push(err56);
                                }
                                errors++;
                            }
                            if (func2(data16) < 1) {
                                const err57 = { instancePath: instancePath + "/data/fx/directionLabel", schemaPath: "#/properties/data/properties/fx/properties/directionLabel/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                if (vErrors === null) {
                                    vErrors = [err57];
                                }
                                else {
                                    vErrors.push(err57);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err58 = { instancePath: instancePath + "/data/fx/directionLabel", schemaPath: "#/properties/data/properties/fx/properties/directionLabel/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err58];
                            }
                            else {
                                vErrors.push(err58);
                            }
                            errors++;
                        }
                    }
                    if (data12.suppliedRate !== undefined) {
                        let data17 = data12.suppliedRate;
                        if ((typeof data17 !== "string") && (data17 !== null)) {
                            const err59 = { instancePath: instancePath + "/data/fx/suppliedRate", schemaPath: "#/properties/data/properties/fx/properties/suppliedRate/type", keyword: "type", params: { type: schema22.properties.data.properties.fx.properties.suppliedRate.type }, message: "must be string,null" };
                            if (vErrors === null) {
                                vErrors = [err59];
                            }
                            else {
                                vErrors.push(err59);
                            }
                            errors++;
                        }
                        if (typeof data17 === "string") {
                            if (!pattern60.test(data17)) {
                                const err60 = { instancePath: instancePath + "/data/fx/suppliedRate", schemaPath: "#/properties/data/properties/fx/properties/suppliedRate/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]{0,11})(?:\\.[0-9]{1,12})?$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]{0,11})(?:\\.[0-9]{1,12})?$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err60];
                                }
                                else {
                                    vErrors.push(err60);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data12.rateCoefficient !== undefined) {
                        let data18 = data12.rateCoefficient;
                        if ((typeof data18 !== "string") && (data18 !== null)) {
                            const err61 = { instancePath: instancePath + "/data/fx/rateCoefficient", schemaPath: "#/properties/data/properties/fx/properties/rateCoefficient/type", keyword: "type", params: { type: schema22.properties.data.properties.fx.properties.rateCoefficient.type }, message: "must be string,null" };
                            if (vErrors === null) {
                                vErrors = [err61];
                            }
                            else {
                                vErrors.push(err61);
                            }
                            errors++;
                        }
                        if (typeof data18 === "string") {
                            if (!pattern61.test(data18)) {
                                const err62 = { instancePath: instancePath + "/data/fx/rateCoefficient", schemaPath: "#/properties/data/properties/fx/properties/rateCoefficient/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]{0,23}$" }, message: "must match pattern \"" + "^[1-9][0-9]{0,23}$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err62];
                                }
                                else {
                                    vErrors.push(err62);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data12.rateScale !== undefined) {
                        let data19 = data12.rateScale;
                        if ((!(((typeof data19 == "number") && (!(data19 % 1) && !isNaN(data19))) && (isFinite(data19)))) && (data19 !== null)) {
                            const err63 = { instancePath: instancePath + "/data/fx/rateScale", schemaPath: "#/properties/data/properties/fx/properties/rateScale/type", keyword: "type", params: { type: schema22.properties.data.properties.fx.properties.rateScale.type }, message: "must be integer,null" };
                            if (vErrors === null) {
                                vErrors = [err63];
                            }
                            else {
                                vErrors.push(err63);
                            }
                            errors++;
                        }
                        if ((typeof data19 == "number") && (isFinite(data19))) {
                            if (data19 > 12 || isNaN(data19)) {
                                const err64 = { instancePath: instancePath + "/data/fx/rateScale", schemaPath: "#/properties/data/properties/fx/properties/rateScale/maximum", keyword: "maximum", params: { comparison: "<=", limit: 12 }, message: "must be <= 12" };
                                if (vErrors === null) {
                                    vErrors = [err64];
                                }
                                else {
                                    vErrors.push(err64);
                                }
                                errors++;
                            }
                            if (data19 < 0 || isNaN(data19)) {
                                const err65 = { instancePath: instancePath + "/data/fx/rateScale", schemaPath: "#/properties/data/properties/fx/properties/rateScale/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                                if (vErrors === null) {
                                    vErrors = [err65];
                                }
                                else {
                                    vErrors.push(err65);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data12.displayRate !== undefined) {
                        let data20 = data12.displayRate;
                        if (typeof data20 === "string") {
                            if (!pattern62.test(data20)) {
                                const err66 = { instancePath: instancePath + "/data/fx/displayRate", schemaPath: "#/properties/data/properties/fx/properties/displayRate/pattern", keyword: "pattern", params: { pattern: "^[0-9]+\\.[0-9]{6}$" }, message: "must match pattern \"" + "^[0-9]+\\.[0-9]{6}$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err66];
                                }
                                else {
                                    vErrors.push(err66);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err67 = { instancePath: instancePath + "/data/fx/displayRate", schemaPath: "#/properties/data/properties/fx/properties/displayRate/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err67];
                            }
                            else {
                                vErrors.push(err67);
                            }
                            errors++;
                        }
                    }
                    if (data12.displayRateApproximate !== undefined) {
                        if (typeof data12.displayRateApproximate !== "boolean") {
                            const err68 = { instancePath: instancePath + "/data/fx/displayRateApproximate", schemaPath: "#/properties/data/properties/fx/properties/displayRateApproximate/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                                vErrors = [err68];
                            }
                            else {
                                vErrors.push(err68);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err69 = { instancePath: instancePath + "/data/fx", schemaPath: "#/properties/data/properties/fx/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                        vErrors = [err69];
                    }
                    else {
                        vErrors.push(err69);
                    }
                    errors++;
                }
            }
            if (data0.legs !== undefined) {
                let data22 = data0.legs;
                if (Array.isArray(data22)) {
                    if (data22.length > 2) {
                        const err70 = { instancePath: instancePath + "/data/legs", schemaPath: "#/properties/data/properties/legs/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" };
                        if (vErrors === null) {
                            vErrors = [err70];
                        }
                        else {
                            vErrors.push(err70);
                        }
                        errors++;
                    }
                    const len0 = data22.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                        let data23 = data22[i0];
                        if (data23 && typeof data23 == "object" && !Array.isArray(data23)) {
                            if (data23.accountId === undefined) {
                                const err71 = { instancePath: instancePath + "/data/legs/" + i0, schemaPath: "#/properties/data/properties/legs/items/required", keyword: "required", params: { missingProperty: "accountId" }, message: "must have required property '" + "accountId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err71];
                                }
                                else {
                                    vErrors.push(err71);
                                }
                                errors++;
                            }
                            if (data23.accountKind === undefined) {
                                const err72 = { instancePath: instancePath + "/data/legs/" + i0, schemaPath: "#/properties/data/properties/legs/items/required", keyword: "required", params: { missingProperty: "accountKind" }, message: "must have required property '" + "accountKind" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err72];
                                }
                                else {
                                    vErrors.push(err72);
                                }
                                errors++;
                            }
                            if (data23.side === undefined) {
                                const err73 = { instancePath: instancePath + "/data/legs/" + i0, schemaPath: "#/properties/data/properties/legs/items/required", keyword: "required", params: { missingProperty: "side" }, message: "must have required property '" + "side" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err73];
                                }
                                else {
                                    vErrors.push(err73);
                                }
                                errors++;
                            }
                            if (data23.signedMinor === undefined) {
                                const err74 = { instancePath: instancePath + "/data/legs/" + i0, schemaPath: "#/properties/data/properties/legs/items/required", keyword: "required", params: { missingProperty: "signedMinor" }, message: "must have required property '" + "signedMinor" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err74];
                                }
                                else {
                                    vErrors.push(err74);
                                }
                                errors++;
                            }
                            if (data23.currency === undefined) {
                                const err75 = { instancePath: instancePath + "/data/legs/" + i0, schemaPath: "#/properties/data/properties/legs/items/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err75];
                                }
                                else {
                                    vErrors.push(err75);
                                }
                                errors++;
                            }
                            for (const key3 in data23) {
                                if (!((((((key3 === "accountId") || (key3 === "accountKind")) || (key3 === "side")) || (key3 === "signedMinor")) || (key3 === "currency")) || (key3 === "entryId"))) {
                                    const err76 = { instancePath: instancePath + "/data/legs/" + i0, schemaPath: "#/properties/data/properties/legs/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                                    if (vErrors === null) {
                                        vErrors = [err76];
                                    }
                                    else {
                                        vErrors.push(err76);
                                    }
                                    errors++;
                                }
                            }
                            if (data23.accountId !== undefined) {
                                let data24 = data23.accountId;
                                if (typeof data24 === "string") {
                                    if (!pattern0.test(data24)) {
                                        const err77 = { instancePath: instancePath + "/data/legs/" + i0 + "/accountId", schemaPath: "#/properties/data/properties/legs/items/properties/accountId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err77];
                                        }
                                        else {
                                            vErrors.push(err77);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err78 = { instancePath: instancePath + "/data/legs/" + i0 + "/accountId", schemaPath: "#/properties/data/properties/legs/items/properties/accountId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err78];
                                    }
                                    else {
                                        vErrors.push(err78);
                                    }
                                    errors++;
                                }
                            }
                            if (data23.accountKind !== undefined) {
                                let data25 = data23.accountKind;
                                if (typeof data25 !== "string") {
                                    const err79 = { instancePath: instancePath + "/data/legs/" + i0 + "/accountKind", schemaPath: "#/properties/data/properties/legs/items/properties/accountKind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err79];
                                    }
                                    else {
                                        vErrors.push(err79);
                                    }
                                    errors++;
                                }
                                if (!((data25 === "cash") || (data25 === "card"))) {
                                    const err80 = { instancePath: instancePath + "/data/legs/" + i0 + "/accountKind", schemaPath: "#/properties/data/properties/legs/items/properties/accountKind/enum", keyword: "enum", params: { allowedValues: schema22.properties.data.properties.legs.items.properties.accountKind.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err80];
                                    }
                                    else {
                                        vErrors.push(err80);
                                    }
                                    errors++;
                                }
                            }
                            if (data23.side !== undefined) {
                                let data26 = data23.side;
                                if (typeof data26 !== "string") {
                                    const err81 = { instancePath: instancePath + "/data/legs/" + i0 + "/side", schemaPath: "#/properties/data/properties/legs/items/properties/side/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err81];
                                    }
                                    else {
                                        vErrors.push(err81);
                                    }
                                    errors++;
                                }
                                if (!((data26 === "outgoing") || (data26 === "incoming"))) {
                                    const err82 = { instancePath: instancePath + "/data/legs/" + i0 + "/side", schemaPath: "#/properties/data/properties/legs/items/properties/side/enum", keyword: "enum", params: { allowedValues: schema22.properties.data.properties.legs.items.properties.side.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err82];
                                    }
                                    else {
                                        vErrors.push(err82);
                                    }
                                    errors++;
                                }
                            }
                            if (data23.signedMinor !== undefined) {
                                let data27 = data23.signedMinor;
                                if (typeof data27 === "string") {
                                    if (!pattern3.test(data27)) {
                                        const err83 = { instancePath: instancePath + "/data/legs/" + i0 + "/signedMinor", schemaPath: "#/properties/data/properties/legs/items/properties/signedMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err83];
                                        }
                                        else {
                                            vErrors.push(err83);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err84 = { instancePath: instancePath + "/data/legs/" + i0 + "/signedMinor", schemaPath: "#/properties/data/properties/legs/items/properties/signedMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err84];
                                    }
                                    else {
                                        vErrors.push(err84);
                                    }
                                    errors++;
                                }
                            }
                            if (data23.currency !== undefined) {
                                let data28 = data23.currency;
                                if (typeof data28 !== "string") {
                                    const err85 = { instancePath: instancePath + "/data/legs/" + i0 + "/currency", schemaPath: "#/properties/data/properties/legs/items/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err85];
                                    }
                                    else {
                                        vErrors.push(err85);
                                    }
                                    errors++;
                                }
                                if (!(((data28 === "BRL") || (data28 === "CAD")) || (data28 === "USD"))) {
                                    const err86 = { instancePath: instancePath + "/data/legs/" + i0 + "/currency", schemaPath: "#/properties/data/properties/legs/items/properties/currency/enum", keyword: "enum", params: { allowedValues: schema22.properties.data.properties.legs.items.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err86];
                                    }
                                    else {
                                        vErrors.push(err86);
                                    }
                                    errors++;
                                }
                            }
                            if (data23.entryId !== undefined) {
                                let data29 = data23.entryId;
                                if ((typeof data29 !== "string") && (data29 !== null)) {
                                    const err87 = { instancePath: instancePath + "/data/legs/" + i0 + "/entryId", schemaPath: "#/properties/data/properties/legs/items/properties/entryId/type", keyword: "type", params: { type: schema22.properties.data.properties.legs.items.properties.entryId.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err87];
                                    }
                                    else {
                                        vErrors.push(err87);
                                    }
                                    errors++;
                                }
                                if (typeof data29 === "string") {
                                    if (!pattern0.test(data29)) {
                                        const err88 = { instancePath: instancePath + "/data/legs/" + i0 + "/entryId", schemaPath: "#/properties/data/properties/legs/items/properties/entryId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err88];
                                        }
                                        else {
                                            vErrors.push(err88);
                                        }
                                        errors++;
                                    }
                                }
                            }
                        }
                        else {
                            const err89 = { instancePath: instancePath + "/data/legs/" + i0, schemaPath: "#/properties/data/properties/legs/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                                vErrors = [err89];
                            }
                            else {
                                vErrors.push(err89);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err90 = { instancePath: instancePath + "/data/legs", schemaPath: "#/properties/data/properties/legs/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err90];
                    }
                    else {
                        vErrors.push(err90);
                    }
                    errors++;
                }
            }
            if (data0.affectedEntryIds !== undefined) {
                let data30 = data0.affectedEntryIds;
                if (Array.isArray(data30)) {
                    if (data30.length > 2) {
                        const err91 = { instancePath: instancePath + "/data/affectedEntryIds", schemaPath: "#/properties/data/properties/affectedEntryIds/maxItems", keyword: "maxItems", params: { limit: 2 }, message: "must NOT have more than 2 items" };
                        if (vErrors === null) {
                            vErrors = [err91];
                        }
                        else {
                            vErrors.push(err91);
                        }
                        errors++;
                    }
                    const len1 = data30.length;
                    for (let i1 = 0; i1 < len1; i1++) {
                        let data31 = data30[i1];
                        if (typeof data31 === "string") {
                            if (!pattern0.test(data31)) {
                                const err92 = { instancePath: instancePath + "/data/affectedEntryIds/" + i1, schemaPath: "#/properties/data/properties/affectedEntryIds/items/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err92];
                                }
                                else {
                                    vErrors.push(err92);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err93 = { instancePath: instancePath + "/data/affectedEntryIds/" + i1, schemaPath: "#/properties/data/properties/affectedEntryIds/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err93];
                            }
                            else {
                                vErrors.push(err93);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err94 = { instancePath: instancePath + "/data/affectedEntryIds", schemaPath: "#/properties/data/properties/affectedEntryIds/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err94];
                    }
                    else {
                        vErrors.push(err94);
                    }
                    errors++;
                }
            }
        }
        else {
            const err95 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err95];
            }
            else {
                vErrors.push(err95);
            }
            errors++;
        }
    }
    if (data.meta !== undefined) {
        let data32 = data.meta;
        if (data32 && typeof data32 == "object" && !Array.isArray(data32)) {
            if (data32.requestId === undefined) {
                const err96 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "requestId" }, message: "must have required property '" + "requestId" + "'" };
                if (vErrors === null) {
                    vErrors = [err96];
                }
                else {
                    vErrors.push(err96);
                }
                errors++;
            }
            if (data32.asOf === undefined) {
                const err97 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "asOf" }, message: "must have required property '" + "asOf" + "'" };
                if (vErrors === null) {
                    vErrors = [err97];
                }
                else {
                    vErrors.push(err97);
                }
                errors++;
            }
            if (data32.businessToday === undefined) {
                const err98 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err98];
                }
                else {
                    vErrors.push(err98);
                }
                errors++;
            }
            if (data32.timeZone === undefined) {
                const err99 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "timeZone" }, message: "must have required property '" + "timeZone" + "'" };
                if (vErrors === null) {
                    vErrors = [err99];
                }
                else {
                    vErrors.push(err99);
                }
                errors++;
            }
            if (data32.dataRevision === undefined) {
                const err100 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "dataRevision" }, message: "must have required property '" + "dataRevision" + "'" };
                if (vErrors === null) {
                    vErrors = [err100];
                }
                else {
                    vErrors.push(err100);
                }
                errors++;
            }
            for (const key4 in data32) {
                if (!(((((key4 === "requestId") || (key4 === "asOf")) || (key4 === "businessToday")) || (key4 === "timeZone")) || (key4 === "dataRevision"))) {
                    const err101 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key4 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err101];
                    }
                    else {
                        vErrors.push(err101);
                    }
                    errors++;
                }
            }
            if (data32.requestId !== undefined) {
                let data33 = data32.requestId;
                if (typeof data33 === "string") {
                    if (func2(data33) > 64) {
                        const err102 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err102];
                        }
                        else {
                            vErrors.push(err102);
                        }
                        errors++;
                    }
                    if (func2(data33) < 1) {
                        const err103 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err103];
                        }
                        else {
                            vErrors.push(err103);
                        }
                        errors++;
                    }
                }
                else {
                    const err104 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err104];
                    }
                    else {
                        vErrors.push(err104);
                    }
                    errors++;
                }
            }
            if (data32.asOf !== undefined) {
                let data34 = data32.asOf;
                if (typeof data34 === "string") {
                    if (func2(data34) > 64) {
                        const err105 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err105];
                        }
                        else {
                            vErrors.push(err105);
                        }
                        errors++;
                    }
                    if (func2(data34) < 1) {
                        const err106 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err106];
                        }
                        else {
                            vErrors.push(err106);
                        }
                        errors++;
                    }
                }
                else {
                    const err107 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err107];
                    }
                    else {
                        vErrors.push(err107);
                    }
                    errors++;
                }
            }
            if (data32.businessToday !== undefined) {
                let data35 = data32.businessToday;
                if (typeof data35 === "string") {
                    if (!pattern4.test(data35)) {
                        const err108 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err108];
                        }
                        else {
                            vErrors.push(err108);
                        }
                        errors++;
                    }
                }
                else {
                    const err109 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err109];
                    }
                    else {
                        vErrors.push(err109);
                    }
                    errors++;
                }
            }
            if (data32.timeZone !== undefined) {
                let data36 = data32.timeZone;
                if (typeof data36 === "string") {
                    if (func2(data36) > 64) {
                        const err110 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err110];
                        }
                        else {
                            vErrors.push(err110);
                        }
                        errors++;
                    }
                    if (func2(data36) < 1) {
                        const err111 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err111];
                        }
                        else {
                            vErrors.push(err111);
                        }
                        errors++;
                    }
                }
                else {
                    const err112 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err112];
                    }
                    else {
                        vErrors.push(err112);
                    }
                    errors++;
                }
            }
            if (data32.dataRevision !== undefined) {
                let data37 = data32.dataRevision;
                if (typeof data37 === "string") {
                    if (!pattern2.test(data37)) {
                        const err113 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err113];
                        }
                        else {
                            vErrors.push(err113);
                        }
                        errors++;
                    }
                }
                else {
                    const err114 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err114];
                    }
                    else {
                        vErrors.push(err114);
                    }
                    errors++;
                }
            }
        }
        else {
            const err115 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err115];
            }
            else {
                vErrors.push(err115);
            }
            errors++;
        }
    }
}
else {
    const err116 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
        vErrors = [err116];
    }
    else {
        vErrors.push(err116);
    }
    errors++;
} validate21.errors = vErrors; return errors === 0; }
export const validateLedgerTransferPairSuggestionsEnvelope = validate22;
const schema23 = { "$id": "https://saldo.local/schemas/ledger-transfer-pair-suggestions-envelope.json", "$schema": "http://json-schema.org/draft-07/schema#", "title": "LedgerTransferPairSuggestionsEnvelope", "type": "object", "additionalProperties": false, "required": ["data", "meta"], "properties": { "data": { "type": "object", "additionalProperties": false, "required": ["suggestions"], "properties": { "suggestions": { "type": "array", "maxItems": 50, "items": { "type": "object", "additionalProperties": false, "required": ["sourceAccountId", "sourceAccountName", "destinationAccountId", "destinationAccountName", "sourceCurrency", "destinationCurrency", "lastTransferDate", "lastStatus", "useCount", "lastSourceMinor", "lastDestinationMinor", "lastInputMode", "lastSuppliedRate"], "properties": { "sourceAccountId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "sourceAccountName": { "type": "string", "minLength": 1, "maxLength": 120 }, "destinationAccountId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "destinationAccountName": { "type": "string", "minLength": 1, "maxLength": 120 }, "sourceCurrency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "destinationCurrency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "lastTransferDate": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "lastStatus": { "type": "string", "enum": ["planned", "completed"] }, "useCount": { "type": "integer", "minimum": 1 }, "lastSourceMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "lastDestinationMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "lastInputMode": { "type": ["string", "null"], "enum": ["rate", "destination", null] }, "lastSuppliedRate": { "type": ["string", "null"], "pattern": "^(?:0|[1-9][0-9]{0,11})(?:\\.[0-9]{1,12})?$" } } } } } }, "meta": { "type": "object", "additionalProperties": false, "required": ["requestId", "asOf", "businessToday", "timeZone", "dataRevision"], "properties": { "requestId": { "type": "string", "minLength": 1, "maxLength": 64 }, "asOf": { "type": "string", "minLength": 1, "maxLength": 64 }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "timeZone": { "type": "string", "minLength": 1, "maxLength": 64 }, "dataRevision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } } } };
function validate22(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="https://saldo.local/schemas/ledger-transfer-pair-suggestions-envelope.json" */ ; let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.data === undefined) {
        const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property '" + "data" + "'" };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
    }
    if (data.meta === undefined) {
        const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "meta" }, message: "must have required property '" + "meta" + "'" };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    for (const key0 in data) {
        if (!((key0 === "data") || (key0 === "meta"))) {
            const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.data !== undefined) {
        let data0 = data.data;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.suggestions === undefined) {
                const err3 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "suggestions" }, message: "must have required property '" + "suggestions" + "'" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
            for (const key1 in data0) {
                if (!(key1 === "suggestions")) {
                    const err4 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
            }
            if (data0.suggestions !== undefined) {
                let data1 = data0.suggestions;
                if (Array.isArray(data1)) {
                    if (data1.length > 50) {
                        const err5 = { instancePath: instancePath + "/data/suggestions", schemaPath: "#/properties/data/properties/suggestions/maxItems", keyword: "maxItems", params: { limit: 50 }, message: "must NOT have more than 50 items" };
                        if (vErrors === null) {
                            vErrors = [err5];
                        }
                        else {
                            vErrors.push(err5);
                        }
                        errors++;
                    }
                    const len0 = data1.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                        let data2 = data1[i0];
                        if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                            if (data2.sourceAccountId === undefined) {
                                const err6 = { instancePath: instancePath + "/data/suggestions/" + i0, schemaPath: "#/properties/data/properties/suggestions/items/required", keyword: "required", params: { missingProperty: "sourceAccountId" }, message: "must have required property '" + "sourceAccountId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err6];
                                }
                                else {
                                    vErrors.push(err6);
                                }
                                errors++;
                            }
                            if (data2.sourceAccountName === undefined) {
                                const err7 = { instancePath: instancePath + "/data/suggestions/" + i0, schemaPath: "#/properties/data/properties/suggestions/items/required", keyword: "required", params: { missingProperty: "sourceAccountName" }, message: "must have required property '" + "sourceAccountName" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err7];
                                }
                                else {
                                    vErrors.push(err7);
                                }
                                errors++;
                            }
                            if (data2.destinationAccountId === undefined) {
                                const err8 = { instancePath: instancePath + "/data/suggestions/" + i0, schemaPath: "#/properties/data/properties/suggestions/items/required", keyword: "required", params: { missingProperty: "destinationAccountId" }, message: "must have required property '" + "destinationAccountId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err8];
                                }
                                else {
                                    vErrors.push(err8);
                                }
                                errors++;
                            }
                            if (data2.destinationAccountName === undefined) {
                                const err9 = { instancePath: instancePath + "/data/suggestions/" + i0, schemaPath: "#/properties/data/properties/suggestions/items/required", keyword: "required", params: { missingProperty: "destinationAccountName" }, message: "must have required property '" + "destinationAccountName" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err9];
                                }
                                else {
                                    vErrors.push(err9);
                                }
                                errors++;
                            }
                            if (data2.sourceCurrency === undefined) {
                                const err10 = { instancePath: instancePath + "/data/suggestions/" + i0, schemaPath: "#/properties/data/properties/suggestions/items/required", keyword: "required", params: { missingProperty: "sourceCurrency" }, message: "must have required property '" + "sourceCurrency" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err10];
                                }
                                else {
                                    vErrors.push(err10);
                                }
                                errors++;
                            }
                            if (data2.destinationCurrency === undefined) {
                                const err11 = { instancePath: instancePath + "/data/suggestions/" + i0, schemaPath: "#/properties/data/properties/suggestions/items/required", keyword: "required", params: { missingProperty: "destinationCurrency" }, message: "must have required property '" + "destinationCurrency" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err11];
                                }
                                else {
                                    vErrors.push(err11);
                                }
                                errors++;
                            }
                            if (data2.lastTransferDate === undefined) {
                                const err12 = { instancePath: instancePath + "/data/suggestions/" + i0, schemaPath: "#/properties/data/properties/suggestions/items/required", keyword: "required", params: { missingProperty: "lastTransferDate" }, message: "must have required property '" + "lastTransferDate" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err12];
                                }
                                else {
                                    vErrors.push(err12);
                                }
                                errors++;
                            }
                            if (data2.lastStatus === undefined) {
                                const err13 = { instancePath: instancePath + "/data/suggestions/" + i0, schemaPath: "#/properties/data/properties/suggestions/items/required", keyword: "required", params: { missingProperty: "lastStatus" }, message: "must have required property '" + "lastStatus" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err13];
                                }
                                else {
                                    vErrors.push(err13);
                                }
                                errors++;
                            }
                            if (data2.useCount === undefined) {
                                const err14 = { instancePath: instancePath + "/data/suggestions/" + i0, schemaPath: "#/properties/data/properties/suggestions/items/required", keyword: "required", params: { missingProperty: "useCount" }, message: "must have required property '" + "useCount" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err14];
                                }
                                else {
                                    vErrors.push(err14);
                                }
                                errors++;
                            }
                            if (data2.lastSourceMinor === undefined) {
                                const err15 = { instancePath: instancePath + "/data/suggestions/" + i0, schemaPath: "#/properties/data/properties/suggestions/items/required", keyword: "required", params: { missingProperty: "lastSourceMinor" }, message: "must have required property '" + "lastSourceMinor" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err15];
                                }
                                else {
                                    vErrors.push(err15);
                                }
                                errors++;
                            }
                            if (data2.lastDestinationMinor === undefined) {
                                const err16 = { instancePath: instancePath + "/data/suggestions/" + i0, schemaPath: "#/properties/data/properties/suggestions/items/required", keyword: "required", params: { missingProperty: "lastDestinationMinor" }, message: "must have required property '" + "lastDestinationMinor" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err16];
                                }
                                else {
                                    vErrors.push(err16);
                                }
                                errors++;
                            }
                            if (data2.lastInputMode === undefined) {
                                const err17 = { instancePath: instancePath + "/data/suggestions/" + i0, schemaPath: "#/properties/data/properties/suggestions/items/required", keyword: "required", params: { missingProperty: "lastInputMode" }, message: "must have required property '" + "lastInputMode" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err17];
                                }
                                else {
                                    vErrors.push(err17);
                                }
                                errors++;
                            }
                            if (data2.lastSuppliedRate === undefined) {
                                const err18 = { instancePath: instancePath + "/data/suggestions/" + i0, schemaPath: "#/properties/data/properties/suggestions/items/required", keyword: "required", params: { missingProperty: "lastSuppliedRate" }, message: "must have required property '" + "lastSuppliedRate" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err18];
                                }
                                else {
                                    vErrors.push(err18);
                                }
                                errors++;
                            }
                            for (const key2 in data2) {
                                if (!(func35.call(schema23.properties.data.properties.suggestions.items.properties, key2))) {
                                    const err19 = { instancePath: instancePath + "/data/suggestions/" + i0, schemaPath: "#/properties/data/properties/suggestions/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                                    if (vErrors === null) {
                                        vErrors = [err19];
                                    }
                                    else {
                                        vErrors.push(err19);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.sourceAccountId !== undefined) {
                                let data3 = data2.sourceAccountId;
                                if (typeof data3 === "string") {
                                    if (!pattern0.test(data3)) {
                                        const err20 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/sourceAccountId", schemaPath: "#/properties/data/properties/suggestions/items/properties/sourceAccountId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err20];
                                        }
                                        else {
                                            vErrors.push(err20);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err21 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/sourceAccountId", schemaPath: "#/properties/data/properties/suggestions/items/properties/sourceAccountId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err21];
                                    }
                                    else {
                                        vErrors.push(err21);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.sourceAccountName !== undefined) {
                                let data4 = data2.sourceAccountName;
                                if (typeof data4 === "string") {
                                    if (func2(data4) > 120) {
                                        const err22 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/sourceAccountName", schemaPath: "#/properties/data/properties/suggestions/items/properties/sourceAccountName/maxLength", keyword: "maxLength", params: { limit: 120 }, message: "must NOT have more than 120 characters" };
                                        if (vErrors === null) {
                                            vErrors = [err22];
                                        }
                                        else {
                                            vErrors.push(err22);
                                        }
                                        errors++;
                                    }
                                    if (func2(data4) < 1) {
                                        const err23 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/sourceAccountName", schemaPath: "#/properties/data/properties/suggestions/items/properties/sourceAccountName/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                        if (vErrors === null) {
                                            vErrors = [err23];
                                        }
                                        else {
                                            vErrors.push(err23);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err24 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/sourceAccountName", schemaPath: "#/properties/data/properties/suggestions/items/properties/sourceAccountName/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err24];
                                    }
                                    else {
                                        vErrors.push(err24);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.destinationAccountId !== undefined) {
                                let data5 = data2.destinationAccountId;
                                if (typeof data5 === "string") {
                                    if (!pattern0.test(data5)) {
                                        const err25 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/destinationAccountId", schemaPath: "#/properties/data/properties/suggestions/items/properties/destinationAccountId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err25];
                                        }
                                        else {
                                            vErrors.push(err25);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err26 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/destinationAccountId", schemaPath: "#/properties/data/properties/suggestions/items/properties/destinationAccountId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err26];
                                    }
                                    else {
                                        vErrors.push(err26);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.destinationAccountName !== undefined) {
                                let data6 = data2.destinationAccountName;
                                if (typeof data6 === "string") {
                                    if (func2(data6) > 120) {
                                        const err27 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/destinationAccountName", schemaPath: "#/properties/data/properties/suggestions/items/properties/destinationAccountName/maxLength", keyword: "maxLength", params: { limit: 120 }, message: "must NOT have more than 120 characters" };
                                        if (vErrors === null) {
                                            vErrors = [err27];
                                        }
                                        else {
                                            vErrors.push(err27);
                                        }
                                        errors++;
                                    }
                                    if (func2(data6) < 1) {
                                        const err28 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/destinationAccountName", schemaPath: "#/properties/data/properties/suggestions/items/properties/destinationAccountName/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                        if (vErrors === null) {
                                            vErrors = [err28];
                                        }
                                        else {
                                            vErrors.push(err28);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err29 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/destinationAccountName", schemaPath: "#/properties/data/properties/suggestions/items/properties/destinationAccountName/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err29];
                                    }
                                    else {
                                        vErrors.push(err29);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.sourceCurrency !== undefined) {
                                let data7 = data2.sourceCurrency;
                                if (typeof data7 !== "string") {
                                    const err30 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/sourceCurrency", schemaPath: "#/properties/data/properties/suggestions/items/properties/sourceCurrency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err30];
                                    }
                                    else {
                                        vErrors.push(err30);
                                    }
                                    errors++;
                                }
                                if (!(((data7 === "BRL") || (data7 === "CAD")) || (data7 === "USD"))) {
                                    const err31 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/sourceCurrency", schemaPath: "#/properties/data/properties/suggestions/items/properties/sourceCurrency/enum", keyword: "enum", params: { allowedValues: schema23.properties.data.properties.suggestions.items.properties.sourceCurrency.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err31];
                                    }
                                    else {
                                        vErrors.push(err31);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.destinationCurrency !== undefined) {
                                let data8 = data2.destinationCurrency;
                                if (typeof data8 !== "string") {
                                    const err32 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/destinationCurrency", schemaPath: "#/properties/data/properties/suggestions/items/properties/destinationCurrency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err32];
                                    }
                                    else {
                                        vErrors.push(err32);
                                    }
                                    errors++;
                                }
                                if (!(((data8 === "BRL") || (data8 === "CAD")) || (data8 === "USD"))) {
                                    const err33 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/destinationCurrency", schemaPath: "#/properties/data/properties/suggestions/items/properties/destinationCurrency/enum", keyword: "enum", params: { allowedValues: schema23.properties.data.properties.suggestions.items.properties.destinationCurrency.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err33];
                                    }
                                    else {
                                        vErrors.push(err33);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.lastTransferDate !== undefined) {
                                let data9 = data2.lastTransferDate;
                                if (typeof data9 === "string") {
                                    if (!pattern4.test(data9)) {
                                        const err34 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/lastTransferDate", schemaPath: "#/properties/data/properties/suggestions/items/properties/lastTransferDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err34];
                                        }
                                        else {
                                            vErrors.push(err34);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err35 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/lastTransferDate", schemaPath: "#/properties/data/properties/suggestions/items/properties/lastTransferDate/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err35];
                                    }
                                    else {
                                        vErrors.push(err35);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.lastStatus !== undefined) {
                                let data10 = data2.lastStatus;
                                if (typeof data10 !== "string") {
                                    const err36 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/lastStatus", schemaPath: "#/properties/data/properties/suggestions/items/properties/lastStatus/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err36];
                                    }
                                    else {
                                        vErrors.push(err36);
                                    }
                                    errors++;
                                }
                                if (!((data10 === "planned") || (data10 === "completed"))) {
                                    const err37 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/lastStatus", schemaPath: "#/properties/data/properties/suggestions/items/properties/lastStatus/enum", keyword: "enum", params: { allowedValues: schema23.properties.data.properties.suggestions.items.properties.lastStatus.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err37];
                                    }
                                    else {
                                        vErrors.push(err37);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.useCount !== undefined) {
                                let data11 = data2.useCount;
                                if (!(((typeof data11 == "number") && (!(data11 % 1) && !isNaN(data11))) && (isFinite(data11)))) {
                                    const err38 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/useCount", schemaPath: "#/properties/data/properties/suggestions/items/properties/useCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                    if (vErrors === null) {
                                        vErrors = [err38];
                                    }
                                    else {
                                        vErrors.push(err38);
                                    }
                                    errors++;
                                }
                                if ((typeof data11 == "number") && (isFinite(data11))) {
                                    if (data11 < 1 || isNaN(data11)) {
                                        const err39 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/useCount", schemaPath: "#/properties/data/properties/suggestions/items/properties/useCount/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                                        if (vErrors === null) {
                                            vErrors = [err39];
                                        }
                                        else {
                                            vErrors.push(err39);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data2.lastSourceMinor !== undefined) {
                                let data12 = data2.lastSourceMinor;
                                if (typeof data12 === "string") {
                                    if (!pattern3.test(data12)) {
                                        const err40 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/lastSourceMinor", schemaPath: "#/properties/data/properties/suggestions/items/properties/lastSourceMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err40];
                                        }
                                        else {
                                            vErrors.push(err40);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err41 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/lastSourceMinor", schemaPath: "#/properties/data/properties/suggestions/items/properties/lastSourceMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err41];
                                    }
                                    else {
                                        vErrors.push(err41);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.lastDestinationMinor !== undefined) {
                                let data13 = data2.lastDestinationMinor;
                                if (typeof data13 === "string") {
                                    if (!pattern3.test(data13)) {
                                        const err42 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/lastDestinationMinor", schemaPath: "#/properties/data/properties/suggestions/items/properties/lastDestinationMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err42];
                                        }
                                        else {
                                            vErrors.push(err42);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err43 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/lastDestinationMinor", schemaPath: "#/properties/data/properties/suggestions/items/properties/lastDestinationMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err43];
                                    }
                                    else {
                                        vErrors.push(err43);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.lastInputMode !== undefined) {
                                let data14 = data2.lastInputMode;
                                if ((typeof data14 !== "string") && (data14 !== null)) {
                                    const err44 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/lastInputMode", schemaPath: "#/properties/data/properties/suggestions/items/properties/lastInputMode/type", keyword: "type", params: { type: schema23.properties.data.properties.suggestions.items.properties.lastInputMode.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err44];
                                    }
                                    else {
                                        vErrors.push(err44);
                                    }
                                    errors++;
                                }
                                if (!(((data14 === "rate") || (data14 === "destination")) || (data14 === null))) {
                                    const err45 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/lastInputMode", schemaPath: "#/properties/data/properties/suggestions/items/properties/lastInputMode/enum", keyword: "enum", params: { allowedValues: schema23.properties.data.properties.suggestions.items.properties.lastInputMode.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err45];
                                    }
                                    else {
                                        vErrors.push(err45);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.lastSuppliedRate !== undefined) {
                                let data15 = data2.lastSuppliedRate;
                                if ((typeof data15 !== "string") && (data15 !== null)) {
                                    const err46 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/lastSuppliedRate", schemaPath: "#/properties/data/properties/suggestions/items/properties/lastSuppliedRate/type", keyword: "type", params: { type: schema23.properties.data.properties.suggestions.items.properties.lastSuppliedRate.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err46];
                                    }
                                    else {
                                        vErrors.push(err46);
                                    }
                                    errors++;
                                }
                                if (typeof data15 === "string") {
                                    if (!pattern60.test(data15)) {
                                        const err47 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/lastSuppliedRate", schemaPath: "#/properties/data/properties/suggestions/items/properties/lastSuppliedRate/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]{0,11})(?:\\.[0-9]{1,12})?$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]{0,11})(?:\\.[0-9]{1,12})?$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err47];
                                        }
                                        else {
                                            vErrors.push(err47);
                                        }
                                        errors++;
                                    }
                                }
                            }
                        }
                        else {
                            const err48 = { instancePath: instancePath + "/data/suggestions/" + i0, schemaPath: "#/properties/data/properties/suggestions/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                                vErrors = [err48];
                            }
                            else {
                                vErrors.push(err48);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err49 = { instancePath: instancePath + "/data/suggestions", schemaPath: "#/properties/data/properties/suggestions/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err49];
                    }
                    else {
                        vErrors.push(err49);
                    }
                    errors++;
                }
            }
        }
        else {
            const err50 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err50];
            }
            else {
                vErrors.push(err50);
            }
            errors++;
        }
    }
    if (data.meta !== undefined) {
        let data16 = data.meta;
        if (data16 && typeof data16 == "object" && !Array.isArray(data16)) {
            if (data16.requestId === undefined) {
                const err51 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "requestId" }, message: "must have required property '" + "requestId" + "'" };
                if (vErrors === null) {
                    vErrors = [err51];
                }
                else {
                    vErrors.push(err51);
                }
                errors++;
            }
            if (data16.asOf === undefined) {
                const err52 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "asOf" }, message: "must have required property '" + "asOf" + "'" };
                if (vErrors === null) {
                    vErrors = [err52];
                }
                else {
                    vErrors.push(err52);
                }
                errors++;
            }
            if (data16.businessToday === undefined) {
                const err53 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err53];
                }
                else {
                    vErrors.push(err53);
                }
                errors++;
            }
            if (data16.timeZone === undefined) {
                const err54 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "timeZone" }, message: "must have required property '" + "timeZone" + "'" };
                if (vErrors === null) {
                    vErrors = [err54];
                }
                else {
                    vErrors.push(err54);
                }
                errors++;
            }
            if (data16.dataRevision === undefined) {
                const err55 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "dataRevision" }, message: "must have required property '" + "dataRevision" + "'" };
                if (vErrors === null) {
                    vErrors = [err55];
                }
                else {
                    vErrors.push(err55);
                }
                errors++;
            }
            for (const key3 in data16) {
                if (!(((((key3 === "requestId") || (key3 === "asOf")) || (key3 === "businessToday")) || (key3 === "timeZone")) || (key3 === "dataRevision"))) {
                    const err56 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err56];
                    }
                    else {
                        vErrors.push(err56);
                    }
                    errors++;
                }
            }
            if (data16.requestId !== undefined) {
                let data17 = data16.requestId;
                if (typeof data17 === "string") {
                    if (func2(data17) > 64) {
                        const err57 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err57];
                        }
                        else {
                            vErrors.push(err57);
                        }
                        errors++;
                    }
                    if (func2(data17) < 1) {
                        const err58 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err58];
                        }
                        else {
                            vErrors.push(err58);
                        }
                        errors++;
                    }
                }
                else {
                    const err59 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err59];
                    }
                    else {
                        vErrors.push(err59);
                    }
                    errors++;
                }
            }
            if (data16.asOf !== undefined) {
                let data18 = data16.asOf;
                if (typeof data18 === "string") {
                    if (func2(data18) > 64) {
                        const err60 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err60];
                        }
                        else {
                            vErrors.push(err60);
                        }
                        errors++;
                    }
                    if (func2(data18) < 1) {
                        const err61 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err61];
                        }
                        else {
                            vErrors.push(err61);
                        }
                        errors++;
                    }
                }
                else {
                    const err62 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err62];
                    }
                    else {
                        vErrors.push(err62);
                    }
                    errors++;
                }
            }
            if (data16.businessToday !== undefined) {
                let data19 = data16.businessToday;
                if (typeof data19 === "string") {
                    if (!pattern4.test(data19)) {
                        const err63 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err63];
                        }
                        else {
                            vErrors.push(err63);
                        }
                        errors++;
                    }
                }
                else {
                    const err64 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err64];
                    }
                    else {
                        vErrors.push(err64);
                    }
                    errors++;
                }
            }
            if (data16.timeZone !== undefined) {
                let data20 = data16.timeZone;
                if (typeof data20 === "string") {
                    if (func2(data20) > 64) {
                        const err65 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err65];
                        }
                        else {
                            vErrors.push(err65);
                        }
                        errors++;
                    }
                    if (func2(data20) < 1) {
                        const err66 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err66];
                        }
                        else {
                            vErrors.push(err66);
                        }
                        errors++;
                    }
                }
                else {
                    const err67 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err67];
                    }
                    else {
                        vErrors.push(err67);
                    }
                    errors++;
                }
            }
            if (data16.dataRevision !== undefined) {
                let data21 = data16.dataRevision;
                if (typeof data21 === "string") {
                    if (!pattern2.test(data21)) {
                        const err68 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err68];
                        }
                        else {
                            vErrors.push(err68);
                        }
                        errors++;
                    }
                }
                else {
                    const err69 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err69];
                    }
                    else {
                        vErrors.push(err69);
                    }
                    errors++;
                }
            }
        }
        else {
            const err70 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err70];
            }
            else {
                vErrors.push(err70);
            }
            errors++;
        }
    }
}
else {
    const err71 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
        vErrors = [err71];
    }
    else {
        vErrors.push(err71);
    }
    errors++;
} validate22.errors = vErrors; return errors === 0; }
export const validateLedgerCategoryEnvelope = validate23;
const schema24 = { "$id": "https://saldo.local/schemas/ledger-category-envelope.json", "$schema": "http://json-schema.org/draft-07/schema#", "title": "LedgerCategoryEnvelope", "type": "object", "additionalProperties": false, "required": ["data", "meta"], "properties": { "data": { "type": "object", "additionalProperties": false, "required": ["id", "name", "archived", "revision", "entryCount", "totals"], "properties": { "id": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "name": { "type": "string", "minLength": 1, "maxLength": 120 }, "archived": { "type": "boolean" }, "revision": { "type": "string", "pattern": "^[1-9][0-9]*$" }, "entryCount": { "type": "integer", "minimum": 0 }, "totals": { "type": "array", "maxItems": 3, "items": { "type": "object", "additionalProperties": false, "required": ["currency", "minorUnits"], "properties": { "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "minorUnits": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" } } } } } }, "meta": { "type": "object", "additionalProperties": false, "required": ["requestId", "asOf", "businessToday", "timeZone", "dataRevision"], "properties": { "requestId": { "type": "string", "minLength": 1, "maxLength": 64 }, "asOf": { "type": "string", "minLength": 1, "maxLength": 64 }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "timeZone": { "type": "string", "minLength": 1, "maxLength": 64 }, "dataRevision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } } } };
function validate23(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="https://saldo.local/schemas/ledger-category-envelope.json" */ ; let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.data === undefined) {
        const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property '" + "data" + "'" };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
    }
    if (data.meta === undefined) {
        const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "meta" }, message: "must have required property '" + "meta" + "'" };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    for (const key0 in data) {
        if (!((key0 === "data") || (key0 === "meta"))) {
            const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.data !== undefined) {
        let data0 = data.data;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.id === undefined) {
                const err3 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property '" + "id" + "'" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
            if (data0.name === undefined) {
                const err4 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "name" }, message: "must have required property '" + "name" + "'" };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
            if (data0.archived === undefined) {
                const err5 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "archived" }, message: "must have required property '" + "archived" + "'" };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
            }
            if (data0.revision === undefined) {
                const err6 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property '" + "revision" + "'" };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
            }
            if (data0.entryCount === undefined) {
                const err7 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "entryCount" }, message: "must have required property '" + "entryCount" + "'" };
                if (vErrors === null) {
                    vErrors = [err7];
                }
                else {
                    vErrors.push(err7);
                }
                errors++;
            }
            if (data0.totals === undefined) {
                const err8 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "totals" }, message: "must have required property '" + "totals" + "'" };
                if (vErrors === null) {
                    vErrors = [err8];
                }
                else {
                    vErrors.push(err8);
                }
                errors++;
            }
            for (const key1 in data0) {
                if (!((((((key1 === "id") || (key1 === "name")) || (key1 === "archived")) || (key1 === "revision")) || (key1 === "entryCount")) || (key1 === "totals"))) {
                    const err9 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err9];
                    }
                    else {
                        vErrors.push(err9);
                    }
                    errors++;
                }
            }
            if (data0.id !== undefined) {
                let data1 = data0.id;
                if (typeof data1 === "string") {
                    if (!pattern0.test(data1)) {
                        const err10 = { instancePath: instancePath + "/data/id", schemaPath: "#/properties/data/properties/id/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err10];
                        }
                        else {
                            vErrors.push(err10);
                        }
                        errors++;
                    }
                }
                else {
                    const err11 = { instancePath: instancePath + "/data/id", schemaPath: "#/properties/data/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err11];
                    }
                    else {
                        vErrors.push(err11);
                    }
                    errors++;
                }
            }
            if (data0.name !== undefined) {
                let data2 = data0.name;
                if (typeof data2 === "string") {
                    if (func2(data2) > 120) {
                        const err12 = { instancePath: instancePath + "/data/name", schemaPath: "#/properties/data/properties/name/maxLength", keyword: "maxLength", params: { limit: 120 }, message: "must NOT have more than 120 characters" };
                        if (vErrors === null) {
                            vErrors = [err12];
                        }
                        else {
                            vErrors.push(err12);
                        }
                        errors++;
                    }
                    if (func2(data2) < 1) {
                        const err13 = { instancePath: instancePath + "/data/name", schemaPath: "#/properties/data/properties/name/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err13];
                        }
                        else {
                            vErrors.push(err13);
                        }
                        errors++;
                    }
                }
                else {
                    const err14 = { instancePath: instancePath + "/data/name", schemaPath: "#/properties/data/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err14];
                    }
                    else {
                        vErrors.push(err14);
                    }
                    errors++;
                }
            }
            if (data0.archived !== undefined) {
                if (typeof data0.archived !== "boolean") {
                    const err15 = { instancePath: instancePath + "/data/archived", schemaPath: "#/properties/data/properties/archived/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                    if (vErrors === null) {
                        vErrors = [err15];
                    }
                    else {
                        vErrors.push(err15);
                    }
                    errors++;
                }
            }
            if (data0.revision !== undefined) {
                let data4 = data0.revision;
                if (typeof data4 === "string") {
                    if (!pattern2.test(data4)) {
                        const err16 = { instancePath: instancePath + "/data/revision", schemaPath: "#/properties/data/properties/revision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err16];
                        }
                        else {
                            vErrors.push(err16);
                        }
                        errors++;
                    }
                }
                else {
                    const err17 = { instancePath: instancePath + "/data/revision", schemaPath: "#/properties/data/properties/revision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err17];
                    }
                    else {
                        vErrors.push(err17);
                    }
                    errors++;
                }
            }
            if (data0.entryCount !== undefined) {
                let data5 = data0.entryCount;
                if (!(((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5))) && (isFinite(data5)))) {
                    const err18 = { instancePath: instancePath + "/data/entryCount", schemaPath: "#/properties/data/properties/entryCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                        vErrors = [err18];
                    }
                    else {
                        vErrors.push(err18);
                    }
                    errors++;
                }
                if ((typeof data5 == "number") && (isFinite(data5))) {
                    if (data5 < 0 || isNaN(data5)) {
                        const err19 = { instancePath: instancePath + "/data/entryCount", schemaPath: "#/properties/data/properties/entryCount/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                        if (vErrors === null) {
                            vErrors = [err19];
                        }
                        else {
                            vErrors.push(err19);
                        }
                        errors++;
                    }
                }
            }
            if (data0.totals !== undefined) {
                let data6 = data0.totals;
                if (Array.isArray(data6)) {
                    if (data6.length > 3) {
                        const err20 = { instancePath: instancePath + "/data/totals", schemaPath: "#/properties/data/properties/totals/maxItems", keyword: "maxItems", params: { limit: 3 }, message: "must NOT have more than 3 items" };
                        if (vErrors === null) {
                            vErrors = [err20];
                        }
                        else {
                            vErrors.push(err20);
                        }
                        errors++;
                    }
                    const len0 = data6.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                        let data7 = data6[i0];
                        if (data7 && typeof data7 == "object" && !Array.isArray(data7)) {
                            if (data7.currency === undefined) {
                                const err21 = { instancePath: instancePath + "/data/totals/" + i0, schemaPath: "#/properties/data/properties/totals/items/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err21];
                                }
                                else {
                                    vErrors.push(err21);
                                }
                                errors++;
                            }
                            if (data7.minorUnits === undefined) {
                                const err22 = { instancePath: instancePath + "/data/totals/" + i0, schemaPath: "#/properties/data/properties/totals/items/required", keyword: "required", params: { missingProperty: "minorUnits" }, message: "must have required property '" + "minorUnits" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err22];
                                }
                                else {
                                    vErrors.push(err22);
                                }
                                errors++;
                            }
                            for (const key2 in data7) {
                                if (!((key2 === "currency") || (key2 === "minorUnits"))) {
                                    const err23 = { instancePath: instancePath + "/data/totals/" + i0, schemaPath: "#/properties/data/properties/totals/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                                    if (vErrors === null) {
                                        vErrors = [err23];
                                    }
                                    else {
                                        vErrors.push(err23);
                                    }
                                    errors++;
                                }
                            }
                            if (data7.currency !== undefined) {
                                let data8 = data7.currency;
                                if (typeof data8 !== "string") {
                                    const err24 = { instancePath: instancePath + "/data/totals/" + i0 + "/currency", schemaPath: "#/properties/data/properties/totals/items/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err24];
                                    }
                                    else {
                                        vErrors.push(err24);
                                    }
                                    errors++;
                                }
                                if (!(((data8 === "BRL") || (data8 === "CAD")) || (data8 === "USD"))) {
                                    const err25 = { instancePath: instancePath + "/data/totals/" + i0 + "/currency", schemaPath: "#/properties/data/properties/totals/items/properties/currency/enum", keyword: "enum", params: { allowedValues: schema24.properties.data.properties.totals.items.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err25];
                                    }
                                    else {
                                        vErrors.push(err25);
                                    }
                                    errors++;
                                }
                            }
                            if (data7.minorUnits !== undefined) {
                                let data9 = data7.minorUnits;
                                if (typeof data9 === "string") {
                                    if (!pattern3.test(data9)) {
                                        const err26 = { instancePath: instancePath + "/data/totals/" + i0 + "/minorUnits", schemaPath: "#/properties/data/properties/totals/items/properties/minorUnits/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err26];
                                        }
                                        else {
                                            vErrors.push(err26);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err27 = { instancePath: instancePath + "/data/totals/" + i0 + "/minorUnits", schemaPath: "#/properties/data/properties/totals/items/properties/minorUnits/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err27];
                                    }
                                    else {
                                        vErrors.push(err27);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err28 = { instancePath: instancePath + "/data/totals/" + i0, schemaPath: "#/properties/data/properties/totals/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                                vErrors = [err28];
                            }
                            else {
                                vErrors.push(err28);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err29 = { instancePath: instancePath + "/data/totals", schemaPath: "#/properties/data/properties/totals/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err29];
                    }
                    else {
                        vErrors.push(err29);
                    }
                    errors++;
                }
            }
        }
        else {
            const err30 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err30];
            }
            else {
                vErrors.push(err30);
            }
            errors++;
        }
    }
    if (data.meta !== undefined) {
        let data10 = data.meta;
        if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
            if (data10.requestId === undefined) {
                const err31 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "requestId" }, message: "must have required property '" + "requestId" + "'" };
                if (vErrors === null) {
                    vErrors = [err31];
                }
                else {
                    vErrors.push(err31);
                }
                errors++;
            }
            if (data10.asOf === undefined) {
                const err32 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "asOf" }, message: "must have required property '" + "asOf" + "'" };
                if (vErrors === null) {
                    vErrors = [err32];
                }
                else {
                    vErrors.push(err32);
                }
                errors++;
            }
            if (data10.businessToday === undefined) {
                const err33 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err33];
                }
                else {
                    vErrors.push(err33);
                }
                errors++;
            }
            if (data10.timeZone === undefined) {
                const err34 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "timeZone" }, message: "must have required property '" + "timeZone" + "'" };
                if (vErrors === null) {
                    vErrors = [err34];
                }
                else {
                    vErrors.push(err34);
                }
                errors++;
            }
            if (data10.dataRevision === undefined) {
                const err35 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "dataRevision" }, message: "must have required property '" + "dataRevision" + "'" };
                if (vErrors === null) {
                    vErrors = [err35];
                }
                else {
                    vErrors.push(err35);
                }
                errors++;
            }
            for (const key3 in data10) {
                if (!(((((key3 === "requestId") || (key3 === "asOf")) || (key3 === "businessToday")) || (key3 === "timeZone")) || (key3 === "dataRevision"))) {
                    const err36 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err36];
                    }
                    else {
                        vErrors.push(err36);
                    }
                    errors++;
                }
            }
            if (data10.requestId !== undefined) {
                let data11 = data10.requestId;
                if (typeof data11 === "string") {
                    if (func2(data11) > 64) {
                        const err37 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err37];
                        }
                        else {
                            vErrors.push(err37);
                        }
                        errors++;
                    }
                    if (func2(data11) < 1) {
                        const err38 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err38];
                        }
                        else {
                            vErrors.push(err38);
                        }
                        errors++;
                    }
                }
                else {
                    const err39 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err39];
                    }
                    else {
                        vErrors.push(err39);
                    }
                    errors++;
                }
            }
            if (data10.asOf !== undefined) {
                let data12 = data10.asOf;
                if (typeof data12 === "string") {
                    if (func2(data12) > 64) {
                        const err40 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err40];
                        }
                        else {
                            vErrors.push(err40);
                        }
                        errors++;
                    }
                    if (func2(data12) < 1) {
                        const err41 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err41];
                        }
                        else {
                            vErrors.push(err41);
                        }
                        errors++;
                    }
                }
                else {
                    const err42 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err42];
                    }
                    else {
                        vErrors.push(err42);
                    }
                    errors++;
                }
            }
            if (data10.businessToday !== undefined) {
                let data13 = data10.businessToday;
                if (typeof data13 === "string") {
                    if (!pattern4.test(data13)) {
                        const err43 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err43];
                        }
                        else {
                            vErrors.push(err43);
                        }
                        errors++;
                    }
                }
                else {
                    const err44 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err44];
                    }
                    else {
                        vErrors.push(err44);
                    }
                    errors++;
                }
            }
            if (data10.timeZone !== undefined) {
                let data14 = data10.timeZone;
                if (typeof data14 === "string") {
                    if (func2(data14) > 64) {
                        const err45 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err45];
                        }
                        else {
                            vErrors.push(err45);
                        }
                        errors++;
                    }
                    if (func2(data14) < 1) {
                        const err46 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err46];
                        }
                        else {
                            vErrors.push(err46);
                        }
                        errors++;
                    }
                }
                else {
                    const err47 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err47];
                    }
                    else {
                        vErrors.push(err47);
                    }
                    errors++;
                }
            }
            if (data10.dataRevision !== undefined) {
                let data15 = data10.dataRevision;
                if (typeof data15 === "string") {
                    if (!pattern2.test(data15)) {
                        const err48 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err48];
                        }
                        else {
                            vErrors.push(err48);
                        }
                        errors++;
                    }
                }
                else {
                    const err49 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err49];
                    }
                    else {
                        vErrors.push(err49);
                    }
                    errors++;
                }
            }
        }
        else {
            const err50 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err50];
            }
            else {
                vErrors.push(err50);
            }
            errors++;
        }
    }
}
else {
    const err51 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
        vErrors = [err51];
    }
    else {
        vErrors.push(err51);
    }
    errors++;
} validate23.errors = vErrors; return errors === 0; }
export const validateLedgerCategoriesEnvelope = validate24;
const schema25 = { "$id": "https://saldo.local/schemas/ledger-categories-envelope.json", "$schema": "http://json-schema.org/draft-07/schema#", "title": "LedgerCategoriesEnvelope", "type": "object", "additionalProperties": false, "required": ["data", "meta"], "properties": { "data": { "type": "object", "additionalProperties": false, "required": ["categories"], "properties": { "categories": { "type": "array", "maxItems": 500, "items": { "type": "object", "additionalProperties": false, "required": ["id", "name", "archived", "revision", "entryCount", "totals"], "properties": { "id": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "name": { "type": "string", "minLength": 1, "maxLength": 120 }, "archived": { "type": "boolean" }, "revision": { "type": "string", "pattern": "^[1-9][0-9]*$" }, "entryCount": { "type": "integer", "minimum": 0 }, "totals": { "type": "array", "maxItems": 3, "items": { "type": "object", "additionalProperties": false, "required": ["currency", "minorUnits"], "properties": { "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "minorUnits": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" } } } } } } } } }, "meta": { "type": "object", "additionalProperties": false, "required": ["requestId", "asOf", "businessToday", "timeZone", "dataRevision"], "properties": { "requestId": { "type": "string", "minLength": 1, "maxLength": 64 }, "asOf": { "type": "string", "minLength": 1, "maxLength": 64 }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "timeZone": { "type": "string", "minLength": 1, "maxLength": 64 }, "dataRevision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } } } };
function validate24(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="https://saldo.local/schemas/ledger-categories-envelope.json" */ ; let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.data === undefined) {
        const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property '" + "data" + "'" };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
    }
    if (data.meta === undefined) {
        const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "meta" }, message: "must have required property '" + "meta" + "'" };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    for (const key0 in data) {
        if (!((key0 === "data") || (key0 === "meta"))) {
            const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.data !== undefined) {
        let data0 = data.data;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.categories === undefined) {
                const err3 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "categories" }, message: "must have required property '" + "categories" + "'" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
            for (const key1 in data0) {
                if (!(key1 === "categories")) {
                    const err4 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
            }
            if (data0.categories !== undefined) {
                let data1 = data0.categories;
                if (Array.isArray(data1)) {
                    if (data1.length > 500) {
                        const err5 = { instancePath: instancePath + "/data/categories", schemaPath: "#/properties/data/properties/categories/maxItems", keyword: "maxItems", params: { limit: 500 }, message: "must NOT have more than 500 items" };
                        if (vErrors === null) {
                            vErrors = [err5];
                        }
                        else {
                            vErrors.push(err5);
                        }
                        errors++;
                    }
                    const len0 = data1.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                        let data2 = data1[i0];
                        if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                            if (data2.id === undefined) {
                                const err6 = { instancePath: instancePath + "/data/categories/" + i0, schemaPath: "#/properties/data/properties/categories/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property '" + "id" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err6];
                                }
                                else {
                                    vErrors.push(err6);
                                }
                                errors++;
                            }
                            if (data2.name === undefined) {
                                const err7 = { instancePath: instancePath + "/data/categories/" + i0, schemaPath: "#/properties/data/properties/categories/items/required", keyword: "required", params: { missingProperty: "name" }, message: "must have required property '" + "name" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err7];
                                }
                                else {
                                    vErrors.push(err7);
                                }
                                errors++;
                            }
                            if (data2.archived === undefined) {
                                const err8 = { instancePath: instancePath + "/data/categories/" + i0, schemaPath: "#/properties/data/properties/categories/items/required", keyword: "required", params: { missingProperty: "archived" }, message: "must have required property '" + "archived" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err8];
                                }
                                else {
                                    vErrors.push(err8);
                                }
                                errors++;
                            }
                            if (data2.revision === undefined) {
                                const err9 = { instancePath: instancePath + "/data/categories/" + i0, schemaPath: "#/properties/data/properties/categories/items/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property '" + "revision" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err9];
                                }
                                else {
                                    vErrors.push(err9);
                                }
                                errors++;
                            }
                            if (data2.entryCount === undefined) {
                                const err10 = { instancePath: instancePath + "/data/categories/" + i0, schemaPath: "#/properties/data/properties/categories/items/required", keyword: "required", params: { missingProperty: "entryCount" }, message: "must have required property '" + "entryCount" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err10];
                                }
                                else {
                                    vErrors.push(err10);
                                }
                                errors++;
                            }
                            if (data2.totals === undefined) {
                                const err11 = { instancePath: instancePath + "/data/categories/" + i0, schemaPath: "#/properties/data/properties/categories/items/required", keyword: "required", params: { missingProperty: "totals" }, message: "must have required property '" + "totals" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err11];
                                }
                                else {
                                    vErrors.push(err11);
                                }
                                errors++;
                            }
                            for (const key2 in data2) {
                                if (!((((((key2 === "id") || (key2 === "name")) || (key2 === "archived")) || (key2 === "revision")) || (key2 === "entryCount")) || (key2 === "totals"))) {
                                    const err12 = { instancePath: instancePath + "/data/categories/" + i0, schemaPath: "#/properties/data/properties/categories/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                                    if (vErrors === null) {
                                        vErrors = [err12];
                                    }
                                    else {
                                        vErrors.push(err12);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.id !== undefined) {
                                let data3 = data2.id;
                                if (typeof data3 === "string") {
                                    if (!pattern0.test(data3)) {
                                        const err13 = { instancePath: instancePath + "/data/categories/" + i0 + "/id", schemaPath: "#/properties/data/properties/categories/items/properties/id/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err13];
                                        }
                                        else {
                                            vErrors.push(err13);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err14 = { instancePath: instancePath + "/data/categories/" + i0 + "/id", schemaPath: "#/properties/data/properties/categories/items/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err14];
                                    }
                                    else {
                                        vErrors.push(err14);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.name !== undefined) {
                                let data4 = data2.name;
                                if (typeof data4 === "string") {
                                    if (func2(data4) > 120) {
                                        const err15 = { instancePath: instancePath + "/data/categories/" + i0 + "/name", schemaPath: "#/properties/data/properties/categories/items/properties/name/maxLength", keyword: "maxLength", params: { limit: 120 }, message: "must NOT have more than 120 characters" };
                                        if (vErrors === null) {
                                            vErrors = [err15];
                                        }
                                        else {
                                            vErrors.push(err15);
                                        }
                                        errors++;
                                    }
                                    if (func2(data4) < 1) {
                                        const err16 = { instancePath: instancePath + "/data/categories/" + i0 + "/name", schemaPath: "#/properties/data/properties/categories/items/properties/name/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                        if (vErrors === null) {
                                            vErrors = [err16];
                                        }
                                        else {
                                            vErrors.push(err16);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err17 = { instancePath: instancePath + "/data/categories/" + i0 + "/name", schemaPath: "#/properties/data/properties/categories/items/properties/name/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err17];
                                    }
                                    else {
                                        vErrors.push(err17);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.archived !== undefined) {
                                if (typeof data2.archived !== "boolean") {
                                    const err18 = { instancePath: instancePath + "/data/categories/" + i0 + "/archived", schemaPath: "#/properties/data/properties/categories/items/properties/archived/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                    if (vErrors === null) {
                                        vErrors = [err18];
                                    }
                                    else {
                                        vErrors.push(err18);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.revision !== undefined) {
                                let data6 = data2.revision;
                                if (typeof data6 === "string") {
                                    if (!pattern2.test(data6)) {
                                        const err19 = { instancePath: instancePath + "/data/categories/" + i0 + "/revision", schemaPath: "#/properties/data/properties/categories/items/properties/revision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err19];
                                        }
                                        else {
                                            vErrors.push(err19);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err20 = { instancePath: instancePath + "/data/categories/" + i0 + "/revision", schemaPath: "#/properties/data/properties/categories/items/properties/revision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err20];
                                    }
                                    else {
                                        vErrors.push(err20);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.entryCount !== undefined) {
                                let data7 = data2.entryCount;
                                if (!(((typeof data7 == "number") && (!(data7 % 1) && !isNaN(data7))) && (isFinite(data7)))) {
                                    const err21 = { instancePath: instancePath + "/data/categories/" + i0 + "/entryCount", schemaPath: "#/properties/data/properties/categories/items/properties/entryCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                    if (vErrors === null) {
                                        vErrors = [err21];
                                    }
                                    else {
                                        vErrors.push(err21);
                                    }
                                    errors++;
                                }
                                if ((typeof data7 == "number") && (isFinite(data7))) {
                                    if (data7 < 0 || isNaN(data7)) {
                                        const err22 = { instancePath: instancePath + "/data/categories/" + i0 + "/entryCount", schemaPath: "#/properties/data/properties/categories/items/properties/entryCount/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                                        if (vErrors === null) {
                                            vErrors = [err22];
                                        }
                                        else {
                                            vErrors.push(err22);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data2.totals !== undefined) {
                                let data8 = data2.totals;
                                if (Array.isArray(data8)) {
                                    if (data8.length > 3) {
                                        const err23 = { instancePath: instancePath + "/data/categories/" + i0 + "/totals", schemaPath: "#/properties/data/properties/categories/items/properties/totals/maxItems", keyword: "maxItems", params: { limit: 3 }, message: "must NOT have more than 3 items" };
                                        if (vErrors === null) {
                                            vErrors = [err23];
                                        }
                                        else {
                                            vErrors.push(err23);
                                        }
                                        errors++;
                                    }
                                    const len1 = data8.length;
                                    for (let i1 = 0; i1 < len1; i1++) {
                                        let data9 = data8[i1];
                                        if (data9 && typeof data9 == "object" && !Array.isArray(data9)) {
                                            if (data9.currency === undefined) {
                                                const err24 = { instancePath: instancePath + "/data/categories/" + i0 + "/totals/" + i1, schemaPath: "#/properties/data/properties/categories/items/properties/totals/items/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                                                if (vErrors === null) {
                                                    vErrors = [err24];
                                                }
                                                else {
                                                    vErrors.push(err24);
                                                }
                                                errors++;
                                            }
                                            if (data9.minorUnits === undefined) {
                                                const err25 = { instancePath: instancePath + "/data/categories/" + i0 + "/totals/" + i1, schemaPath: "#/properties/data/properties/categories/items/properties/totals/items/required", keyword: "required", params: { missingProperty: "minorUnits" }, message: "must have required property '" + "minorUnits" + "'" };
                                                if (vErrors === null) {
                                                    vErrors = [err25];
                                                }
                                                else {
                                                    vErrors.push(err25);
                                                }
                                                errors++;
                                            }
                                            for (const key3 in data9) {
                                                if (!((key3 === "currency") || (key3 === "minorUnits"))) {
                                                    const err26 = { instancePath: instancePath + "/data/categories/" + i0 + "/totals/" + i1, schemaPath: "#/properties/data/properties/categories/items/properties/totals/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                                                    if (vErrors === null) {
                                                        vErrors = [err26];
                                                    }
                                                    else {
                                                        vErrors.push(err26);
                                                    }
                                                    errors++;
                                                }
                                            }
                                            if (data9.currency !== undefined) {
                                                let data10 = data9.currency;
                                                if (typeof data10 !== "string") {
                                                    const err27 = { instancePath: instancePath + "/data/categories/" + i0 + "/totals/" + i1 + "/currency", schemaPath: "#/properties/data/properties/categories/items/properties/totals/items/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                        vErrors = [err27];
                                                    }
                                                    else {
                                                        vErrors.push(err27);
                                                    }
                                                    errors++;
                                                }
                                                if (!(((data10 === "BRL") || (data10 === "CAD")) || (data10 === "USD"))) {
                                                    const err28 = { instancePath: instancePath + "/data/categories/" + i0 + "/totals/" + i1 + "/currency", schemaPath: "#/properties/data/properties/categories/items/properties/totals/items/properties/currency/enum", keyword: "enum", params: { allowedValues: schema25.properties.data.properties.categories.items.properties.totals.items.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                                                    if (vErrors === null) {
                                                        vErrors = [err28];
                                                    }
                                                    else {
                                                        vErrors.push(err28);
                                                    }
                                                    errors++;
                                                }
                                            }
                                            if (data9.minorUnits !== undefined) {
                                                let data11 = data9.minorUnits;
                                                if (typeof data11 === "string") {
                                                    if (!pattern3.test(data11)) {
                                                        const err29 = { instancePath: instancePath + "/data/categories/" + i0 + "/totals/" + i1 + "/minorUnits", schemaPath: "#/properties/data/properties/categories/items/properties/totals/items/properties/minorUnits/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                                        if (vErrors === null) {
                                                            vErrors = [err29];
                                                        }
                                                        else {
                                                            vErrors.push(err29);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                else {
                                                    const err30 = { instancePath: instancePath + "/data/categories/" + i0 + "/totals/" + i1 + "/minorUnits", schemaPath: "#/properties/data/properties/categories/items/properties/totals/items/properties/minorUnits/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                        vErrors = [err30];
                                                    }
                                                    else {
                                                        vErrors.push(err30);
                                                    }
                                                    errors++;
                                                }
                                            }
                                        }
                                        else {
                                            const err31 = { instancePath: instancePath + "/data/categories/" + i0 + "/totals/" + i1, schemaPath: "#/properties/data/properties/categories/items/properties/totals/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                            if (vErrors === null) {
                                                vErrors = [err31];
                                            }
                                            else {
                                                vErrors.push(err31);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                                else {
                                    const err32 = { instancePath: instancePath + "/data/categories/" + i0 + "/totals", schemaPath: "#/properties/data/properties/categories/items/properties/totals/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                                    if (vErrors === null) {
                                        vErrors = [err32];
                                    }
                                    else {
                                        vErrors.push(err32);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err33 = { instancePath: instancePath + "/data/categories/" + i0, schemaPath: "#/properties/data/properties/categories/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                                vErrors = [err33];
                            }
                            else {
                                vErrors.push(err33);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err34 = { instancePath: instancePath + "/data/categories", schemaPath: "#/properties/data/properties/categories/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err34];
                    }
                    else {
                        vErrors.push(err34);
                    }
                    errors++;
                }
            }
        }
        else {
            const err35 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err35];
            }
            else {
                vErrors.push(err35);
            }
            errors++;
        }
    }
    if (data.meta !== undefined) {
        let data12 = data.meta;
        if (data12 && typeof data12 == "object" && !Array.isArray(data12)) {
            if (data12.requestId === undefined) {
                const err36 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "requestId" }, message: "must have required property '" + "requestId" + "'" };
                if (vErrors === null) {
                    vErrors = [err36];
                }
                else {
                    vErrors.push(err36);
                }
                errors++;
            }
            if (data12.asOf === undefined) {
                const err37 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "asOf" }, message: "must have required property '" + "asOf" + "'" };
                if (vErrors === null) {
                    vErrors = [err37];
                }
                else {
                    vErrors.push(err37);
                }
                errors++;
            }
            if (data12.businessToday === undefined) {
                const err38 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err38];
                }
                else {
                    vErrors.push(err38);
                }
                errors++;
            }
            if (data12.timeZone === undefined) {
                const err39 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "timeZone" }, message: "must have required property '" + "timeZone" + "'" };
                if (vErrors === null) {
                    vErrors = [err39];
                }
                else {
                    vErrors.push(err39);
                }
                errors++;
            }
            if (data12.dataRevision === undefined) {
                const err40 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "dataRevision" }, message: "must have required property '" + "dataRevision" + "'" };
                if (vErrors === null) {
                    vErrors = [err40];
                }
                else {
                    vErrors.push(err40);
                }
                errors++;
            }
            for (const key4 in data12) {
                if (!(((((key4 === "requestId") || (key4 === "asOf")) || (key4 === "businessToday")) || (key4 === "timeZone")) || (key4 === "dataRevision"))) {
                    const err41 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key4 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err41];
                    }
                    else {
                        vErrors.push(err41);
                    }
                    errors++;
                }
            }
            if (data12.requestId !== undefined) {
                let data13 = data12.requestId;
                if (typeof data13 === "string") {
                    if (func2(data13) > 64) {
                        const err42 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err42];
                        }
                        else {
                            vErrors.push(err42);
                        }
                        errors++;
                    }
                    if (func2(data13) < 1) {
                        const err43 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err43];
                        }
                        else {
                            vErrors.push(err43);
                        }
                        errors++;
                    }
                }
                else {
                    const err44 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err44];
                    }
                    else {
                        vErrors.push(err44);
                    }
                    errors++;
                }
            }
            if (data12.asOf !== undefined) {
                let data14 = data12.asOf;
                if (typeof data14 === "string") {
                    if (func2(data14) > 64) {
                        const err45 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err45];
                        }
                        else {
                            vErrors.push(err45);
                        }
                        errors++;
                    }
                    if (func2(data14) < 1) {
                        const err46 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err46];
                        }
                        else {
                            vErrors.push(err46);
                        }
                        errors++;
                    }
                }
                else {
                    const err47 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err47];
                    }
                    else {
                        vErrors.push(err47);
                    }
                    errors++;
                }
            }
            if (data12.businessToday !== undefined) {
                let data15 = data12.businessToday;
                if (typeof data15 === "string") {
                    if (!pattern4.test(data15)) {
                        const err48 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err48];
                        }
                        else {
                            vErrors.push(err48);
                        }
                        errors++;
                    }
                }
                else {
                    const err49 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err49];
                    }
                    else {
                        vErrors.push(err49);
                    }
                    errors++;
                }
            }
            if (data12.timeZone !== undefined) {
                let data16 = data12.timeZone;
                if (typeof data16 === "string") {
                    if (func2(data16) > 64) {
                        const err50 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err50];
                        }
                        else {
                            vErrors.push(err50);
                        }
                        errors++;
                    }
                    if (func2(data16) < 1) {
                        const err51 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err51];
                        }
                        else {
                            vErrors.push(err51);
                        }
                        errors++;
                    }
                }
                else {
                    const err52 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err52];
                    }
                    else {
                        vErrors.push(err52);
                    }
                    errors++;
                }
            }
            if (data12.dataRevision !== undefined) {
                let data17 = data12.dataRevision;
                if (typeof data17 === "string") {
                    if (!pattern2.test(data17)) {
                        const err53 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err53];
                        }
                        else {
                            vErrors.push(err53);
                        }
                        errors++;
                    }
                }
                else {
                    const err54 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err54];
                    }
                    else {
                        vErrors.push(err54);
                    }
                    errors++;
                }
            }
        }
        else {
            const err55 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err55];
            }
            else {
                vErrors.push(err55);
            }
            errors++;
        }
    }
}
else {
    const err56 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
        vErrors = [err56];
    }
    else {
        vErrors.push(err56);
    }
    errors++;
} validate24.errors = vErrors; return errors === 0; }
export const validateLedgerEntryLifecyclePreviewEnvelope = validate25;
const schema26 = { "$id": "https://saldo.local/schemas/ledger-entry-lifecycle-preview-envelope.json", "$schema": "http://json-schema.org/draft-07/schema#", "title": "LedgerEntryLifecyclePreviewEnvelope", "type": "object", "additionalProperties": false, "required": ["data", "meta"], "properties": { "data": { "type": "object", "additionalProperties": false, "required": ["id", "action", "entryId", "revision", "businessToday", "expiresAt", "canceled", "impact"], "properties": { "id": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "action": { "type": "string", "enum": ["entry.delete", "entry.duplicate"] }, "entryId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "revision": { "type": "string", "pattern": "^[1-9][0-9]*$" }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "expiresAt": { "type": "string", "minLength": 1, "maxLength": 64 }, "canceled": { "type": "boolean" }, "impact": { "type": "object", "additionalProperties": false, "required": ["accountId", "currency", "signedMinor", "balanceDeltaMinor", "paid", "effective", "requiresConfirmation", "references"], "properties": { "accountId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "signedMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "balanceDeltaMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "paid": { "type": ["boolean", "null"] }, "effective": { "type": "boolean" }, "requiresConfirmation": { "type": "boolean" }, "references": { "type": "array", "maxItems": 16, "items": { "type": "object", "additionalProperties": false, "required": ["kind", "count"], "properties": { "kind": { "type": "string", "enum": ["entry", "account", "category", "installmentGroup", "transfer"] }, "count": { "type": "integer", "minimum": 1 } } } } } } } }, "meta": { "type": "object", "additionalProperties": false, "required": ["requestId", "asOf", "businessToday", "timeZone", "dataRevision"], "properties": { "requestId": { "type": "string", "minLength": 1, "maxLength": 64 }, "asOf": { "type": "string", "minLength": 1, "maxLength": 64 }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "timeZone": { "type": "string", "minLength": 1, "maxLength": 64 }, "dataRevision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } } } };
function validate25(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="https://saldo.local/schemas/ledger-entry-lifecycle-preview-envelope.json" */ ; let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.data === undefined) {
        const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property '" + "data" + "'" };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
    }
    if (data.meta === undefined) {
        const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "meta" }, message: "must have required property '" + "meta" + "'" };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    for (const key0 in data) {
        if (!((key0 === "data") || (key0 === "meta"))) {
            const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.data !== undefined) {
        let data0 = data.data;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.id === undefined) {
                const err3 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property '" + "id" + "'" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
            if (data0.action === undefined) {
                const err4 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "action" }, message: "must have required property '" + "action" + "'" };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
            if (data0.entryId === undefined) {
                const err5 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "entryId" }, message: "must have required property '" + "entryId" + "'" };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
            }
            if (data0.revision === undefined) {
                const err6 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property '" + "revision" + "'" };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
            }
            if (data0.businessToday === undefined) {
                const err7 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err7];
                }
                else {
                    vErrors.push(err7);
                }
                errors++;
            }
            if (data0.expiresAt === undefined) {
                const err8 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "expiresAt" }, message: "must have required property '" + "expiresAt" + "'" };
                if (vErrors === null) {
                    vErrors = [err8];
                }
                else {
                    vErrors.push(err8);
                }
                errors++;
            }
            if (data0.canceled === undefined) {
                const err9 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "canceled" }, message: "must have required property '" + "canceled" + "'" };
                if (vErrors === null) {
                    vErrors = [err9];
                }
                else {
                    vErrors.push(err9);
                }
                errors++;
            }
            if (data0.impact === undefined) {
                const err10 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "impact" }, message: "must have required property '" + "impact" + "'" };
                if (vErrors === null) {
                    vErrors = [err10];
                }
                else {
                    vErrors.push(err10);
                }
                errors++;
            }
            for (const key1 in data0) {
                if (!((((((((key1 === "id") || (key1 === "action")) || (key1 === "entryId")) || (key1 === "revision")) || (key1 === "businessToday")) || (key1 === "expiresAt")) || (key1 === "canceled")) || (key1 === "impact"))) {
                    const err11 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err11];
                    }
                    else {
                        vErrors.push(err11);
                    }
                    errors++;
                }
            }
            if (data0.id !== undefined) {
                let data1 = data0.id;
                if (typeof data1 === "string") {
                    if (!pattern0.test(data1)) {
                        const err12 = { instancePath: instancePath + "/data/id", schemaPath: "#/properties/data/properties/id/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err12];
                        }
                        else {
                            vErrors.push(err12);
                        }
                        errors++;
                    }
                }
                else {
                    const err13 = { instancePath: instancePath + "/data/id", schemaPath: "#/properties/data/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err13];
                    }
                    else {
                        vErrors.push(err13);
                    }
                    errors++;
                }
            }
            if (data0.action !== undefined) {
                let data2 = data0.action;
                if (typeof data2 !== "string") {
                    const err14 = { instancePath: instancePath + "/data/action", schemaPath: "#/properties/data/properties/action/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err14];
                    }
                    else {
                        vErrors.push(err14);
                    }
                    errors++;
                }
                if (!((data2 === "entry.delete") || (data2 === "entry.duplicate"))) {
                    const err15 = { instancePath: instancePath + "/data/action", schemaPath: "#/properties/data/properties/action/enum", keyword: "enum", params: { allowedValues: schema26.properties.data.properties.action.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err15];
                    }
                    else {
                        vErrors.push(err15);
                    }
                    errors++;
                }
            }
            if (data0.entryId !== undefined) {
                let data3 = data0.entryId;
                if (typeof data3 === "string") {
                    if (!pattern0.test(data3)) {
                        const err16 = { instancePath: instancePath + "/data/entryId", schemaPath: "#/properties/data/properties/entryId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err16];
                        }
                        else {
                            vErrors.push(err16);
                        }
                        errors++;
                    }
                }
                else {
                    const err17 = { instancePath: instancePath + "/data/entryId", schemaPath: "#/properties/data/properties/entryId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err17];
                    }
                    else {
                        vErrors.push(err17);
                    }
                    errors++;
                }
            }
            if (data0.revision !== undefined) {
                let data4 = data0.revision;
                if (typeof data4 === "string") {
                    if (!pattern2.test(data4)) {
                        const err18 = { instancePath: instancePath + "/data/revision", schemaPath: "#/properties/data/properties/revision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err18];
                        }
                        else {
                            vErrors.push(err18);
                        }
                        errors++;
                    }
                }
                else {
                    const err19 = { instancePath: instancePath + "/data/revision", schemaPath: "#/properties/data/properties/revision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err19];
                    }
                    else {
                        vErrors.push(err19);
                    }
                    errors++;
                }
            }
            if (data0.businessToday !== undefined) {
                let data5 = data0.businessToday;
                if (typeof data5 === "string") {
                    if (!pattern4.test(data5)) {
                        const err20 = { instancePath: instancePath + "/data/businessToday", schemaPath: "#/properties/data/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err20];
                        }
                        else {
                            vErrors.push(err20);
                        }
                        errors++;
                    }
                }
                else {
                    const err21 = { instancePath: instancePath + "/data/businessToday", schemaPath: "#/properties/data/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err21];
                    }
                    else {
                        vErrors.push(err21);
                    }
                    errors++;
                }
            }
            if (data0.expiresAt !== undefined) {
                let data6 = data0.expiresAt;
                if (typeof data6 === "string") {
                    if (func2(data6) > 64) {
                        const err22 = { instancePath: instancePath + "/data/expiresAt", schemaPath: "#/properties/data/properties/expiresAt/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err22];
                        }
                        else {
                            vErrors.push(err22);
                        }
                        errors++;
                    }
                    if (func2(data6) < 1) {
                        const err23 = { instancePath: instancePath + "/data/expiresAt", schemaPath: "#/properties/data/properties/expiresAt/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err23];
                        }
                        else {
                            vErrors.push(err23);
                        }
                        errors++;
                    }
                }
                else {
                    const err24 = { instancePath: instancePath + "/data/expiresAt", schemaPath: "#/properties/data/properties/expiresAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err24];
                    }
                    else {
                        vErrors.push(err24);
                    }
                    errors++;
                }
            }
            if (data0.canceled !== undefined) {
                if (typeof data0.canceled !== "boolean") {
                    const err25 = { instancePath: instancePath + "/data/canceled", schemaPath: "#/properties/data/properties/canceled/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                    if (vErrors === null) {
                        vErrors = [err25];
                    }
                    else {
                        vErrors.push(err25);
                    }
                    errors++;
                }
            }
            if (data0.impact !== undefined) {
                let data8 = data0.impact;
                if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
                    if (data8.accountId === undefined) {
                        const err26 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/required", keyword: "required", params: { missingProperty: "accountId" }, message: "must have required property '" + "accountId" + "'" };
                        if (vErrors === null) {
                            vErrors = [err26];
                        }
                        else {
                            vErrors.push(err26);
                        }
                        errors++;
                    }
                    if (data8.currency === undefined) {
                        const err27 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                        if (vErrors === null) {
                            vErrors = [err27];
                        }
                        else {
                            vErrors.push(err27);
                        }
                        errors++;
                    }
                    if (data8.signedMinor === undefined) {
                        const err28 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/required", keyword: "required", params: { missingProperty: "signedMinor" }, message: "must have required property '" + "signedMinor" + "'" };
                        if (vErrors === null) {
                            vErrors = [err28];
                        }
                        else {
                            vErrors.push(err28);
                        }
                        errors++;
                    }
                    if (data8.balanceDeltaMinor === undefined) {
                        const err29 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/required", keyword: "required", params: { missingProperty: "balanceDeltaMinor" }, message: "must have required property '" + "balanceDeltaMinor" + "'" };
                        if (vErrors === null) {
                            vErrors = [err29];
                        }
                        else {
                            vErrors.push(err29);
                        }
                        errors++;
                    }
                    if (data8.paid === undefined) {
                        const err30 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/required", keyword: "required", params: { missingProperty: "paid" }, message: "must have required property '" + "paid" + "'" };
                        if (vErrors === null) {
                            vErrors = [err30];
                        }
                        else {
                            vErrors.push(err30);
                        }
                        errors++;
                    }
                    if (data8.effective === undefined) {
                        const err31 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/required", keyword: "required", params: { missingProperty: "effective" }, message: "must have required property '" + "effective" + "'" };
                        if (vErrors === null) {
                            vErrors = [err31];
                        }
                        else {
                            vErrors.push(err31);
                        }
                        errors++;
                    }
                    if (data8.requiresConfirmation === undefined) {
                        const err32 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/required", keyword: "required", params: { missingProperty: "requiresConfirmation" }, message: "must have required property '" + "requiresConfirmation" + "'" };
                        if (vErrors === null) {
                            vErrors = [err32];
                        }
                        else {
                            vErrors.push(err32);
                        }
                        errors++;
                    }
                    if (data8.references === undefined) {
                        const err33 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/required", keyword: "required", params: { missingProperty: "references" }, message: "must have required property '" + "references" + "'" };
                        if (vErrors === null) {
                            vErrors = [err33];
                        }
                        else {
                            vErrors.push(err33);
                        }
                        errors++;
                    }
                    for (const key2 in data8) {
                        if (!((((((((key2 === "accountId") || (key2 === "currency")) || (key2 === "signedMinor")) || (key2 === "balanceDeltaMinor")) || (key2 === "paid")) || (key2 === "effective")) || (key2 === "requiresConfirmation")) || (key2 === "references"))) {
                            const err34 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                                vErrors = [err34];
                            }
                            else {
                                vErrors.push(err34);
                            }
                            errors++;
                        }
                    }
                    if (data8.accountId !== undefined) {
                        let data9 = data8.accountId;
                        if (typeof data9 === "string") {
                            if (!pattern0.test(data9)) {
                                const err35 = { instancePath: instancePath + "/data/impact/accountId", schemaPath: "#/properties/data/properties/impact/properties/accountId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err35];
                                }
                                else {
                                    vErrors.push(err35);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err36 = { instancePath: instancePath + "/data/impact/accountId", schemaPath: "#/properties/data/properties/impact/properties/accountId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err36];
                            }
                            else {
                                vErrors.push(err36);
                            }
                            errors++;
                        }
                    }
                    if (data8.currency !== undefined) {
                        let data10 = data8.currency;
                        if (typeof data10 !== "string") {
                            const err37 = { instancePath: instancePath + "/data/impact/currency", schemaPath: "#/properties/data/properties/impact/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err37];
                            }
                            else {
                                vErrors.push(err37);
                            }
                            errors++;
                        }
                        if (!(((data10 === "BRL") || (data10 === "CAD")) || (data10 === "USD"))) {
                            const err38 = { instancePath: instancePath + "/data/impact/currency", schemaPath: "#/properties/data/properties/impact/properties/currency/enum", keyword: "enum", params: { allowedValues: schema26.properties.data.properties.impact.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                                vErrors = [err38];
                            }
                            else {
                                vErrors.push(err38);
                            }
                            errors++;
                        }
                    }
                    if (data8.signedMinor !== undefined) {
                        let data11 = data8.signedMinor;
                        if (typeof data11 === "string") {
                            if (!pattern3.test(data11)) {
                                const err39 = { instancePath: instancePath + "/data/impact/signedMinor", schemaPath: "#/properties/data/properties/impact/properties/signedMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err39];
                                }
                                else {
                                    vErrors.push(err39);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err40 = { instancePath: instancePath + "/data/impact/signedMinor", schemaPath: "#/properties/data/properties/impact/properties/signedMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err40];
                            }
                            else {
                                vErrors.push(err40);
                            }
                            errors++;
                        }
                    }
                    if (data8.balanceDeltaMinor !== undefined) {
                        let data12 = data8.balanceDeltaMinor;
                        if (typeof data12 === "string") {
                            if (!pattern3.test(data12)) {
                                const err41 = { instancePath: instancePath + "/data/impact/balanceDeltaMinor", schemaPath: "#/properties/data/properties/impact/properties/balanceDeltaMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err41];
                                }
                                else {
                                    vErrors.push(err41);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err42 = { instancePath: instancePath + "/data/impact/balanceDeltaMinor", schemaPath: "#/properties/data/properties/impact/properties/balanceDeltaMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err42];
                            }
                            else {
                                vErrors.push(err42);
                            }
                            errors++;
                        }
                    }
                    if (data8.paid !== undefined) {
                        let data13 = data8.paid;
                        if ((typeof data13 !== "boolean") && (data13 !== null)) {
                            const err43 = { instancePath: instancePath + "/data/impact/paid", schemaPath: "#/properties/data/properties/impact/properties/paid/type", keyword: "type", params: { type: schema26.properties.data.properties.impact.properties.paid.type }, message: "must be boolean,null" };
                            if (vErrors === null) {
                                vErrors = [err43];
                            }
                            else {
                                vErrors.push(err43);
                            }
                            errors++;
                        }
                    }
                    if (data8.effective !== undefined) {
                        if (typeof data8.effective !== "boolean") {
                            const err44 = { instancePath: instancePath + "/data/impact/effective", schemaPath: "#/properties/data/properties/impact/properties/effective/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                                vErrors = [err44];
                            }
                            else {
                                vErrors.push(err44);
                            }
                            errors++;
                        }
                    }
                    if (data8.requiresConfirmation !== undefined) {
                        if (typeof data8.requiresConfirmation !== "boolean") {
                            const err45 = { instancePath: instancePath + "/data/impact/requiresConfirmation", schemaPath: "#/properties/data/properties/impact/properties/requiresConfirmation/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                                vErrors = [err45];
                            }
                            else {
                                vErrors.push(err45);
                            }
                            errors++;
                        }
                    }
                    if (data8.references !== undefined) {
                        let data16 = data8.references;
                        if (Array.isArray(data16)) {
                            if (data16.length > 16) {
                                const err46 = { instancePath: instancePath + "/data/impact/references", schemaPath: "#/properties/data/properties/impact/properties/references/maxItems", keyword: "maxItems", params: { limit: 16 }, message: "must NOT have more than 16 items" };
                                if (vErrors === null) {
                                    vErrors = [err46];
                                }
                                else {
                                    vErrors.push(err46);
                                }
                                errors++;
                            }
                            const len0 = data16.length;
                            for (let i0 = 0; i0 < len0; i0++) {
                                let data17 = data16[i0];
                                if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                                    if (data17.kind === undefined) {
                                        const err47 = { instancePath: instancePath + "/data/impact/references/" + i0, schemaPath: "#/properties/data/properties/impact/properties/references/items/required", keyword: "required", params: { missingProperty: "kind" }, message: "must have required property '" + "kind" + "'" };
                                        if (vErrors === null) {
                                            vErrors = [err47];
                                        }
                                        else {
                                            vErrors.push(err47);
                                        }
                                        errors++;
                                    }
                                    if (data17.count === undefined) {
                                        const err48 = { instancePath: instancePath + "/data/impact/references/" + i0, schemaPath: "#/properties/data/properties/impact/properties/references/items/required", keyword: "required", params: { missingProperty: "count" }, message: "must have required property '" + "count" + "'" };
                                        if (vErrors === null) {
                                            vErrors = [err48];
                                        }
                                        else {
                                            vErrors.push(err48);
                                        }
                                        errors++;
                                    }
                                    for (const key3 in data17) {
                                        if (!((key3 === "kind") || (key3 === "count"))) {
                                            const err49 = { instancePath: instancePath + "/data/impact/references/" + i0, schemaPath: "#/properties/data/properties/impact/properties/references/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                                            if (vErrors === null) {
                                                vErrors = [err49];
                                            }
                                            else {
                                                vErrors.push(err49);
                                            }
                                            errors++;
                                        }
                                    }
                                    if (data17.kind !== undefined) {
                                        let data18 = data17.kind;
                                        if (typeof data18 !== "string") {
                                            const err50 = { instancePath: instancePath + "/data/impact/references/" + i0 + "/kind", schemaPath: "#/properties/data/properties/impact/properties/references/items/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                            if (vErrors === null) {
                                                vErrors = [err50];
                                            }
                                            else {
                                                vErrors.push(err50);
                                            }
                                            errors++;
                                        }
                                        if (!(((((data18 === "entry") || (data18 === "account")) || (data18 === "category")) || (data18 === "installmentGroup")) || (data18 === "transfer"))) {
                                            const err51 = { instancePath: instancePath + "/data/impact/references/" + i0 + "/kind", schemaPath: "#/properties/data/properties/impact/properties/references/items/properties/kind/enum", keyword: "enum", params: { allowedValues: schema26.properties.data.properties.impact.properties.references.items.properties.kind.enum }, message: "must be equal to one of the allowed values" };
                                            if (vErrors === null) {
                                                vErrors = [err51];
                                            }
                                            else {
                                                vErrors.push(err51);
                                            }
                                            errors++;
                                        }
                                    }
                                    if (data17.count !== undefined) {
                                        let data19 = data17.count;
                                        if (!(((typeof data19 == "number") && (!(data19 % 1) && !isNaN(data19))) && (isFinite(data19)))) {
                                            const err52 = { instancePath: instancePath + "/data/impact/references/" + i0 + "/count", schemaPath: "#/properties/data/properties/impact/properties/references/items/properties/count/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                            if (vErrors === null) {
                                                vErrors = [err52];
                                            }
                                            else {
                                                vErrors.push(err52);
                                            }
                                            errors++;
                                        }
                                        if ((typeof data19 == "number") && (isFinite(data19))) {
                                            if (data19 < 1 || isNaN(data19)) {
                                                const err53 = { instancePath: instancePath + "/data/impact/references/" + i0 + "/count", schemaPath: "#/properties/data/properties/impact/properties/references/items/properties/count/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                                                if (vErrors === null) {
                                                    vErrors = [err53];
                                                }
                                                else {
                                                    vErrors.push(err53);
                                                }
                                                errors++;
                                            }
                                        }
                                    }
                                }
                                else {
                                    const err54 = { instancePath: instancePath + "/data/impact/references/" + i0, schemaPath: "#/properties/data/properties/impact/properties/references/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                    if (vErrors === null) {
                                        vErrors = [err54];
                                    }
                                    else {
                                        vErrors.push(err54);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err55 = { instancePath: instancePath + "/data/impact/references", schemaPath: "#/properties/data/properties/impact/properties/references/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                            if (vErrors === null) {
                                vErrors = [err55];
                            }
                            else {
                                vErrors.push(err55);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err56 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                        vErrors = [err56];
                    }
                    else {
                        vErrors.push(err56);
                    }
                    errors++;
                }
            }
        }
        else {
            const err57 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err57];
            }
            else {
                vErrors.push(err57);
            }
            errors++;
        }
    }
    if (data.meta !== undefined) {
        let data20 = data.meta;
        if (data20 && typeof data20 == "object" && !Array.isArray(data20)) {
            if (data20.requestId === undefined) {
                const err58 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "requestId" }, message: "must have required property '" + "requestId" + "'" };
                if (vErrors === null) {
                    vErrors = [err58];
                }
                else {
                    vErrors.push(err58);
                }
                errors++;
            }
            if (data20.asOf === undefined) {
                const err59 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "asOf" }, message: "must have required property '" + "asOf" + "'" };
                if (vErrors === null) {
                    vErrors = [err59];
                }
                else {
                    vErrors.push(err59);
                }
                errors++;
            }
            if (data20.businessToday === undefined) {
                const err60 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err60];
                }
                else {
                    vErrors.push(err60);
                }
                errors++;
            }
            if (data20.timeZone === undefined) {
                const err61 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "timeZone" }, message: "must have required property '" + "timeZone" + "'" };
                if (vErrors === null) {
                    vErrors = [err61];
                }
                else {
                    vErrors.push(err61);
                }
                errors++;
            }
            if (data20.dataRevision === undefined) {
                const err62 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "dataRevision" }, message: "must have required property '" + "dataRevision" + "'" };
                if (vErrors === null) {
                    vErrors = [err62];
                }
                else {
                    vErrors.push(err62);
                }
                errors++;
            }
            for (const key4 in data20) {
                if (!(((((key4 === "requestId") || (key4 === "asOf")) || (key4 === "businessToday")) || (key4 === "timeZone")) || (key4 === "dataRevision"))) {
                    const err63 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key4 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err63];
                    }
                    else {
                        vErrors.push(err63);
                    }
                    errors++;
                }
            }
            if (data20.requestId !== undefined) {
                let data21 = data20.requestId;
                if (typeof data21 === "string") {
                    if (func2(data21) > 64) {
                        const err64 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err64];
                        }
                        else {
                            vErrors.push(err64);
                        }
                        errors++;
                    }
                    if (func2(data21) < 1) {
                        const err65 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err65];
                        }
                        else {
                            vErrors.push(err65);
                        }
                        errors++;
                    }
                }
                else {
                    const err66 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err66];
                    }
                    else {
                        vErrors.push(err66);
                    }
                    errors++;
                }
            }
            if (data20.asOf !== undefined) {
                let data22 = data20.asOf;
                if (typeof data22 === "string") {
                    if (func2(data22) > 64) {
                        const err67 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err67];
                        }
                        else {
                            vErrors.push(err67);
                        }
                        errors++;
                    }
                    if (func2(data22) < 1) {
                        const err68 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err68];
                        }
                        else {
                            vErrors.push(err68);
                        }
                        errors++;
                    }
                }
                else {
                    const err69 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err69];
                    }
                    else {
                        vErrors.push(err69);
                    }
                    errors++;
                }
            }
            if (data20.businessToday !== undefined) {
                let data23 = data20.businessToday;
                if (typeof data23 === "string") {
                    if (!pattern4.test(data23)) {
                        const err70 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err70];
                        }
                        else {
                            vErrors.push(err70);
                        }
                        errors++;
                    }
                }
                else {
                    const err71 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err71];
                    }
                    else {
                        vErrors.push(err71);
                    }
                    errors++;
                }
            }
            if (data20.timeZone !== undefined) {
                let data24 = data20.timeZone;
                if (typeof data24 === "string") {
                    if (func2(data24) > 64) {
                        const err72 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err72];
                        }
                        else {
                            vErrors.push(err72);
                        }
                        errors++;
                    }
                    if (func2(data24) < 1) {
                        const err73 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err73];
                        }
                        else {
                            vErrors.push(err73);
                        }
                        errors++;
                    }
                }
                else {
                    const err74 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err74];
                    }
                    else {
                        vErrors.push(err74);
                    }
                    errors++;
                }
            }
            if (data20.dataRevision !== undefined) {
                let data25 = data20.dataRevision;
                if (typeof data25 === "string") {
                    if (!pattern2.test(data25)) {
                        const err75 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err75];
                        }
                        else {
                            vErrors.push(err75);
                        }
                        errors++;
                    }
                }
                else {
                    const err76 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err76];
                    }
                    else {
                        vErrors.push(err76);
                    }
                    errors++;
                }
            }
        }
        else {
            const err77 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err77];
            }
            else {
                vErrors.push(err77);
            }
            errors++;
        }
    }
}
else {
    const err78 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
        vErrors = [err78];
    }
    else {
        vErrors.push(err78);
    }
    errors++;
} validate25.errors = vErrors; return errors === 0; }
export const validateLedgerEntrySuggestionsEnvelope = validate26;
const schema27 = { "$id": "https://saldo.local/schemas/ledger-entry-suggestions-envelope.json", "$schema": "http://json-schema.org/draft-07/schema#", "title": "LedgerEntrySuggestionsEnvelope", "type": "object", "additionalProperties": false, "required": ["data", "meta"], "properties": { "data": { "type": "object", "additionalProperties": false, "required": ["suggestions"], "properties": { "suggestions": { "type": "array", "maxItems": 50, "items": { "type": "object", "additionalProperties": false, "required": ["description", "occurrences", "lastUsedDate", "accountId", "signedMinor", "currency", "categoryId"], "properties": { "description": { "type": "string", "minLength": 1, "maxLength": 500 }, "occurrences": { "type": "integer", "minimum": 1 }, "lastUsedDate": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "accountId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "signedMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "categoryId": { "type": ["string", "null"], "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } } } } } }, "meta": { "type": "object", "additionalProperties": false, "required": ["requestId", "asOf", "businessToday", "timeZone", "dataRevision"], "properties": { "requestId": { "type": "string", "minLength": 1, "maxLength": 64 }, "asOf": { "type": "string", "minLength": 1, "maxLength": 64 }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "timeZone": { "type": "string", "minLength": 1, "maxLength": 64 }, "dataRevision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } } } };
function validate26(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="https://saldo.local/schemas/ledger-entry-suggestions-envelope.json" */ ; let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.data === undefined) {
        const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property '" + "data" + "'" };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
    }
    if (data.meta === undefined) {
        const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "meta" }, message: "must have required property '" + "meta" + "'" };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    for (const key0 in data) {
        if (!((key0 === "data") || (key0 === "meta"))) {
            const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.data !== undefined) {
        let data0 = data.data;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.suggestions === undefined) {
                const err3 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "suggestions" }, message: "must have required property '" + "suggestions" + "'" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
            for (const key1 in data0) {
                if (!(key1 === "suggestions")) {
                    const err4 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
            }
            if (data0.suggestions !== undefined) {
                let data1 = data0.suggestions;
                if (Array.isArray(data1)) {
                    if (data1.length > 50) {
                        const err5 = { instancePath: instancePath + "/data/suggestions", schemaPath: "#/properties/data/properties/suggestions/maxItems", keyword: "maxItems", params: { limit: 50 }, message: "must NOT have more than 50 items" };
                        if (vErrors === null) {
                            vErrors = [err5];
                        }
                        else {
                            vErrors.push(err5);
                        }
                        errors++;
                    }
                    const len0 = data1.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                        let data2 = data1[i0];
                        if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                            if (data2.description === undefined) {
                                const err6 = { instancePath: instancePath + "/data/suggestions/" + i0, schemaPath: "#/properties/data/properties/suggestions/items/required", keyword: "required", params: { missingProperty: "description" }, message: "must have required property '" + "description" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err6];
                                }
                                else {
                                    vErrors.push(err6);
                                }
                                errors++;
                            }
                            if (data2.occurrences === undefined) {
                                const err7 = { instancePath: instancePath + "/data/suggestions/" + i0, schemaPath: "#/properties/data/properties/suggestions/items/required", keyword: "required", params: { missingProperty: "occurrences" }, message: "must have required property '" + "occurrences" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err7];
                                }
                                else {
                                    vErrors.push(err7);
                                }
                                errors++;
                            }
                            if (data2.lastUsedDate === undefined) {
                                const err8 = { instancePath: instancePath + "/data/suggestions/" + i0, schemaPath: "#/properties/data/properties/suggestions/items/required", keyword: "required", params: { missingProperty: "lastUsedDate" }, message: "must have required property '" + "lastUsedDate" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err8];
                                }
                                else {
                                    vErrors.push(err8);
                                }
                                errors++;
                            }
                            if (data2.accountId === undefined) {
                                const err9 = { instancePath: instancePath + "/data/suggestions/" + i0, schemaPath: "#/properties/data/properties/suggestions/items/required", keyword: "required", params: { missingProperty: "accountId" }, message: "must have required property '" + "accountId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err9];
                                }
                                else {
                                    vErrors.push(err9);
                                }
                                errors++;
                            }
                            if (data2.signedMinor === undefined) {
                                const err10 = { instancePath: instancePath + "/data/suggestions/" + i0, schemaPath: "#/properties/data/properties/suggestions/items/required", keyword: "required", params: { missingProperty: "signedMinor" }, message: "must have required property '" + "signedMinor" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err10];
                                }
                                else {
                                    vErrors.push(err10);
                                }
                                errors++;
                            }
                            if (data2.currency === undefined) {
                                const err11 = { instancePath: instancePath + "/data/suggestions/" + i0, schemaPath: "#/properties/data/properties/suggestions/items/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err11];
                                }
                                else {
                                    vErrors.push(err11);
                                }
                                errors++;
                            }
                            if (data2.categoryId === undefined) {
                                const err12 = { instancePath: instancePath + "/data/suggestions/" + i0, schemaPath: "#/properties/data/properties/suggestions/items/required", keyword: "required", params: { missingProperty: "categoryId" }, message: "must have required property '" + "categoryId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err12];
                                }
                                else {
                                    vErrors.push(err12);
                                }
                                errors++;
                            }
                            for (const key2 in data2) {
                                if (!(((((((key2 === "description") || (key2 === "occurrences")) || (key2 === "lastUsedDate")) || (key2 === "accountId")) || (key2 === "signedMinor")) || (key2 === "currency")) || (key2 === "categoryId"))) {
                                    const err13 = { instancePath: instancePath + "/data/suggestions/" + i0, schemaPath: "#/properties/data/properties/suggestions/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                                    if (vErrors === null) {
                                        vErrors = [err13];
                                    }
                                    else {
                                        vErrors.push(err13);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.description !== undefined) {
                                let data3 = data2.description;
                                if (typeof data3 === "string") {
                                    if (func2(data3) > 500) {
                                        const err14 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/description", schemaPath: "#/properties/data/properties/suggestions/items/properties/description/maxLength", keyword: "maxLength", params: { limit: 500 }, message: "must NOT have more than 500 characters" };
                                        if (vErrors === null) {
                                            vErrors = [err14];
                                        }
                                        else {
                                            vErrors.push(err14);
                                        }
                                        errors++;
                                    }
                                    if (func2(data3) < 1) {
                                        const err15 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/description", schemaPath: "#/properties/data/properties/suggestions/items/properties/description/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                        if (vErrors === null) {
                                            vErrors = [err15];
                                        }
                                        else {
                                            vErrors.push(err15);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err16 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/description", schemaPath: "#/properties/data/properties/suggestions/items/properties/description/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err16];
                                    }
                                    else {
                                        vErrors.push(err16);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.occurrences !== undefined) {
                                let data4 = data2.occurrences;
                                if (!(((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4))) && (isFinite(data4)))) {
                                    const err17 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/occurrences", schemaPath: "#/properties/data/properties/suggestions/items/properties/occurrences/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                    if (vErrors === null) {
                                        vErrors = [err17];
                                    }
                                    else {
                                        vErrors.push(err17);
                                    }
                                    errors++;
                                }
                                if ((typeof data4 == "number") && (isFinite(data4))) {
                                    if (data4 < 1 || isNaN(data4)) {
                                        const err18 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/occurrences", schemaPath: "#/properties/data/properties/suggestions/items/properties/occurrences/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                                        if (vErrors === null) {
                                            vErrors = [err18];
                                        }
                                        else {
                                            vErrors.push(err18);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data2.lastUsedDate !== undefined) {
                                let data5 = data2.lastUsedDate;
                                if (typeof data5 === "string") {
                                    if (!pattern4.test(data5)) {
                                        const err19 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/lastUsedDate", schemaPath: "#/properties/data/properties/suggestions/items/properties/lastUsedDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err19];
                                        }
                                        else {
                                            vErrors.push(err19);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err20 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/lastUsedDate", schemaPath: "#/properties/data/properties/suggestions/items/properties/lastUsedDate/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err20];
                                    }
                                    else {
                                        vErrors.push(err20);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.accountId !== undefined) {
                                let data6 = data2.accountId;
                                if (typeof data6 === "string") {
                                    if (!pattern0.test(data6)) {
                                        const err21 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/accountId", schemaPath: "#/properties/data/properties/suggestions/items/properties/accountId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err21];
                                        }
                                        else {
                                            vErrors.push(err21);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err22 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/accountId", schemaPath: "#/properties/data/properties/suggestions/items/properties/accountId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err22];
                                    }
                                    else {
                                        vErrors.push(err22);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.signedMinor !== undefined) {
                                let data7 = data2.signedMinor;
                                if (typeof data7 === "string") {
                                    if (!pattern3.test(data7)) {
                                        const err23 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/signedMinor", schemaPath: "#/properties/data/properties/suggestions/items/properties/signedMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err23];
                                        }
                                        else {
                                            vErrors.push(err23);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err24 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/signedMinor", schemaPath: "#/properties/data/properties/suggestions/items/properties/signedMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err24];
                                    }
                                    else {
                                        vErrors.push(err24);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.currency !== undefined) {
                                let data8 = data2.currency;
                                if (typeof data8 !== "string") {
                                    const err25 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/currency", schemaPath: "#/properties/data/properties/suggestions/items/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err25];
                                    }
                                    else {
                                        vErrors.push(err25);
                                    }
                                    errors++;
                                }
                                if (!(((data8 === "BRL") || (data8 === "CAD")) || (data8 === "USD"))) {
                                    const err26 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/currency", schemaPath: "#/properties/data/properties/suggestions/items/properties/currency/enum", keyword: "enum", params: { allowedValues: schema27.properties.data.properties.suggestions.items.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err26];
                                    }
                                    else {
                                        vErrors.push(err26);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.categoryId !== undefined) {
                                let data9 = data2.categoryId;
                                if ((typeof data9 !== "string") && (data9 !== null)) {
                                    const err27 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/categoryId", schemaPath: "#/properties/data/properties/suggestions/items/properties/categoryId/type", keyword: "type", params: { type: schema27.properties.data.properties.suggestions.items.properties.categoryId.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err27];
                                    }
                                    else {
                                        vErrors.push(err27);
                                    }
                                    errors++;
                                }
                                if (typeof data9 === "string") {
                                    if (!pattern0.test(data9)) {
                                        const err28 = { instancePath: instancePath + "/data/suggestions/" + i0 + "/categoryId", schemaPath: "#/properties/data/properties/suggestions/items/properties/categoryId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err28];
                                        }
                                        else {
                                            vErrors.push(err28);
                                        }
                                        errors++;
                                    }
                                }
                            }
                        }
                        else {
                            const err29 = { instancePath: instancePath + "/data/suggestions/" + i0, schemaPath: "#/properties/data/properties/suggestions/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                                vErrors = [err29];
                            }
                            else {
                                vErrors.push(err29);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err30 = { instancePath: instancePath + "/data/suggestions", schemaPath: "#/properties/data/properties/suggestions/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err30];
                    }
                    else {
                        vErrors.push(err30);
                    }
                    errors++;
                }
            }
        }
        else {
            const err31 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err31];
            }
            else {
                vErrors.push(err31);
            }
            errors++;
        }
    }
    if (data.meta !== undefined) {
        let data10 = data.meta;
        if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
            if (data10.requestId === undefined) {
                const err32 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "requestId" }, message: "must have required property '" + "requestId" + "'" };
                if (vErrors === null) {
                    vErrors = [err32];
                }
                else {
                    vErrors.push(err32);
                }
                errors++;
            }
            if (data10.asOf === undefined) {
                const err33 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "asOf" }, message: "must have required property '" + "asOf" + "'" };
                if (vErrors === null) {
                    vErrors = [err33];
                }
                else {
                    vErrors.push(err33);
                }
                errors++;
            }
            if (data10.businessToday === undefined) {
                const err34 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err34];
                }
                else {
                    vErrors.push(err34);
                }
                errors++;
            }
            if (data10.timeZone === undefined) {
                const err35 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "timeZone" }, message: "must have required property '" + "timeZone" + "'" };
                if (vErrors === null) {
                    vErrors = [err35];
                }
                else {
                    vErrors.push(err35);
                }
                errors++;
            }
            if (data10.dataRevision === undefined) {
                const err36 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "dataRevision" }, message: "must have required property '" + "dataRevision" + "'" };
                if (vErrors === null) {
                    vErrors = [err36];
                }
                else {
                    vErrors.push(err36);
                }
                errors++;
            }
            for (const key3 in data10) {
                if (!(((((key3 === "requestId") || (key3 === "asOf")) || (key3 === "businessToday")) || (key3 === "timeZone")) || (key3 === "dataRevision"))) {
                    const err37 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err37];
                    }
                    else {
                        vErrors.push(err37);
                    }
                    errors++;
                }
            }
            if (data10.requestId !== undefined) {
                let data11 = data10.requestId;
                if (typeof data11 === "string") {
                    if (func2(data11) > 64) {
                        const err38 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err38];
                        }
                        else {
                            vErrors.push(err38);
                        }
                        errors++;
                    }
                    if (func2(data11) < 1) {
                        const err39 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err39];
                        }
                        else {
                            vErrors.push(err39);
                        }
                        errors++;
                    }
                }
                else {
                    const err40 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err40];
                    }
                    else {
                        vErrors.push(err40);
                    }
                    errors++;
                }
            }
            if (data10.asOf !== undefined) {
                let data12 = data10.asOf;
                if (typeof data12 === "string") {
                    if (func2(data12) > 64) {
                        const err41 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err41];
                        }
                        else {
                            vErrors.push(err41);
                        }
                        errors++;
                    }
                    if (func2(data12) < 1) {
                        const err42 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err42];
                        }
                        else {
                            vErrors.push(err42);
                        }
                        errors++;
                    }
                }
                else {
                    const err43 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err43];
                    }
                    else {
                        vErrors.push(err43);
                    }
                    errors++;
                }
            }
            if (data10.businessToday !== undefined) {
                let data13 = data10.businessToday;
                if (typeof data13 === "string") {
                    if (!pattern4.test(data13)) {
                        const err44 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err44];
                        }
                        else {
                            vErrors.push(err44);
                        }
                        errors++;
                    }
                }
                else {
                    const err45 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err45];
                    }
                    else {
                        vErrors.push(err45);
                    }
                    errors++;
                }
            }
            if (data10.timeZone !== undefined) {
                let data14 = data10.timeZone;
                if (typeof data14 === "string") {
                    if (func2(data14) > 64) {
                        const err46 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err46];
                        }
                        else {
                            vErrors.push(err46);
                        }
                        errors++;
                    }
                    if (func2(data14) < 1) {
                        const err47 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err47];
                        }
                        else {
                            vErrors.push(err47);
                        }
                        errors++;
                    }
                }
                else {
                    const err48 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err48];
                    }
                    else {
                        vErrors.push(err48);
                    }
                    errors++;
                }
            }
            if (data10.dataRevision !== undefined) {
                let data15 = data10.dataRevision;
                if (typeof data15 === "string") {
                    if (!pattern2.test(data15)) {
                        const err49 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err49];
                        }
                        else {
                            vErrors.push(err49);
                        }
                        errors++;
                    }
                }
                else {
                    const err50 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err50];
                    }
                    else {
                        vErrors.push(err50);
                    }
                    errors++;
                }
            }
        }
        else {
            const err51 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err51];
            }
            else {
                vErrors.push(err51);
            }
            errors++;
        }
    }
}
else {
    const err52 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
        vErrors = [err52];
    }
    else {
        vErrors.push(err52);
    }
    errors++;
} validate26.errors = vErrors; return errors === 0; }
export const validateLedgerReportsEnvelope = validate27;
const schema28 = { "$id": "https://saldo.local/schemas/ledger-reports-envelope.json", "$schema": "http://json-schema.org/draft-07/schema#", "title": "LedgerReportsEnvelope", "type": "object", "additionalProperties": false, "required": ["data", "meta"], "properties": { "data": { "type": "object", "additionalProperties": false, "required": ["period", "cutoff", "roleScope", "accountId", "blocks"], "properties": { "period": { "type": "object", "additionalProperties": false, "required": ["kind", "start", "endExclusive", "label"], "properties": { "kind": { "type": "string", "enum": ["month", "range", "all"] }, "start": { "type": ["string", "null"], "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "endExclusive": { "type": ["string", "null"], "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "label": { "type": "string", "minLength": 1, "maxLength": 64 } } }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "cutoff": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "roleScope": { "type": "string", "enum": ["all", "cash", "card"] }, "accountId": { "type": ["string", "null"], "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "blocks": { "type": "array", "maxItems": 3, "items": { "type": "object", "additionalProperties": false, "required": ["currency", "totals", "categories"], "properties": { "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "totals": { "type": "object", "additionalProperties": false, "required": ["incomeMinor", "expenseMinor", "netMinor", "recorded", "pending"], "properties": { "incomeMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "expenseMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "netMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "recorded": { "type": "object", "additionalProperties": false, "required": ["incomeMinor", "expenseMinor", "netMinor"], "properties": { "incomeMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "expenseMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "netMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" } } }, "pending": { "type": "object", "additionalProperties": false, "required": ["incomeMinor", "expenseMinor", "netMinor"], "properties": { "incomeMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "expenseMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "netMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" } } } } }, "categories": { "type": "array", "maxItems": 500, "items": { "type": "object", "additionalProperties": false, "required": ["categoryId", "label", "archived", "entryCount", "totals"], "properties": { "categoryId": { "type": ["string", "null"], "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "label": { "type": "string", "minLength": 1, "maxLength": 120 }, "archived": { "type": "boolean" }, "entryCount": { "type": "integer", "minimum": 0 }, "totals": { "type": "object", "additionalProperties": false, "required": ["incomeMinor", "expenseMinor", "netMinor", "recorded", "pending"], "properties": { "incomeMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "expenseMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "netMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "recorded": { "type": "object", "additionalProperties": false, "required": ["incomeMinor", "expenseMinor", "netMinor"], "properties": { "incomeMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "expenseMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "netMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" } } }, "pending": { "type": "object", "additionalProperties": false, "required": ["incomeMinor", "expenseMinor", "netMinor"], "properties": { "incomeMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "expenseMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "netMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" } } } } } } } } } } } } }, "meta": { "type": "object", "additionalProperties": false, "required": ["requestId", "asOf", "businessToday", "timeZone", "dataRevision"], "properties": { "requestId": { "type": "string", "minLength": 1, "maxLength": 64 }, "asOf": { "type": "string", "minLength": 1, "maxLength": 64 }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "timeZone": { "type": "string", "minLength": 1, "maxLength": 64 }, "dataRevision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } } } };
function validate27(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="https://saldo.local/schemas/ledger-reports-envelope.json" */ ; let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.data === undefined) {
        const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property '" + "data" + "'" };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
    }
    if (data.meta === undefined) {
        const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "meta" }, message: "must have required property '" + "meta" + "'" };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    for (const key0 in data) {
        if (!((key0 === "data") || (key0 === "meta"))) {
            const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.data !== undefined) {
        let data0 = data.data;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.period === undefined) {
                const err3 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "period" }, message: "must have required property '" + "period" + "'" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
            if (data0.cutoff === undefined) {
                const err4 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "cutoff" }, message: "must have required property '" + "cutoff" + "'" };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
            if (data0.roleScope === undefined) {
                const err5 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "roleScope" }, message: "must have required property '" + "roleScope" + "'" };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
            }
            if (data0.accountId === undefined) {
                const err6 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "accountId" }, message: "must have required property '" + "accountId" + "'" };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
            }
            if (data0.blocks === undefined) {
                const err7 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "blocks" }, message: "must have required property '" + "blocks" + "'" };
                if (vErrors === null) {
                    vErrors = [err7];
                }
                else {
                    vErrors.push(err7);
                }
                errors++;
            }
            for (const key1 in data0) {
                if (!((((((key1 === "period") || (key1 === "businessToday")) || (key1 === "cutoff")) || (key1 === "roleScope")) || (key1 === "accountId")) || (key1 === "blocks"))) {
                    const err8 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err8];
                    }
                    else {
                        vErrors.push(err8);
                    }
                    errors++;
                }
            }
            if (data0.period !== undefined) {
                let data1 = data0.period;
                if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
                    if (data1.kind === undefined) {
                        const err9 = { instancePath: instancePath + "/data/period", schemaPath: "#/properties/data/properties/period/required", keyword: "required", params: { missingProperty: "kind" }, message: "must have required property '" + "kind" + "'" };
                        if (vErrors === null) {
                            vErrors = [err9];
                        }
                        else {
                            vErrors.push(err9);
                        }
                        errors++;
                    }
                    if (data1.start === undefined) {
                        const err10 = { instancePath: instancePath + "/data/period", schemaPath: "#/properties/data/properties/period/required", keyword: "required", params: { missingProperty: "start" }, message: "must have required property '" + "start" + "'" };
                        if (vErrors === null) {
                            vErrors = [err10];
                        }
                        else {
                            vErrors.push(err10);
                        }
                        errors++;
                    }
                    if (data1.endExclusive === undefined) {
                        const err11 = { instancePath: instancePath + "/data/period", schemaPath: "#/properties/data/properties/period/required", keyword: "required", params: { missingProperty: "endExclusive" }, message: "must have required property '" + "endExclusive" + "'" };
                        if (vErrors === null) {
                            vErrors = [err11];
                        }
                        else {
                            vErrors.push(err11);
                        }
                        errors++;
                    }
                    if (data1.label === undefined) {
                        const err12 = { instancePath: instancePath + "/data/period", schemaPath: "#/properties/data/properties/period/required", keyword: "required", params: { missingProperty: "label" }, message: "must have required property '" + "label" + "'" };
                        if (vErrors === null) {
                            vErrors = [err12];
                        }
                        else {
                            vErrors.push(err12);
                        }
                        errors++;
                    }
                    for (const key2 in data1) {
                        if (!((((key2 === "kind") || (key2 === "start")) || (key2 === "endExclusive")) || (key2 === "label"))) {
                            const err13 = { instancePath: instancePath + "/data/period", schemaPath: "#/properties/data/properties/period/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                                vErrors = [err13];
                            }
                            else {
                                vErrors.push(err13);
                            }
                            errors++;
                        }
                    }
                    if (data1.kind !== undefined) {
                        let data2 = data1.kind;
                        if (typeof data2 !== "string") {
                            const err14 = { instancePath: instancePath + "/data/period/kind", schemaPath: "#/properties/data/properties/period/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err14];
                            }
                            else {
                                vErrors.push(err14);
                            }
                            errors++;
                        }
                        if (!(((data2 === "month") || (data2 === "range")) || (data2 === "all"))) {
                            const err15 = { instancePath: instancePath + "/data/period/kind", schemaPath: "#/properties/data/properties/period/properties/kind/enum", keyword: "enum", params: { allowedValues: schema28.properties.data.properties.period.properties.kind.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                                vErrors = [err15];
                            }
                            else {
                                vErrors.push(err15);
                            }
                            errors++;
                        }
                    }
                    if (data1.start !== undefined) {
                        let data3 = data1.start;
                        if ((typeof data3 !== "string") && (data3 !== null)) {
                            const err16 = { instancePath: instancePath + "/data/period/start", schemaPath: "#/properties/data/properties/period/properties/start/type", keyword: "type", params: { type: schema28.properties.data.properties.period.properties.start.type }, message: "must be string,null" };
                            if (vErrors === null) {
                                vErrors = [err16];
                            }
                            else {
                                vErrors.push(err16);
                            }
                            errors++;
                        }
                        if (typeof data3 === "string") {
                            if (!pattern4.test(data3)) {
                                const err17 = { instancePath: instancePath + "/data/period/start", schemaPath: "#/properties/data/properties/period/properties/start/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err17];
                                }
                                else {
                                    vErrors.push(err17);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data1.endExclusive !== undefined) {
                        let data4 = data1.endExclusive;
                        if ((typeof data4 !== "string") && (data4 !== null)) {
                            const err18 = { instancePath: instancePath + "/data/period/endExclusive", schemaPath: "#/properties/data/properties/period/properties/endExclusive/type", keyword: "type", params: { type: schema28.properties.data.properties.period.properties.endExclusive.type }, message: "must be string,null" };
                            if (vErrors === null) {
                                vErrors = [err18];
                            }
                            else {
                                vErrors.push(err18);
                            }
                            errors++;
                        }
                        if (typeof data4 === "string") {
                            if (!pattern4.test(data4)) {
                                const err19 = { instancePath: instancePath + "/data/period/endExclusive", schemaPath: "#/properties/data/properties/period/properties/endExclusive/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err19];
                                }
                                else {
                                    vErrors.push(err19);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data1.label !== undefined) {
                        let data5 = data1.label;
                        if (typeof data5 === "string") {
                            if (func2(data5) > 64) {
                                const err20 = { instancePath: instancePath + "/data/period/label", schemaPath: "#/properties/data/properties/period/properties/label/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                                if (vErrors === null) {
                                    vErrors = [err20];
                                }
                                else {
                                    vErrors.push(err20);
                                }
                                errors++;
                            }
                            if (func2(data5) < 1) {
                                const err21 = { instancePath: instancePath + "/data/period/label", schemaPath: "#/properties/data/properties/period/properties/label/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                if (vErrors === null) {
                                    vErrors = [err21];
                                }
                                else {
                                    vErrors.push(err21);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err22 = { instancePath: instancePath + "/data/period/label", schemaPath: "#/properties/data/properties/period/properties/label/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err22];
                            }
                            else {
                                vErrors.push(err22);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err23 = { instancePath: instancePath + "/data/period", schemaPath: "#/properties/data/properties/period/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                        vErrors = [err23];
                    }
                    else {
                        vErrors.push(err23);
                    }
                    errors++;
                }
            }
            if (data0.businessToday !== undefined) {
                let data6 = data0.businessToday;
                if (typeof data6 === "string") {
                    if (!pattern4.test(data6)) {
                        const err24 = { instancePath: instancePath + "/data/businessToday", schemaPath: "#/properties/data/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err24];
                        }
                        else {
                            vErrors.push(err24);
                        }
                        errors++;
                    }
                }
                else {
                    const err25 = { instancePath: instancePath + "/data/businessToday", schemaPath: "#/properties/data/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err25];
                    }
                    else {
                        vErrors.push(err25);
                    }
                    errors++;
                }
            }
            if (data0.cutoff !== undefined) {
                let data7 = data0.cutoff;
                if (typeof data7 === "string") {
                    if (!pattern4.test(data7)) {
                        const err26 = { instancePath: instancePath + "/data/cutoff", schemaPath: "#/properties/data/properties/cutoff/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err26];
                        }
                        else {
                            vErrors.push(err26);
                        }
                        errors++;
                    }
                }
                else {
                    const err27 = { instancePath: instancePath + "/data/cutoff", schemaPath: "#/properties/data/properties/cutoff/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err27];
                    }
                    else {
                        vErrors.push(err27);
                    }
                    errors++;
                }
            }
            if (data0.roleScope !== undefined) {
                let data8 = data0.roleScope;
                if (typeof data8 !== "string") {
                    const err28 = { instancePath: instancePath + "/data/roleScope", schemaPath: "#/properties/data/properties/roleScope/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err28];
                    }
                    else {
                        vErrors.push(err28);
                    }
                    errors++;
                }
                if (!(((data8 === "all") || (data8 === "cash")) || (data8 === "card"))) {
                    const err29 = { instancePath: instancePath + "/data/roleScope", schemaPath: "#/properties/data/properties/roleScope/enum", keyword: "enum", params: { allowedValues: schema28.properties.data.properties.roleScope.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err29];
                    }
                    else {
                        vErrors.push(err29);
                    }
                    errors++;
                }
            }
            if (data0.accountId !== undefined) {
                let data9 = data0.accountId;
                if ((typeof data9 !== "string") && (data9 !== null)) {
                    const err30 = { instancePath: instancePath + "/data/accountId", schemaPath: "#/properties/data/properties/accountId/type", keyword: "type", params: { type: schema28.properties.data.properties.accountId.type }, message: "must be string,null" };
                    if (vErrors === null) {
                        vErrors = [err30];
                    }
                    else {
                        vErrors.push(err30);
                    }
                    errors++;
                }
                if (typeof data9 === "string") {
                    if (!pattern0.test(data9)) {
                        const err31 = { instancePath: instancePath + "/data/accountId", schemaPath: "#/properties/data/properties/accountId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err31];
                        }
                        else {
                            vErrors.push(err31);
                        }
                        errors++;
                    }
                }
            }
            if (data0.blocks !== undefined) {
                let data10 = data0.blocks;
                if (Array.isArray(data10)) {
                    if (data10.length > 3) {
                        const err32 = { instancePath: instancePath + "/data/blocks", schemaPath: "#/properties/data/properties/blocks/maxItems", keyword: "maxItems", params: { limit: 3 }, message: "must NOT have more than 3 items" };
                        if (vErrors === null) {
                            vErrors = [err32];
                        }
                        else {
                            vErrors.push(err32);
                        }
                        errors++;
                    }
                    const len0 = data10.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                        let data11 = data10[i0];
                        if (data11 && typeof data11 == "object" && !Array.isArray(data11)) {
                            if (data11.currency === undefined) {
                                const err33 = { instancePath: instancePath + "/data/blocks/" + i0, schemaPath: "#/properties/data/properties/blocks/items/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err33];
                                }
                                else {
                                    vErrors.push(err33);
                                }
                                errors++;
                            }
                            if (data11.totals === undefined) {
                                const err34 = { instancePath: instancePath + "/data/blocks/" + i0, schemaPath: "#/properties/data/properties/blocks/items/required", keyword: "required", params: { missingProperty: "totals" }, message: "must have required property '" + "totals" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err34];
                                }
                                else {
                                    vErrors.push(err34);
                                }
                                errors++;
                            }
                            if (data11.categories === undefined) {
                                const err35 = { instancePath: instancePath + "/data/blocks/" + i0, schemaPath: "#/properties/data/properties/blocks/items/required", keyword: "required", params: { missingProperty: "categories" }, message: "must have required property '" + "categories" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err35];
                                }
                                else {
                                    vErrors.push(err35);
                                }
                                errors++;
                            }
                            for (const key3 in data11) {
                                if (!(((key3 === "currency") || (key3 === "totals")) || (key3 === "categories"))) {
                                    const err36 = { instancePath: instancePath + "/data/blocks/" + i0, schemaPath: "#/properties/data/properties/blocks/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                                    if (vErrors === null) {
                                        vErrors = [err36];
                                    }
                                    else {
                                        vErrors.push(err36);
                                    }
                                    errors++;
                                }
                            }
                            if (data11.currency !== undefined) {
                                let data12 = data11.currency;
                                if (typeof data12 !== "string") {
                                    const err37 = { instancePath: instancePath + "/data/blocks/" + i0 + "/currency", schemaPath: "#/properties/data/properties/blocks/items/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err37];
                                    }
                                    else {
                                        vErrors.push(err37);
                                    }
                                    errors++;
                                }
                                if (!(((data12 === "BRL") || (data12 === "CAD")) || (data12 === "USD"))) {
                                    const err38 = { instancePath: instancePath + "/data/blocks/" + i0 + "/currency", schemaPath: "#/properties/data/properties/blocks/items/properties/currency/enum", keyword: "enum", params: { allowedValues: schema28.properties.data.properties.blocks.items.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err38];
                                    }
                                    else {
                                        vErrors.push(err38);
                                    }
                                    errors++;
                                }
                            }
                            if (data11.totals !== undefined) {
                                let data13 = data11.totals;
                                if (data13 && typeof data13 == "object" && !Array.isArray(data13)) {
                                    if (data13.incomeMinor === undefined) {
                                        const err39 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/required", keyword: "required", params: { missingProperty: "incomeMinor" }, message: "must have required property '" + "incomeMinor" + "'" };
                                        if (vErrors === null) {
                                            vErrors = [err39];
                                        }
                                        else {
                                            vErrors.push(err39);
                                        }
                                        errors++;
                                    }
                                    if (data13.expenseMinor === undefined) {
                                        const err40 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/required", keyword: "required", params: { missingProperty: "expenseMinor" }, message: "must have required property '" + "expenseMinor" + "'" };
                                        if (vErrors === null) {
                                            vErrors = [err40];
                                        }
                                        else {
                                            vErrors.push(err40);
                                        }
                                        errors++;
                                    }
                                    if (data13.netMinor === undefined) {
                                        const err41 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/required", keyword: "required", params: { missingProperty: "netMinor" }, message: "must have required property '" + "netMinor" + "'" };
                                        if (vErrors === null) {
                                            vErrors = [err41];
                                        }
                                        else {
                                            vErrors.push(err41);
                                        }
                                        errors++;
                                    }
                                    if (data13.recorded === undefined) {
                                        const err42 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/required", keyword: "required", params: { missingProperty: "recorded" }, message: "must have required property '" + "recorded" + "'" };
                                        if (vErrors === null) {
                                            vErrors = [err42];
                                        }
                                        else {
                                            vErrors.push(err42);
                                        }
                                        errors++;
                                    }
                                    if (data13.pending === undefined) {
                                        const err43 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/required", keyword: "required", params: { missingProperty: "pending" }, message: "must have required property '" + "pending" + "'" };
                                        if (vErrors === null) {
                                            vErrors = [err43];
                                        }
                                        else {
                                            vErrors.push(err43);
                                        }
                                        errors++;
                                    }
                                    for (const key4 in data13) {
                                        if (!(((((key4 === "incomeMinor") || (key4 === "expenseMinor")) || (key4 === "netMinor")) || (key4 === "recorded")) || (key4 === "pending"))) {
                                            const err44 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key4 }, message: "must NOT have additional properties" };
                                            if (vErrors === null) {
                                                vErrors = [err44];
                                            }
                                            else {
                                                vErrors.push(err44);
                                            }
                                            errors++;
                                        }
                                    }
                                    if (data13.incomeMinor !== undefined) {
                                        let data14 = data13.incomeMinor;
                                        if (typeof data14 === "string") {
                                            if (!pattern3.test(data14)) {
                                                const err45 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/incomeMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/incomeMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                                if (vErrors === null) {
                                                    vErrors = [err45];
                                                }
                                                else {
                                                    vErrors.push(err45);
                                                }
                                                errors++;
                                            }
                                        }
                                        else {
                                            const err46 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/incomeMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/incomeMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                            if (vErrors === null) {
                                                vErrors = [err46];
                                            }
                                            else {
                                                vErrors.push(err46);
                                            }
                                            errors++;
                                        }
                                    }
                                    if (data13.expenseMinor !== undefined) {
                                        let data15 = data13.expenseMinor;
                                        if (typeof data15 === "string") {
                                            if (!pattern3.test(data15)) {
                                                const err47 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/expenseMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/expenseMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                                if (vErrors === null) {
                                                    vErrors = [err47];
                                                }
                                                else {
                                                    vErrors.push(err47);
                                                }
                                                errors++;
                                            }
                                        }
                                        else {
                                            const err48 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/expenseMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/expenseMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                            if (vErrors === null) {
                                                vErrors = [err48];
                                            }
                                            else {
                                                vErrors.push(err48);
                                            }
                                            errors++;
                                        }
                                    }
                                    if (data13.netMinor !== undefined) {
                                        let data16 = data13.netMinor;
                                        if (typeof data16 === "string") {
                                            if (!pattern3.test(data16)) {
                                                const err49 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/netMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/netMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                                if (vErrors === null) {
                                                    vErrors = [err49];
                                                }
                                                else {
                                                    vErrors.push(err49);
                                                }
                                                errors++;
                                            }
                                        }
                                        else {
                                            const err50 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/netMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/netMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                            if (vErrors === null) {
                                                vErrors = [err50];
                                            }
                                            else {
                                                vErrors.push(err50);
                                            }
                                            errors++;
                                        }
                                    }
                                    if (data13.recorded !== undefined) {
                                        let data17 = data13.recorded;
                                        if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
                                            if (data17.incomeMinor === undefined) {
                                                const err51 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/recorded", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/recorded/required", keyword: "required", params: { missingProperty: "incomeMinor" }, message: "must have required property '" + "incomeMinor" + "'" };
                                                if (vErrors === null) {
                                                    vErrors = [err51];
                                                }
                                                else {
                                                    vErrors.push(err51);
                                                }
                                                errors++;
                                            }
                                            if (data17.expenseMinor === undefined) {
                                                const err52 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/recorded", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/recorded/required", keyword: "required", params: { missingProperty: "expenseMinor" }, message: "must have required property '" + "expenseMinor" + "'" };
                                                if (vErrors === null) {
                                                    vErrors = [err52];
                                                }
                                                else {
                                                    vErrors.push(err52);
                                                }
                                                errors++;
                                            }
                                            if (data17.netMinor === undefined) {
                                                const err53 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/recorded", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/recorded/required", keyword: "required", params: { missingProperty: "netMinor" }, message: "must have required property '" + "netMinor" + "'" };
                                                if (vErrors === null) {
                                                    vErrors = [err53];
                                                }
                                                else {
                                                    vErrors.push(err53);
                                                }
                                                errors++;
                                            }
                                            for (const key5 in data17) {
                                                if (!(((key5 === "incomeMinor") || (key5 === "expenseMinor")) || (key5 === "netMinor"))) {
                                                    const err54 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/recorded", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/recorded/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key5 }, message: "must NOT have additional properties" };
                                                    if (vErrors === null) {
                                                        vErrors = [err54];
                                                    }
                                                    else {
                                                        vErrors.push(err54);
                                                    }
                                                    errors++;
                                                }
                                            }
                                            if (data17.incomeMinor !== undefined) {
                                                let data18 = data17.incomeMinor;
                                                if (typeof data18 === "string") {
                                                    if (!pattern3.test(data18)) {
                                                        const err55 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/recorded/incomeMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/recorded/properties/incomeMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                                        if (vErrors === null) {
                                                            vErrors = [err55];
                                                        }
                                                        else {
                                                            vErrors.push(err55);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                else {
                                                    const err56 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/recorded/incomeMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/recorded/properties/incomeMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                        vErrors = [err56];
                                                    }
                                                    else {
                                                        vErrors.push(err56);
                                                    }
                                                    errors++;
                                                }
                                            }
                                            if (data17.expenseMinor !== undefined) {
                                                let data19 = data17.expenseMinor;
                                                if (typeof data19 === "string") {
                                                    if (!pattern3.test(data19)) {
                                                        const err57 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/recorded/expenseMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/recorded/properties/expenseMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                                        if (vErrors === null) {
                                                            vErrors = [err57];
                                                        }
                                                        else {
                                                            vErrors.push(err57);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                else {
                                                    const err58 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/recorded/expenseMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/recorded/properties/expenseMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                        vErrors = [err58];
                                                    }
                                                    else {
                                                        vErrors.push(err58);
                                                    }
                                                    errors++;
                                                }
                                            }
                                            if (data17.netMinor !== undefined) {
                                                let data20 = data17.netMinor;
                                                if (typeof data20 === "string") {
                                                    if (!pattern3.test(data20)) {
                                                        const err59 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/recorded/netMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/recorded/properties/netMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                                        if (vErrors === null) {
                                                            vErrors = [err59];
                                                        }
                                                        else {
                                                            vErrors.push(err59);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                else {
                                                    const err60 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/recorded/netMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/recorded/properties/netMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                        vErrors = [err60];
                                                    }
                                                    else {
                                                        vErrors.push(err60);
                                                    }
                                                    errors++;
                                                }
                                            }
                                        }
                                        else {
                                            const err61 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/recorded", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/recorded/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                            if (vErrors === null) {
                                                vErrors = [err61];
                                            }
                                            else {
                                                vErrors.push(err61);
                                            }
                                            errors++;
                                        }
                                    }
                                    if (data13.pending !== undefined) {
                                        let data21 = data13.pending;
                                        if (data21 && typeof data21 == "object" && !Array.isArray(data21)) {
                                            if (data21.incomeMinor === undefined) {
                                                const err62 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/pending", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/pending/required", keyword: "required", params: { missingProperty: "incomeMinor" }, message: "must have required property '" + "incomeMinor" + "'" };
                                                if (vErrors === null) {
                                                    vErrors = [err62];
                                                }
                                                else {
                                                    vErrors.push(err62);
                                                }
                                                errors++;
                                            }
                                            if (data21.expenseMinor === undefined) {
                                                const err63 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/pending", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/pending/required", keyword: "required", params: { missingProperty: "expenseMinor" }, message: "must have required property '" + "expenseMinor" + "'" };
                                                if (vErrors === null) {
                                                    vErrors = [err63];
                                                }
                                                else {
                                                    vErrors.push(err63);
                                                }
                                                errors++;
                                            }
                                            if (data21.netMinor === undefined) {
                                                const err64 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/pending", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/pending/required", keyword: "required", params: { missingProperty: "netMinor" }, message: "must have required property '" + "netMinor" + "'" };
                                                if (vErrors === null) {
                                                    vErrors = [err64];
                                                }
                                                else {
                                                    vErrors.push(err64);
                                                }
                                                errors++;
                                            }
                                            for (const key6 in data21) {
                                                if (!(((key6 === "incomeMinor") || (key6 === "expenseMinor")) || (key6 === "netMinor"))) {
                                                    const err65 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/pending", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/pending/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key6 }, message: "must NOT have additional properties" };
                                                    if (vErrors === null) {
                                                        vErrors = [err65];
                                                    }
                                                    else {
                                                        vErrors.push(err65);
                                                    }
                                                    errors++;
                                                }
                                            }
                                            if (data21.incomeMinor !== undefined) {
                                                let data22 = data21.incomeMinor;
                                                if (typeof data22 === "string") {
                                                    if (!pattern3.test(data22)) {
                                                        const err66 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/pending/incomeMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/pending/properties/incomeMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                                        if (vErrors === null) {
                                                            vErrors = [err66];
                                                        }
                                                        else {
                                                            vErrors.push(err66);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                else {
                                                    const err67 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/pending/incomeMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/pending/properties/incomeMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                        vErrors = [err67];
                                                    }
                                                    else {
                                                        vErrors.push(err67);
                                                    }
                                                    errors++;
                                                }
                                            }
                                            if (data21.expenseMinor !== undefined) {
                                                let data23 = data21.expenseMinor;
                                                if (typeof data23 === "string") {
                                                    if (!pattern3.test(data23)) {
                                                        const err68 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/pending/expenseMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/pending/properties/expenseMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                                        if (vErrors === null) {
                                                            vErrors = [err68];
                                                        }
                                                        else {
                                                            vErrors.push(err68);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                else {
                                                    const err69 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/pending/expenseMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/pending/properties/expenseMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                        vErrors = [err69];
                                                    }
                                                    else {
                                                        vErrors.push(err69);
                                                    }
                                                    errors++;
                                                }
                                            }
                                            if (data21.netMinor !== undefined) {
                                                let data24 = data21.netMinor;
                                                if (typeof data24 === "string") {
                                                    if (!pattern3.test(data24)) {
                                                        const err70 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/pending/netMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/pending/properties/netMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                                        if (vErrors === null) {
                                                            vErrors = [err70];
                                                        }
                                                        else {
                                                            vErrors.push(err70);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                else {
                                                    const err71 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/pending/netMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/pending/properties/netMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                        vErrors = [err71];
                                                    }
                                                    else {
                                                        vErrors.push(err71);
                                                    }
                                                    errors++;
                                                }
                                            }
                                        }
                                        else {
                                            const err72 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals/pending", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/properties/pending/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                            if (vErrors === null) {
                                                vErrors = [err72];
                                            }
                                            else {
                                                vErrors.push(err72);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                                else {
                                    const err73 = { instancePath: instancePath + "/data/blocks/" + i0 + "/totals", schemaPath: "#/properties/data/properties/blocks/items/properties/totals/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                    if (vErrors === null) {
                                        vErrors = [err73];
                                    }
                                    else {
                                        vErrors.push(err73);
                                    }
                                    errors++;
                                }
                            }
                            if (data11.categories !== undefined) {
                                let data25 = data11.categories;
                                if (Array.isArray(data25)) {
                                    if (data25.length > 500) {
                                        const err74 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/maxItems", keyword: "maxItems", params: { limit: 500 }, message: "must NOT have more than 500 items" };
                                        if (vErrors === null) {
                                            vErrors = [err74];
                                        }
                                        else {
                                            vErrors.push(err74);
                                        }
                                        errors++;
                                    }
                                    const len1 = data25.length;
                                    for (let i1 = 0; i1 < len1; i1++) {
                                        let data26 = data25[i1];
                                        if (data26 && typeof data26 == "object" && !Array.isArray(data26)) {
                                            if (data26.categoryId === undefined) {
                                                const err75 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1, schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/required", keyword: "required", params: { missingProperty: "categoryId" }, message: "must have required property '" + "categoryId" + "'" };
                                                if (vErrors === null) {
                                                    vErrors = [err75];
                                                }
                                                else {
                                                    vErrors.push(err75);
                                                }
                                                errors++;
                                            }
                                            if (data26.label === undefined) {
                                                const err76 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1, schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/required", keyword: "required", params: { missingProperty: "label" }, message: "must have required property '" + "label" + "'" };
                                                if (vErrors === null) {
                                                    vErrors = [err76];
                                                }
                                                else {
                                                    vErrors.push(err76);
                                                }
                                                errors++;
                                            }
                                            if (data26.archived === undefined) {
                                                const err77 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1, schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/required", keyword: "required", params: { missingProperty: "archived" }, message: "must have required property '" + "archived" + "'" };
                                                if (vErrors === null) {
                                                    vErrors = [err77];
                                                }
                                                else {
                                                    vErrors.push(err77);
                                                }
                                                errors++;
                                            }
                                            if (data26.entryCount === undefined) {
                                                const err78 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1, schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/required", keyword: "required", params: { missingProperty: "entryCount" }, message: "must have required property '" + "entryCount" + "'" };
                                                if (vErrors === null) {
                                                    vErrors = [err78];
                                                }
                                                else {
                                                    vErrors.push(err78);
                                                }
                                                errors++;
                                            }
                                            if (data26.totals === undefined) {
                                                const err79 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1, schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/required", keyword: "required", params: { missingProperty: "totals" }, message: "must have required property '" + "totals" + "'" };
                                                if (vErrors === null) {
                                                    vErrors = [err79];
                                                }
                                                else {
                                                    vErrors.push(err79);
                                                }
                                                errors++;
                                            }
                                            for (const key7 in data26) {
                                                if (!(((((key7 === "categoryId") || (key7 === "label")) || (key7 === "archived")) || (key7 === "entryCount")) || (key7 === "totals"))) {
                                                    const err80 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1, schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key7 }, message: "must NOT have additional properties" };
                                                    if (vErrors === null) {
                                                        vErrors = [err80];
                                                    }
                                                    else {
                                                        vErrors.push(err80);
                                                    }
                                                    errors++;
                                                }
                                            }
                                            if (data26.categoryId !== undefined) {
                                                let data27 = data26.categoryId;
                                                if ((typeof data27 !== "string") && (data27 !== null)) {
                                                    const err81 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/categoryId", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/categoryId/type", keyword: "type", params: { type: schema28.properties.data.properties.blocks.items.properties.categories.items.properties.categoryId.type }, message: "must be string,null" };
                                                    if (vErrors === null) {
                                                        vErrors = [err81];
                                                    }
                                                    else {
                                                        vErrors.push(err81);
                                                    }
                                                    errors++;
                                                }
                                                if (typeof data27 === "string") {
                                                    if (!pattern0.test(data27)) {
                                                        const err82 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/categoryId", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/categoryId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                                        if (vErrors === null) {
                                                            vErrors = [err82];
                                                        }
                                                        else {
                                                            vErrors.push(err82);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                            }
                                            if (data26.label !== undefined) {
                                                let data28 = data26.label;
                                                if (typeof data28 === "string") {
                                                    if (func2(data28) > 120) {
                                                        const err83 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/label", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/label/maxLength", keyword: "maxLength", params: { limit: 120 }, message: "must NOT have more than 120 characters" };
                                                        if (vErrors === null) {
                                                            vErrors = [err83];
                                                        }
                                                        else {
                                                            vErrors.push(err83);
                                                        }
                                                        errors++;
                                                    }
                                                    if (func2(data28) < 1) {
                                                        const err84 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/label", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/label/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                                        if (vErrors === null) {
                                                            vErrors = [err84];
                                                        }
                                                        else {
                                                            vErrors.push(err84);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                else {
                                                    const err85 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/label", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/label/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                    if (vErrors === null) {
                                                        vErrors = [err85];
                                                    }
                                                    else {
                                                        vErrors.push(err85);
                                                    }
                                                    errors++;
                                                }
                                            }
                                            if (data26.archived !== undefined) {
                                                if (typeof data26.archived !== "boolean") {
                                                    const err86 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/archived", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/archived/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                                    if (vErrors === null) {
                                                        vErrors = [err86];
                                                    }
                                                    else {
                                                        vErrors.push(err86);
                                                    }
                                                    errors++;
                                                }
                                            }
                                            if (data26.entryCount !== undefined) {
                                                let data30 = data26.entryCount;
                                                if (!(((typeof data30 == "number") && (!(data30 % 1) && !isNaN(data30))) && (isFinite(data30)))) {
                                                    const err87 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/entryCount", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/entryCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                                    if (vErrors === null) {
                                                        vErrors = [err87];
                                                    }
                                                    else {
                                                        vErrors.push(err87);
                                                    }
                                                    errors++;
                                                }
                                                if ((typeof data30 == "number") && (isFinite(data30))) {
                                                    if (data30 < 0 || isNaN(data30)) {
                                                        const err88 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/entryCount", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/entryCount/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                                                        if (vErrors === null) {
                                                            vErrors = [err88];
                                                        }
                                                        else {
                                                            vErrors.push(err88);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                            }
                                            if (data26.totals !== undefined) {
                                                let data31 = data26.totals;
                                                if (data31 && typeof data31 == "object" && !Array.isArray(data31)) {
                                                    if (data31.incomeMinor === undefined) {
                                                        const err89 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/required", keyword: "required", params: { missingProperty: "incomeMinor" }, message: "must have required property '" + "incomeMinor" + "'" };
                                                        if (vErrors === null) {
                                                            vErrors = [err89];
                                                        }
                                                        else {
                                                            vErrors.push(err89);
                                                        }
                                                        errors++;
                                                    }
                                                    if (data31.expenseMinor === undefined) {
                                                        const err90 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/required", keyword: "required", params: { missingProperty: "expenseMinor" }, message: "must have required property '" + "expenseMinor" + "'" };
                                                        if (vErrors === null) {
                                                            vErrors = [err90];
                                                        }
                                                        else {
                                                            vErrors.push(err90);
                                                        }
                                                        errors++;
                                                    }
                                                    if (data31.netMinor === undefined) {
                                                        const err91 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/required", keyword: "required", params: { missingProperty: "netMinor" }, message: "must have required property '" + "netMinor" + "'" };
                                                        if (vErrors === null) {
                                                            vErrors = [err91];
                                                        }
                                                        else {
                                                            vErrors.push(err91);
                                                        }
                                                        errors++;
                                                    }
                                                    if (data31.recorded === undefined) {
                                                        const err92 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/required", keyword: "required", params: { missingProperty: "recorded" }, message: "must have required property '" + "recorded" + "'" };
                                                        if (vErrors === null) {
                                                            vErrors = [err92];
                                                        }
                                                        else {
                                                            vErrors.push(err92);
                                                        }
                                                        errors++;
                                                    }
                                                    if (data31.pending === undefined) {
                                                        const err93 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/required", keyword: "required", params: { missingProperty: "pending" }, message: "must have required property '" + "pending" + "'" };
                                                        if (vErrors === null) {
                                                            vErrors = [err93];
                                                        }
                                                        else {
                                                            vErrors.push(err93);
                                                        }
                                                        errors++;
                                                    }
                                                    for (const key8 in data31) {
                                                        if (!(((((key8 === "incomeMinor") || (key8 === "expenseMinor")) || (key8 === "netMinor")) || (key8 === "recorded")) || (key8 === "pending"))) {
                                                            const err94 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key8 }, message: "must NOT have additional properties" };
                                                            if (vErrors === null) {
                                                                vErrors = [err94];
                                                            }
                                                            else {
                                                                vErrors.push(err94);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    if (data31.incomeMinor !== undefined) {
                                                        let data32 = data31.incomeMinor;
                                                        if (typeof data32 === "string") {
                                                            if (!pattern3.test(data32)) {
                                                                const err95 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/incomeMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/incomeMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                                                if (vErrors === null) {
                                                                    vErrors = [err95];
                                                                }
                                                                else {
                                                                    vErrors.push(err95);
                                                                }
                                                                errors++;
                                                            }
                                                        }
                                                        else {
                                                            const err96 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/incomeMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/incomeMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                            if (vErrors === null) {
                                                                vErrors = [err96];
                                                            }
                                                            else {
                                                                vErrors.push(err96);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    if (data31.expenseMinor !== undefined) {
                                                        let data33 = data31.expenseMinor;
                                                        if (typeof data33 === "string") {
                                                            if (!pattern3.test(data33)) {
                                                                const err97 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/expenseMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/expenseMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                                                if (vErrors === null) {
                                                                    vErrors = [err97];
                                                                }
                                                                else {
                                                                    vErrors.push(err97);
                                                                }
                                                                errors++;
                                                            }
                                                        }
                                                        else {
                                                            const err98 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/expenseMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/expenseMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                            if (vErrors === null) {
                                                                vErrors = [err98];
                                                            }
                                                            else {
                                                                vErrors.push(err98);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    if (data31.netMinor !== undefined) {
                                                        let data34 = data31.netMinor;
                                                        if (typeof data34 === "string") {
                                                            if (!pattern3.test(data34)) {
                                                                const err99 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/netMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/netMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                                                if (vErrors === null) {
                                                                    vErrors = [err99];
                                                                }
                                                                else {
                                                                    vErrors.push(err99);
                                                                }
                                                                errors++;
                                                            }
                                                        }
                                                        else {
                                                            const err100 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/netMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/netMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                            if (vErrors === null) {
                                                                vErrors = [err100];
                                                            }
                                                            else {
                                                                vErrors.push(err100);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    if (data31.recorded !== undefined) {
                                                        let data35 = data31.recorded;
                                                        if (data35 && typeof data35 == "object" && !Array.isArray(data35)) {
                                                            if (data35.incomeMinor === undefined) {
                                                                const err101 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/recorded", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/recorded/required", keyword: "required", params: { missingProperty: "incomeMinor" }, message: "must have required property '" + "incomeMinor" + "'" };
                                                                if (vErrors === null) {
                                                                    vErrors = [err101];
                                                                }
                                                                else {
                                                                    vErrors.push(err101);
                                                                }
                                                                errors++;
                                                            }
                                                            if (data35.expenseMinor === undefined) {
                                                                const err102 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/recorded", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/recorded/required", keyword: "required", params: { missingProperty: "expenseMinor" }, message: "must have required property '" + "expenseMinor" + "'" };
                                                                if (vErrors === null) {
                                                                    vErrors = [err102];
                                                                }
                                                                else {
                                                                    vErrors.push(err102);
                                                                }
                                                                errors++;
                                                            }
                                                            if (data35.netMinor === undefined) {
                                                                const err103 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/recorded", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/recorded/required", keyword: "required", params: { missingProperty: "netMinor" }, message: "must have required property '" + "netMinor" + "'" };
                                                                if (vErrors === null) {
                                                                    vErrors = [err103];
                                                                }
                                                                else {
                                                                    vErrors.push(err103);
                                                                }
                                                                errors++;
                                                            }
                                                            for (const key9 in data35) {
                                                                if (!(((key9 === "incomeMinor") || (key9 === "expenseMinor")) || (key9 === "netMinor"))) {
                                                                    const err104 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/recorded", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/recorded/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key9 }, message: "must NOT have additional properties" };
                                                                    if (vErrors === null) {
                                                                        vErrors = [err104];
                                                                    }
                                                                    else {
                                                                        vErrors.push(err104);
                                                                    }
                                                                    errors++;
                                                                }
                                                            }
                                                            if (data35.incomeMinor !== undefined) {
                                                                let data36 = data35.incomeMinor;
                                                                if (typeof data36 === "string") {
                                                                    if (!pattern3.test(data36)) {
                                                                        const err105 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/recorded/incomeMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/recorded/properties/incomeMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                                                        if (vErrors === null) {
                                                                            vErrors = [err105];
                                                                        }
                                                                        else {
                                                                            vErrors.push(err105);
                                                                        }
                                                                        errors++;
                                                                    }
                                                                }
                                                                else {
                                                                    const err106 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/recorded/incomeMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/recorded/properties/incomeMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                                    if (vErrors === null) {
                                                                        vErrors = [err106];
                                                                    }
                                                                    else {
                                                                        vErrors.push(err106);
                                                                    }
                                                                    errors++;
                                                                }
                                                            }
                                                            if (data35.expenseMinor !== undefined) {
                                                                let data37 = data35.expenseMinor;
                                                                if (typeof data37 === "string") {
                                                                    if (!pattern3.test(data37)) {
                                                                        const err107 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/recorded/expenseMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/recorded/properties/expenseMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                                                        if (vErrors === null) {
                                                                            vErrors = [err107];
                                                                        }
                                                                        else {
                                                                            vErrors.push(err107);
                                                                        }
                                                                        errors++;
                                                                    }
                                                                }
                                                                else {
                                                                    const err108 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/recorded/expenseMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/recorded/properties/expenseMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                                    if (vErrors === null) {
                                                                        vErrors = [err108];
                                                                    }
                                                                    else {
                                                                        vErrors.push(err108);
                                                                    }
                                                                    errors++;
                                                                }
                                                            }
                                                            if (data35.netMinor !== undefined) {
                                                                let data38 = data35.netMinor;
                                                                if (typeof data38 === "string") {
                                                                    if (!pattern3.test(data38)) {
                                                                        const err109 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/recorded/netMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/recorded/properties/netMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                                                        if (vErrors === null) {
                                                                            vErrors = [err109];
                                                                        }
                                                                        else {
                                                                            vErrors.push(err109);
                                                                        }
                                                                        errors++;
                                                                    }
                                                                }
                                                                else {
                                                                    const err110 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/recorded/netMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/recorded/properties/netMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                                    if (vErrors === null) {
                                                                        vErrors = [err110];
                                                                    }
                                                                    else {
                                                                        vErrors.push(err110);
                                                                    }
                                                                    errors++;
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            const err111 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/recorded", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/recorded/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                                            if (vErrors === null) {
                                                                vErrors = [err111];
                                                            }
                                                            else {
                                                                vErrors.push(err111);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    if (data31.pending !== undefined) {
                                                        let data39 = data31.pending;
                                                        if (data39 && typeof data39 == "object" && !Array.isArray(data39)) {
                                                            if (data39.incomeMinor === undefined) {
                                                                const err112 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/pending", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/pending/required", keyword: "required", params: { missingProperty: "incomeMinor" }, message: "must have required property '" + "incomeMinor" + "'" };
                                                                if (vErrors === null) {
                                                                    vErrors = [err112];
                                                                }
                                                                else {
                                                                    vErrors.push(err112);
                                                                }
                                                                errors++;
                                                            }
                                                            if (data39.expenseMinor === undefined) {
                                                                const err113 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/pending", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/pending/required", keyword: "required", params: { missingProperty: "expenseMinor" }, message: "must have required property '" + "expenseMinor" + "'" };
                                                                if (vErrors === null) {
                                                                    vErrors = [err113];
                                                                }
                                                                else {
                                                                    vErrors.push(err113);
                                                                }
                                                                errors++;
                                                            }
                                                            if (data39.netMinor === undefined) {
                                                                const err114 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/pending", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/pending/required", keyword: "required", params: { missingProperty: "netMinor" }, message: "must have required property '" + "netMinor" + "'" };
                                                                if (vErrors === null) {
                                                                    vErrors = [err114];
                                                                }
                                                                else {
                                                                    vErrors.push(err114);
                                                                }
                                                                errors++;
                                                            }
                                                            for (const key10 in data39) {
                                                                if (!(((key10 === "incomeMinor") || (key10 === "expenseMinor")) || (key10 === "netMinor"))) {
                                                                    const err115 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/pending", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/pending/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key10 }, message: "must NOT have additional properties" };
                                                                    if (vErrors === null) {
                                                                        vErrors = [err115];
                                                                    }
                                                                    else {
                                                                        vErrors.push(err115);
                                                                    }
                                                                    errors++;
                                                                }
                                                            }
                                                            if (data39.incomeMinor !== undefined) {
                                                                let data40 = data39.incomeMinor;
                                                                if (typeof data40 === "string") {
                                                                    if (!pattern3.test(data40)) {
                                                                        const err116 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/pending/incomeMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/pending/properties/incomeMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                                                        if (vErrors === null) {
                                                                            vErrors = [err116];
                                                                        }
                                                                        else {
                                                                            vErrors.push(err116);
                                                                        }
                                                                        errors++;
                                                                    }
                                                                }
                                                                else {
                                                                    const err117 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/pending/incomeMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/pending/properties/incomeMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                                    if (vErrors === null) {
                                                                        vErrors = [err117];
                                                                    }
                                                                    else {
                                                                        vErrors.push(err117);
                                                                    }
                                                                    errors++;
                                                                }
                                                            }
                                                            if (data39.expenseMinor !== undefined) {
                                                                let data41 = data39.expenseMinor;
                                                                if (typeof data41 === "string") {
                                                                    if (!pattern3.test(data41)) {
                                                                        const err118 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/pending/expenseMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/pending/properties/expenseMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                                                        if (vErrors === null) {
                                                                            vErrors = [err118];
                                                                        }
                                                                        else {
                                                                            vErrors.push(err118);
                                                                        }
                                                                        errors++;
                                                                    }
                                                                }
                                                                else {
                                                                    const err119 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/pending/expenseMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/pending/properties/expenseMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                                    if (vErrors === null) {
                                                                        vErrors = [err119];
                                                                    }
                                                                    else {
                                                                        vErrors.push(err119);
                                                                    }
                                                                    errors++;
                                                                }
                                                            }
                                                            if (data39.netMinor !== undefined) {
                                                                let data42 = data39.netMinor;
                                                                if (typeof data42 === "string") {
                                                                    if (!pattern3.test(data42)) {
                                                                        const err120 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/pending/netMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/pending/properties/netMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                                                        if (vErrors === null) {
                                                                            vErrors = [err120];
                                                                        }
                                                                        else {
                                                                            vErrors.push(err120);
                                                                        }
                                                                        errors++;
                                                                    }
                                                                }
                                                                else {
                                                                    const err121 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/pending/netMinor", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/pending/properties/netMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                                                    if (vErrors === null) {
                                                                        vErrors = [err121];
                                                                    }
                                                                    else {
                                                                        vErrors.push(err121);
                                                                    }
                                                                    errors++;
                                                                }
                                                            }
                                                        }
                                                        else {
                                                            const err122 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals/pending", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/properties/pending/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                                            if (vErrors === null) {
                                                                vErrors = [err122];
                                                            }
                                                            else {
                                                                vErrors.push(err122);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                }
                                                else {
                                                    const err123 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1 + "/totals", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/properties/totals/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                                    if (vErrors === null) {
                                                        vErrors = [err123];
                                                    }
                                                    else {
                                                        vErrors.push(err123);
                                                    }
                                                    errors++;
                                                }
                                            }
                                        }
                                        else {
                                            const err124 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories/" + i1, schemaPath: "#/properties/data/properties/blocks/items/properties/categories/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                            if (vErrors === null) {
                                                vErrors = [err124];
                                            }
                                            else {
                                                vErrors.push(err124);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                                else {
                                    const err125 = { instancePath: instancePath + "/data/blocks/" + i0 + "/categories", schemaPath: "#/properties/data/properties/blocks/items/properties/categories/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                                    if (vErrors === null) {
                                        vErrors = [err125];
                                    }
                                    else {
                                        vErrors.push(err125);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err126 = { instancePath: instancePath + "/data/blocks/" + i0, schemaPath: "#/properties/data/properties/blocks/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                                vErrors = [err126];
                            }
                            else {
                                vErrors.push(err126);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err127 = { instancePath: instancePath + "/data/blocks", schemaPath: "#/properties/data/properties/blocks/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err127];
                    }
                    else {
                        vErrors.push(err127);
                    }
                    errors++;
                }
            }
        }
        else {
            const err128 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err128];
            }
            else {
                vErrors.push(err128);
            }
            errors++;
        }
    }
    if (data.meta !== undefined) {
        let data43 = data.meta;
        if (data43 && typeof data43 == "object" && !Array.isArray(data43)) {
            if (data43.requestId === undefined) {
                const err129 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "requestId" }, message: "must have required property '" + "requestId" + "'" };
                if (vErrors === null) {
                    vErrors = [err129];
                }
                else {
                    vErrors.push(err129);
                }
                errors++;
            }
            if (data43.asOf === undefined) {
                const err130 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "asOf" }, message: "must have required property '" + "asOf" + "'" };
                if (vErrors === null) {
                    vErrors = [err130];
                }
                else {
                    vErrors.push(err130);
                }
                errors++;
            }
            if (data43.businessToday === undefined) {
                const err131 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err131];
                }
                else {
                    vErrors.push(err131);
                }
                errors++;
            }
            if (data43.timeZone === undefined) {
                const err132 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "timeZone" }, message: "must have required property '" + "timeZone" + "'" };
                if (vErrors === null) {
                    vErrors = [err132];
                }
                else {
                    vErrors.push(err132);
                }
                errors++;
            }
            if (data43.dataRevision === undefined) {
                const err133 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "dataRevision" }, message: "must have required property '" + "dataRevision" + "'" };
                if (vErrors === null) {
                    vErrors = [err133];
                }
                else {
                    vErrors.push(err133);
                }
                errors++;
            }
            for (const key11 in data43) {
                if (!(((((key11 === "requestId") || (key11 === "asOf")) || (key11 === "businessToday")) || (key11 === "timeZone")) || (key11 === "dataRevision"))) {
                    const err134 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key11 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err134];
                    }
                    else {
                        vErrors.push(err134);
                    }
                    errors++;
                }
            }
            if (data43.requestId !== undefined) {
                let data44 = data43.requestId;
                if (typeof data44 === "string") {
                    if (func2(data44) > 64) {
                        const err135 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err135];
                        }
                        else {
                            vErrors.push(err135);
                        }
                        errors++;
                    }
                    if (func2(data44) < 1) {
                        const err136 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err136];
                        }
                        else {
                            vErrors.push(err136);
                        }
                        errors++;
                    }
                }
                else {
                    const err137 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err137];
                    }
                    else {
                        vErrors.push(err137);
                    }
                    errors++;
                }
            }
            if (data43.asOf !== undefined) {
                let data45 = data43.asOf;
                if (typeof data45 === "string") {
                    if (func2(data45) > 64) {
                        const err138 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err138];
                        }
                        else {
                            vErrors.push(err138);
                        }
                        errors++;
                    }
                    if (func2(data45) < 1) {
                        const err139 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err139];
                        }
                        else {
                            vErrors.push(err139);
                        }
                        errors++;
                    }
                }
                else {
                    const err140 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err140];
                    }
                    else {
                        vErrors.push(err140);
                    }
                    errors++;
                }
            }
            if (data43.businessToday !== undefined) {
                let data46 = data43.businessToday;
                if (typeof data46 === "string") {
                    if (!pattern4.test(data46)) {
                        const err141 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err141];
                        }
                        else {
                            vErrors.push(err141);
                        }
                        errors++;
                    }
                }
                else {
                    const err142 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err142];
                    }
                    else {
                        vErrors.push(err142);
                    }
                    errors++;
                }
            }
            if (data43.timeZone !== undefined) {
                let data47 = data43.timeZone;
                if (typeof data47 === "string") {
                    if (func2(data47) > 64) {
                        const err143 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err143];
                        }
                        else {
                            vErrors.push(err143);
                        }
                        errors++;
                    }
                    if (func2(data47) < 1) {
                        const err144 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err144];
                        }
                        else {
                            vErrors.push(err144);
                        }
                        errors++;
                    }
                }
                else {
                    const err145 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err145];
                    }
                    else {
                        vErrors.push(err145);
                    }
                    errors++;
                }
            }
            if (data43.dataRevision !== undefined) {
                let data48 = data43.dataRevision;
                if (typeof data48 === "string") {
                    if (!pattern2.test(data48)) {
                        const err146 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err146];
                        }
                        else {
                            vErrors.push(err146);
                        }
                        errors++;
                    }
                }
                else {
                    const err147 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err147];
                    }
                    else {
                        vErrors.push(err147);
                    }
                    errors++;
                }
            }
        }
        else {
            const err148 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err148];
            }
            else {
                vErrors.push(err148);
            }
            errors++;
        }
    }
}
else {
    const err149 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
        vErrors = [err149];
    }
    else {
        vErrors.push(err149);
    }
    errors++;
} validate27.errors = vErrors; return errors === 0; }
export const validateLedgerForecastEnvelope = validate28;
const schema29 = { "$id": "https://saldo.local/schemas/ledger-forecast-envelope.json", "$schema": "http://json-schema.org/draft-07/schema#", "title": "LedgerForecastEnvelope", "type": "object", "additionalProperties": false, "required": ["data", "meta"], "properties": { "data": { "type": "object", "additionalProperties": false, "required": ["accountId", "accountName", "currency", "kind", "archived", "cutoff", "through", "recordedMinor", "projectedMinor", "components", "coverage"], "properties": { "accountId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "accountName": { "type": "string", "minLength": 1, "maxLength": 120 }, "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "kind": { "type": "string", "enum": ["cash", "card"] }, "archived": { "type": "boolean" }, "cutoff": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "through": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "recordedMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "projectedMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "components": { "type": "object", "additionalProperties": false, "required": ["recordedMinor", "pendingOutgoingMinor", "pendingIncomingMinor", "plannedOutgoingMinor", "plannedIncomingMinor", "futureCompletedOutgoingMinor", "futureCompletedIncomingMinor", "overdueOutgoingMinor", "overdueIncomingMinor", "overdueCount", "pendingCount", "plannedCount"], "properties": { "recordedMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "pendingOutgoingMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "pendingIncomingMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "plannedOutgoingMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "plannedIncomingMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "futureCompletedOutgoingMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "futureCompletedIncomingMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "overdueOutgoingMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "overdueIncomingMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "overdueCount": { "type": "integer", "minimum": 0 }, "pendingCount": { "type": "integer", "minimum": 0 }, "plannedCount": { "type": "integer", "minimum": 0 } } }, "coverage": { "type": "object", "additionalProperties": false, "required": ["complete", "completeThrough", "reason", "note"], "properties": { "complete": { "type": "boolean" }, "completeThrough": { "type": ["string", "null"], "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "reason": { "type": "string", "enum": ["complete", "gap", "unknown"], "description": "`complete`: every applicable template covers the horizon. `gap`: generation stops at `completeThrough`. `unknown`: a template has generated nothing, so there is no boundary." }, "note": { "type": "string", "minLength": 1, "maxLength": 600 } } } } }, "meta": { "type": "object", "additionalProperties": false, "required": ["requestId", "asOf", "businessToday", "timeZone", "dataRevision"], "properties": { "requestId": { "type": "string", "minLength": 1, "maxLength": 64 }, "asOf": { "type": "string", "minLength": 1, "maxLength": 64 }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "timeZone": { "type": "string", "minLength": 1, "maxLength": 64 }, "dataRevision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } } } };
function validate28(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="https://saldo.local/schemas/ledger-forecast-envelope.json" */ ; let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.data === undefined) {
        const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property '" + "data" + "'" };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
    }
    if (data.meta === undefined) {
        const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "meta" }, message: "must have required property '" + "meta" + "'" };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    for (const key0 in data) {
        if (!((key0 === "data") || (key0 === "meta"))) {
            const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.data !== undefined) {
        let data0 = data.data;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.accountId === undefined) {
                const err3 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "accountId" }, message: "must have required property '" + "accountId" + "'" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
            if (data0.accountName === undefined) {
                const err4 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "accountName" }, message: "must have required property '" + "accountName" + "'" };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
            if (data0.currency === undefined) {
                const err5 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
            }
            if (data0.kind === undefined) {
                const err6 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "kind" }, message: "must have required property '" + "kind" + "'" };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
            }
            if (data0.archived === undefined) {
                const err7 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "archived" }, message: "must have required property '" + "archived" + "'" };
                if (vErrors === null) {
                    vErrors = [err7];
                }
                else {
                    vErrors.push(err7);
                }
                errors++;
            }
            if (data0.cutoff === undefined) {
                const err8 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "cutoff" }, message: "must have required property '" + "cutoff" + "'" };
                if (vErrors === null) {
                    vErrors = [err8];
                }
                else {
                    vErrors.push(err8);
                }
                errors++;
            }
            if (data0.through === undefined) {
                const err9 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "through" }, message: "must have required property '" + "through" + "'" };
                if (vErrors === null) {
                    vErrors = [err9];
                }
                else {
                    vErrors.push(err9);
                }
                errors++;
            }
            if (data0.recordedMinor === undefined) {
                const err10 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "recordedMinor" }, message: "must have required property '" + "recordedMinor" + "'" };
                if (vErrors === null) {
                    vErrors = [err10];
                }
                else {
                    vErrors.push(err10);
                }
                errors++;
            }
            if (data0.projectedMinor === undefined) {
                const err11 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "projectedMinor" }, message: "must have required property '" + "projectedMinor" + "'" };
                if (vErrors === null) {
                    vErrors = [err11];
                }
                else {
                    vErrors.push(err11);
                }
                errors++;
            }
            if (data0.components === undefined) {
                const err12 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "components" }, message: "must have required property '" + "components" + "'" };
                if (vErrors === null) {
                    vErrors = [err12];
                }
                else {
                    vErrors.push(err12);
                }
                errors++;
            }
            if (data0.coverage === undefined) {
                const err13 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "coverage" }, message: "must have required property '" + "coverage" + "'" };
                if (vErrors === null) {
                    vErrors = [err13];
                }
                else {
                    vErrors.push(err13);
                }
                errors++;
            }
            for (const key1 in data0) {
                if (!(func35.call(schema29.properties.data.properties, key1))) {
                    const err14 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err14];
                    }
                    else {
                        vErrors.push(err14);
                    }
                    errors++;
                }
            }
            if (data0.accountId !== undefined) {
                let data1 = data0.accountId;
                if (typeof data1 === "string") {
                    if (!pattern0.test(data1)) {
                        const err15 = { instancePath: instancePath + "/data/accountId", schemaPath: "#/properties/data/properties/accountId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err15];
                        }
                        else {
                            vErrors.push(err15);
                        }
                        errors++;
                    }
                }
                else {
                    const err16 = { instancePath: instancePath + "/data/accountId", schemaPath: "#/properties/data/properties/accountId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err16];
                    }
                    else {
                        vErrors.push(err16);
                    }
                    errors++;
                }
            }
            if (data0.accountName !== undefined) {
                let data2 = data0.accountName;
                if (typeof data2 === "string") {
                    if (func2(data2) > 120) {
                        const err17 = { instancePath: instancePath + "/data/accountName", schemaPath: "#/properties/data/properties/accountName/maxLength", keyword: "maxLength", params: { limit: 120 }, message: "must NOT have more than 120 characters" };
                        if (vErrors === null) {
                            vErrors = [err17];
                        }
                        else {
                            vErrors.push(err17);
                        }
                        errors++;
                    }
                    if (func2(data2) < 1) {
                        const err18 = { instancePath: instancePath + "/data/accountName", schemaPath: "#/properties/data/properties/accountName/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err18];
                        }
                        else {
                            vErrors.push(err18);
                        }
                        errors++;
                    }
                }
                else {
                    const err19 = { instancePath: instancePath + "/data/accountName", schemaPath: "#/properties/data/properties/accountName/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err19];
                    }
                    else {
                        vErrors.push(err19);
                    }
                    errors++;
                }
            }
            if (data0.currency !== undefined) {
                let data3 = data0.currency;
                if (typeof data3 !== "string") {
                    const err20 = { instancePath: instancePath + "/data/currency", schemaPath: "#/properties/data/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err20];
                    }
                    else {
                        vErrors.push(err20);
                    }
                    errors++;
                }
                if (!(((data3 === "BRL") || (data3 === "CAD")) || (data3 === "USD"))) {
                    const err21 = { instancePath: instancePath + "/data/currency", schemaPath: "#/properties/data/properties/currency/enum", keyword: "enum", params: { allowedValues: schema29.properties.data.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err21];
                    }
                    else {
                        vErrors.push(err21);
                    }
                    errors++;
                }
            }
            if (data0.kind !== undefined) {
                let data4 = data0.kind;
                if (typeof data4 !== "string") {
                    const err22 = { instancePath: instancePath + "/data/kind", schemaPath: "#/properties/data/properties/kind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err22];
                    }
                    else {
                        vErrors.push(err22);
                    }
                    errors++;
                }
                if (!((data4 === "cash") || (data4 === "card"))) {
                    const err23 = { instancePath: instancePath + "/data/kind", schemaPath: "#/properties/data/properties/kind/enum", keyword: "enum", params: { allowedValues: schema29.properties.data.properties.kind.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err23];
                    }
                    else {
                        vErrors.push(err23);
                    }
                    errors++;
                }
            }
            if (data0.archived !== undefined) {
                if (typeof data0.archived !== "boolean") {
                    const err24 = { instancePath: instancePath + "/data/archived", schemaPath: "#/properties/data/properties/archived/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                    if (vErrors === null) {
                        vErrors = [err24];
                    }
                    else {
                        vErrors.push(err24);
                    }
                    errors++;
                }
            }
            if (data0.cutoff !== undefined) {
                let data6 = data0.cutoff;
                if (typeof data6 === "string") {
                    if (!pattern4.test(data6)) {
                        const err25 = { instancePath: instancePath + "/data/cutoff", schemaPath: "#/properties/data/properties/cutoff/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err25];
                        }
                        else {
                            vErrors.push(err25);
                        }
                        errors++;
                    }
                }
                else {
                    const err26 = { instancePath: instancePath + "/data/cutoff", schemaPath: "#/properties/data/properties/cutoff/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err26];
                    }
                    else {
                        vErrors.push(err26);
                    }
                    errors++;
                }
            }
            if (data0.through !== undefined) {
                let data7 = data0.through;
                if (typeof data7 === "string") {
                    if (!pattern4.test(data7)) {
                        const err27 = { instancePath: instancePath + "/data/through", schemaPath: "#/properties/data/properties/through/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err27];
                        }
                        else {
                            vErrors.push(err27);
                        }
                        errors++;
                    }
                }
                else {
                    const err28 = { instancePath: instancePath + "/data/through", schemaPath: "#/properties/data/properties/through/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err28];
                    }
                    else {
                        vErrors.push(err28);
                    }
                    errors++;
                }
            }
            if (data0.recordedMinor !== undefined) {
                let data8 = data0.recordedMinor;
                if (typeof data8 === "string") {
                    if (!pattern3.test(data8)) {
                        const err29 = { instancePath: instancePath + "/data/recordedMinor", schemaPath: "#/properties/data/properties/recordedMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err29];
                        }
                        else {
                            vErrors.push(err29);
                        }
                        errors++;
                    }
                }
                else {
                    const err30 = { instancePath: instancePath + "/data/recordedMinor", schemaPath: "#/properties/data/properties/recordedMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err30];
                    }
                    else {
                        vErrors.push(err30);
                    }
                    errors++;
                }
            }
            if (data0.projectedMinor !== undefined) {
                let data9 = data0.projectedMinor;
                if (typeof data9 === "string") {
                    if (!pattern3.test(data9)) {
                        const err31 = { instancePath: instancePath + "/data/projectedMinor", schemaPath: "#/properties/data/properties/projectedMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err31];
                        }
                        else {
                            vErrors.push(err31);
                        }
                        errors++;
                    }
                }
                else {
                    const err32 = { instancePath: instancePath + "/data/projectedMinor", schemaPath: "#/properties/data/properties/projectedMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err32];
                    }
                    else {
                        vErrors.push(err32);
                    }
                    errors++;
                }
            }
            if (data0.components !== undefined) {
                let data10 = data0.components;
                if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
                    if (data10.recordedMinor === undefined) {
                        const err33 = { instancePath: instancePath + "/data/components", schemaPath: "#/properties/data/properties/components/required", keyword: "required", params: { missingProperty: "recordedMinor" }, message: "must have required property '" + "recordedMinor" + "'" };
                        if (vErrors === null) {
                            vErrors = [err33];
                        }
                        else {
                            vErrors.push(err33);
                        }
                        errors++;
                    }
                    if (data10.pendingOutgoingMinor === undefined) {
                        const err34 = { instancePath: instancePath + "/data/components", schemaPath: "#/properties/data/properties/components/required", keyword: "required", params: { missingProperty: "pendingOutgoingMinor" }, message: "must have required property '" + "pendingOutgoingMinor" + "'" };
                        if (vErrors === null) {
                            vErrors = [err34];
                        }
                        else {
                            vErrors.push(err34);
                        }
                        errors++;
                    }
                    if (data10.pendingIncomingMinor === undefined) {
                        const err35 = { instancePath: instancePath + "/data/components", schemaPath: "#/properties/data/properties/components/required", keyword: "required", params: { missingProperty: "pendingIncomingMinor" }, message: "must have required property '" + "pendingIncomingMinor" + "'" };
                        if (vErrors === null) {
                            vErrors = [err35];
                        }
                        else {
                            vErrors.push(err35);
                        }
                        errors++;
                    }
                    if (data10.plannedOutgoingMinor === undefined) {
                        const err36 = { instancePath: instancePath + "/data/components", schemaPath: "#/properties/data/properties/components/required", keyword: "required", params: { missingProperty: "plannedOutgoingMinor" }, message: "must have required property '" + "plannedOutgoingMinor" + "'" };
                        if (vErrors === null) {
                            vErrors = [err36];
                        }
                        else {
                            vErrors.push(err36);
                        }
                        errors++;
                    }
                    if (data10.plannedIncomingMinor === undefined) {
                        const err37 = { instancePath: instancePath + "/data/components", schemaPath: "#/properties/data/properties/components/required", keyword: "required", params: { missingProperty: "plannedIncomingMinor" }, message: "must have required property '" + "plannedIncomingMinor" + "'" };
                        if (vErrors === null) {
                            vErrors = [err37];
                        }
                        else {
                            vErrors.push(err37);
                        }
                        errors++;
                    }
                    if (data10.futureCompletedOutgoingMinor === undefined) {
                        const err38 = { instancePath: instancePath + "/data/components", schemaPath: "#/properties/data/properties/components/required", keyword: "required", params: { missingProperty: "futureCompletedOutgoingMinor" }, message: "must have required property '" + "futureCompletedOutgoingMinor" + "'" };
                        if (vErrors === null) {
                            vErrors = [err38];
                        }
                        else {
                            vErrors.push(err38);
                        }
                        errors++;
                    }
                    if (data10.futureCompletedIncomingMinor === undefined) {
                        const err39 = { instancePath: instancePath + "/data/components", schemaPath: "#/properties/data/properties/components/required", keyword: "required", params: { missingProperty: "futureCompletedIncomingMinor" }, message: "must have required property '" + "futureCompletedIncomingMinor" + "'" };
                        if (vErrors === null) {
                            vErrors = [err39];
                        }
                        else {
                            vErrors.push(err39);
                        }
                        errors++;
                    }
                    if (data10.overdueOutgoingMinor === undefined) {
                        const err40 = { instancePath: instancePath + "/data/components", schemaPath: "#/properties/data/properties/components/required", keyword: "required", params: { missingProperty: "overdueOutgoingMinor" }, message: "must have required property '" + "overdueOutgoingMinor" + "'" };
                        if (vErrors === null) {
                            vErrors = [err40];
                        }
                        else {
                            vErrors.push(err40);
                        }
                        errors++;
                    }
                    if (data10.overdueIncomingMinor === undefined) {
                        const err41 = { instancePath: instancePath + "/data/components", schemaPath: "#/properties/data/properties/components/required", keyword: "required", params: { missingProperty: "overdueIncomingMinor" }, message: "must have required property '" + "overdueIncomingMinor" + "'" };
                        if (vErrors === null) {
                            vErrors = [err41];
                        }
                        else {
                            vErrors.push(err41);
                        }
                        errors++;
                    }
                    if (data10.overdueCount === undefined) {
                        const err42 = { instancePath: instancePath + "/data/components", schemaPath: "#/properties/data/properties/components/required", keyword: "required", params: { missingProperty: "overdueCount" }, message: "must have required property '" + "overdueCount" + "'" };
                        if (vErrors === null) {
                            vErrors = [err42];
                        }
                        else {
                            vErrors.push(err42);
                        }
                        errors++;
                    }
                    if (data10.pendingCount === undefined) {
                        const err43 = { instancePath: instancePath + "/data/components", schemaPath: "#/properties/data/properties/components/required", keyword: "required", params: { missingProperty: "pendingCount" }, message: "must have required property '" + "pendingCount" + "'" };
                        if (vErrors === null) {
                            vErrors = [err43];
                        }
                        else {
                            vErrors.push(err43);
                        }
                        errors++;
                    }
                    if (data10.plannedCount === undefined) {
                        const err44 = { instancePath: instancePath + "/data/components", schemaPath: "#/properties/data/properties/components/required", keyword: "required", params: { missingProperty: "plannedCount" }, message: "must have required property '" + "plannedCount" + "'" };
                        if (vErrors === null) {
                            vErrors = [err44];
                        }
                        else {
                            vErrors.push(err44);
                        }
                        errors++;
                    }
                    for (const key2 in data10) {
                        if (!(func35.call(schema29.properties.data.properties.components.properties, key2))) {
                            const err45 = { instancePath: instancePath + "/data/components", schemaPath: "#/properties/data/properties/components/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                                vErrors = [err45];
                            }
                            else {
                                vErrors.push(err45);
                            }
                            errors++;
                        }
                    }
                    if (data10.recordedMinor !== undefined) {
                        let data11 = data10.recordedMinor;
                        if (typeof data11 === "string") {
                            if (!pattern3.test(data11)) {
                                const err46 = { instancePath: instancePath + "/data/components/recordedMinor", schemaPath: "#/properties/data/properties/components/properties/recordedMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err46];
                                }
                                else {
                                    vErrors.push(err46);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err47 = { instancePath: instancePath + "/data/components/recordedMinor", schemaPath: "#/properties/data/properties/components/properties/recordedMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err47];
                            }
                            else {
                                vErrors.push(err47);
                            }
                            errors++;
                        }
                    }
                    if (data10.pendingOutgoingMinor !== undefined) {
                        let data12 = data10.pendingOutgoingMinor;
                        if (typeof data12 === "string") {
                            if (!pattern3.test(data12)) {
                                const err48 = { instancePath: instancePath + "/data/components/pendingOutgoingMinor", schemaPath: "#/properties/data/properties/components/properties/pendingOutgoingMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err48];
                                }
                                else {
                                    vErrors.push(err48);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err49 = { instancePath: instancePath + "/data/components/pendingOutgoingMinor", schemaPath: "#/properties/data/properties/components/properties/pendingOutgoingMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err49];
                            }
                            else {
                                vErrors.push(err49);
                            }
                            errors++;
                        }
                    }
                    if (data10.pendingIncomingMinor !== undefined) {
                        let data13 = data10.pendingIncomingMinor;
                        if (typeof data13 === "string") {
                            if (!pattern3.test(data13)) {
                                const err50 = { instancePath: instancePath + "/data/components/pendingIncomingMinor", schemaPath: "#/properties/data/properties/components/properties/pendingIncomingMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err50];
                                }
                                else {
                                    vErrors.push(err50);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err51 = { instancePath: instancePath + "/data/components/pendingIncomingMinor", schemaPath: "#/properties/data/properties/components/properties/pendingIncomingMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err51];
                            }
                            else {
                                vErrors.push(err51);
                            }
                            errors++;
                        }
                    }
                    if (data10.plannedOutgoingMinor !== undefined) {
                        let data14 = data10.plannedOutgoingMinor;
                        if (typeof data14 === "string") {
                            if (!pattern3.test(data14)) {
                                const err52 = { instancePath: instancePath + "/data/components/plannedOutgoingMinor", schemaPath: "#/properties/data/properties/components/properties/plannedOutgoingMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err52];
                                }
                                else {
                                    vErrors.push(err52);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err53 = { instancePath: instancePath + "/data/components/plannedOutgoingMinor", schemaPath: "#/properties/data/properties/components/properties/plannedOutgoingMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err53];
                            }
                            else {
                                vErrors.push(err53);
                            }
                            errors++;
                        }
                    }
                    if (data10.plannedIncomingMinor !== undefined) {
                        let data15 = data10.plannedIncomingMinor;
                        if (typeof data15 === "string") {
                            if (!pattern3.test(data15)) {
                                const err54 = { instancePath: instancePath + "/data/components/plannedIncomingMinor", schemaPath: "#/properties/data/properties/components/properties/plannedIncomingMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err54];
                                }
                                else {
                                    vErrors.push(err54);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err55 = { instancePath: instancePath + "/data/components/plannedIncomingMinor", schemaPath: "#/properties/data/properties/components/properties/plannedIncomingMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err55];
                            }
                            else {
                                vErrors.push(err55);
                            }
                            errors++;
                        }
                    }
                    if (data10.futureCompletedOutgoingMinor !== undefined) {
                        let data16 = data10.futureCompletedOutgoingMinor;
                        if (typeof data16 === "string") {
                            if (!pattern3.test(data16)) {
                                const err56 = { instancePath: instancePath + "/data/components/futureCompletedOutgoingMinor", schemaPath: "#/properties/data/properties/components/properties/futureCompletedOutgoingMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err56];
                                }
                                else {
                                    vErrors.push(err56);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err57 = { instancePath: instancePath + "/data/components/futureCompletedOutgoingMinor", schemaPath: "#/properties/data/properties/components/properties/futureCompletedOutgoingMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err57];
                            }
                            else {
                                vErrors.push(err57);
                            }
                            errors++;
                        }
                    }
                    if (data10.futureCompletedIncomingMinor !== undefined) {
                        let data17 = data10.futureCompletedIncomingMinor;
                        if (typeof data17 === "string") {
                            if (!pattern3.test(data17)) {
                                const err58 = { instancePath: instancePath + "/data/components/futureCompletedIncomingMinor", schemaPath: "#/properties/data/properties/components/properties/futureCompletedIncomingMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err58];
                                }
                                else {
                                    vErrors.push(err58);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err59 = { instancePath: instancePath + "/data/components/futureCompletedIncomingMinor", schemaPath: "#/properties/data/properties/components/properties/futureCompletedIncomingMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err59];
                            }
                            else {
                                vErrors.push(err59);
                            }
                            errors++;
                        }
                    }
                    if (data10.overdueOutgoingMinor !== undefined) {
                        let data18 = data10.overdueOutgoingMinor;
                        if (typeof data18 === "string") {
                            if (!pattern3.test(data18)) {
                                const err60 = { instancePath: instancePath + "/data/components/overdueOutgoingMinor", schemaPath: "#/properties/data/properties/components/properties/overdueOutgoingMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err60];
                                }
                                else {
                                    vErrors.push(err60);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err61 = { instancePath: instancePath + "/data/components/overdueOutgoingMinor", schemaPath: "#/properties/data/properties/components/properties/overdueOutgoingMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err61];
                            }
                            else {
                                vErrors.push(err61);
                            }
                            errors++;
                        }
                    }
                    if (data10.overdueIncomingMinor !== undefined) {
                        let data19 = data10.overdueIncomingMinor;
                        if (typeof data19 === "string") {
                            if (!pattern3.test(data19)) {
                                const err62 = { instancePath: instancePath + "/data/components/overdueIncomingMinor", schemaPath: "#/properties/data/properties/components/properties/overdueIncomingMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err62];
                                }
                                else {
                                    vErrors.push(err62);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err63 = { instancePath: instancePath + "/data/components/overdueIncomingMinor", schemaPath: "#/properties/data/properties/components/properties/overdueIncomingMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err63];
                            }
                            else {
                                vErrors.push(err63);
                            }
                            errors++;
                        }
                    }
                    if (data10.overdueCount !== undefined) {
                        let data20 = data10.overdueCount;
                        if (!(((typeof data20 == "number") && (!(data20 % 1) && !isNaN(data20))) && (isFinite(data20)))) {
                            const err64 = { instancePath: instancePath + "/data/components/overdueCount", schemaPath: "#/properties/data/properties/components/properties/overdueCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                                vErrors = [err64];
                            }
                            else {
                                vErrors.push(err64);
                            }
                            errors++;
                        }
                        if ((typeof data20 == "number") && (isFinite(data20))) {
                            if (data20 < 0 || isNaN(data20)) {
                                const err65 = { instancePath: instancePath + "/data/components/overdueCount", schemaPath: "#/properties/data/properties/components/properties/overdueCount/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                                if (vErrors === null) {
                                    vErrors = [err65];
                                }
                                else {
                                    vErrors.push(err65);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data10.pendingCount !== undefined) {
                        let data21 = data10.pendingCount;
                        if (!(((typeof data21 == "number") && (!(data21 % 1) && !isNaN(data21))) && (isFinite(data21)))) {
                            const err66 = { instancePath: instancePath + "/data/components/pendingCount", schemaPath: "#/properties/data/properties/components/properties/pendingCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                                vErrors = [err66];
                            }
                            else {
                                vErrors.push(err66);
                            }
                            errors++;
                        }
                        if ((typeof data21 == "number") && (isFinite(data21))) {
                            if (data21 < 0 || isNaN(data21)) {
                                const err67 = { instancePath: instancePath + "/data/components/pendingCount", schemaPath: "#/properties/data/properties/components/properties/pendingCount/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                                if (vErrors === null) {
                                    vErrors = [err67];
                                }
                                else {
                                    vErrors.push(err67);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data10.plannedCount !== undefined) {
                        let data22 = data10.plannedCount;
                        if (!(((typeof data22 == "number") && (!(data22 % 1) && !isNaN(data22))) && (isFinite(data22)))) {
                            const err68 = { instancePath: instancePath + "/data/components/plannedCount", schemaPath: "#/properties/data/properties/components/properties/plannedCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                                vErrors = [err68];
                            }
                            else {
                                vErrors.push(err68);
                            }
                            errors++;
                        }
                        if ((typeof data22 == "number") && (isFinite(data22))) {
                            if (data22 < 0 || isNaN(data22)) {
                                const err69 = { instancePath: instancePath + "/data/components/plannedCount", schemaPath: "#/properties/data/properties/components/properties/plannedCount/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                                if (vErrors === null) {
                                    vErrors = [err69];
                                }
                                else {
                                    vErrors.push(err69);
                                }
                                errors++;
                            }
                        }
                    }
                }
                else {
                    const err70 = { instancePath: instancePath + "/data/components", schemaPath: "#/properties/data/properties/components/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                        vErrors = [err70];
                    }
                    else {
                        vErrors.push(err70);
                    }
                    errors++;
                }
            }
            if (data0.coverage !== undefined) {
                let data23 = data0.coverage;
                if (data23 && typeof data23 == "object" && !Array.isArray(data23)) {
                    if (data23.complete === undefined) {
                        const err71 = { instancePath: instancePath + "/data/coverage", schemaPath: "#/properties/data/properties/coverage/required", keyword: "required", params: { missingProperty: "complete" }, message: "must have required property '" + "complete" + "'" };
                        if (vErrors === null) {
                            vErrors = [err71];
                        }
                        else {
                            vErrors.push(err71);
                        }
                        errors++;
                    }
                    if (data23.completeThrough === undefined) {
                        const err72 = { instancePath: instancePath + "/data/coverage", schemaPath: "#/properties/data/properties/coverage/required", keyword: "required", params: { missingProperty: "completeThrough" }, message: "must have required property '" + "completeThrough" + "'" };
                        if (vErrors === null) {
                            vErrors = [err72];
                        }
                        else {
                            vErrors.push(err72);
                        }
                        errors++;
                    }
                    if (data23.reason === undefined) {
                        const err73 = { instancePath: instancePath + "/data/coverage", schemaPath: "#/properties/data/properties/coverage/required", keyword: "required", params: { missingProperty: "reason" }, message: "must have required property '" + "reason" + "'" };
                        if (vErrors === null) {
                            vErrors = [err73];
                        }
                        else {
                            vErrors.push(err73);
                        }
                        errors++;
                    }
                    if (data23.note === undefined) {
                        const err74 = { instancePath: instancePath + "/data/coverage", schemaPath: "#/properties/data/properties/coverage/required", keyword: "required", params: { missingProperty: "note" }, message: "must have required property '" + "note" + "'" };
                        if (vErrors === null) {
                            vErrors = [err74];
                        }
                        else {
                            vErrors.push(err74);
                        }
                        errors++;
                    }
                    for (const key3 in data23) {
                        if (!((((key3 === "complete") || (key3 === "completeThrough")) || (key3 === "reason")) || (key3 === "note"))) {
                            const err75 = { instancePath: instancePath + "/data/coverage", schemaPath: "#/properties/data/properties/coverage/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                                vErrors = [err75];
                            }
                            else {
                                vErrors.push(err75);
                            }
                            errors++;
                        }
                    }
                    if (data23.complete !== undefined) {
                        if (typeof data23.complete !== "boolean") {
                            const err76 = { instancePath: instancePath + "/data/coverage/complete", schemaPath: "#/properties/data/properties/coverage/properties/complete/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                            if (vErrors === null) {
                                vErrors = [err76];
                            }
                            else {
                                vErrors.push(err76);
                            }
                            errors++;
                        }
                    }
                    if (data23.completeThrough !== undefined) {
                        let data25 = data23.completeThrough;
                        if ((typeof data25 !== "string") && (data25 !== null)) {
                            const err77 = { instancePath: instancePath + "/data/coverage/completeThrough", schemaPath: "#/properties/data/properties/coverage/properties/completeThrough/type", keyword: "type", params: { type: schema29.properties.data.properties.coverage.properties.completeThrough.type }, message: "must be string,null" };
                            if (vErrors === null) {
                                vErrors = [err77];
                            }
                            else {
                                vErrors.push(err77);
                            }
                            errors++;
                        }
                        if (typeof data25 === "string") {
                            if (!pattern4.test(data25)) {
                                const err78 = { instancePath: instancePath + "/data/coverage/completeThrough", schemaPath: "#/properties/data/properties/coverage/properties/completeThrough/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err78];
                                }
                                else {
                                    vErrors.push(err78);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data23.reason !== undefined) {
                        let data26 = data23.reason;
                        if (typeof data26 !== "string") {
                            const err79 = { instancePath: instancePath + "/data/coverage/reason", schemaPath: "#/properties/data/properties/coverage/properties/reason/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err79];
                            }
                            else {
                                vErrors.push(err79);
                            }
                            errors++;
                        }
                        if (!(((data26 === "complete") || (data26 === "gap")) || (data26 === "unknown"))) {
                            const err80 = { instancePath: instancePath + "/data/coverage/reason", schemaPath: "#/properties/data/properties/coverage/properties/reason/enum", keyword: "enum", params: { allowedValues: schema29.properties.data.properties.coverage.properties.reason.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                                vErrors = [err80];
                            }
                            else {
                                vErrors.push(err80);
                            }
                            errors++;
                        }
                    }
                    if (data23.note !== undefined) {
                        let data27 = data23.note;
                        if (typeof data27 === "string") {
                            if (func2(data27) > 600) {
                                const err81 = { instancePath: instancePath + "/data/coverage/note", schemaPath: "#/properties/data/properties/coverage/properties/note/maxLength", keyword: "maxLength", params: { limit: 600 }, message: "must NOT have more than 600 characters" };
                                if (vErrors === null) {
                                    vErrors = [err81];
                                }
                                else {
                                    vErrors.push(err81);
                                }
                                errors++;
                            }
                            if (func2(data27) < 1) {
                                const err82 = { instancePath: instancePath + "/data/coverage/note", schemaPath: "#/properties/data/properties/coverage/properties/note/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                if (vErrors === null) {
                                    vErrors = [err82];
                                }
                                else {
                                    vErrors.push(err82);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err83 = { instancePath: instancePath + "/data/coverage/note", schemaPath: "#/properties/data/properties/coverage/properties/note/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err83];
                            }
                            else {
                                vErrors.push(err83);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err84 = { instancePath: instancePath + "/data/coverage", schemaPath: "#/properties/data/properties/coverage/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                        vErrors = [err84];
                    }
                    else {
                        vErrors.push(err84);
                    }
                    errors++;
                }
            }
        }
        else {
            const err85 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err85];
            }
            else {
                vErrors.push(err85);
            }
            errors++;
        }
    }
    if (data.meta !== undefined) {
        let data28 = data.meta;
        if (data28 && typeof data28 == "object" && !Array.isArray(data28)) {
            if (data28.requestId === undefined) {
                const err86 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "requestId" }, message: "must have required property '" + "requestId" + "'" };
                if (vErrors === null) {
                    vErrors = [err86];
                }
                else {
                    vErrors.push(err86);
                }
                errors++;
            }
            if (data28.asOf === undefined) {
                const err87 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "asOf" }, message: "must have required property '" + "asOf" + "'" };
                if (vErrors === null) {
                    vErrors = [err87];
                }
                else {
                    vErrors.push(err87);
                }
                errors++;
            }
            if (data28.businessToday === undefined) {
                const err88 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err88];
                }
                else {
                    vErrors.push(err88);
                }
                errors++;
            }
            if (data28.timeZone === undefined) {
                const err89 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "timeZone" }, message: "must have required property '" + "timeZone" + "'" };
                if (vErrors === null) {
                    vErrors = [err89];
                }
                else {
                    vErrors.push(err89);
                }
                errors++;
            }
            if (data28.dataRevision === undefined) {
                const err90 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "dataRevision" }, message: "must have required property '" + "dataRevision" + "'" };
                if (vErrors === null) {
                    vErrors = [err90];
                }
                else {
                    vErrors.push(err90);
                }
                errors++;
            }
            for (const key4 in data28) {
                if (!(((((key4 === "requestId") || (key4 === "asOf")) || (key4 === "businessToday")) || (key4 === "timeZone")) || (key4 === "dataRevision"))) {
                    const err91 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key4 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err91];
                    }
                    else {
                        vErrors.push(err91);
                    }
                    errors++;
                }
            }
            if (data28.requestId !== undefined) {
                let data29 = data28.requestId;
                if (typeof data29 === "string") {
                    if (func2(data29) > 64) {
                        const err92 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err92];
                        }
                        else {
                            vErrors.push(err92);
                        }
                        errors++;
                    }
                    if (func2(data29) < 1) {
                        const err93 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err93];
                        }
                        else {
                            vErrors.push(err93);
                        }
                        errors++;
                    }
                }
                else {
                    const err94 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err94];
                    }
                    else {
                        vErrors.push(err94);
                    }
                    errors++;
                }
            }
            if (data28.asOf !== undefined) {
                let data30 = data28.asOf;
                if (typeof data30 === "string") {
                    if (func2(data30) > 64) {
                        const err95 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err95];
                        }
                        else {
                            vErrors.push(err95);
                        }
                        errors++;
                    }
                    if (func2(data30) < 1) {
                        const err96 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err96];
                        }
                        else {
                            vErrors.push(err96);
                        }
                        errors++;
                    }
                }
                else {
                    const err97 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err97];
                    }
                    else {
                        vErrors.push(err97);
                    }
                    errors++;
                }
            }
            if (data28.businessToday !== undefined) {
                let data31 = data28.businessToday;
                if (typeof data31 === "string") {
                    if (!pattern4.test(data31)) {
                        const err98 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err98];
                        }
                        else {
                            vErrors.push(err98);
                        }
                        errors++;
                    }
                }
                else {
                    const err99 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err99];
                    }
                    else {
                        vErrors.push(err99);
                    }
                    errors++;
                }
            }
            if (data28.timeZone !== undefined) {
                let data32 = data28.timeZone;
                if (typeof data32 === "string") {
                    if (func2(data32) > 64) {
                        const err100 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err100];
                        }
                        else {
                            vErrors.push(err100);
                        }
                        errors++;
                    }
                    if (func2(data32) < 1) {
                        const err101 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err101];
                        }
                        else {
                            vErrors.push(err101);
                        }
                        errors++;
                    }
                }
                else {
                    const err102 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err102];
                    }
                    else {
                        vErrors.push(err102);
                    }
                    errors++;
                }
            }
            if (data28.dataRevision !== undefined) {
                let data33 = data28.dataRevision;
                if (typeof data33 === "string") {
                    if (!pattern2.test(data33)) {
                        const err103 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err103];
                        }
                        else {
                            vErrors.push(err103);
                        }
                        errors++;
                    }
                }
                else {
                    const err104 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err104];
                    }
                    else {
                        vErrors.push(err104);
                    }
                    errors++;
                }
            }
        }
        else {
            const err105 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err105];
            }
            else {
                vErrors.push(err105);
            }
            errors++;
        }
    }
}
else {
    const err106 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
        vErrors = [err106];
    }
    else {
        vErrors.push(err106);
    }
    errors++;
} validate28.errors = vErrors; return errors === 0; }
export const validateLedgerRecurrenceEnvelope = validate29;
const schema30 = { "$id": "https://saldo.local/schemas/ledger-recurrence-envelope.json", "$schema": "http://json-schema.org/draft-07/schema#", "title": "LedgerRecurrenceEnvelope", "type": "object", "additionalProperties": false, "required": ["data", "meta"], "properties": { "data": { "type": "object", "additionalProperties": false, "required": ["template", "occurrences", "cancellableEntryIds", "editedExceptionEntryIds", "excluded"], "properties": { "template": { "type": "object", "additionalProperties": false, "required": ["id", "accountId", "categoryId", "description", "signedMinor", "currency", "accountKind", "frequency", "anchorDate", "endDate", "status", "generatedThrough", "revision"], "properties": { "id": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "accountId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "categoryId": { "type": ["string", "null"], "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "description": { "type": "string", "minLength": 1, "maxLength": 500 }, "signedMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "accountKind": { "type": "string", "enum": ["cash", "card"] }, "frequency": { "type": "string", "enum": ["monthly", "weekly", "biweekly"] }, "anchorDate": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "endDate": { "type": ["string", "null"], "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "status": { "type": "string", "enum": ["active", "stopped"] }, "generatedThrough": { "type": ["string", "null"], "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "revision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } }, "occurrences": { "type": "array", "maxItems": 2000, "items": { "type": "object", "additionalProperties": false, "required": ["ordinal", "occurrenceDate", "entryId", "disposition", "editedFields", "accountId", "signedMinor", "description", "dueDate", "paid", "revision"], "properties": { "ordinal": { "type": "integer", "minimum": 1 }, "occurrenceDate": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "entryId": { "type": ["string", "null"], "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "disposition": { "type": "string", "enum": ["eligible-forward", "edited-exception", "paid", "effective", "overdue", "canceled", "deleted"] }, "editedFields": { "type": "array", "maxItems": 6, "items": { "type": "string", "enum": ["amount", "description", "category", "account", "dueDate", "transactionDate"] } }, "accountId": { "type": ["string", "null"], "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "signedMinor": { "type": ["string", "null"], "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "description": { "type": ["string", "null"], "maxLength": 500 }, "dueDate": { "type": ["string", "null"], "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "paid": { "type": ["boolean", "null"] }, "revision": { "type": ["string", "null"], "pattern": "^[1-9][0-9]*$" } } } }, "cancellableEntryIds": { "type": "array", "maxItems": 2000, "items": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } }, "editedExceptionEntryIds": { "type": "array", "maxItems": 2000, "items": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } }, "excluded": { "type": "array", "maxItems": 2000, "items": { "type": "object", "additionalProperties": false, "required": ["ordinal", "entryId", "reason"], "properties": { "ordinal": { "type": "integer", "minimum": 1 }, "entryId": { "type": ["string", "null"], "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "reason": { "type": "string", "enum": ["eligible-forward", "edited-exception", "paid", "effective", "overdue", "canceled", "deleted"] } } } } } }, "meta": { "type": "object", "additionalProperties": false, "required": ["requestId", "asOf", "businessToday", "timeZone", "dataRevision"], "properties": { "requestId": { "type": "string", "minLength": 1, "maxLength": 64 }, "asOf": { "type": "string", "minLength": 1, "maxLength": 64 }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "timeZone": { "type": "string", "minLength": 1, "maxLength": 64 }, "dataRevision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } } } };
function validate29(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="https://saldo.local/schemas/ledger-recurrence-envelope.json" */ ; let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.data === undefined) {
        const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property '" + "data" + "'" };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
    }
    if (data.meta === undefined) {
        const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "meta" }, message: "must have required property '" + "meta" + "'" };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    for (const key0 in data) {
        if (!((key0 === "data") || (key0 === "meta"))) {
            const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.data !== undefined) {
        let data0 = data.data;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.template === undefined) {
                const err3 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "template" }, message: "must have required property '" + "template" + "'" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
            if (data0.occurrences === undefined) {
                const err4 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "occurrences" }, message: "must have required property '" + "occurrences" + "'" };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
            if (data0.cancellableEntryIds === undefined) {
                const err5 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "cancellableEntryIds" }, message: "must have required property '" + "cancellableEntryIds" + "'" };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
            }
            if (data0.editedExceptionEntryIds === undefined) {
                const err6 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "editedExceptionEntryIds" }, message: "must have required property '" + "editedExceptionEntryIds" + "'" };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
            }
            if (data0.excluded === undefined) {
                const err7 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "excluded" }, message: "must have required property '" + "excluded" + "'" };
                if (vErrors === null) {
                    vErrors = [err7];
                }
                else {
                    vErrors.push(err7);
                }
                errors++;
            }
            for (const key1 in data0) {
                if (!(((((key1 === "template") || (key1 === "occurrences")) || (key1 === "cancellableEntryIds")) || (key1 === "editedExceptionEntryIds")) || (key1 === "excluded"))) {
                    const err8 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err8];
                    }
                    else {
                        vErrors.push(err8);
                    }
                    errors++;
                }
            }
            if (data0.template !== undefined) {
                let data1 = data0.template;
                if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
                    if (data1.id === undefined) {
                        const err9 = { instancePath: instancePath + "/data/template", schemaPath: "#/properties/data/properties/template/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property '" + "id" + "'" };
                        if (vErrors === null) {
                            vErrors = [err9];
                        }
                        else {
                            vErrors.push(err9);
                        }
                        errors++;
                    }
                    if (data1.accountId === undefined) {
                        const err10 = { instancePath: instancePath + "/data/template", schemaPath: "#/properties/data/properties/template/required", keyword: "required", params: { missingProperty: "accountId" }, message: "must have required property '" + "accountId" + "'" };
                        if (vErrors === null) {
                            vErrors = [err10];
                        }
                        else {
                            vErrors.push(err10);
                        }
                        errors++;
                    }
                    if (data1.categoryId === undefined) {
                        const err11 = { instancePath: instancePath + "/data/template", schemaPath: "#/properties/data/properties/template/required", keyword: "required", params: { missingProperty: "categoryId" }, message: "must have required property '" + "categoryId" + "'" };
                        if (vErrors === null) {
                            vErrors = [err11];
                        }
                        else {
                            vErrors.push(err11);
                        }
                        errors++;
                    }
                    if (data1.description === undefined) {
                        const err12 = { instancePath: instancePath + "/data/template", schemaPath: "#/properties/data/properties/template/required", keyword: "required", params: { missingProperty: "description" }, message: "must have required property '" + "description" + "'" };
                        if (vErrors === null) {
                            vErrors = [err12];
                        }
                        else {
                            vErrors.push(err12);
                        }
                        errors++;
                    }
                    if (data1.signedMinor === undefined) {
                        const err13 = { instancePath: instancePath + "/data/template", schemaPath: "#/properties/data/properties/template/required", keyword: "required", params: { missingProperty: "signedMinor" }, message: "must have required property '" + "signedMinor" + "'" };
                        if (vErrors === null) {
                            vErrors = [err13];
                        }
                        else {
                            vErrors.push(err13);
                        }
                        errors++;
                    }
                    if (data1.currency === undefined) {
                        const err14 = { instancePath: instancePath + "/data/template", schemaPath: "#/properties/data/properties/template/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                        if (vErrors === null) {
                            vErrors = [err14];
                        }
                        else {
                            vErrors.push(err14);
                        }
                        errors++;
                    }
                    if (data1.accountKind === undefined) {
                        const err15 = { instancePath: instancePath + "/data/template", schemaPath: "#/properties/data/properties/template/required", keyword: "required", params: { missingProperty: "accountKind" }, message: "must have required property '" + "accountKind" + "'" };
                        if (vErrors === null) {
                            vErrors = [err15];
                        }
                        else {
                            vErrors.push(err15);
                        }
                        errors++;
                    }
                    if (data1.frequency === undefined) {
                        const err16 = { instancePath: instancePath + "/data/template", schemaPath: "#/properties/data/properties/template/required", keyword: "required", params: { missingProperty: "frequency" }, message: "must have required property '" + "frequency" + "'" };
                        if (vErrors === null) {
                            vErrors = [err16];
                        }
                        else {
                            vErrors.push(err16);
                        }
                        errors++;
                    }
                    if (data1.anchorDate === undefined) {
                        const err17 = { instancePath: instancePath + "/data/template", schemaPath: "#/properties/data/properties/template/required", keyword: "required", params: { missingProperty: "anchorDate" }, message: "must have required property '" + "anchorDate" + "'" };
                        if (vErrors === null) {
                            vErrors = [err17];
                        }
                        else {
                            vErrors.push(err17);
                        }
                        errors++;
                    }
                    if (data1.endDate === undefined) {
                        const err18 = { instancePath: instancePath + "/data/template", schemaPath: "#/properties/data/properties/template/required", keyword: "required", params: { missingProperty: "endDate" }, message: "must have required property '" + "endDate" + "'" };
                        if (vErrors === null) {
                            vErrors = [err18];
                        }
                        else {
                            vErrors.push(err18);
                        }
                        errors++;
                    }
                    if (data1.status === undefined) {
                        const err19 = { instancePath: instancePath + "/data/template", schemaPath: "#/properties/data/properties/template/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property '" + "status" + "'" };
                        if (vErrors === null) {
                            vErrors = [err19];
                        }
                        else {
                            vErrors.push(err19);
                        }
                        errors++;
                    }
                    if (data1.generatedThrough === undefined) {
                        const err20 = { instancePath: instancePath + "/data/template", schemaPath: "#/properties/data/properties/template/required", keyword: "required", params: { missingProperty: "generatedThrough" }, message: "must have required property '" + "generatedThrough" + "'" };
                        if (vErrors === null) {
                            vErrors = [err20];
                        }
                        else {
                            vErrors.push(err20);
                        }
                        errors++;
                    }
                    if (data1.revision === undefined) {
                        const err21 = { instancePath: instancePath + "/data/template", schemaPath: "#/properties/data/properties/template/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property '" + "revision" + "'" };
                        if (vErrors === null) {
                            vErrors = [err21];
                        }
                        else {
                            vErrors.push(err21);
                        }
                        errors++;
                    }
                    for (const key2 in data1) {
                        if (!(func35.call(schema30.properties.data.properties.template.properties, key2))) {
                            const err22 = { instancePath: instancePath + "/data/template", schemaPath: "#/properties/data/properties/template/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                                vErrors = [err22];
                            }
                            else {
                                vErrors.push(err22);
                            }
                            errors++;
                        }
                    }
                    if (data1.id !== undefined) {
                        let data2 = data1.id;
                        if (typeof data2 === "string") {
                            if (!pattern0.test(data2)) {
                                const err23 = { instancePath: instancePath + "/data/template/id", schemaPath: "#/properties/data/properties/template/properties/id/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err23];
                                }
                                else {
                                    vErrors.push(err23);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err24 = { instancePath: instancePath + "/data/template/id", schemaPath: "#/properties/data/properties/template/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err24];
                            }
                            else {
                                vErrors.push(err24);
                            }
                            errors++;
                        }
                    }
                    if (data1.accountId !== undefined) {
                        let data3 = data1.accountId;
                        if (typeof data3 === "string") {
                            if (!pattern0.test(data3)) {
                                const err25 = { instancePath: instancePath + "/data/template/accountId", schemaPath: "#/properties/data/properties/template/properties/accountId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err25];
                                }
                                else {
                                    vErrors.push(err25);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err26 = { instancePath: instancePath + "/data/template/accountId", schemaPath: "#/properties/data/properties/template/properties/accountId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err26];
                            }
                            else {
                                vErrors.push(err26);
                            }
                            errors++;
                        }
                    }
                    if (data1.categoryId !== undefined) {
                        let data4 = data1.categoryId;
                        if ((typeof data4 !== "string") && (data4 !== null)) {
                            const err27 = { instancePath: instancePath + "/data/template/categoryId", schemaPath: "#/properties/data/properties/template/properties/categoryId/type", keyword: "type", params: { type: schema30.properties.data.properties.template.properties.categoryId.type }, message: "must be string,null" };
                            if (vErrors === null) {
                                vErrors = [err27];
                            }
                            else {
                                vErrors.push(err27);
                            }
                            errors++;
                        }
                        if (typeof data4 === "string") {
                            if (!pattern0.test(data4)) {
                                const err28 = { instancePath: instancePath + "/data/template/categoryId", schemaPath: "#/properties/data/properties/template/properties/categoryId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err28];
                                }
                                else {
                                    vErrors.push(err28);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data1.description !== undefined) {
                        let data5 = data1.description;
                        if (typeof data5 === "string") {
                            if (func2(data5) > 500) {
                                const err29 = { instancePath: instancePath + "/data/template/description", schemaPath: "#/properties/data/properties/template/properties/description/maxLength", keyword: "maxLength", params: { limit: 500 }, message: "must NOT have more than 500 characters" };
                                if (vErrors === null) {
                                    vErrors = [err29];
                                }
                                else {
                                    vErrors.push(err29);
                                }
                                errors++;
                            }
                            if (func2(data5) < 1) {
                                const err30 = { instancePath: instancePath + "/data/template/description", schemaPath: "#/properties/data/properties/template/properties/description/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                if (vErrors === null) {
                                    vErrors = [err30];
                                }
                                else {
                                    vErrors.push(err30);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err31 = { instancePath: instancePath + "/data/template/description", schemaPath: "#/properties/data/properties/template/properties/description/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err31];
                            }
                            else {
                                vErrors.push(err31);
                            }
                            errors++;
                        }
                    }
                    if (data1.signedMinor !== undefined) {
                        let data6 = data1.signedMinor;
                        if (typeof data6 === "string") {
                            if (!pattern3.test(data6)) {
                                const err32 = { instancePath: instancePath + "/data/template/signedMinor", schemaPath: "#/properties/data/properties/template/properties/signedMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err32];
                                }
                                else {
                                    vErrors.push(err32);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err33 = { instancePath: instancePath + "/data/template/signedMinor", schemaPath: "#/properties/data/properties/template/properties/signedMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err33];
                            }
                            else {
                                vErrors.push(err33);
                            }
                            errors++;
                        }
                    }
                    if (data1.currency !== undefined) {
                        let data7 = data1.currency;
                        if (typeof data7 !== "string") {
                            const err34 = { instancePath: instancePath + "/data/template/currency", schemaPath: "#/properties/data/properties/template/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err34];
                            }
                            else {
                                vErrors.push(err34);
                            }
                            errors++;
                        }
                        if (!(((data7 === "BRL") || (data7 === "CAD")) || (data7 === "USD"))) {
                            const err35 = { instancePath: instancePath + "/data/template/currency", schemaPath: "#/properties/data/properties/template/properties/currency/enum", keyword: "enum", params: { allowedValues: schema30.properties.data.properties.template.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                                vErrors = [err35];
                            }
                            else {
                                vErrors.push(err35);
                            }
                            errors++;
                        }
                    }
                    if (data1.accountKind !== undefined) {
                        let data8 = data1.accountKind;
                        if (typeof data8 !== "string") {
                            const err36 = { instancePath: instancePath + "/data/template/accountKind", schemaPath: "#/properties/data/properties/template/properties/accountKind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err36];
                            }
                            else {
                                vErrors.push(err36);
                            }
                            errors++;
                        }
                        if (!((data8 === "cash") || (data8 === "card"))) {
                            const err37 = { instancePath: instancePath + "/data/template/accountKind", schemaPath: "#/properties/data/properties/template/properties/accountKind/enum", keyword: "enum", params: { allowedValues: schema30.properties.data.properties.template.properties.accountKind.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                                vErrors = [err37];
                            }
                            else {
                                vErrors.push(err37);
                            }
                            errors++;
                        }
                    }
                    if (data1.frequency !== undefined) {
                        let data9 = data1.frequency;
                        if (typeof data9 !== "string") {
                            const err38 = { instancePath: instancePath + "/data/template/frequency", schemaPath: "#/properties/data/properties/template/properties/frequency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err38];
                            }
                            else {
                                vErrors.push(err38);
                            }
                            errors++;
                        }
                        if (!(((data9 === "monthly") || (data9 === "weekly")) || (data9 === "biweekly"))) {
                            const err39 = { instancePath: instancePath + "/data/template/frequency", schemaPath: "#/properties/data/properties/template/properties/frequency/enum", keyword: "enum", params: { allowedValues: schema30.properties.data.properties.template.properties.frequency.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                                vErrors = [err39];
                            }
                            else {
                                vErrors.push(err39);
                            }
                            errors++;
                        }
                    }
                    if (data1.anchorDate !== undefined) {
                        let data10 = data1.anchorDate;
                        if (typeof data10 === "string") {
                            if (!pattern4.test(data10)) {
                                const err40 = { instancePath: instancePath + "/data/template/anchorDate", schemaPath: "#/properties/data/properties/template/properties/anchorDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err40];
                                }
                                else {
                                    vErrors.push(err40);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err41 = { instancePath: instancePath + "/data/template/anchorDate", schemaPath: "#/properties/data/properties/template/properties/anchorDate/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err41];
                            }
                            else {
                                vErrors.push(err41);
                            }
                            errors++;
                        }
                    }
                    if (data1.endDate !== undefined) {
                        let data11 = data1.endDate;
                        if ((typeof data11 !== "string") && (data11 !== null)) {
                            const err42 = { instancePath: instancePath + "/data/template/endDate", schemaPath: "#/properties/data/properties/template/properties/endDate/type", keyword: "type", params: { type: schema30.properties.data.properties.template.properties.endDate.type }, message: "must be string,null" };
                            if (vErrors === null) {
                                vErrors = [err42];
                            }
                            else {
                                vErrors.push(err42);
                            }
                            errors++;
                        }
                        if (typeof data11 === "string") {
                            if (!pattern4.test(data11)) {
                                const err43 = { instancePath: instancePath + "/data/template/endDate", schemaPath: "#/properties/data/properties/template/properties/endDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err43];
                                }
                                else {
                                    vErrors.push(err43);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data1.status !== undefined) {
                        let data12 = data1.status;
                        if (typeof data12 !== "string") {
                            const err44 = { instancePath: instancePath + "/data/template/status", schemaPath: "#/properties/data/properties/template/properties/status/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err44];
                            }
                            else {
                                vErrors.push(err44);
                            }
                            errors++;
                        }
                        if (!((data12 === "active") || (data12 === "stopped"))) {
                            const err45 = { instancePath: instancePath + "/data/template/status", schemaPath: "#/properties/data/properties/template/properties/status/enum", keyword: "enum", params: { allowedValues: schema30.properties.data.properties.template.properties.status.enum }, message: "must be equal to one of the allowed values" };
                            if (vErrors === null) {
                                vErrors = [err45];
                            }
                            else {
                                vErrors.push(err45);
                            }
                            errors++;
                        }
                    }
                    if (data1.generatedThrough !== undefined) {
                        let data13 = data1.generatedThrough;
                        if ((typeof data13 !== "string") && (data13 !== null)) {
                            const err46 = { instancePath: instancePath + "/data/template/generatedThrough", schemaPath: "#/properties/data/properties/template/properties/generatedThrough/type", keyword: "type", params: { type: schema30.properties.data.properties.template.properties.generatedThrough.type }, message: "must be string,null" };
                            if (vErrors === null) {
                                vErrors = [err46];
                            }
                            else {
                                vErrors.push(err46);
                            }
                            errors++;
                        }
                        if (typeof data13 === "string") {
                            if (!pattern4.test(data13)) {
                                const err47 = { instancePath: instancePath + "/data/template/generatedThrough", schemaPath: "#/properties/data/properties/template/properties/generatedThrough/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err47];
                                }
                                else {
                                    vErrors.push(err47);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data1.revision !== undefined) {
                        let data14 = data1.revision;
                        if (typeof data14 === "string") {
                            if (!pattern2.test(data14)) {
                                const err48 = { instancePath: instancePath + "/data/template/revision", schemaPath: "#/properties/data/properties/template/properties/revision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err48];
                                }
                                else {
                                    vErrors.push(err48);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err49 = { instancePath: instancePath + "/data/template/revision", schemaPath: "#/properties/data/properties/template/properties/revision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err49];
                            }
                            else {
                                vErrors.push(err49);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err50 = { instancePath: instancePath + "/data/template", schemaPath: "#/properties/data/properties/template/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                        vErrors = [err50];
                    }
                    else {
                        vErrors.push(err50);
                    }
                    errors++;
                }
            }
            if (data0.occurrences !== undefined) {
                let data15 = data0.occurrences;
                if (Array.isArray(data15)) {
                    if (data15.length > 2000) {
                        const err51 = { instancePath: instancePath + "/data/occurrences", schemaPath: "#/properties/data/properties/occurrences/maxItems", keyword: "maxItems", params: { limit: 2000 }, message: "must NOT have more than 2000 items" };
                        if (vErrors === null) {
                            vErrors = [err51];
                        }
                        else {
                            vErrors.push(err51);
                        }
                        errors++;
                    }
                    const len0 = data15.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                        let data16 = data15[i0];
                        if (data16 && typeof data16 == "object" && !Array.isArray(data16)) {
                            if (data16.ordinal === undefined) {
                                const err52 = { instancePath: instancePath + "/data/occurrences/" + i0, schemaPath: "#/properties/data/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "ordinal" }, message: "must have required property '" + "ordinal" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err52];
                                }
                                else {
                                    vErrors.push(err52);
                                }
                                errors++;
                            }
                            if (data16.occurrenceDate === undefined) {
                                const err53 = { instancePath: instancePath + "/data/occurrences/" + i0, schemaPath: "#/properties/data/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "occurrenceDate" }, message: "must have required property '" + "occurrenceDate" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err53];
                                }
                                else {
                                    vErrors.push(err53);
                                }
                                errors++;
                            }
                            if (data16.entryId === undefined) {
                                const err54 = { instancePath: instancePath + "/data/occurrences/" + i0, schemaPath: "#/properties/data/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "entryId" }, message: "must have required property '" + "entryId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err54];
                                }
                                else {
                                    vErrors.push(err54);
                                }
                                errors++;
                            }
                            if (data16.disposition === undefined) {
                                const err55 = { instancePath: instancePath + "/data/occurrences/" + i0, schemaPath: "#/properties/data/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "disposition" }, message: "must have required property '" + "disposition" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err55];
                                }
                                else {
                                    vErrors.push(err55);
                                }
                                errors++;
                            }
                            if (data16.editedFields === undefined) {
                                const err56 = { instancePath: instancePath + "/data/occurrences/" + i0, schemaPath: "#/properties/data/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "editedFields" }, message: "must have required property '" + "editedFields" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err56];
                                }
                                else {
                                    vErrors.push(err56);
                                }
                                errors++;
                            }
                            if (data16.accountId === undefined) {
                                const err57 = { instancePath: instancePath + "/data/occurrences/" + i0, schemaPath: "#/properties/data/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "accountId" }, message: "must have required property '" + "accountId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err57];
                                }
                                else {
                                    vErrors.push(err57);
                                }
                                errors++;
                            }
                            if (data16.signedMinor === undefined) {
                                const err58 = { instancePath: instancePath + "/data/occurrences/" + i0, schemaPath: "#/properties/data/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "signedMinor" }, message: "must have required property '" + "signedMinor" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err58];
                                }
                                else {
                                    vErrors.push(err58);
                                }
                                errors++;
                            }
                            if (data16.description === undefined) {
                                const err59 = { instancePath: instancePath + "/data/occurrences/" + i0, schemaPath: "#/properties/data/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "description" }, message: "must have required property '" + "description" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err59];
                                }
                                else {
                                    vErrors.push(err59);
                                }
                                errors++;
                            }
                            if (data16.dueDate === undefined) {
                                const err60 = { instancePath: instancePath + "/data/occurrences/" + i0, schemaPath: "#/properties/data/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "dueDate" }, message: "must have required property '" + "dueDate" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err60];
                                }
                                else {
                                    vErrors.push(err60);
                                }
                                errors++;
                            }
                            if (data16.paid === undefined) {
                                const err61 = { instancePath: instancePath + "/data/occurrences/" + i0, schemaPath: "#/properties/data/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "paid" }, message: "must have required property '" + "paid" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err61];
                                }
                                else {
                                    vErrors.push(err61);
                                }
                                errors++;
                            }
                            if (data16.revision === undefined) {
                                const err62 = { instancePath: instancePath + "/data/occurrences/" + i0, schemaPath: "#/properties/data/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property '" + "revision" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err62];
                                }
                                else {
                                    vErrors.push(err62);
                                }
                                errors++;
                            }
                            for (const key3 in data16) {
                                if (!(func35.call(schema30.properties.data.properties.occurrences.items.properties, key3))) {
                                    const err63 = { instancePath: instancePath + "/data/occurrences/" + i0, schemaPath: "#/properties/data/properties/occurrences/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                                    if (vErrors === null) {
                                        vErrors = [err63];
                                    }
                                    else {
                                        vErrors.push(err63);
                                    }
                                    errors++;
                                }
                            }
                            if (data16.ordinal !== undefined) {
                                let data17 = data16.ordinal;
                                if (!(((typeof data17 == "number") && (!(data17 % 1) && !isNaN(data17))) && (isFinite(data17)))) {
                                    const err64 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/ordinal", schemaPath: "#/properties/data/properties/occurrences/items/properties/ordinal/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                    if (vErrors === null) {
                                        vErrors = [err64];
                                    }
                                    else {
                                        vErrors.push(err64);
                                    }
                                    errors++;
                                }
                                if ((typeof data17 == "number") && (isFinite(data17))) {
                                    if (data17 < 1 || isNaN(data17)) {
                                        const err65 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/ordinal", schemaPath: "#/properties/data/properties/occurrences/items/properties/ordinal/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                                        if (vErrors === null) {
                                            vErrors = [err65];
                                        }
                                        else {
                                            vErrors.push(err65);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data16.occurrenceDate !== undefined) {
                                let data18 = data16.occurrenceDate;
                                if (typeof data18 === "string") {
                                    if (!pattern4.test(data18)) {
                                        const err66 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/occurrenceDate", schemaPath: "#/properties/data/properties/occurrences/items/properties/occurrenceDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err66];
                                        }
                                        else {
                                            vErrors.push(err66);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err67 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/occurrenceDate", schemaPath: "#/properties/data/properties/occurrences/items/properties/occurrenceDate/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err67];
                                    }
                                    else {
                                        vErrors.push(err67);
                                    }
                                    errors++;
                                }
                            }
                            if (data16.entryId !== undefined) {
                                let data19 = data16.entryId;
                                if ((typeof data19 !== "string") && (data19 !== null)) {
                                    const err68 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/entryId", schemaPath: "#/properties/data/properties/occurrences/items/properties/entryId/type", keyword: "type", params: { type: schema30.properties.data.properties.occurrences.items.properties.entryId.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err68];
                                    }
                                    else {
                                        vErrors.push(err68);
                                    }
                                    errors++;
                                }
                                if (typeof data19 === "string") {
                                    if (!pattern0.test(data19)) {
                                        const err69 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/entryId", schemaPath: "#/properties/data/properties/occurrences/items/properties/entryId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err69];
                                        }
                                        else {
                                            vErrors.push(err69);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data16.disposition !== undefined) {
                                let data20 = data16.disposition;
                                if (typeof data20 !== "string") {
                                    const err70 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/disposition", schemaPath: "#/properties/data/properties/occurrences/items/properties/disposition/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err70];
                                    }
                                    else {
                                        vErrors.push(err70);
                                    }
                                    errors++;
                                }
                                if (!(((((((data20 === "eligible-forward") || (data20 === "edited-exception")) || (data20 === "paid")) || (data20 === "effective")) || (data20 === "overdue")) || (data20 === "canceled")) || (data20 === "deleted"))) {
                                    const err71 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/disposition", schemaPath: "#/properties/data/properties/occurrences/items/properties/disposition/enum", keyword: "enum", params: { allowedValues: schema30.properties.data.properties.occurrences.items.properties.disposition.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err71];
                                    }
                                    else {
                                        vErrors.push(err71);
                                    }
                                    errors++;
                                }
                            }
                            if (data16.editedFields !== undefined) {
                                let data21 = data16.editedFields;
                                if (Array.isArray(data21)) {
                                    if (data21.length > 6) {
                                        const err72 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/editedFields", schemaPath: "#/properties/data/properties/occurrences/items/properties/editedFields/maxItems", keyword: "maxItems", params: { limit: 6 }, message: "must NOT have more than 6 items" };
                                        if (vErrors === null) {
                                            vErrors = [err72];
                                        }
                                        else {
                                            vErrors.push(err72);
                                        }
                                        errors++;
                                    }
                                    const len1 = data21.length;
                                    for (let i1 = 0; i1 < len1; i1++) {
                                        let data22 = data21[i1];
                                        if (typeof data22 !== "string") {
                                            const err73 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/editedFields/" + i1, schemaPath: "#/properties/data/properties/occurrences/items/properties/editedFields/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                            if (vErrors === null) {
                                                vErrors = [err73];
                                            }
                                            else {
                                                vErrors.push(err73);
                                            }
                                            errors++;
                                        }
                                        if (!((((((data22 === "amount") || (data22 === "description")) || (data22 === "category")) || (data22 === "account")) || (data22 === "dueDate")) || (data22 === "transactionDate"))) {
                                            const err74 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/editedFields/" + i1, schemaPath: "#/properties/data/properties/occurrences/items/properties/editedFields/items/enum", keyword: "enum", params: { allowedValues: schema30.properties.data.properties.occurrences.items.properties.editedFields.items.enum }, message: "must be equal to one of the allowed values" };
                                            if (vErrors === null) {
                                                vErrors = [err74];
                                            }
                                            else {
                                                vErrors.push(err74);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                                else {
                                    const err75 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/editedFields", schemaPath: "#/properties/data/properties/occurrences/items/properties/editedFields/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                                    if (vErrors === null) {
                                        vErrors = [err75];
                                    }
                                    else {
                                        vErrors.push(err75);
                                    }
                                    errors++;
                                }
                            }
                            if (data16.accountId !== undefined) {
                                let data23 = data16.accountId;
                                if ((typeof data23 !== "string") && (data23 !== null)) {
                                    const err76 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/accountId", schemaPath: "#/properties/data/properties/occurrences/items/properties/accountId/type", keyword: "type", params: { type: schema30.properties.data.properties.occurrences.items.properties.accountId.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err76];
                                    }
                                    else {
                                        vErrors.push(err76);
                                    }
                                    errors++;
                                }
                                if (typeof data23 === "string") {
                                    if (!pattern0.test(data23)) {
                                        const err77 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/accountId", schemaPath: "#/properties/data/properties/occurrences/items/properties/accountId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err77];
                                        }
                                        else {
                                            vErrors.push(err77);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data16.signedMinor !== undefined) {
                                let data24 = data16.signedMinor;
                                if ((typeof data24 !== "string") && (data24 !== null)) {
                                    const err78 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/signedMinor", schemaPath: "#/properties/data/properties/occurrences/items/properties/signedMinor/type", keyword: "type", params: { type: schema30.properties.data.properties.occurrences.items.properties.signedMinor.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err78];
                                    }
                                    else {
                                        vErrors.push(err78);
                                    }
                                    errors++;
                                }
                                if (typeof data24 === "string") {
                                    if (!pattern3.test(data24)) {
                                        const err79 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/signedMinor", schemaPath: "#/properties/data/properties/occurrences/items/properties/signedMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err79];
                                        }
                                        else {
                                            vErrors.push(err79);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data16.description !== undefined) {
                                let data25 = data16.description;
                                if ((typeof data25 !== "string") && (data25 !== null)) {
                                    const err80 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/description", schemaPath: "#/properties/data/properties/occurrences/items/properties/description/type", keyword: "type", params: { type: schema30.properties.data.properties.occurrences.items.properties.description.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err80];
                                    }
                                    else {
                                        vErrors.push(err80);
                                    }
                                    errors++;
                                }
                                if (typeof data25 === "string") {
                                    if (func2(data25) > 500) {
                                        const err81 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/description", schemaPath: "#/properties/data/properties/occurrences/items/properties/description/maxLength", keyword: "maxLength", params: { limit: 500 }, message: "must NOT have more than 500 characters" };
                                        if (vErrors === null) {
                                            vErrors = [err81];
                                        }
                                        else {
                                            vErrors.push(err81);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data16.dueDate !== undefined) {
                                let data26 = data16.dueDate;
                                if ((typeof data26 !== "string") && (data26 !== null)) {
                                    const err82 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/dueDate", schemaPath: "#/properties/data/properties/occurrences/items/properties/dueDate/type", keyword: "type", params: { type: schema30.properties.data.properties.occurrences.items.properties.dueDate.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err82];
                                    }
                                    else {
                                        vErrors.push(err82);
                                    }
                                    errors++;
                                }
                                if (typeof data26 === "string") {
                                    if (!pattern4.test(data26)) {
                                        const err83 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/dueDate", schemaPath: "#/properties/data/properties/occurrences/items/properties/dueDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err83];
                                        }
                                        else {
                                            vErrors.push(err83);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data16.paid !== undefined) {
                                let data27 = data16.paid;
                                if ((typeof data27 !== "boolean") && (data27 !== null)) {
                                    const err84 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/paid", schemaPath: "#/properties/data/properties/occurrences/items/properties/paid/type", keyword: "type", params: { type: schema30.properties.data.properties.occurrences.items.properties.paid.type }, message: "must be boolean,null" };
                                    if (vErrors === null) {
                                        vErrors = [err84];
                                    }
                                    else {
                                        vErrors.push(err84);
                                    }
                                    errors++;
                                }
                            }
                            if (data16.revision !== undefined) {
                                let data28 = data16.revision;
                                if ((typeof data28 !== "string") && (data28 !== null)) {
                                    const err85 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/revision", schemaPath: "#/properties/data/properties/occurrences/items/properties/revision/type", keyword: "type", params: { type: schema30.properties.data.properties.occurrences.items.properties.revision.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err85];
                                    }
                                    else {
                                        vErrors.push(err85);
                                    }
                                    errors++;
                                }
                                if (typeof data28 === "string") {
                                    if (!pattern2.test(data28)) {
                                        const err86 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/revision", schemaPath: "#/properties/data/properties/occurrences/items/properties/revision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err86];
                                        }
                                        else {
                                            vErrors.push(err86);
                                        }
                                        errors++;
                                    }
                                }
                            }
                        }
                        else {
                            const err87 = { instancePath: instancePath + "/data/occurrences/" + i0, schemaPath: "#/properties/data/properties/occurrences/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                                vErrors = [err87];
                            }
                            else {
                                vErrors.push(err87);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err88 = { instancePath: instancePath + "/data/occurrences", schemaPath: "#/properties/data/properties/occurrences/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err88];
                    }
                    else {
                        vErrors.push(err88);
                    }
                    errors++;
                }
            }
            if (data0.cancellableEntryIds !== undefined) {
                let data29 = data0.cancellableEntryIds;
                if (Array.isArray(data29)) {
                    if (data29.length > 2000) {
                        const err89 = { instancePath: instancePath + "/data/cancellableEntryIds", schemaPath: "#/properties/data/properties/cancellableEntryIds/maxItems", keyword: "maxItems", params: { limit: 2000 }, message: "must NOT have more than 2000 items" };
                        if (vErrors === null) {
                            vErrors = [err89];
                        }
                        else {
                            vErrors.push(err89);
                        }
                        errors++;
                    }
                    const len2 = data29.length;
                    for (let i2 = 0; i2 < len2; i2++) {
                        let data30 = data29[i2];
                        if (typeof data30 === "string") {
                            if (!pattern0.test(data30)) {
                                const err90 = { instancePath: instancePath + "/data/cancellableEntryIds/" + i2, schemaPath: "#/properties/data/properties/cancellableEntryIds/items/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err90];
                                }
                                else {
                                    vErrors.push(err90);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err91 = { instancePath: instancePath + "/data/cancellableEntryIds/" + i2, schemaPath: "#/properties/data/properties/cancellableEntryIds/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err91];
                            }
                            else {
                                vErrors.push(err91);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err92 = { instancePath: instancePath + "/data/cancellableEntryIds", schemaPath: "#/properties/data/properties/cancellableEntryIds/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err92];
                    }
                    else {
                        vErrors.push(err92);
                    }
                    errors++;
                }
            }
            if (data0.editedExceptionEntryIds !== undefined) {
                let data31 = data0.editedExceptionEntryIds;
                if (Array.isArray(data31)) {
                    if (data31.length > 2000) {
                        const err93 = { instancePath: instancePath + "/data/editedExceptionEntryIds", schemaPath: "#/properties/data/properties/editedExceptionEntryIds/maxItems", keyword: "maxItems", params: { limit: 2000 }, message: "must NOT have more than 2000 items" };
                        if (vErrors === null) {
                            vErrors = [err93];
                        }
                        else {
                            vErrors.push(err93);
                        }
                        errors++;
                    }
                    const len3 = data31.length;
                    for (let i3 = 0; i3 < len3; i3++) {
                        let data32 = data31[i3];
                        if (typeof data32 === "string") {
                            if (!pattern0.test(data32)) {
                                const err94 = { instancePath: instancePath + "/data/editedExceptionEntryIds/" + i3, schemaPath: "#/properties/data/properties/editedExceptionEntryIds/items/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err94];
                                }
                                else {
                                    vErrors.push(err94);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err95 = { instancePath: instancePath + "/data/editedExceptionEntryIds/" + i3, schemaPath: "#/properties/data/properties/editedExceptionEntryIds/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err95];
                            }
                            else {
                                vErrors.push(err95);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err96 = { instancePath: instancePath + "/data/editedExceptionEntryIds", schemaPath: "#/properties/data/properties/editedExceptionEntryIds/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err96];
                    }
                    else {
                        vErrors.push(err96);
                    }
                    errors++;
                }
            }
            if (data0.excluded !== undefined) {
                let data33 = data0.excluded;
                if (Array.isArray(data33)) {
                    if (data33.length > 2000) {
                        const err97 = { instancePath: instancePath + "/data/excluded", schemaPath: "#/properties/data/properties/excluded/maxItems", keyword: "maxItems", params: { limit: 2000 }, message: "must NOT have more than 2000 items" };
                        if (vErrors === null) {
                            vErrors = [err97];
                        }
                        else {
                            vErrors.push(err97);
                        }
                        errors++;
                    }
                    const len4 = data33.length;
                    for (let i4 = 0; i4 < len4; i4++) {
                        let data34 = data33[i4];
                        if (data34 && typeof data34 == "object" && !Array.isArray(data34)) {
                            if (data34.ordinal === undefined) {
                                const err98 = { instancePath: instancePath + "/data/excluded/" + i4, schemaPath: "#/properties/data/properties/excluded/items/required", keyword: "required", params: { missingProperty: "ordinal" }, message: "must have required property '" + "ordinal" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err98];
                                }
                                else {
                                    vErrors.push(err98);
                                }
                                errors++;
                            }
                            if (data34.entryId === undefined) {
                                const err99 = { instancePath: instancePath + "/data/excluded/" + i4, schemaPath: "#/properties/data/properties/excluded/items/required", keyword: "required", params: { missingProperty: "entryId" }, message: "must have required property '" + "entryId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err99];
                                }
                                else {
                                    vErrors.push(err99);
                                }
                                errors++;
                            }
                            if (data34.reason === undefined) {
                                const err100 = { instancePath: instancePath + "/data/excluded/" + i4, schemaPath: "#/properties/data/properties/excluded/items/required", keyword: "required", params: { missingProperty: "reason" }, message: "must have required property '" + "reason" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err100];
                                }
                                else {
                                    vErrors.push(err100);
                                }
                                errors++;
                            }
                            for (const key4 in data34) {
                                if (!(((key4 === "ordinal") || (key4 === "entryId")) || (key4 === "reason"))) {
                                    const err101 = { instancePath: instancePath + "/data/excluded/" + i4, schemaPath: "#/properties/data/properties/excluded/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key4 }, message: "must NOT have additional properties" };
                                    if (vErrors === null) {
                                        vErrors = [err101];
                                    }
                                    else {
                                        vErrors.push(err101);
                                    }
                                    errors++;
                                }
                            }
                            if (data34.ordinal !== undefined) {
                                let data35 = data34.ordinal;
                                if (!(((typeof data35 == "number") && (!(data35 % 1) && !isNaN(data35))) && (isFinite(data35)))) {
                                    const err102 = { instancePath: instancePath + "/data/excluded/" + i4 + "/ordinal", schemaPath: "#/properties/data/properties/excluded/items/properties/ordinal/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                    if (vErrors === null) {
                                        vErrors = [err102];
                                    }
                                    else {
                                        vErrors.push(err102);
                                    }
                                    errors++;
                                }
                                if ((typeof data35 == "number") && (isFinite(data35))) {
                                    if (data35 < 1 || isNaN(data35)) {
                                        const err103 = { instancePath: instancePath + "/data/excluded/" + i4 + "/ordinal", schemaPath: "#/properties/data/properties/excluded/items/properties/ordinal/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                                        if (vErrors === null) {
                                            vErrors = [err103];
                                        }
                                        else {
                                            vErrors.push(err103);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data34.entryId !== undefined) {
                                let data36 = data34.entryId;
                                if ((typeof data36 !== "string") && (data36 !== null)) {
                                    const err104 = { instancePath: instancePath + "/data/excluded/" + i4 + "/entryId", schemaPath: "#/properties/data/properties/excluded/items/properties/entryId/type", keyword: "type", params: { type: schema30.properties.data.properties.excluded.items.properties.entryId.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err104];
                                    }
                                    else {
                                        vErrors.push(err104);
                                    }
                                    errors++;
                                }
                                if (typeof data36 === "string") {
                                    if (!pattern0.test(data36)) {
                                        const err105 = { instancePath: instancePath + "/data/excluded/" + i4 + "/entryId", schemaPath: "#/properties/data/properties/excluded/items/properties/entryId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err105];
                                        }
                                        else {
                                            vErrors.push(err105);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data34.reason !== undefined) {
                                let data37 = data34.reason;
                                if (typeof data37 !== "string") {
                                    const err106 = { instancePath: instancePath + "/data/excluded/" + i4 + "/reason", schemaPath: "#/properties/data/properties/excluded/items/properties/reason/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err106];
                                    }
                                    else {
                                        vErrors.push(err106);
                                    }
                                    errors++;
                                }
                                if (!(((((((data37 === "eligible-forward") || (data37 === "edited-exception")) || (data37 === "paid")) || (data37 === "effective")) || (data37 === "overdue")) || (data37 === "canceled")) || (data37 === "deleted"))) {
                                    const err107 = { instancePath: instancePath + "/data/excluded/" + i4 + "/reason", schemaPath: "#/properties/data/properties/excluded/items/properties/reason/enum", keyword: "enum", params: { allowedValues: schema30.properties.data.properties.excluded.items.properties.reason.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err107];
                                    }
                                    else {
                                        vErrors.push(err107);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err108 = { instancePath: instancePath + "/data/excluded/" + i4, schemaPath: "#/properties/data/properties/excluded/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                                vErrors = [err108];
                            }
                            else {
                                vErrors.push(err108);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err109 = { instancePath: instancePath + "/data/excluded", schemaPath: "#/properties/data/properties/excluded/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err109];
                    }
                    else {
                        vErrors.push(err109);
                    }
                    errors++;
                }
            }
        }
        else {
            const err110 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err110];
            }
            else {
                vErrors.push(err110);
            }
            errors++;
        }
    }
    if (data.meta !== undefined) {
        let data38 = data.meta;
        if (data38 && typeof data38 == "object" && !Array.isArray(data38)) {
            if (data38.requestId === undefined) {
                const err111 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "requestId" }, message: "must have required property '" + "requestId" + "'" };
                if (vErrors === null) {
                    vErrors = [err111];
                }
                else {
                    vErrors.push(err111);
                }
                errors++;
            }
            if (data38.asOf === undefined) {
                const err112 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "asOf" }, message: "must have required property '" + "asOf" + "'" };
                if (vErrors === null) {
                    vErrors = [err112];
                }
                else {
                    vErrors.push(err112);
                }
                errors++;
            }
            if (data38.businessToday === undefined) {
                const err113 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err113];
                }
                else {
                    vErrors.push(err113);
                }
                errors++;
            }
            if (data38.timeZone === undefined) {
                const err114 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "timeZone" }, message: "must have required property '" + "timeZone" + "'" };
                if (vErrors === null) {
                    vErrors = [err114];
                }
                else {
                    vErrors.push(err114);
                }
                errors++;
            }
            if (data38.dataRevision === undefined) {
                const err115 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "dataRevision" }, message: "must have required property '" + "dataRevision" + "'" };
                if (vErrors === null) {
                    vErrors = [err115];
                }
                else {
                    vErrors.push(err115);
                }
                errors++;
            }
            for (const key5 in data38) {
                if (!(((((key5 === "requestId") || (key5 === "asOf")) || (key5 === "businessToday")) || (key5 === "timeZone")) || (key5 === "dataRevision"))) {
                    const err116 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key5 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err116];
                    }
                    else {
                        vErrors.push(err116);
                    }
                    errors++;
                }
            }
            if (data38.requestId !== undefined) {
                let data39 = data38.requestId;
                if (typeof data39 === "string") {
                    if (func2(data39) > 64) {
                        const err117 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err117];
                        }
                        else {
                            vErrors.push(err117);
                        }
                        errors++;
                    }
                    if (func2(data39) < 1) {
                        const err118 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err118];
                        }
                        else {
                            vErrors.push(err118);
                        }
                        errors++;
                    }
                }
                else {
                    const err119 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err119];
                    }
                    else {
                        vErrors.push(err119);
                    }
                    errors++;
                }
            }
            if (data38.asOf !== undefined) {
                let data40 = data38.asOf;
                if (typeof data40 === "string") {
                    if (func2(data40) > 64) {
                        const err120 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err120];
                        }
                        else {
                            vErrors.push(err120);
                        }
                        errors++;
                    }
                    if (func2(data40) < 1) {
                        const err121 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err121];
                        }
                        else {
                            vErrors.push(err121);
                        }
                        errors++;
                    }
                }
                else {
                    const err122 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err122];
                    }
                    else {
                        vErrors.push(err122);
                    }
                    errors++;
                }
            }
            if (data38.businessToday !== undefined) {
                let data41 = data38.businessToday;
                if (typeof data41 === "string") {
                    if (!pattern4.test(data41)) {
                        const err123 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err123];
                        }
                        else {
                            vErrors.push(err123);
                        }
                        errors++;
                    }
                }
                else {
                    const err124 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err124];
                    }
                    else {
                        vErrors.push(err124);
                    }
                    errors++;
                }
            }
            if (data38.timeZone !== undefined) {
                let data42 = data38.timeZone;
                if (typeof data42 === "string") {
                    if (func2(data42) > 64) {
                        const err125 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err125];
                        }
                        else {
                            vErrors.push(err125);
                        }
                        errors++;
                    }
                    if (func2(data42) < 1) {
                        const err126 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err126];
                        }
                        else {
                            vErrors.push(err126);
                        }
                        errors++;
                    }
                }
                else {
                    const err127 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err127];
                    }
                    else {
                        vErrors.push(err127);
                    }
                    errors++;
                }
            }
            if (data38.dataRevision !== undefined) {
                let data43 = data38.dataRevision;
                if (typeof data43 === "string") {
                    if (!pattern2.test(data43)) {
                        const err128 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err128];
                        }
                        else {
                            vErrors.push(err128);
                        }
                        errors++;
                    }
                }
                else {
                    const err129 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err129];
                    }
                    else {
                        vErrors.push(err129);
                    }
                    errors++;
                }
            }
        }
        else {
            const err130 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err130];
            }
            else {
                vErrors.push(err130);
            }
            errors++;
        }
    }
}
else {
    const err131 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
        vErrors = [err131];
    }
    else {
        vErrors.push(err131);
    }
    errors++;
} validate29.errors = vErrors; return errors === 0; }
export const validateLedgerRecurrencesEnvelope = validate30;
const schema31 = { "$id": "https://saldo.local/schemas/ledger-recurrences-envelope.json", "$schema": "http://json-schema.org/draft-07/schema#", "title": "LedgerRecurrencesEnvelope", "type": "object", "additionalProperties": false, "required": ["data", "meta"], "properties": { "data": { "type": "object", "additionalProperties": false, "required": ["recurrences"], "properties": { "recurrences": { "type": "array", "maxItems": 200, "items": { "type": "object", "additionalProperties": false, "required": ["id", "accountId", "categoryId", "description", "signedMinor", "currency", "accountKind", "frequency", "anchorDate", "endDate", "status", "generatedThrough", "revision"], "properties": { "id": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "accountId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "categoryId": { "type": ["string", "null"], "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "description": { "type": "string", "minLength": 1, "maxLength": 500 }, "signedMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "accountKind": { "type": "string", "enum": ["cash", "card"] }, "frequency": { "type": "string", "enum": ["monthly", "weekly", "biweekly"] }, "anchorDate": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "endDate": { "type": ["string", "null"], "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "status": { "type": "string", "enum": ["active", "stopped"] }, "generatedThrough": { "type": ["string", "null"], "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "revision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } } } } }, "meta": { "type": "object", "additionalProperties": false, "required": ["requestId", "asOf", "businessToday", "timeZone", "dataRevision"], "properties": { "requestId": { "type": "string", "minLength": 1, "maxLength": 64 }, "asOf": { "type": "string", "minLength": 1, "maxLength": 64 }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "timeZone": { "type": "string", "minLength": 1, "maxLength": 64 }, "dataRevision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } } } };
function validate30(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="https://saldo.local/schemas/ledger-recurrences-envelope.json" */ ; let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.data === undefined) {
        const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property '" + "data" + "'" };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
    }
    if (data.meta === undefined) {
        const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "meta" }, message: "must have required property '" + "meta" + "'" };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    for (const key0 in data) {
        if (!((key0 === "data") || (key0 === "meta"))) {
            const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.data !== undefined) {
        let data0 = data.data;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.recurrences === undefined) {
                const err3 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "recurrences" }, message: "must have required property '" + "recurrences" + "'" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
            for (const key1 in data0) {
                if (!(key1 === "recurrences")) {
                    const err4 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
            }
            if (data0.recurrences !== undefined) {
                let data1 = data0.recurrences;
                if (Array.isArray(data1)) {
                    if (data1.length > 200) {
                        const err5 = { instancePath: instancePath + "/data/recurrences", schemaPath: "#/properties/data/properties/recurrences/maxItems", keyword: "maxItems", params: { limit: 200 }, message: "must NOT have more than 200 items" };
                        if (vErrors === null) {
                            vErrors = [err5];
                        }
                        else {
                            vErrors.push(err5);
                        }
                        errors++;
                    }
                    const len0 = data1.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                        let data2 = data1[i0];
                        if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
                            if (data2.id === undefined) {
                                const err6 = { instancePath: instancePath + "/data/recurrences/" + i0, schemaPath: "#/properties/data/properties/recurrences/items/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property '" + "id" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err6];
                                }
                                else {
                                    vErrors.push(err6);
                                }
                                errors++;
                            }
                            if (data2.accountId === undefined) {
                                const err7 = { instancePath: instancePath + "/data/recurrences/" + i0, schemaPath: "#/properties/data/properties/recurrences/items/required", keyword: "required", params: { missingProperty: "accountId" }, message: "must have required property '" + "accountId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err7];
                                }
                                else {
                                    vErrors.push(err7);
                                }
                                errors++;
                            }
                            if (data2.categoryId === undefined) {
                                const err8 = { instancePath: instancePath + "/data/recurrences/" + i0, schemaPath: "#/properties/data/properties/recurrences/items/required", keyword: "required", params: { missingProperty: "categoryId" }, message: "must have required property '" + "categoryId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err8];
                                }
                                else {
                                    vErrors.push(err8);
                                }
                                errors++;
                            }
                            if (data2.description === undefined) {
                                const err9 = { instancePath: instancePath + "/data/recurrences/" + i0, schemaPath: "#/properties/data/properties/recurrences/items/required", keyword: "required", params: { missingProperty: "description" }, message: "must have required property '" + "description" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err9];
                                }
                                else {
                                    vErrors.push(err9);
                                }
                                errors++;
                            }
                            if (data2.signedMinor === undefined) {
                                const err10 = { instancePath: instancePath + "/data/recurrences/" + i0, schemaPath: "#/properties/data/properties/recurrences/items/required", keyword: "required", params: { missingProperty: "signedMinor" }, message: "must have required property '" + "signedMinor" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err10];
                                }
                                else {
                                    vErrors.push(err10);
                                }
                                errors++;
                            }
                            if (data2.currency === undefined) {
                                const err11 = { instancePath: instancePath + "/data/recurrences/" + i0, schemaPath: "#/properties/data/properties/recurrences/items/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err11];
                                }
                                else {
                                    vErrors.push(err11);
                                }
                                errors++;
                            }
                            if (data2.accountKind === undefined) {
                                const err12 = { instancePath: instancePath + "/data/recurrences/" + i0, schemaPath: "#/properties/data/properties/recurrences/items/required", keyword: "required", params: { missingProperty: "accountKind" }, message: "must have required property '" + "accountKind" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err12];
                                }
                                else {
                                    vErrors.push(err12);
                                }
                                errors++;
                            }
                            if (data2.frequency === undefined) {
                                const err13 = { instancePath: instancePath + "/data/recurrences/" + i0, schemaPath: "#/properties/data/properties/recurrences/items/required", keyword: "required", params: { missingProperty: "frequency" }, message: "must have required property '" + "frequency" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err13];
                                }
                                else {
                                    vErrors.push(err13);
                                }
                                errors++;
                            }
                            if (data2.anchorDate === undefined) {
                                const err14 = { instancePath: instancePath + "/data/recurrences/" + i0, schemaPath: "#/properties/data/properties/recurrences/items/required", keyword: "required", params: { missingProperty: "anchorDate" }, message: "must have required property '" + "anchorDate" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err14];
                                }
                                else {
                                    vErrors.push(err14);
                                }
                                errors++;
                            }
                            if (data2.endDate === undefined) {
                                const err15 = { instancePath: instancePath + "/data/recurrences/" + i0, schemaPath: "#/properties/data/properties/recurrences/items/required", keyword: "required", params: { missingProperty: "endDate" }, message: "must have required property '" + "endDate" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err15];
                                }
                                else {
                                    vErrors.push(err15);
                                }
                                errors++;
                            }
                            if (data2.status === undefined) {
                                const err16 = { instancePath: instancePath + "/data/recurrences/" + i0, schemaPath: "#/properties/data/properties/recurrences/items/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property '" + "status" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err16];
                                }
                                else {
                                    vErrors.push(err16);
                                }
                                errors++;
                            }
                            if (data2.generatedThrough === undefined) {
                                const err17 = { instancePath: instancePath + "/data/recurrences/" + i0, schemaPath: "#/properties/data/properties/recurrences/items/required", keyword: "required", params: { missingProperty: "generatedThrough" }, message: "must have required property '" + "generatedThrough" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err17];
                                }
                                else {
                                    vErrors.push(err17);
                                }
                                errors++;
                            }
                            if (data2.revision === undefined) {
                                const err18 = { instancePath: instancePath + "/data/recurrences/" + i0, schemaPath: "#/properties/data/properties/recurrences/items/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property '" + "revision" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err18];
                                }
                                else {
                                    vErrors.push(err18);
                                }
                                errors++;
                            }
                            for (const key2 in data2) {
                                if (!(func35.call(schema31.properties.data.properties.recurrences.items.properties, key2))) {
                                    const err19 = { instancePath: instancePath + "/data/recurrences/" + i0, schemaPath: "#/properties/data/properties/recurrences/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                                    if (vErrors === null) {
                                        vErrors = [err19];
                                    }
                                    else {
                                        vErrors.push(err19);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.id !== undefined) {
                                let data3 = data2.id;
                                if (typeof data3 === "string") {
                                    if (!pattern0.test(data3)) {
                                        const err20 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/id", schemaPath: "#/properties/data/properties/recurrences/items/properties/id/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err20];
                                        }
                                        else {
                                            vErrors.push(err20);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err21 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/id", schemaPath: "#/properties/data/properties/recurrences/items/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err21];
                                    }
                                    else {
                                        vErrors.push(err21);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.accountId !== undefined) {
                                let data4 = data2.accountId;
                                if (typeof data4 === "string") {
                                    if (!pattern0.test(data4)) {
                                        const err22 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/accountId", schemaPath: "#/properties/data/properties/recurrences/items/properties/accountId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err22];
                                        }
                                        else {
                                            vErrors.push(err22);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err23 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/accountId", schemaPath: "#/properties/data/properties/recurrences/items/properties/accountId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err23];
                                    }
                                    else {
                                        vErrors.push(err23);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.categoryId !== undefined) {
                                let data5 = data2.categoryId;
                                if ((typeof data5 !== "string") && (data5 !== null)) {
                                    const err24 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/categoryId", schemaPath: "#/properties/data/properties/recurrences/items/properties/categoryId/type", keyword: "type", params: { type: schema31.properties.data.properties.recurrences.items.properties.categoryId.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err24];
                                    }
                                    else {
                                        vErrors.push(err24);
                                    }
                                    errors++;
                                }
                                if (typeof data5 === "string") {
                                    if (!pattern0.test(data5)) {
                                        const err25 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/categoryId", schemaPath: "#/properties/data/properties/recurrences/items/properties/categoryId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err25];
                                        }
                                        else {
                                            vErrors.push(err25);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data2.description !== undefined) {
                                let data6 = data2.description;
                                if (typeof data6 === "string") {
                                    if (func2(data6) > 500) {
                                        const err26 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/description", schemaPath: "#/properties/data/properties/recurrences/items/properties/description/maxLength", keyword: "maxLength", params: { limit: 500 }, message: "must NOT have more than 500 characters" };
                                        if (vErrors === null) {
                                            vErrors = [err26];
                                        }
                                        else {
                                            vErrors.push(err26);
                                        }
                                        errors++;
                                    }
                                    if (func2(data6) < 1) {
                                        const err27 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/description", schemaPath: "#/properties/data/properties/recurrences/items/properties/description/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                        if (vErrors === null) {
                                            vErrors = [err27];
                                        }
                                        else {
                                            vErrors.push(err27);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err28 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/description", schemaPath: "#/properties/data/properties/recurrences/items/properties/description/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err28];
                                    }
                                    else {
                                        vErrors.push(err28);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.signedMinor !== undefined) {
                                let data7 = data2.signedMinor;
                                if (typeof data7 === "string") {
                                    if (!pattern3.test(data7)) {
                                        const err29 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/signedMinor", schemaPath: "#/properties/data/properties/recurrences/items/properties/signedMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err29];
                                        }
                                        else {
                                            vErrors.push(err29);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err30 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/signedMinor", schemaPath: "#/properties/data/properties/recurrences/items/properties/signedMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err30];
                                    }
                                    else {
                                        vErrors.push(err30);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.currency !== undefined) {
                                let data8 = data2.currency;
                                if (typeof data8 !== "string") {
                                    const err31 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/currency", schemaPath: "#/properties/data/properties/recurrences/items/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err31];
                                    }
                                    else {
                                        vErrors.push(err31);
                                    }
                                    errors++;
                                }
                                if (!(((data8 === "BRL") || (data8 === "CAD")) || (data8 === "USD"))) {
                                    const err32 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/currency", schemaPath: "#/properties/data/properties/recurrences/items/properties/currency/enum", keyword: "enum", params: { allowedValues: schema31.properties.data.properties.recurrences.items.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err32];
                                    }
                                    else {
                                        vErrors.push(err32);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.accountKind !== undefined) {
                                let data9 = data2.accountKind;
                                if (typeof data9 !== "string") {
                                    const err33 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/accountKind", schemaPath: "#/properties/data/properties/recurrences/items/properties/accountKind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err33];
                                    }
                                    else {
                                        vErrors.push(err33);
                                    }
                                    errors++;
                                }
                                if (!((data9 === "cash") || (data9 === "card"))) {
                                    const err34 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/accountKind", schemaPath: "#/properties/data/properties/recurrences/items/properties/accountKind/enum", keyword: "enum", params: { allowedValues: schema31.properties.data.properties.recurrences.items.properties.accountKind.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err34];
                                    }
                                    else {
                                        vErrors.push(err34);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.frequency !== undefined) {
                                let data10 = data2.frequency;
                                if (typeof data10 !== "string") {
                                    const err35 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/frequency", schemaPath: "#/properties/data/properties/recurrences/items/properties/frequency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err35];
                                    }
                                    else {
                                        vErrors.push(err35);
                                    }
                                    errors++;
                                }
                                if (!(((data10 === "monthly") || (data10 === "weekly")) || (data10 === "biweekly"))) {
                                    const err36 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/frequency", schemaPath: "#/properties/data/properties/recurrences/items/properties/frequency/enum", keyword: "enum", params: { allowedValues: schema31.properties.data.properties.recurrences.items.properties.frequency.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err36];
                                    }
                                    else {
                                        vErrors.push(err36);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.anchorDate !== undefined) {
                                let data11 = data2.anchorDate;
                                if (typeof data11 === "string") {
                                    if (!pattern4.test(data11)) {
                                        const err37 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/anchorDate", schemaPath: "#/properties/data/properties/recurrences/items/properties/anchorDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err37];
                                        }
                                        else {
                                            vErrors.push(err37);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err38 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/anchorDate", schemaPath: "#/properties/data/properties/recurrences/items/properties/anchorDate/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err38];
                                    }
                                    else {
                                        vErrors.push(err38);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.endDate !== undefined) {
                                let data12 = data2.endDate;
                                if ((typeof data12 !== "string") && (data12 !== null)) {
                                    const err39 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/endDate", schemaPath: "#/properties/data/properties/recurrences/items/properties/endDate/type", keyword: "type", params: { type: schema31.properties.data.properties.recurrences.items.properties.endDate.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err39];
                                    }
                                    else {
                                        vErrors.push(err39);
                                    }
                                    errors++;
                                }
                                if (typeof data12 === "string") {
                                    if (!pattern4.test(data12)) {
                                        const err40 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/endDate", schemaPath: "#/properties/data/properties/recurrences/items/properties/endDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err40];
                                        }
                                        else {
                                            vErrors.push(err40);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data2.status !== undefined) {
                                let data13 = data2.status;
                                if (typeof data13 !== "string") {
                                    const err41 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/status", schemaPath: "#/properties/data/properties/recurrences/items/properties/status/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err41];
                                    }
                                    else {
                                        vErrors.push(err41);
                                    }
                                    errors++;
                                }
                                if (!((data13 === "active") || (data13 === "stopped"))) {
                                    const err42 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/status", schemaPath: "#/properties/data/properties/recurrences/items/properties/status/enum", keyword: "enum", params: { allowedValues: schema31.properties.data.properties.recurrences.items.properties.status.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err42];
                                    }
                                    else {
                                        vErrors.push(err42);
                                    }
                                    errors++;
                                }
                            }
                            if (data2.generatedThrough !== undefined) {
                                let data14 = data2.generatedThrough;
                                if ((typeof data14 !== "string") && (data14 !== null)) {
                                    const err43 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/generatedThrough", schemaPath: "#/properties/data/properties/recurrences/items/properties/generatedThrough/type", keyword: "type", params: { type: schema31.properties.data.properties.recurrences.items.properties.generatedThrough.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err43];
                                    }
                                    else {
                                        vErrors.push(err43);
                                    }
                                    errors++;
                                }
                                if (typeof data14 === "string") {
                                    if (!pattern4.test(data14)) {
                                        const err44 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/generatedThrough", schemaPath: "#/properties/data/properties/recurrences/items/properties/generatedThrough/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err44];
                                        }
                                        else {
                                            vErrors.push(err44);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data2.revision !== undefined) {
                                let data15 = data2.revision;
                                if (typeof data15 === "string") {
                                    if (!pattern2.test(data15)) {
                                        const err45 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/revision", schemaPath: "#/properties/data/properties/recurrences/items/properties/revision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err45];
                                        }
                                        else {
                                            vErrors.push(err45);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err46 = { instancePath: instancePath + "/data/recurrences/" + i0 + "/revision", schemaPath: "#/properties/data/properties/recurrences/items/properties/revision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err46];
                                    }
                                    else {
                                        vErrors.push(err46);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err47 = { instancePath: instancePath + "/data/recurrences/" + i0, schemaPath: "#/properties/data/properties/recurrences/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                                vErrors = [err47];
                            }
                            else {
                                vErrors.push(err47);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err48 = { instancePath: instancePath + "/data/recurrences", schemaPath: "#/properties/data/properties/recurrences/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err48];
                    }
                    else {
                        vErrors.push(err48);
                    }
                    errors++;
                }
            }
        }
        else {
            const err49 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err49];
            }
            else {
                vErrors.push(err49);
            }
            errors++;
        }
    }
    if (data.meta !== undefined) {
        let data16 = data.meta;
        if (data16 && typeof data16 == "object" && !Array.isArray(data16)) {
            if (data16.requestId === undefined) {
                const err50 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "requestId" }, message: "must have required property '" + "requestId" + "'" };
                if (vErrors === null) {
                    vErrors = [err50];
                }
                else {
                    vErrors.push(err50);
                }
                errors++;
            }
            if (data16.asOf === undefined) {
                const err51 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "asOf" }, message: "must have required property '" + "asOf" + "'" };
                if (vErrors === null) {
                    vErrors = [err51];
                }
                else {
                    vErrors.push(err51);
                }
                errors++;
            }
            if (data16.businessToday === undefined) {
                const err52 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err52];
                }
                else {
                    vErrors.push(err52);
                }
                errors++;
            }
            if (data16.timeZone === undefined) {
                const err53 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "timeZone" }, message: "must have required property '" + "timeZone" + "'" };
                if (vErrors === null) {
                    vErrors = [err53];
                }
                else {
                    vErrors.push(err53);
                }
                errors++;
            }
            if (data16.dataRevision === undefined) {
                const err54 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "dataRevision" }, message: "must have required property '" + "dataRevision" + "'" };
                if (vErrors === null) {
                    vErrors = [err54];
                }
                else {
                    vErrors.push(err54);
                }
                errors++;
            }
            for (const key3 in data16) {
                if (!(((((key3 === "requestId") || (key3 === "asOf")) || (key3 === "businessToday")) || (key3 === "timeZone")) || (key3 === "dataRevision"))) {
                    const err55 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err55];
                    }
                    else {
                        vErrors.push(err55);
                    }
                    errors++;
                }
            }
            if (data16.requestId !== undefined) {
                let data17 = data16.requestId;
                if (typeof data17 === "string") {
                    if (func2(data17) > 64) {
                        const err56 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err56];
                        }
                        else {
                            vErrors.push(err56);
                        }
                        errors++;
                    }
                    if (func2(data17) < 1) {
                        const err57 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err57];
                        }
                        else {
                            vErrors.push(err57);
                        }
                        errors++;
                    }
                }
                else {
                    const err58 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err58];
                    }
                    else {
                        vErrors.push(err58);
                    }
                    errors++;
                }
            }
            if (data16.asOf !== undefined) {
                let data18 = data16.asOf;
                if (typeof data18 === "string") {
                    if (func2(data18) > 64) {
                        const err59 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err59];
                        }
                        else {
                            vErrors.push(err59);
                        }
                        errors++;
                    }
                    if (func2(data18) < 1) {
                        const err60 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err60];
                        }
                        else {
                            vErrors.push(err60);
                        }
                        errors++;
                    }
                }
                else {
                    const err61 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err61];
                    }
                    else {
                        vErrors.push(err61);
                    }
                    errors++;
                }
            }
            if (data16.businessToday !== undefined) {
                let data19 = data16.businessToday;
                if (typeof data19 === "string") {
                    if (!pattern4.test(data19)) {
                        const err62 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err62];
                        }
                        else {
                            vErrors.push(err62);
                        }
                        errors++;
                    }
                }
                else {
                    const err63 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err63];
                    }
                    else {
                        vErrors.push(err63);
                    }
                    errors++;
                }
            }
            if (data16.timeZone !== undefined) {
                let data20 = data16.timeZone;
                if (typeof data20 === "string") {
                    if (func2(data20) > 64) {
                        const err64 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err64];
                        }
                        else {
                            vErrors.push(err64);
                        }
                        errors++;
                    }
                    if (func2(data20) < 1) {
                        const err65 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err65];
                        }
                        else {
                            vErrors.push(err65);
                        }
                        errors++;
                    }
                }
                else {
                    const err66 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err66];
                    }
                    else {
                        vErrors.push(err66);
                    }
                    errors++;
                }
            }
            if (data16.dataRevision !== undefined) {
                let data21 = data16.dataRevision;
                if (typeof data21 === "string") {
                    if (!pattern2.test(data21)) {
                        const err67 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err67];
                        }
                        else {
                            vErrors.push(err67);
                        }
                        errors++;
                    }
                }
                else {
                    const err68 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err68];
                    }
                    else {
                        vErrors.push(err68);
                    }
                    errors++;
                }
            }
        }
        else {
            const err69 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err69];
            }
            else {
                vErrors.push(err69);
            }
            errors++;
        }
    }
}
else {
    const err70 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
        vErrors = [err70];
    }
    else {
        vErrors.push(err70);
    }
    errors++;
} validate30.errors = vErrors; return errors === 0; }
export const validateLedgerRecurrencePreviewEnvelope = validate31;
const schema32 = { "$id": "https://saldo.local/schemas/ledger-recurrence-preview-envelope.json", "$schema": "http://json-schema.org/draft-07/schema#", "title": "LedgerRecurrencePreviewEnvelope", "type": "object", "additionalProperties": false, "required": ["data", "meta"], "properties": { "data": { "oneOf": [{ "type": "object", "additionalProperties": false, "required": ["id", "action", "templateId", "revision", "businessToday", "expiresAt", "accountId", "currency", "occurrences", "overlap", "note", "requiresConfirmation"], "properties": { "id": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "action": { "type": "string", "enum": ["recurrence.create"] }, "templateId": { "type": "null" }, "revision": { "type": "null" }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "expiresAt": { "type": "string", "minLength": 1, "maxLength": 64 }, "accountId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "occurrences": { "type": "array", "maxItems": 2000, "items": { "type": "object", "additionalProperties": false, "required": ["ordinal", "occurrenceDate", "signedMinor", "currency"], "properties": { "ordinal": { "type": "integer", "minimum": 1 }, "occurrenceDate": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "signedMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] } } } }, "overlap": { "type": "array", "maxItems": 2000, "items": { "type": "object", "additionalProperties": false, "required": ["occurrenceDate", "entryId", "description", "signedMinor", "currency", "generated"], "properties": { "occurrenceDate": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "entryId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "description": { "type": "string", "minLength": 1, "maxLength": 500 }, "signedMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "generated": { "type": "boolean" } } } }, "note": { "type": "string", "minLength": 1, "maxLength": 600 }, "requiresConfirmation": { "type": "boolean" } } }, { "type": "object", "additionalProperties": false, "required": ["id", "action", "templateId", "revision", "businessToday", "expiresAt", "mode", "occurrences", "cancellableEntryIds", "editedExceptionEntryIds", "excluded", "selectedEntryIds", "cancelledEntryIds"], "properties": { "id": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "action": { "type": "string", "enum": ["recurrence.stop"] }, "templateId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "revision": { "type": "string", "pattern": "^[1-9][0-9]*$" }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "expiresAt": { "type": "string", "minLength": 1, "maxLength": 64 }, "mode": { "type": "string", "enum": ["stop-and-cancel", "stop-only"] }, "occurrences": { "type": "array", "maxItems": 2000, "items": { "type": "object", "additionalProperties": false, "required": ["ordinal", "occurrenceDate", "entryId", "disposition", "editedFields", "accountId", "signedMinor", "description", "dueDate", "paid", "revision"], "properties": { "ordinal": { "type": "integer", "minimum": 1 }, "occurrenceDate": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "entryId": { "type": ["string", "null"], "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "disposition": { "type": "string", "enum": ["eligible-forward", "edited-exception", "paid", "effective", "overdue", "canceled", "deleted"] }, "editedFields": { "type": "array", "maxItems": 6, "items": { "type": "string", "enum": ["amount", "description", "category", "account", "dueDate", "transactionDate"] } }, "accountId": { "type": ["string", "null"], "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "signedMinor": { "type": ["string", "null"], "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "description": { "type": ["string", "null"], "maxLength": 500 }, "dueDate": { "type": ["string", "null"], "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "paid": { "type": ["boolean", "null"] }, "revision": { "type": ["string", "null"], "pattern": "^[1-9][0-9]*$" } } } }, "cancellableEntryIds": { "type": "array", "maxItems": 2000, "items": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } }, "editedExceptionEntryIds": { "type": "array", "maxItems": 2000, "items": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } }, "excluded": { "type": "array", "maxItems": 2000, "items": { "type": "object", "additionalProperties": false, "required": ["ordinal", "entryId", "reason"], "properties": { "ordinal": { "type": "integer", "minimum": 1 }, "entryId": { "type": ["string", "null"], "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "reason": { "type": "string", "enum": ["eligible-forward", "edited-exception", "paid", "effective", "overdue", "canceled", "deleted"] } } } }, "selectedEntryIds": { "type": "array", "maxItems": 2000, "items": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } }, "cancelledEntryIds": { "type": "array", "maxItems": 2000, "items": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } } } }] }, "meta": { "type": "object", "additionalProperties": false, "required": ["requestId", "asOf", "businessToday", "timeZone", "dataRevision"], "properties": { "requestId": { "type": "string", "minLength": 1, "maxLength": 64 }, "asOf": { "type": "string", "minLength": 1, "maxLength": 64 }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "timeZone": { "type": "string", "minLength": 1, "maxLength": 64 }, "dataRevision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } } } };
function validate31(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="https://saldo.local/schemas/ledger-recurrence-preview-envelope.json" */ ; let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.data === undefined) {
        const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property '" + "data" + "'" };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
    }
    if (data.meta === undefined) {
        const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "meta" }, message: "must have required property '" + "meta" + "'" };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    for (const key0 in data) {
        if (!((key0 === "data") || (key0 === "meta"))) {
            const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.data !== undefined) {
        let data0 = data.data;
        const _errs3 = errors;
        let valid1 = false;
        let passing0 = null;
        const _errs4 = errors;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.id === undefined) {
                const err3 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/0/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property '" + "id" + "'" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
            if (data0.action === undefined) {
                const err4 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/0/required", keyword: "required", params: { missingProperty: "action" }, message: "must have required property '" + "action" + "'" };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
            if (data0.templateId === undefined) {
                const err5 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/0/required", keyword: "required", params: { missingProperty: "templateId" }, message: "must have required property '" + "templateId" + "'" };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
            }
            if (data0.revision === undefined) {
                const err6 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/0/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property '" + "revision" + "'" };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
            }
            if (data0.businessToday === undefined) {
                const err7 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/0/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err7];
                }
                else {
                    vErrors.push(err7);
                }
                errors++;
            }
            if (data0.expiresAt === undefined) {
                const err8 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/0/required", keyword: "required", params: { missingProperty: "expiresAt" }, message: "must have required property '" + "expiresAt" + "'" };
                if (vErrors === null) {
                    vErrors = [err8];
                }
                else {
                    vErrors.push(err8);
                }
                errors++;
            }
            if (data0.accountId === undefined) {
                const err9 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/0/required", keyword: "required", params: { missingProperty: "accountId" }, message: "must have required property '" + "accountId" + "'" };
                if (vErrors === null) {
                    vErrors = [err9];
                }
                else {
                    vErrors.push(err9);
                }
                errors++;
            }
            if (data0.currency === undefined) {
                const err10 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/0/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                if (vErrors === null) {
                    vErrors = [err10];
                }
                else {
                    vErrors.push(err10);
                }
                errors++;
            }
            if (data0.occurrences === undefined) {
                const err11 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/0/required", keyword: "required", params: { missingProperty: "occurrences" }, message: "must have required property '" + "occurrences" + "'" };
                if (vErrors === null) {
                    vErrors = [err11];
                }
                else {
                    vErrors.push(err11);
                }
                errors++;
            }
            if (data0.overlap === undefined) {
                const err12 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/0/required", keyword: "required", params: { missingProperty: "overlap" }, message: "must have required property '" + "overlap" + "'" };
                if (vErrors === null) {
                    vErrors = [err12];
                }
                else {
                    vErrors.push(err12);
                }
                errors++;
            }
            if (data0.note === undefined) {
                const err13 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/0/required", keyword: "required", params: { missingProperty: "note" }, message: "must have required property '" + "note" + "'" };
                if (vErrors === null) {
                    vErrors = [err13];
                }
                else {
                    vErrors.push(err13);
                }
                errors++;
            }
            if (data0.requiresConfirmation === undefined) {
                const err14 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/0/required", keyword: "required", params: { missingProperty: "requiresConfirmation" }, message: "must have required property '" + "requiresConfirmation" + "'" };
                if (vErrors === null) {
                    vErrors = [err14];
                }
                else {
                    vErrors.push(err14);
                }
                errors++;
            }
            for (const key1 in data0) {
                if (!(func35.call(schema32.properties.data.oneOf[0].properties, key1))) {
                    const err15 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/0/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err15];
                    }
                    else {
                        vErrors.push(err15);
                    }
                    errors++;
                }
            }
            if (data0.id !== undefined) {
                let data1 = data0.id;
                if (typeof data1 === "string") {
                    if (!pattern0.test(data1)) {
                        const err16 = { instancePath: instancePath + "/data/id", schemaPath: "#/properties/data/oneOf/0/properties/id/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err16];
                        }
                        else {
                            vErrors.push(err16);
                        }
                        errors++;
                    }
                }
                else {
                    const err17 = { instancePath: instancePath + "/data/id", schemaPath: "#/properties/data/oneOf/0/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err17];
                    }
                    else {
                        vErrors.push(err17);
                    }
                    errors++;
                }
            }
            if (data0.action !== undefined) {
                let data2 = data0.action;
                if (typeof data2 !== "string") {
                    const err18 = { instancePath: instancePath + "/data/action", schemaPath: "#/properties/data/oneOf/0/properties/action/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err18];
                    }
                    else {
                        vErrors.push(err18);
                    }
                    errors++;
                }
                if (!(data2 === "recurrence.create")) {
                    const err19 = { instancePath: instancePath + "/data/action", schemaPath: "#/properties/data/oneOf/0/properties/action/enum", keyword: "enum", params: { allowedValues: schema32.properties.data.oneOf[0].properties.action.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err19];
                    }
                    else {
                        vErrors.push(err19);
                    }
                    errors++;
                }
            }
            if (data0.templateId !== undefined) {
                if (data0.templateId !== null) {
                    const err20 = { instancePath: instancePath + "/data/templateId", schemaPath: "#/properties/data/oneOf/0/properties/templateId/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                    if (vErrors === null) {
                        vErrors = [err20];
                    }
                    else {
                        vErrors.push(err20);
                    }
                    errors++;
                }
            }
            if (data0.revision !== undefined) {
                if (data0.revision !== null) {
                    const err21 = { instancePath: instancePath + "/data/revision", schemaPath: "#/properties/data/oneOf/0/properties/revision/type", keyword: "type", params: { type: "null" }, message: "must be null" };
                    if (vErrors === null) {
                        vErrors = [err21];
                    }
                    else {
                        vErrors.push(err21);
                    }
                    errors++;
                }
            }
            if (data0.businessToday !== undefined) {
                let data5 = data0.businessToday;
                if (typeof data5 === "string") {
                    if (!pattern4.test(data5)) {
                        const err22 = { instancePath: instancePath + "/data/businessToday", schemaPath: "#/properties/data/oneOf/0/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err22];
                        }
                        else {
                            vErrors.push(err22);
                        }
                        errors++;
                    }
                }
                else {
                    const err23 = { instancePath: instancePath + "/data/businessToday", schemaPath: "#/properties/data/oneOf/0/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err23];
                    }
                    else {
                        vErrors.push(err23);
                    }
                    errors++;
                }
            }
            if (data0.expiresAt !== undefined) {
                let data6 = data0.expiresAt;
                if (typeof data6 === "string") {
                    if (func2(data6) > 64) {
                        const err24 = { instancePath: instancePath + "/data/expiresAt", schemaPath: "#/properties/data/oneOf/0/properties/expiresAt/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err24];
                        }
                        else {
                            vErrors.push(err24);
                        }
                        errors++;
                    }
                    if (func2(data6) < 1) {
                        const err25 = { instancePath: instancePath + "/data/expiresAt", schemaPath: "#/properties/data/oneOf/0/properties/expiresAt/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err25];
                        }
                        else {
                            vErrors.push(err25);
                        }
                        errors++;
                    }
                }
                else {
                    const err26 = { instancePath: instancePath + "/data/expiresAt", schemaPath: "#/properties/data/oneOf/0/properties/expiresAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err26];
                    }
                    else {
                        vErrors.push(err26);
                    }
                    errors++;
                }
            }
            if (data0.accountId !== undefined) {
                let data7 = data0.accountId;
                if (typeof data7 === "string") {
                    if (!pattern0.test(data7)) {
                        const err27 = { instancePath: instancePath + "/data/accountId", schemaPath: "#/properties/data/oneOf/0/properties/accountId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err27];
                        }
                        else {
                            vErrors.push(err27);
                        }
                        errors++;
                    }
                }
                else {
                    const err28 = { instancePath: instancePath + "/data/accountId", schemaPath: "#/properties/data/oneOf/0/properties/accountId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err28];
                    }
                    else {
                        vErrors.push(err28);
                    }
                    errors++;
                }
            }
            if (data0.currency !== undefined) {
                let data8 = data0.currency;
                if (typeof data8 !== "string") {
                    const err29 = { instancePath: instancePath + "/data/currency", schemaPath: "#/properties/data/oneOf/0/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err29];
                    }
                    else {
                        vErrors.push(err29);
                    }
                    errors++;
                }
                if (!(((data8 === "BRL") || (data8 === "CAD")) || (data8 === "USD"))) {
                    const err30 = { instancePath: instancePath + "/data/currency", schemaPath: "#/properties/data/oneOf/0/properties/currency/enum", keyword: "enum", params: { allowedValues: schema32.properties.data.oneOf[0].properties.currency.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err30];
                    }
                    else {
                        vErrors.push(err30);
                    }
                    errors++;
                }
            }
            if (data0.occurrences !== undefined) {
                let data9 = data0.occurrences;
                if (Array.isArray(data9)) {
                    if (data9.length > 2000) {
                        const err31 = { instancePath: instancePath + "/data/occurrences", schemaPath: "#/properties/data/oneOf/0/properties/occurrences/maxItems", keyword: "maxItems", params: { limit: 2000 }, message: "must NOT have more than 2000 items" };
                        if (vErrors === null) {
                            vErrors = [err31];
                        }
                        else {
                            vErrors.push(err31);
                        }
                        errors++;
                    }
                    const len0 = data9.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                        let data10 = data9[i0];
                        if (data10 && typeof data10 == "object" && !Array.isArray(data10)) {
                            if (data10.ordinal === undefined) {
                                const err32 = { instancePath: instancePath + "/data/occurrences/" + i0, schemaPath: "#/properties/data/oneOf/0/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "ordinal" }, message: "must have required property '" + "ordinal" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err32];
                                }
                                else {
                                    vErrors.push(err32);
                                }
                                errors++;
                            }
                            if (data10.occurrenceDate === undefined) {
                                const err33 = { instancePath: instancePath + "/data/occurrences/" + i0, schemaPath: "#/properties/data/oneOf/0/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "occurrenceDate" }, message: "must have required property '" + "occurrenceDate" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err33];
                                }
                                else {
                                    vErrors.push(err33);
                                }
                                errors++;
                            }
                            if (data10.signedMinor === undefined) {
                                const err34 = { instancePath: instancePath + "/data/occurrences/" + i0, schemaPath: "#/properties/data/oneOf/0/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "signedMinor" }, message: "must have required property '" + "signedMinor" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err34];
                                }
                                else {
                                    vErrors.push(err34);
                                }
                                errors++;
                            }
                            if (data10.currency === undefined) {
                                const err35 = { instancePath: instancePath + "/data/occurrences/" + i0, schemaPath: "#/properties/data/oneOf/0/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err35];
                                }
                                else {
                                    vErrors.push(err35);
                                }
                                errors++;
                            }
                            for (const key2 in data10) {
                                if (!((((key2 === "ordinal") || (key2 === "occurrenceDate")) || (key2 === "signedMinor")) || (key2 === "currency"))) {
                                    const err36 = { instancePath: instancePath + "/data/occurrences/" + i0, schemaPath: "#/properties/data/oneOf/0/properties/occurrences/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                                    if (vErrors === null) {
                                        vErrors = [err36];
                                    }
                                    else {
                                        vErrors.push(err36);
                                    }
                                    errors++;
                                }
                            }
                            if (data10.ordinal !== undefined) {
                                let data11 = data10.ordinal;
                                if (!(((typeof data11 == "number") && (!(data11 % 1) && !isNaN(data11))) && (isFinite(data11)))) {
                                    const err37 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/ordinal", schemaPath: "#/properties/data/oneOf/0/properties/occurrences/items/properties/ordinal/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                    if (vErrors === null) {
                                        vErrors = [err37];
                                    }
                                    else {
                                        vErrors.push(err37);
                                    }
                                    errors++;
                                }
                                if ((typeof data11 == "number") && (isFinite(data11))) {
                                    if (data11 < 1 || isNaN(data11)) {
                                        const err38 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/ordinal", schemaPath: "#/properties/data/oneOf/0/properties/occurrences/items/properties/ordinal/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                                        if (vErrors === null) {
                                            vErrors = [err38];
                                        }
                                        else {
                                            vErrors.push(err38);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data10.occurrenceDate !== undefined) {
                                let data12 = data10.occurrenceDate;
                                if (typeof data12 === "string") {
                                    if (!pattern4.test(data12)) {
                                        const err39 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/occurrenceDate", schemaPath: "#/properties/data/oneOf/0/properties/occurrences/items/properties/occurrenceDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err39];
                                        }
                                        else {
                                            vErrors.push(err39);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err40 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/occurrenceDate", schemaPath: "#/properties/data/oneOf/0/properties/occurrences/items/properties/occurrenceDate/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err40];
                                    }
                                    else {
                                        vErrors.push(err40);
                                    }
                                    errors++;
                                }
                            }
                            if (data10.signedMinor !== undefined) {
                                let data13 = data10.signedMinor;
                                if (typeof data13 === "string") {
                                    if (!pattern3.test(data13)) {
                                        const err41 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/signedMinor", schemaPath: "#/properties/data/oneOf/0/properties/occurrences/items/properties/signedMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err41];
                                        }
                                        else {
                                            vErrors.push(err41);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err42 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/signedMinor", schemaPath: "#/properties/data/oneOf/0/properties/occurrences/items/properties/signedMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err42];
                                    }
                                    else {
                                        vErrors.push(err42);
                                    }
                                    errors++;
                                }
                            }
                            if (data10.currency !== undefined) {
                                let data14 = data10.currency;
                                if (typeof data14 !== "string") {
                                    const err43 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/currency", schemaPath: "#/properties/data/oneOf/0/properties/occurrences/items/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err43];
                                    }
                                    else {
                                        vErrors.push(err43);
                                    }
                                    errors++;
                                }
                                if (!(((data14 === "BRL") || (data14 === "CAD")) || (data14 === "USD"))) {
                                    const err44 = { instancePath: instancePath + "/data/occurrences/" + i0 + "/currency", schemaPath: "#/properties/data/oneOf/0/properties/occurrences/items/properties/currency/enum", keyword: "enum", params: { allowedValues: schema32.properties.data.oneOf[0].properties.occurrences.items.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err44];
                                    }
                                    else {
                                        vErrors.push(err44);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err45 = { instancePath: instancePath + "/data/occurrences/" + i0, schemaPath: "#/properties/data/oneOf/0/properties/occurrences/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                                vErrors = [err45];
                            }
                            else {
                                vErrors.push(err45);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err46 = { instancePath: instancePath + "/data/occurrences", schemaPath: "#/properties/data/oneOf/0/properties/occurrences/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err46];
                    }
                    else {
                        vErrors.push(err46);
                    }
                    errors++;
                }
            }
            if (data0.overlap !== undefined) {
                let data15 = data0.overlap;
                if (Array.isArray(data15)) {
                    if (data15.length > 2000) {
                        const err47 = { instancePath: instancePath + "/data/overlap", schemaPath: "#/properties/data/oneOf/0/properties/overlap/maxItems", keyword: "maxItems", params: { limit: 2000 }, message: "must NOT have more than 2000 items" };
                        if (vErrors === null) {
                            vErrors = [err47];
                        }
                        else {
                            vErrors.push(err47);
                        }
                        errors++;
                    }
                    const len1 = data15.length;
                    for (let i1 = 0; i1 < len1; i1++) {
                        let data16 = data15[i1];
                        if (data16 && typeof data16 == "object" && !Array.isArray(data16)) {
                            if (data16.occurrenceDate === undefined) {
                                const err48 = { instancePath: instancePath + "/data/overlap/" + i1, schemaPath: "#/properties/data/oneOf/0/properties/overlap/items/required", keyword: "required", params: { missingProperty: "occurrenceDate" }, message: "must have required property '" + "occurrenceDate" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err48];
                                }
                                else {
                                    vErrors.push(err48);
                                }
                                errors++;
                            }
                            if (data16.entryId === undefined) {
                                const err49 = { instancePath: instancePath + "/data/overlap/" + i1, schemaPath: "#/properties/data/oneOf/0/properties/overlap/items/required", keyword: "required", params: { missingProperty: "entryId" }, message: "must have required property '" + "entryId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err49];
                                }
                                else {
                                    vErrors.push(err49);
                                }
                                errors++;
                            }
                            if (data16.description === undefined) {
                                const err50 = { instancePath: instancePath + "/data/overlap/" + i1, schemaPath: "#/properties/data/oneOf/0/properties/overlap/items/required", keyword: "required", params: { missingProperty: "description" }, message: "must have required property '" + "description" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err50];
                                }
                                else {
                                    vErrors.push(err50);
                                }
                                errors++;
                            }
                            if (data16.signedMinor === undefined) {
                                const err51 = { instancePath: instancePath + "/data/overlap/" + i1, schemaPath: "#/properties/data/oneOf/0/properties/overlap/items/required", keyword: "required", params: { missingProperty: "signedMinor" }, message: "must have required property '" + "signedMinor" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err51];
                                }
                                else {
                                    vErrors.push(err51);
                                }
                                errors++;
                            }
                            if (data16.currency === undefined) {
                                const err52 = { instancePath: instancePath + "/data/overlap/" + i1, schemaPath: "#/properties/data/oneOf/0/properties/overlap/items/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err52];
                                }
                                else {
                                    vErrors.push(err52);
                                }
                                errors++;
                            }
                            if (data16.generated === undefined) {
                                const err53 = { instancePath: instancePath + "/data/overlap/" + i1, schemaPath: "#/properties/data/oneOf/0/properties/overlap/items/required", keyword: "required", params: { missingProperty: "generated" }, message: "must have required property '" + "generated" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err53];
                                }
                                else {
                                    vErrors.push(err53);
                                }
                                errors++;
                            }
                            for (const key3 in data16) {
                                if (!((((((key3 === "occurrenceDate") || (key3 === "entryId")) || (key3 === "description")) || (key3 === "signedMinor")) || (key3 === "currency")) || (key3 === "generated"))) {
                                    const err54 = { instancePath: instancePath + "/data/overlap/" + i1, schemaPath: "#/properties/data/oneOf/0/properties/overlap/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                                    if (vErrors === null) {
                                        vErrors = [err54];
                                    }
                                    else {
                                        vErrors.push(err54);
                                    }
                                    errors++;
                                }
                            }
                            if (data16.occurrenceDate !== undefined) {
                                let data17 = data16.occurrenceDate;
                                if (typeof data17 === "string") {
                                    if (!pattern4.test(data17)) {
                                        const err55 = { instancePath: instancePath + "/data/overlap/" + i1 + "/occurrenceDate", schemaPath: "#/properties/data/oneOf/0/properties/overlap/items/properties/occurrenceDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err55];
                                        }
                                        else {
                                            vErrors.push(err55);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err56 = { instancePath: instancePath + "/data/overlap/" + i1 + "/occurrenceDate", schemaPath: "#/properties/data/oneOf/0/properties/overlap/items/properties/occurrenceDate/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err56];
                                    }
                                    else {
                                        vErrors.push(err56);
                                    }
                                    errors++;
                                }
                            }
                            if (data16.entryId !== undefined) {
                                let data18 = data16.entryId;
                                if (typeof data18 === "string") {
                                    if (!pattern0.test(data18)) {
                                        const err57 = { instancePath: instancePath + "/data/overlap/" + i1 + "/entryId", schemaPath: "#/properties/data/oneOf/0/properties/overlap/items/properties/entryId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err57];
                                        }
                                        else {
                                            vErrors.push(err57);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err58 = { instancePath: instancePath + "/data/overlap/" + i1 + "/entryId", schemaPath: "#/properties/data/oneOf/0/properties/overlap/items/properties/entryId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err58];
                                    }
                                    else {
                                        vErrors.push(err58);
                                    }
                                    errors++;
                                }
                            }
                            if (data16.description !== undefined) {
                                let data19 = data16.description;
                                if (typeof data19 === "string") {
                                    if (func2(data19) > 500) {
                                        const err59 = { instancePath: instancePath + "/data/overlap/" + i1 + "/description", schemaPath: "#/properties/data/oneOf/0/properties/overlap/items/properties/description/maxLength", keyword: "maxLength", params: { limit: 500 }, message: "must NOT have more than 500 characters" };
                                        if (vErrors === null) {
                                            vErrors = [err59];
                                        }
                                        else {
                                            vErrors.push(err59);
                                        }
                                        errors++;
                                    }
                                    if (func2(data19) < 1) {
                                        const err60 = { instancePath: instancePath + "/data/overlap/" + i1 + "/description", schemaPath: "#/properties/data/oneOf/0/properties/overlap/items/properties/description/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                        if (vErrors === null) {
                                            vErrors = [err60];
                                        }
                                        else {
                                            vErrors.push(err60);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err61 = { instancePath: instancePath + "/data/overlap/" + i1 + "/description", schemaPath: "#/properties/data/oneOf/0/properties/overlap/items/properties/description/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err61];
                                    }
                                    else {
                                        vErrors.push(err61);
                                    }
                                    errors++;
                                }
                            }
                            if (data16.signedMinor !== undefined) {
                                let data20 = data16.signedMinor;
                                if (typeof data20 === "string") {
                                    if (!pattern3.test(data20)) {
                                        const err62 = { instancePath: instancePath + "/data/overlap/" + i1 + "/signedMinor", schemaPath: "#/properties/data/oneOf/0/properties/overlap/items/properties/signedMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err62];
                                        }
                                        else {
                                            vErrors.push(err62);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err63 = { instancePath: instancePath + "/data/overlap/" + i1 + "/signedMinor", schemaPath: "#/properties/data/oneOf/0/properties/overlap/items/properties/signedMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err63];
                                    }
                                    else {
                                        vErrors.push(err63);
                                    }
                                    errors++;
                                }
                            }
                            if (data16.currency !== undefined) {
                                let data21 = data16.currency;
                                if (typeof data21 !== "string") {
                                    const err64 = { instancePath: instancePath + "/data/overlap/" + i1 + "/currency", schemaPath: "#/properties/data/oneOf/0/properties/overlap/items/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err64];
                                    }
                                    else {
                                        vErrors.push(err64);
                                    }
                                    errors++;
                                }
                                if (!(((data21 === "BRL") || (data21 === "CAD")) || (data21 === "USD"))) {
                                    const err65 = { instancePath: instancePath + "/data/overlap/" + i1 + "/currency", schemaPath: "#/properties/data/oneOf/0/properties/overlap/items/properties/currency/enum", keyword: "enum", params: { allowedValues: schema32.properties.data.oneOf[0].properties.overlap.items.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err65];
                                    }
                                    else {
                                        vErrors.push(err65);
                                    }
                                    errors++;
                                }
                            }
                            if (data16.generated !== undefined) {
                                if (typeof data16.generated !== "boolean") {
                                    const err66 = { instancePath: instancePath + "/data/overlap/" + i1 + "/generated", schemaPath: "#/properties/data/oneOf/0/properties/overlap/items/properties/generated/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                                    if (vErrors === null) {
                                        vErrors = [err66];
                                    }
                                    else {
                                        vErrors.push(err66);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err67 = { instancePath: instancePath + "/data/overlap/" + i1, schemaPath: "#/properties/data/oneOf/0/properties/overlap/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                                vErrors = [err67];
                            }
                            else {
                                vErrors.push(err67);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err68 = { instancePath: instancePath + "/data/overlap", schemaPath: "#/properties/data/oneOf/0/properties/overlap/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err68];
                    }
                    else {
                        vErrors.push(err68);
                    }
                    errors++;
                }
            }
            if (data0.note !== undefined) {
                let data23 = data0.note;
                if (typeof data23 === "string") {
                    if (func2(data23) > 600) {
                        const err69 = { instancePath: instancePath + "/data/note", schemaPath: "#/properties/data/oneOf/0/properties/note/maxLength", keyword: "maxLength", params: { limit: 600 }, message: "must NOT have more than 600 characters" };
                        if (vErrors === null) {
                            vErrors = [err69];
                        }
                        else {
                            vErrors.push(err69);
                        }
                        errors++;
                    }
                    if (func2(data23) < 1) {
                        const err70 = { instancePath: instancePath + "/data/note", schemaPath: "#/properties/data/oneOf/0/properties/note/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err70];
                        }
                        else {
                            vErrors.push(err70);
                        }
                        errors++;
                    }
                }
                else {
                    const err71 = { instancePath: instancePath + "/data/note", schemaPath: "#/properties/data/oneOf/0/properties/note/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err71];
                    }
                    else {
                        vErrors.push(err71);
                    }
                    errors++;
                }
            }
            if (data0.requiresConfirmation !== undefined) {
                if (typeof data0.requiresConfirmation !== "boolean") {
                    const err72 = { instancePath: instancePath + "/data/requiresConfirmation", schemaPath: "#/properties/data/oneOf/0/properties/requiresConfirmation/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean" };
                    if (vErrors === null) {
                        vErrors = [err72];
                    }
                    else {
                        vErrors.push(err72);
                    }
                    errors++;
                }
            }
        }
        else {
            const err73 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/0/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err73];
            }
            else {
                vErrors.push(err73);
            }
            errors++;
        }
        var _valid0 = _errs4 === errors;
        if (_valid0) {
            valid1 = true;
            passing0 = 0;
        }
        const _errs57 = errors;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.id === undefined) {
                const err74 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/1/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property '" + "id" + "'" };
                if (vErrors === null) {
                    vErrors = [err74];
                }
                else {
                    vErrors.push(err74);
                }
                errors++;
            }
            if (data0.action === undefined) {
                const err75 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/1/required", keyword: "required", params: { missingProperty: "action" }, message: "must have required property '" + "action" + "'" };
                if (vErrors === null) {
                    vErrors = [err75];
                }
                else {
                    vErrors.push(err75);
                }
                errors++;
            }
            if (data0.templateId === undefined) {
                const err76 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/1/required", keyword: "required", params: { missingProperty: "templateId" }, message: "must have required property '" + "templateId" + "'" };
                if (vErrors === null) {
                    vErrors = [err76];
                }
                else {
                    vErrors.push(err76);
                }
                errors++;
            }
            if (data0.revision === undefined) {
                const err77 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/1/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property '" + "revision" + "'" };
                if (vErrors === null) {
                    vErrors = [err77];
                }
                else {
                    vErrors.push(err77);
                }
                errors++;
            }
            if (data0.businessToday === undefined) {
                const err78 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/1/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err78];
                }
                else {
                    vErrors.push(err78);
                }
                errors++;
            }
            if (data0.expiresAt === undefined) {
                const err79 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/1/required", keyword: "required", params: { missingProperty: "expiresAt" }, message: "must have required property '" + "expiresAt" + "'" };
                if (vErrors === null) {
                    vErrors = [err79];
                }
                else {
                    vErrors.push(err79);
                }
                errors++;
            }
            if (data0.mode === undefined) {
                const err80 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/1/required", keyword: "required", params: { missingProperty: "mode" }, message: "must have required property '" + "mode" + "'" };
                if (vErrors === null) {
                    vErrors = [err80];
                }
                else {
                    vErrors.push(err80);
                }
                errors++;
            }
            if (data0.occurrences === undefined) {
                const err81 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/1/required", keyword: "required", params: { missingProperty: "occurrences" }, message: "must have required property '" + "occurrences" + "'" };
                if (vErrors === null) {
                    vErrors = [err81];
                }
                else {
                    vErrors.push(err81);
                }
                errors++;
            }
            if (data0.cancellableEntryIds === undefined) {
                const err82 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/1/required", keyword: "required", params: { missingProperty: "cancellableEntryIds" }, message: "must have required property '" + "cancellableEntryIds" + "'" };
                if (vErrors === null) {
                    vErrors = [err82];
                }
                else {
                    vErrors.push(err82);
                }
                errors++;
            }
            if (data0.editedExceptionEntryIds === undefined) {
                const err83 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/1/required", keyword: "required", params: { missingProperty: "editedExceptionEntryIds" }, message: "must have required property '" + "editedExceptionEntryIds" + "'" };
                if (vErrors === null) {
                    vErrors = [err83];
                }
                else {
                    vErrors.push(err83);
                }
                errors++;
            }
            if (data0.excluded === undefined) {
                const err84 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/1/required", keyword: "required", params: { missingProperty: "excluded" }, message: "must have required property '" + "excluded" + "'" };
                if (vErrors === null) {
                    vErrors = [err84];
                }
                else {
                    vErrors.push(err84);
                }
                errors++;
            }
            if (data0.selectedEntryIds === undefined) {
                const err85 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/1/required", keyword: "required", params: { missingProperty: "selectedEntryIds" }, message: "must have required property '" + "selectedEntryIds" + "'" };
                if (vErrors === null) {
                    vErrors = [err85];
                }
                else {
                    vErrors.push(err85);
                }
                errors++;
            }
            if (data0.cancelledEntryIds === undefined) {
                const err86 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/1/required", keyword: "required", params: { missingProperty: "cancelledEntryIds" }, message: "must have required property '" + "cancelledEntryIds" + "'" };
                if (vErrors === null) {
                    vErrors = [err86];
                }
                else {
                    vErrors.push(err86);
                }
                errors++;
            }
            for (const key4 in data0) {
                if (!(func35.call(schema32.properties.data.oneOf[1].properties, key4))) {
                    const err87 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/1/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key4 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err87];
                    }
                    else {
                        vErrors.push(err87);
                    }
                    errors++;
                }
            }
            if (data0.id !== undefined) {
                let data25 = data0.id;
                if (typeof data25 === "string") {
                    if (!pattern0.test(data25)) {
                        const err88 = { instancePath: instancePath + "/data/id", schemaPath: "#/properties/data/oneOf/1/properties/id/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err88];
                        }
                        else {
                            vErrors.push(err88);
                        }
                        errors++;
                    }
                }
                else {
                    const err89 = { instancePath: instancePath + "/data/id", schemaPath: "#/properties/data/oneOf/1/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err89];
                    }
                    else {
                        vErrors.push(err89);
                    }
                    errors++;
                }
            }
            if (data0.action !== undefined) {
                let data26 = data0.action;
                if (typeof data26 !== "string") {
                    const err90 = { instancePath: instancePath + "/data/action", schemaPath: "#/properties/data/oneOf/1/properties/action/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err90];
                    }
                    else {
                        vErrors.push(err90);
                    }
                    errors++;
                }
                if (!(data26 === "recurrence.stop")) {
                    const err91 = { instancePath: instancePath + "/data/action", schemaPath: "#/properties/data/oneOf/1/properties/action/enum", keyword: "enum", params: { allowedValues: schema32.properties.data.oneOf[1].properties.action.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err91];
                    }
                    else {
                        vErrors.push(err91);
                    }
                    errors++;
                }
            }
            if (data0.templateId !== undefined) {
                let data27 = data0.templateId;
                if (typeof data27 === "string") {
                    if (!pattern0.test(data27)) {
                        const err92 = { instancePath: instancePath + "/data/templateId", schemaPath: "#/properties/data/oneOf/1/properties/templateId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err92];
                        }
                        else {
                            vErrors.push(err92);
                        }
                        errors++;
                    }
                }
                else {
                    const err93 = { instancePath: instancePath + "/data/templateId", schemaPath: "#/properties/data/oneOf/1/properties/templateId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err93];
                    }
                    else {
                        vErrors.push(err93);
                    }
                    errors++;
                }
            }
            if (data0.revision !== undefined) {
                let data28 = data0.revision;
                if (typeof data28 === "string") {
                    if (!pattern2.test(data28)) {
                        const err94 = { instancePath: instancePath + "/data/revision", schemaPath: "#/properties/data/oneOf/1/properties/revision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err94];
                        }
                        else {
                            vErrors.push(err94);
                        }
                        errors++;
                    }
                }
                else {
                    const err95 = { instancePath: instancePath + "/data/revision", schemaPath: "#/properties/data/oneOf/1/properties/revision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err95];
                    }
                    else {
                        vErrors.push(err95);
                    }
                    errors++;
                }
            }
            if (data0.businessToday !== undefined) {
                let data29 = data0.businessToday;
                if (typeof data29 === "string") {
                    if (!pattern4.test(data29)) {
                        const err96 = { instancePath: instancePath + "/data/businessToday", schemaPath: "#/properties/data/oneOf/1/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err96];
                        }
                        else {
                            vErrors.push(err96);
                        }
                        errors++;
                    }
                }
                else {
                    const err97 = { instancePath: instancePath + "/data/businessToday", schemaPath: "#/properties/data/oneOf/1/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err97];
                    }
                    else {
                        vErrors.push(err97);
                    }
                    errors++;
                }
            }
            if (data0.expiresAt !== undefined) {
                let data30 = data0.expiresAt;
                if (typeof data30 === "string") {
                    if (func2(data30) > 64) {
                        const err98 = { instancePath: instancePath + "/data/expiresAt", schemaPath: "#/properties/data/oneOf/1/properties/expiresAt/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err98];
                        }
                        else {
                            vErrors.push(err98);
                        }
                        errors++;
                    }
                    if (func2(data30) < 1) {
                        const err99 = { instancePath: instancePath + "/data/expiresAt", schemaPath: "#/properties/data/oneOf/1/properties/expiresAt/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err99];
                        }
                        else {
                            vErrors.push(err99);
                        }
                        errors++;
                    }
                }
                else {
                    const err100 = { instancePath: instancePath + "/data/expiresAt", schemaPath: "#/properties/data/oneOf/1/properties/expiresAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err100];
                    }
                    else {
                        vErrors.push(err100);
                    }
                    errors++;
                }
            }
            if (data0.mode !== undefined) {
                let data31 = data0.mode;
                if (typeof data31 !== "string") {
                    const err101 = { instancePath: instancePath + "/data/mode", schemaPath: "#/properties/data/oneOf/1/properties/mode/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err101];
                    }
                    else {
                        vErrors.push(err101);
                    }
                    errors++;
                }
                if (!((data31 === "stop-and-cancel") || (data31 === "stop-only"))) {
                    const err102 = { instancePath: instancePath + "/data/mode", schemaPath: "#/properties/data/oneOf/1/properties/mode/enum", keyword: "enum", params: { allowedValues: schema32.properties.data.oneOf[1].properties.mode.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err102];
                    }
                    else {
                        vErrors.push(err102);
                    }
                    errors++;
                }
            }
            if (data0.occurrences !== undefined) {
                let data32 = data0.occurrences;
                if (Array.isArray(data32)) {
                    if (data32.length > 2000) {
                        const err103 = { instancePath: instancePath + "/data/occurrences", schemaPath: "#/properties/data/oneOf/1/properties/occurrences/maxItems", keyword: "maxItems", params: { limit: 2000 }, message: "must NOT have more than 2000 items" };
                        if (vErrors === null) {
                            vErrors = [err103];
                        }
                        else {
                            vErrors.push(err103);
                        }
                        errors++;
                    }
                    const len2 = data32.length;
                    for (let i2 = 0; i2 < len2; i2++) {
                        let data33 = data32[i2];
                        if (data33 && typeof data33 == "object" && !Array.isArray(data33)) {
                            if (data33.ordinal === undefined) {
                                const err104 = { instancePath: instancePath + "/data/occurrences/" + i2, schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "ordinal" }, message: "must have required property '" + "ordinal" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err104];
                                }
                                else {
                                    vErrors.push(err104);
                                }
                                errors++;
                            }
                            if (data33.occurrenceDate === undefined) {
                                const err105 = { instancePath: instancePath + "/data/occurrences/" + i2, schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "occurrenceDate" }, message: "must have required property '" + "occurrenceDate" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err105];
                                }
                                else {
                                    vErrors.push(err105);
                                }
                                errors++;
                            }
                            if (data33.entryId === undefined) {
                                const err106 = { instancePath: instancePath + "/data/occurrences/" + i2, schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "entryId" }, message: "must have required property '" + "entryId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err106];
                                }
                                else {
                                    vErrors.push(err106);
                                }
                                errors++;
                            }
                            if (data33.disposition === undefined) {
                                const err107 = { instancePath: instancePath + "/data/occurrences/" + i2, schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "disposition" }, message: "must have required property '" + "disposition" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err107];
                                }
                                else {
                                    vErrors.push(err107);
                                }
                                errors++;
                            }
                            if (data33.editedFields === undefined) {
                                const err108 = { instancePath: instancePath + "/data/occurrences/" + i2, schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "editedFields" }, message: "must have required property '" + "editedFields" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err108];
                                }
                                else {
                                    vErrors.push(err108);
                                }
                                errors++;
                            }
                            if (data33.accountId === undefined) {
                                const err109 = { instancePath: instancePath + "/data/occurrences/" + i2, schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "accountId" }, message: "must have required property '" + "accountId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err109];
                                }
                                else {
                                    vErrors.push(err109);
                                }
                                errors++;
                            }
                            if (data33.signedMinor === undefined) {
                                const err110 = { instancePath: instancePath + "/data/occurrences/" + i2, schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "signedMinor" }, message: "must have required property '" + "signedMinor" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err110];
                                }
                                else {
                                    vErrors.push(err110);
                                }
                                errors++;
                            }
                            if (data33.description === undefined) {
                                const err111 = { instancePath: instancePath + "/data/occurrences/" + i2, schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "description" }, message: "must have required property '" + "description" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err111];
                                }
                                else {
                                    vErrors.push(err111);
                                }
                                errors++;
                            }
                            if (data33.dueDate === undefined) {
                                const err112 = { instancePath: instancePath + "/data/occurrences/" + i2, schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "dueDate" }, message: "must have required property '" + "dueDate" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err112];
                                }
                                else {
                                    vErrors.push(err112);
                                }
                                errors++;
                            }
                            if (data33.paid === undefined) {
                                const err113 = { instancePath: instancePath + "/data/occurrences/" + i2, schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "paid" }, message: "must have required property '" + "paid" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err113];
                                }
                                else {
                                    vErrors.push(err113);
                                }
                                errors++;
                            }
                            if (data33.revision === undefined) {
                                const err114 = { instancePath: instancePath + "/data/occurrences/" + i2, schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property '" + "revision" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err114];
                                }
                                else {
                                    vErrors.push(err114);
                                }
                                errors++;
                            }
                            for (const key5 in data33) {
                                if (!(func35.call(schema32.properties.data.oneOf[1].properties.occurrences.items.properties, key5))) {
                                    const err115 = { instancePath: instancePath + "/data/occurrences/" + i2, schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key5 }, message: "must NOT have additional properties" };
                                    if (vErrors === null) {
                                        vErrors = [err115];
                                    }
                                    else {
                                        vErrors.push(err115);
                                    }
                                    errors++;
                                }
                            }
                            if (data33.ordinal !== undefined) {
                                let data34 = data33.ordinal;
                                if (!(((typeof data34 == "number") && (!(data34 % 1) && !isNaN(data34))) && (isFinite(data34)))) {
                                    const err116 = { instancePath: instancePath + "/data/occurrences/" + i2 + "/ordinal", schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/properties/ordinal/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                    if (vErrors === null) {
                                        vErrors = [err116];
                                    }
                                    else {
                                        vErrors.push(err116);
                                    }
                                    errors++;
                                }
                                if ((typeof data34 == "number") && (isFinite(data34))) {
                                    if (data34 < 1 || isNaN(data34)) {
                                        const err117 = { instancePath: instancePath + "/data/occurrences/" + i2 + "/ordinal", schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/properties/ordinal/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                                        if (vErrors === null) {
                                            vErrors = [err117];
                                        }
                                        else {
                                            vErrors.push(err117);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data33.occurrenceDate !== undefined) {
                                let data35 = data33.occurrenceDate;
                                if (typeof data35 === "string") {
                                    if (!pattern4.test(data35)) {
                                        const err118 = { instancePath: instancePath + "/data/occurrences/" + i2 + "/occurrenceDate", schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/properties/occurrenceDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err118];
                                        }
                                        else {
                                            vErrors.push(err118);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err119 = { instancePath: instancePath + "/data/occurrences/" + i2 + "/occurrenceDate", schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/properties/occurrenceDate/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err119];
                                    }
                                    else {
                                        vErrors.push(err119);
                                    }
                                    errors++;
                                }
                            }
                            if (data33.entryId !== undefined) {
                                let data36 = data33.entryId;
                                if ((typeof data36 !== "string") && (data36 !== null)) {
                                    const err120 = { instancePath: instancePath + "/data/occurrences/" + i2 + "/entryId", schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/properties/entryId/type", keyword: "type", params: { type: schema32.properties.data.oneOf[1].properties.occurrences.items.properties.entryId.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err120];
                                    }
                                    else {
                                        vErrors.push(err120);
                                    }
                                    errors++;
                                }
                                if (typeof data36 === "string") {
                                    if (!pattern0.test(data36)) {
                                        const err121 = { instancePath: instancePath + "/data/occurrences/" + i2 + "/entryId", schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/properties/entryId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err121];
                                        }
                                        else {
                                            vErrors.push(err121);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data33.disposition !== undefined) {
                                let data37 = data33.disposition;
                                if (typeof data37 !== "string") {
                                    const err122 = { instancePath: instancePath + "/data/occurrences/" + i2 + "/disposition", schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/properties/disposition/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err122];
                                    }
                                    else {
                                        vErrors.push(err122);
                                    }
                                    errors++;
                                }
                                if (!(((((((data37 === "eligible-forward") || (data37 === "edited-exception")) || (data37 === "paid")) || (data37 === "effective")) || (data37 === "overdue")) || (data37 === "canceled")) || (data37 === "deleted"))) {
                                    const err123 = { instancePath: instancePath + "/data/occurrences/" + i2 + "/disposition", schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/properties/disposition/enum", keyword: "enum", params: { allowedValues: schema32.properties.data.oneOf[1].properties.occurrences.items.properties.disposition.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err123];
                                    }
                                    else {
                                        vErrors.push(err123);
                                    }
                                    errors++;
                                }
                            }
                            if (data33.editedFields !== undefined) {
                                let data38 = data33.editedFields;
                                if (Array.isArray(data38)) {
                                    if (data38.length > 6) {
                                        const err124 = { instancePath: instancePath + "/data/occurrences/" + i2 + "/editedFields", schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/properties/editedFields/maxItems", keyword: "maxItems", params: { limit: 6 }, message: "must NOT have more than 6 items" };
                                        if (vErrors === null) {
                                            vErrors = [err124];
                                        }
                                        else {
                                            vErrors.push(err124);
                                        }
                                        errors++;
                                    }
                                    const len3 = data38.length;
                                    for (let i3 = 0; i3 < len3; i3++) {
                                        let data39 = data38[i3];
                                        if (typeof data39 !== "string") {
                                            const err125 = { instancePath: instancePath + "/data/occurrences/" + i2 + "/editedFields/" + i3, schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/properties/editedFields/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                            if (vErrors === null) {
                                                vErrors = [err125];
                                            }
                                            else {
                                                vErrors.push(err125);
                                            }
                                            errors++;
                                        }
                                        if (!((((((data39 === "amount") || (data39 === "description")) || (data39 === "category")) || (data39 === "account")) || (data39 === "dueDate")) || (data39 === "transactionDate"))) {
                                            const err126 = { instancePath: instancePath + "/data/occurrences/" + i2 + "/editedFields/" + i3, schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/properties/editedFields/items/enum", keyword: "enum", params: { allowedValues: schema32.properties.data.oneOf[1].properties.occurrences.items.properties.editedFields.items.enum }, message: "must be equal to one of the allowed values" };
                                            if (vErrors === null) {
                                                vErrors = [err126];
                                            }
                                            else {
                                                vErrors.push(err126);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                                else {
                                    const err127 = { instancePath: instancePath + "/data/occurrences/" + i2 + "/editedFields", schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/properties/editedFields/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                                    if (vErrors === null) {
                                        vErrors = [err127];
                                    }
                                    else {
                                        vErrors.push(err127);
                                    }
                                    errors++;
                                }
                            }
                            if (data33.accountId !== undefined) {
                                let data40 = data33.accountId;
                                if ((typeof data40 !== "string") && (data40 !== null)) {
                                    const err128 = { instancePath: instancePath + "/data/occurrences/" + i2 + "/accountId", schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/properties/accountId/type", keyword: "type", params: { type: schema32.properties.data.oneOf[1].properties.occurrences.items.properties.accountId.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err128];
                                    }
                                    else {
                                        vErrors.push(err128);
                                    }
                                    errors++;
                                }
                                if (typeof data40 === "string") {
                                    if (!pattern0.test(data40)) {
                                        const err129 = { instancePath: instancePath + "/data/occurrences/" + i2 + "/accountId", schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/properties/accountId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err129];
                                        }
                                        else {
                                            vErrors.push(err129);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data33.signedMinor !== undefined) {
                                let data41 = data33.signedMinor;
                                if ((typeof data41 !== "string") && (data41 !== null)) {
                                    const err130 = { instancePath: instancePath + "/data/occurrences/" + i2 + "/signedMinor", schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/properties/signedMinor/type", keyword: "type", params: { type: schema32.properties.data.oneOf[1].properties.occurrences.items.properties.signedMinor.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err130];
                                    }
                                    else {
                                        vErrors.push(err130);
                                    }
                                    errors++;
                                }
                                if (typeof data41 === "string") {
                                    if (!pattern3.test(data41)) {
                                        const err131 = { instancePath: instancePath + "/data/occurrences/" + i2 + "/signedMinor", schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/properties/signedMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err131];
                                        }
                                        else {
                                            vErrors.push(err131);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data33.description !== undefined) {
                                let data42 = data33.description;
                                if ((typeof data42 !== "string") && (data42 !== null)) {
                                    const err132 = { instancePath: instancePath + "/data/occurrences/" + i2 + "/description", schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/properties/description/type", keyword: "type", params: { type: schema32.properties.data.oneOf[1].properties.occurrences.items.properties.description.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err132];
                                    }
                                    else {
                                        vErrors.push(err132);
                                    }
                                    errors++;
                                }
                                if (typeof data42 === "string") {
                                    if (func2(data42) > 500) {
                                        const err133 = { instancePath: instancePath + "/data/occurrences/" + i2 + "/description", schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/properties/description/maxLength", keyword: "maxLength", params: { limit: 500 }, message: "must NOT have more than 500 characters" };
                                        if (vErrors === null) {
                                            vErrors = [err133];
                                        }
                                        else {
                                            vErrors.push(err133);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data33.dueDate !== undefined) {
                                let data43 = data33.dueDate;
                                if ((typeof data43 !== "string") && (data43 !== null)) {
                                    const err134 = { instancePath: instancePath + "/data/occurrences/" + i2 + "/dueDate", schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/properties/dueDate/type", keyword: "type", params: { type: schema32.properties.data.oneOf[1].properties.occurrences.items.properties.dueDate.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err134];
                                    }
                                    else {
                                        vErrors.push(err134);
                                    }
                                    errors++;
                                }
                                if (typeof data43 === "string") {
                                    if (!pattern4.test(data43)) {
                                        const err135 = { instancePath: instancePath + "/data/occurrences/" + i2 + "/dueDate", schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/properties/dueDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err135];
                                        }
                                        else {
                                            vErrors.push(err135);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data33.paid !== undefined) {
                                let data44 = data33.paid;
                                if ((typeof data44 !== "boolean") && (data44 !== null)) {
                                    const err136 = { instancePath: instancePath + "/data/occurrences/" + i2 + "/paid", schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/properties/paid/type", keyword: "type", params: { type: schema32.properties.data.oneOf[1].properties.occurrences.items.properties.paid.type }, message: "must be boolean,null" };
                                    if (vErrors === null) {
                                        vErrors = [err136];
                                    }
                                    else {
                                        vErrors.push(err136);
                                    }
                                    errors++;
                                }
                            }
                            if (data33.revision !== undefined) {
                                let data45 = data33.revision;
                                if ((typeof data45 !== "string") && (data45 !== null)) {
                                    const err137 = { instancePath: instancePath + "/data/occurrences/" + i2 + "/revision", schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/properties/revision/type", keyword: "type", params: { type: schema32.properties.data.oneOf[1].properties.occurrences.items.properties.revision.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err137];
                                    }
                                    else {
                                        vErrors.push(err137);
                                    }
                                    errors++;
                                }
                                if (typeof data45 === "string") {
                                    if (!pattern2.test(data45)) {
                                        const err138 = { instancePath: instancePath + "/data/occurrences/" + i2 + "/revision", schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/properties/revision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err138];
                                        }
                                        else {
                                            vErrors.push(err138);
                                        }
                                        errors++;
                                    }
                                }
                            }
                        }
                        else {
                            const err139 = { instancePath: instancePath + "/data/occurrences/" + i2, schemaPath: "#/properties/data/oneOf/1/properties/occurrences/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                                vErrors = [err139];
                            }
                            else {
                                vErrors.push(err139);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err140 = { instancePath: instancePath + "/data/occurrences", schemaPath: "#/properties/data/oneOf/1/properties/occurrences/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err140];
                    }
                    else {
                        vErrors.push(err140);
                    }
                    errors++;
                }
            }
            if (data0.cancellableEntryIds !== undefined) {
                let data46 = data0.cancellableEntryIds;
                if (Array.isArray(data46)) {
                    if (data46.length > 2000) {
                        const err141 = { instancePath: instancePath + "/data/cancellableEntryIds", schemaPath: "#/properties/data/oneOf/1/properties/cancellableEntryIds/maxItems", keyword: "maxItems", params: { limit: 2000 }, message: "must NOT have more than 2000 items" };
                        if (vErrors === null) {
                            vErrors = [err141];
                        }
                        else {
                            vErrors.push(err141);
                        }
                        errors++;
                    }
                    const len4 = data46.length;
                    for (let i4 = 0; i4 < len4; i4++) {
                        let data47 = data46[i4];
                        if (typeof data47 === "string") {
                            if (!pattern0.test(data47)) {
                                const err142 = { instancePath: instancePath + "/data/cancellableEntryIds/" + i4, schemaPath: "#/properties/data/oneOf/1/properties/cancellableEntryIds/items/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err142];
                                }
                                else {
                                    vErrors.push(err142);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err143 = { instancePath: instancePath + "/data/cancellableEntryIds/" + i4, schemaPath: "#/properties/data/oneOf/1/properties/cancellableEntryIds/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err143];
                            }
                            else {
                                vErrors.push(err143);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err144 = { instancePath: instancePath + "/data/cancellableEntryIds", schemaPath: "#/properties/data/oneOf/1/properties/cancellableEntryIds/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err144];
                    }
                    else {
                        vErrors.push(err144);
                    }
                    errors++;
                }
            }
            if (data0.editedExceptionEntryIds !== undefined) {
                let data48 = data0.editedExceptionEntryIds;
                if (Array.isArray(data48)) {
                    if (data48.length > 2000) {
                        const err145 = { instancePath: instancePath + "/data/editedExceptionEntryIds", schemaPath: "#/properties/data/oneOf/1/properties/editedExceptionEntryIds/maxItems", keyword: "maxItems", params: { limit: 2000 }, message: "must NOT have more than 2000 items" };
                        if (vErrors === null) {
                            vErrors = [err145];
                        }
                        else {
                            vErrors.push(err145);
                        }
                        errors++;
                    }
                    const len5 = data48.length;
                    for (let i5 = 0; i5 < len5; i5++) {
                        let data49 = data48[i5];
                        if (typeof data49 === "string") {
                            if (!pattern0.test(data49)) {
                                const err146 = { instancePath: instancePath + "/data/editedExceptionEntryIds/" + i5, schemaPath: "#/properties/data/oneOf/1/properties/editedExceptionEntryIds/items/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err146];
                                }
                                else {
                                    vErrors.push(err146);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err147 = { instancePath: instancePath + "/data/editedExceptionEntryIds/" + i5, schemaPath: "#/properties/data/oneOf/1/properties/editedExceptionEntryIds/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err147];
                            }
                            else {
                                vErrors.push(err147);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err148 = { instancePath: instancePath + "/data/editedExceptionEntryIds", schemaPath: "#/properties/data/oneOf/1/properties/editedExceptionEntryIds/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err148];
                    }
                    else {
                        vErrors.push(err148);
                    }
                    errors++;
                }
            }
            if (data0.excluded !== undefined) {
                let data50 = data0.excluded;
                if (Array.isArray(data50)) {
                    if (data50.length > 2000) {
                        const err149 = { instancePath: instancePath + "/data/excluded", schemaPath: "#/properties/data/oneOf/1/properties/excluded/maxItems", keyword: "maxItems", params: { limit: 2000 }, message: "must NOT have more than 2000 items" };
                        if (vErrors === null) {
                            vErrors = [err149];
                        }
                        else {
                            vErrors.push(err149);
                        }
                        errors++;
                    }
                    const len6 = data50.length;
                    for (let i6 = 0; i6 < len6; i6++) {
                        let data51 = data50[i6];
                        if (data51 && typeof data51 == "object" && !Array.isArray(data51)) {
                            if (data51.ordinal === undefined) {
                                const err150 = { instancePath: instancePath + "/data/excluded/" + i6, schemaPath: "#/properties/data/oneOf/1/properties/excluded/items/required", keyword: "required", params: { missingProperty: "ordinal" }, message: "must have required property '" + "ordinal" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err150];
                                }
                                else {
                                    vErrors.push(err150);
                                }
                                errors++;
                            }
                            if (data51.entryId === undefined) {
                                const err151 = { instancePath: instancePath + "/data/excluded/" + i6, schemaPath: "#/properties/data/oneOf/1/properties/excluded/items/required", keyword: "required", params: { missingProperty: "entryId" }, message: "must have required property '" + "entryId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err151];
                                }
                                else {
                                    vErrors.push(err151);
                                }
                                errors++;
                            }
                            if (data51.reason === undefined) {
                                const err152 = { instancePath: instancePath + "/data/excluded/" + i6, schemaPath: "#/properties/data/oneOf/1/properties/excluded/items/required", keyword: "required", params: { missingProperty: "reason" }, message: "must have required property '" + "reason" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err152];
                                }
                                else {
                                    vErrors.push(err152);
                                }
                                errors++;
                            }
                            for (const key6 in data51) {
                                if (!(((key6 === "ordinal") || (key6 === "entryId")) || (key6 === "reason"))) {
                                    const err153 = { instancePath: instancePath + "/data/excluded/" + i6, schemaPath: "#/properties/data/oneOf/1/properties/excluded/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key6 }, message: "must NOT have additional properties" };
                                    if (vErrors === null) {
                                        vErrors = [err153];
                                    }
                                    else {
                                        vErrors.push(err153);
                                    }
                                    errors++;
                                }
                            }
                            if (data51.ordinal !== undefined) {
                                let data52 = data51.ordinal;
                                if (!(((typeof data52 == "number") && (!(data52 % 1) && !isNaN(data52))) && (isFinite(data52)))) {
                                    const err154 = { instancePath: instancePath + "/data/excluded/" + i6 + "/ordinal", schemaPath: "#/properties/data/oneOf/1/properties/excluded/items/properties/ordinal/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                                    if (vErrors === null) {
                                        vErrors = [err154];
                                    }
                                    else {
                                        vErrors.push(err154);
                                    }
                                    errors++;
                                }
                                if ((typeof data52 == "number") && (isFinite(data52))) {
                                    if (data52 < 1 || isNaN(data52)) {
                                        const err155 = { instancePath: instancePath + "/data/excluded/" + i6 + "/ordinal", schemaPath: "#/properties/data/oneOf/1/properties/excluded/items/properties/ordinal/minimum", keyword: "minimum", params: { comparison: ">=", limit: 1 }, message: "must be >= 1" };
                                        if (vErrors === null) {
                                            vErrors = [err155];
                                        }
                                        else {
                                            vErrors.push(err155);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data51.entryId !== undefined) {
                                let data53 = data51.entryId;
                                if ((typeof data53 !== "string") && (data53 !== null)) {
                                    const err156 = { instancePath: instancePath + "/data/excluded/" + i6 + "/entryId", schemaPath: "#/properties/data/oneOf/1/properties/excluded/items/properties/entryId/type", keyword: "type", params: { type: schema32.properties.data.oneOf[1].properties.excluded.items.properties.entryId.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err156];
                                    }
                                    else {
                                        vErrors.push(err156);
                                    }
                                    errors++;
                                }
                                if (typeof data53 === "string") {
                                    if (!pattern0.test(data53)) {
                                        const err157 = { instancePath: instancePath + "/data/excluded/" + i6 + "/entryId", schemaPath: "#/properties/data/oneOf/1/properties/excluded/items/properties/entryId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err157];
                                        }
                                        else {
                                            vErrors.push(err157);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data51.reason !== undefined) {
                                let data54 = data51.reason;
                                if (typeof data54 !== "string") {
                                    const err158 = { instancePath: instancePath + "/data/excluded/" + i6 + "/reason", schemaPath: "#/properties/data/oneOf/1/properties/excluded/items/properties/reason/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err158];
                                    }
                                    else {
                                        vErrors.push(err158);
                                    }
                                    errors++;
                                }
                                if (!(((((((data54 === "eligible-forward") || (data54 === "edited-exception")) || (data54 === "paid")) || (data54 === "effective")) || (data54 === "overdue")) || (data54 === "canceled")) || (data54 === "deleted"))) {
                                    const err159 = { instancePath: instancePath + "/data/excluded/" + i6 + "/reason", schemaPath: "#/properties/data/oneOf/1/properties/excluded/items/properties/reason/enum", keyword: "enum", params: { allowedValues: schema32.properties.data.oneOf[1].properties.excluded.items.properties.reason.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err159];
                                    }
                                    else {
                                        vErrors.push(err159);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err160 = { instancePath: instancePath + "/data/excluded/" + i6, schemaPath: "#/properties/data/oneOf/1/properties/excluded/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                                vErrors = [err160];
                            }
                            else {
                                vErrors.push(err160);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err161 = { instancePath: instancePath + "/data/excluded", schemaPath: "#/properties/data/oneOf/1/properties/excluded/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err161];
                    }
                    else {
                        vErrors.push(err161);
                    }
                    errors++;
                }
            }
            if (data0.selectedEntryIds !== undefined) {
                let data55 = data0.selectedEntryIds;
                if (Array.isArray(data55)) {
                    if (data55.length > 2000) {
                        const err162 = { instancePath: instancePath + "/data/selectedEntryIds", schemaPath: "#/properties/data/oneOf/1/properties/selectedEntryIds/maxItems", keyword: "maxItems", params: { limit: 2000 }, message: "must NOT have more than 2000 items" };
                        if (vErrors === null) {
                            vErrors = [err162];
                        }
                        else {
                            vErrors.push(err162);
                        }
                        errors++;
                    }
                    const len7 = data55.length;
                    for (let i7 = 0; i7 < len7; i7++) {
                        let data56 = data55[i7];
                        if (typeof data56 === "string") {
                            if (!pattern0.test(data56)) {
                                const err163 = { instancePath: instancePath + "/data/selectedEntryIds/" + i7, schemaPath: "#/properties/data/oneOf/1/properties/selectedEntryIds/items/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err163];
                                }
                                else {
                                    vErrors.push(err163);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err164 = { instancePath: instancePath + "/data/selectedEntryIds/" + i7, schemaPath: "#/properties/data/oneOf/1/properties/selectedEntryIds/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err164];
                            }
                            else {
                                vErrors.push(err164);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err165 = { instancePath: instancePath + "/data/selectedEntryIds", schemaPath: "#/properties/data/oneOf/1/properties/selectedEntryIds/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err165];
                    }
                    else {
                        vErrors.push(err165);
                    }
                    errors++;
                }
            }
            if (data0.cancelledEntryIds !== undefined) {
                let data57 = data0.cancelledEntryIds;
                if (Array.isArray(data57)) {
                    if (data57.length > 2000) {
                        const err166 = { instancePath: instancePath + "/data/cancelledEntryIds", schemaPath: "#/properties/data/oneOf/1/properties/cancelledEntryIds/maxItems", keyword: "maxItems", params: { limit: 2000 }, message: "must NOT have more than 2000 items" };
                        if (vErrors === null) {
                            vErrors = [err166];
                        }
                        else {
                            vErrors.push(err166);
                        }
                        errors++;
                    }
                    const len8 = data57.length;
                    for (let i8 = 0; i8 < len8; i8++) {
                        let data58 = data57[i8];
                        if (typeof data58 === "string") {
                            if (!pattern0.test(data58)) {
                                const err167 = { instancePath: instancePath + "/data/cancelledEntryIds/" + i8, schemaPath: "#/properties/data/oneOf/1/properties/cancelledEntryIds/items/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err167];
                                }
                                else {
                                    vErrors.push(err167);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err168 = { instancePath: instancePath + "/data/cancelledEntryIds/" + i8, schemaPath: "#/properties/data/oneOf/1/properties/cancelledEntryIds/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err168];
                            }
                            else {
                                vErrors.push(err168);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err169 = { instancePath: instancePath + "/data/cancelledEntryIds", schemaPath: "#/properties/data/oneOf/1/properties/cancelledEntryIds/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err169];
                    }
                    else {
                        vErrors.push(err169);
                    }
                    errors++;
                }
            }
        }
        else {
            const err170 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf/1/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err170];
            }
            else {
                vErrors.push(err170);
            }
            errors++;
        }
        var _valid0 = _errs57 === errors;
        if (_valid0 && valid1) {
            valid1 = false;
            passing0 = [passing0, 1];
        }
        else {
            if (_valid0) {
                valid1 = true;
                passing0 = 1;
            }
        }
        if (!valid1) {
            const err171 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/oneOf", keyword: "oneOf", params: { passingSchemas: passing0 }, message: "must match exactly one schema in oneOf" };
            if (vErrors === null) {
                vErrors = [err171];
            }
            else {
                vErrors.push(err171);
            }
            errors++;
        }
        else {
            errors = _errs3;
            if (vErrors !== null) {
                if (_errs3) {
                    vErrors.length = _errs3;
                }
                else {
                    vErrors = null;
                }
            }
        }
    }
    if (data.meta !== undefined) {
        let data59 = data.meta;
        if (data59 && typeof data59 == "object" && !Array.isArray(data59)) {
            if (data59.requestId === undefined) {
                const err172 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "requestId" }, message: "must have required property '" + "requestId" + "'" };
                if (vErrors === null) {
                    vErrors = [err172];
                }
                else {
                    vErrors.push(err172);
                }
                errors++;
            }
            if (data59.asOf === undefined) {
                const err173 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "asOf" }, message: "must have required property '" + "asOf" + "'" };
                if (vErrors === null) {
                    vErrors = [err173];
                }
                else {
                    vErrors.push(err173);
                }
                errors++;
            }
            if (data59.businessToday === undefined) {
                const err174 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err174];
                }
                else {
                    vErrors.push(err174);
                }
                errors++;
            }
            if (data59.timeZone === undefined) {
                const err175 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "timeZone" }, message: "must have required property '" + "timeZone" + "'" };
                if (vErrors === null) {
                    vErrors = [err175];
                }
                else {
                    vErrors.push(err175);
                }
                errors++;
            }
            if (data59.dataRevision === undefined) {
                const err176 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "dataRevision" }, message: "must have required property '" + "dataRevision" + "'" };
                if (vErrors === null) {
                    vErrors = [err176];
                }
                else {
                    vErrors.push(err176);
                }
                errors++;
            }
            for (const key7 in data59) {
                if (!(((((key7 === "requestId") || (key7 === "asOf")) || (key7 === "businessToday")) || (key7 === "timeZone")) || (key7 === "dataRevision"))) {
                    const err177 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key7 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err177];
                    }
                    else {
                        vErrors.push(err177);
                    }
                    errors++;
                }
            }
            if (data59.requestId !== undefined) {
                let data60 = data59.requestId;
                if (typeof data60 === "string") {
                    if (func2(data60) > 64) {
                        const err178 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err178];
                        }
                        else {
                            vErrors.push(err178);
                        }
                        errors++;
                    }
                    if (func2(data60) < 1) {
                        const err179 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err179];
                        }
                        else {
                            vErrors.push(err179);
                        }
                        errors++;
                    }
                }
                else {
                    const err180 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err180];
                    }
                    else {
                        vErrors.push(err180);
                    }
                    errors++;
                }
            }
            if (data59.asOf !== undefined) {
                let data61 = data59.asOf;
                if (typeof data61 === "string") {
                    if (func2(data61) > 64) {
                        const err181 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err181];
                        }
                        else {
                            vErrors.push(err181);
                        }
                        errors++;
                    }
                    if (func2(data61) < 1) {
                        const err182 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err182];
                        }
                        else {
                            vErrors.push(err182);
                        }
                        errors++;
                    }
                }
                else {
                    const err183 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err183];
                    }
                    else {
                        vErrors.push(err183);
                    }
                    errors++;
                }
            }
            if (data59.businessToday !== undefined) {
                let data62 = data59.businessToday;
                if (typeof data62 === "string") {
                    if (!pattern4.test(data62)) {
                        const err184 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err184];
                        }
                        else {
                            vErrors.push(err184);
                        }
                        errors++;
                    }
                }
                else {
                    const err185 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err185];
                    }
                    else {
                        vErrors.push(err185);
                    }
                    errors++;
                }
            }
            if (data59.timeZone !== undefined) {
                let data63 = data59.timeZone;
                if (typeof data63 === "string") {
                    if (func2(data63) > 64) {
                        const err186 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err186];
                        }
                        else {
                            vErrors.push(err186);
                        }
                        errors++;
                    }
                    if (func2(data63) < 1) {
                        const err187 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err187];
                        }
                        else {
                            vErrors.push(err187);
                        }
                        errors++;
                    }
                }
                else {
                    const err188 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err188];
                    }
                    else {
                        vErrors.push(err188);
                    }
                    errors++;
                }
            }
            if (data59.dataRevision !== undefined) {
                let data64 = data59.dataRevision;
                if (typeof data64 === "string") {
                    if (!pattern2.test(data64)) {
                        const err189 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err189];
                        }
                        else {
                            vErrors.push(err189);
                        }
                        errors++;
                    }
                }
                else {
                    const err190 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err190];
                    }
                    else {
                        vErrors.push(err190);
                    }
                    errors++;
                }
            }
        }
        else {
            const err191 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err191];
            }
            else {
                vErrors.push(err191);
            }
            errors++;
        }
    }
}
else {
    const err192 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
        vErrors = [err192];
    }
    else {
        vErrors.push(err192);
    }
    errors++;
} validate31.errors = vErrors; return errors === 0; }
export const validateLedgerRecurrenceTemplateEnvelope = validate32;
const schema33 = { "$id": "https://saldo.local/schemas/ledger-recurrence-template-envelope.json", "$schema": "http://json-schema.org/draft-07/schema#", "title": "LedgerRecurrenceTemplateEnvelope", "type": "object", "additionalProperties": false, "required": ["data", "meta"], "properties": { "data": { "type": "object", "additionalProperties": false, "required": ["id", "accountId", "categoryId", "description", "signedMinor", "currency", "accountKind", "frequency", "anchorDate", "endDate", "status", "generatedThrough", "revision"], "properties": { "id": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "accountId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "categoryId": { "type": ["string", "null"], "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "description": { "type": "string", "minLength": 1, "maxLength": 500 }, "signedMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "accountKind": { "type": "string", "enum": ["cash", "card"] }, "frequency": { "type": "string", "enum": ["monthly", "weekly", "biweekly"] }, "anchorDate": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "endDate": { "type": ["string", "null"], "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "status": { "type": "string", "enum": ["active", "stopped"] }, "generatedThrough": { "type": ["string", "null"], "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "revision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } }, "meta": { "type": "object", "additionalProperties": false, "required": ["requestId", "asOf", "businessToday", "timeZone", "dataRevision"], "properties": { "requestId": { "type": "string", "minLength": 1, "maxLength": 64 }, "asOf": { "type": "string", "minLength": 1, "maxLength": 64 }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "timeZone": { "type": "string", "minLength": 1, "maxLength": 64 }, "dataRevision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } } } };
function validate32(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="https://saldo.local/schemas/ledger-recurrence-template-envelope.json" */ ; let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.data === undefined) {
        const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property '" + "data" + "'" };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
    }
    if (data.meta === undefined) {
        const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "meta" }, message: "must have required property '" + "meta" + "'" };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    for (const key0 in data) {
        if (!((key0 === "data") || (key0 === "meta"))) {
            const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.data !== undefined) {
        let data0 = data.data;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.id === undefined) {
                const err3 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property '" + "id" + "'" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
            if (data0.accountId === undefined) {
                const err4 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "accountId" }, message: "must have required property '" + "accountId" + "'" };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
            if (data0.categoryId === undefined) {
                const err5 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "categoryId" }, message: "must have required property '" + "categoryId" + "'" };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
            }
            if (data0.description === undefined) {
                const err6 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "description" }, message: "must have required property '" + "description" + "'" };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
            }
            if (data0.signedMinor === undefined) {
                const err7 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "signedMinor" }, message: "must have required property '" + "signedMinor" + "'" };
                if (vErrors === null) {
                    vErrors = [err7];
                }
                else {
                    vErrors.push(err7);
                }
                errors++;
            }
            if (data0.currency === undefined) {
                const err8 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                if (vErrors === null) {
                    vErrors = [err8];
                }
                else {
                    vErrors.push(err8);
                }
                errors++;
            }
            if (data0.accountKind === undefined) {
                const err9 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "accountKind" }, message: "must have required property '" + "accountKind" + "'" };
                if (vErrors === null) {
                    vErrors = [err9];
                }
                else {
                    vErrors.push(err9);
                }
                errors++;
            }
            if (data0.frequency === undefined) {
                const err10 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "frequency" }, message: "must have required property '" + "frequency" + "'" };
                if (vErrors === null) {
                    vErrors = [err10];
                }
                else {
                    vErrors.push(err10);
                }
                errors++;
            }
            if (data0.anchorDate === undefined) {
                const err11 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "anchorDate" }, message: "must have required property '" + "anchorDate" + "'" };
                if (vErrors === null) {
                    vErrors = [err11];
                }
                else {
                    vErrors.push(err11);
                }
                errors++;
            }
            if (data0.endDate === undefined) {
                const err12 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "endDate" }, message: "must have required property '" + "endDate" + "'" };
                if (vErrors === null) {
                    vErrors = [err12];
                }
                else {
                    vErrors.push(err12);
                }
                errors++;
            }
            if (data0.status === undefined) {
                const err13 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "status" }, message: "must have required property '" + "status" + "'" };
                if (vErrors === null) {
                    vErrors = [err13];
                }
                else {
                    vErrors.push(err13);
                }
                errors++;
            }
            if (data0.generatedThrough === undefined) {
                const err14 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "generatedThrough" }, message: "must have required property '" + "generatedThrough" + "'" };
                if (vErrors === null) {
                    vErrors = [err14];
                }
                else {
                    vErrors.push(err14);
                }
                errors++;
            }
            if (data0.revision === undefined) {
                const err15 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property '" + "revision" + "'" };
                if (vErrors === null) {
                    vErrors = [err15];
                }
                else {
                    vErrors.push(err15);
                }
                errors++;
            }
            for (const key1 in data0) {
                if (!(func35.call(schema33.properties.data.properties, key1))) {
                    const err16 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err16];
                    }
                    else {
                        vErrors.push(err16);
                    }
                    errors++;
                }
            }
            if (data0.id !== undefined) {
                let data1 = data0.id;
                if (typeof data1 === "string") {
                    if (!pattern0.test(data1)) {
                        const err17 = { instancePath: instancePath + "/data/id", schemaPath: "#/properties/data/properties/id/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err17];
                        }
                        else {
                            vErrors.push(err17);
                        }
                        errors++;
                    }
                }
                else {
                    const err18 = { instancePath: instancePath + "/data/id", schemaPath: "#/properties/data/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err18];
                    }
                    else {
                        vErrors.push(err18);
                    }
                    errors++;
                }
            }
            if (data0.accountId !== undefined) {
                let data2 = data0.accountId;
                if (typeof data2 === "string") {
                    if (!pattern0.test(data2)) {
                        const err19 = { instancePath: instancePath + "/data/accountId", schemaPath: "#/properties/data/properties/accountId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err19];
                        }
                        else {
                            vErrors.push(err19);
                        }
                        errors++;
                    }
                }
                else {
                    const err20 = { instancePath: instancePath + "/data/accountId", schemaPath: "#/properties/data/properties/accountId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err20];
                    }
                    else {
                        vErrors.push(err20);
                    }
                    errors++;
                }
            }
            if (data0.categoryId !== undefined) {
                let data3 = data0.categoryId;
                if ((typeof data3 !== "string") && (data3 !== null)) {
                    const err21 = { instancePath: instancePath + "/data/categoryId", schemaPath: "#/properties/data/properties/categoryId/type", keyword: "type", params: { type: schema33.properties.data.properties.categoryId.type }, message: "must be string,null" };
                    if (vErrors === null) {
                        vErrors = [err21];
                    }
                    else {
                        vErrors.push(err21);
                    }
                    errors++;
                }
                if (typeof data3 === "string") {
                    if (!pattern0.test(data3)) {
                        const err22 = { instancePath: instancePath + "/data/categoryId", schemaPath: "#/properties/data/properties/categoryId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err22];
                        }
                        else {
                            vErrors.push(err22);
                        }
                        errors++;
                    }
                }
            }
            if (data0.description !== undefined) {
                let data4 = data0.description;
                if (typeof data4 === "string") {
                    if (func2(data4) > 500) {
                        const err23 = { instancePath: instancePath + "/data/description", schemaPath: "#/properties/data/properties/description/maxLength", keyword: "maxLength", params: { limit: 500 }, message: "must NOT have more than 500 characters" };
                        if (vErrors === null) {
                            vErrors = [err23];
                        }
                        else {
                            vErrors.push(err23);
                        }
                        errors++;
                    }
                    if (func2(data4) < 1) {
                        const err24 = { instancePath: instancePath + "/data/description", schemaPath: "#/properties/data/properties/description/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err24];
                        }
                        else {
                            vErrors.push(err24);
                        }
                        errors++;
                    }
                }
                else {
                    const err25 = { instancePath: instancePath + "/data/description", schemaPath: "#/properties/data/properties/description/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err25];
                    }
                    else {
                        vErrors.push(err25);
                    }
                    errors++;
                }
            }
            if (data0.signedMinor !== undefined) {
                let data5 = data0.signedMinor;
                if (typeof data5 === "string") {
                    if (!pattern3.test(data5)) {
                        const err26 = { instancePath: instancePath + "/data/signedMinor", schemaPath: "#/properties/data/properties/signedMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err26];
                        }
                        else {
                            vErrors.push(err26);
                        }
                        errors++;
                    }
                }
                else {
                    const err27 = { instancePath: instancePath + "/data/signedMinor", schemaPath: "#/properties/data/properties/signedMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err27];
                    }
                    else {
                        vErrors.push(err27);
                    }
                    errors++;
                }
            }
            if (data0.currency !== undefined) {
                let data6 = data0.currency;
                if (typeof data6 !== "string") {
                    const err28 = { instancePath: instancePath + "/data/currency", schemaPath: "#/properties/data/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err28];
                    }
                    else {
                        vErrors.push(err28);
                    }
                    errors++;
                }
                if (!(((data6 === "BRL") || (data6 === "CAD")) || (data6 === "USD"))) {
                    const err29 = { instancePath: instancePath + "/data/currency", schemaPath: "#/properties/data/properties/currency/enum", keyword: "enum", params: { allowedValues: schema33.properties.data.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err29];
                    }
                    else {
                        vErrors.push(err29);
                    }
                    errors++;
                }
            }
            if (data0.accountKind !== undefined) {
                let data7 = data0.accountKind;
                if (typeof data7 !== "string") {
                    const err30 = { instancePath: instancePath + "/data/accountKind", schemaPath: "#/properties/data/properties/accountKind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err30];
                    }
                    else {
                        vErrors.push(err30);
                    }
                    errors++;
                }
                if (!((data7 === "cash") || (data7 === "card"))) {
                    const err31 = { instancePath: instancePath + "/data/accountKind", schemaPath: "#/properties/data/properties/accountKind/enum", keyword: "enum", params: { allowedValues: schema33.properties.data.properties.accountKind.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err31];
                    }
                    else {
                        vErrors.push(err31);
                    }
                    errors++;
                }
            }
            if (data0.frequency !== undefined) {
                let data8 = data0.frequency;
                if (typeof data8 !== "string") {
                    const err32 = { instancePath: instancePath + "/data/frequency", schemaPath: "#/properties/data/properties/frequency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err32];
                    }
                    else {
                        vErrors.push(err32);
                    }
                    errors++;
                }
                if (!(((data8 === "monthly") || (data8 === "weekly")) || (data8 === "biweekly"))) {
                    const err33 = { instancePath: instancePath + "/data/frequency", schemaPath: "#/properties/data/properties/frequency/enum", keyword: "enum", params: { allowedValues: schema33.properties.data.properties.frequency.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err33];
                    }
                    else {
                        vErrors.push(err33);
                    }
                    errors++;
                }
            }
            if (data0.anchorDate !== undefined) {
                let data9 = data0.anchorDate;
                if (typeof data9 === "string") {
                    if (!pattern4.test(data9)) {
                        const err34 = { instancePath: instancePath + "/data/anchorDate", schemaPath: "#/properties/data/properties/anchorDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err34];
                        }
                        else {
                            vErrors.push(err34);
                        }
                        errors++;
                    }
                }
                else {
                    const err35 = { instancePath: instancePath + "/data/anchorDate", schemaPath: "#/properties/data/properties/anchorDate/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err35];
                    }
                    else {
                        vErrors.push(err35);
                    }
                    errors++;
                }
            }
            if (data0.endDate !== undefined) {
                let data10 = data0.endDate;
                if ((typeof data10 !== "string") && (data10 !== null)) {
                    const err36 = { instancePath: instancePath + "/data/endDate", schemaPath: "#/properties/data/properties/endDate/type", keyword: "type", params: { type: schema33.properties.data.properties.endDate.type }, message: "must be string,null" };
                    if (vErrors === null) {
                        vErrors = [err36];
                    }
                    else {
                        vErrors.push(err36);
                    }
                    errors++;
                }
                if (typeof data10 === "string") {
                    if (!pattern4.test(data10)) {
                        const err37 = { instancePath: instancePath + "/data/endDate", schemaPath: "#/properties/data/properties/endDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err37];
                        }
                        else {
                            vErrors.push(err37);
                        }
                        errors++;
                    }
                }
            }
            if (data0.status !== undefined) {
                let data11 = data0.status;
                if (typeof data11 !== "string") {
                    const err38 = { instancePath: instancePath + "/data/status", schemaPath: "#/properties/data/properties/status/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err38];
                    }
                    else {
                        vErrors.push(err38);
                    }
                    errors++;
                }
                if (!((data11 === "active") || (data11 === "stopped"))) {
                    const err39 = { instancePath: instancePath + "/data/status", schemaPath: "#/properties/data/properties/status/enum", keyword: "enum", params: { allowedValues: schema33.properties.data.properties.status.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err39];
                    }
                    else {
                        vErrors.push(err39);
                    }
                    errors++;
                }
            }
            if (data0.generatedThrough !== undefined) {
                let data12 = data0.generatedThrough;
                if ((typeof data12 !== "string") && (data12 !== null)) {
                    const err40 = { instancePath: instancePath + "/data/generatedThrough", schemaPath: "#/properties/data/properties/generatedThrough/type", keyword: "type", params: { type: schema33.properties.data.properties.generatedThrough.type }, message: "must be string,null" };
                    if (vErrors === null) {
                        vErrors = [err40];
                    }
                    else {
                        vErrors.push(err40);
                    }
                    errors++;
                }
                if (typeof data12 === "string") {
                    if (!pattern4.test(data12)) {
                        const err41 = { instancePath: instancePath + "/data/generatedThrough", schemaPath: "#/properties/data/properties/generatedThrough/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err41];
                        }
                        else {
                            vErrors.push(err41);
                        }
                        errors++;
                    }
                }
            }
            if (data0.revision !== undefined) {
                let data13 = data0.revision;
                if (typeof data13 === "string") {
                    if (!pattern2.test(data13)) {
                        const err42 = { instancePath: instancePath + "/data/revision", schemaPath: "#/properties/data/properties/revision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err42];
                        }
                        else {
                            vErrors.push(err42);
                        }
                        errors++;
                    }
                }
                else {
                    const err43 = { instancePath: instancePath + "/data/revision", schemaPath: "#/properties/data/properties/revision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err43];
                    }
                    else {
                        vErrors.push(err43);
                    }
                    errors++;
                }
            }
        }
        else {
            const err44 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err44];
            }
            else {
                vErrors.push(err44);
            }
            errors++;
        }
    }
    if (data.meta !== undefined) {
        let data14 = data.meta;
        if (data14 && typeof data14 == "object" && !Array.isArray(data14)) {
            if (data14.requestId === undefined) {
                const err45 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "requestId" }, message: "must have required property '" + "requestId" + "'" };
                if (vErrors === null) {
                    vErrors = [err45];
                }
                else {
                    vErrors.push(err45);
                }
                errors++;
            }
            if (data14.asOf === undefined) {
                const err46 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "asOf" }, message: "must have required property '" + "asOf" + "'" };
                if (vErrors === null) {
                    vErrors = [err46];
                }
                else {
                    vErrors.push(err46);
                }
                errors++;
            }
            if (data14.businessToday === undefined) {
                const err47 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err47];
                }
                else {
                    vErrors.push(err47);
                }
                errors++;
            }
            if (data14.timeZone === undefined) {
                const err48 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "timeZone" }, message: "must have required property '" + "timeZone" + "'" };
                if (vErrors === null) {
                    vErrors = [err48];
                }
                else {
                    vErrors.push(err48);
                }
                errors++;
            }
            if (data14.dataRevision === undefined) {
                const err49 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "dataRevision" }, message: "must have required property '" + "dataRevision" + "'" };
                if (vErrors === null) {
                    vErrors = [err49];
                }
                else {
                    vErrors.push(err49);
                }
                errors++;
            }
            for (const key2 in data14) {
                if (!(((((key2 === "requestId") || (key2 === "asOf")) || (key2 === "businessToday")) || (key2 === "timeZone")) || (key2 === "dataRevision"))) {
                    const err50 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err50];
                    }
                    else {
                        vErrors.push(err50);
                    }
                    errors++;
                }
            }
            if (data14.requestId !== undefined) {
                let data15 = data14.requestId;
                if (typeof data15 === "string") {
                    if (func2(data15) > 64) {
                        const err51 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err51];
                        }
                        else {
                            vErrors.push(err51);
                        }
                        errors++;
                    }
                    if (func2(data15) < 1) {
                        const err52 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err52];
                        }
                        else {
                            vErrors.push(err52);
                        }
                        errors++;
                    }
                }
                else {
                    const err53 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err53];
                    }
                    else {
                        vErrors.push(err53);
                    }
                    errors++;
                }
            }
            if (data14.asOf !== undefined) {
                let data16 = data14.asOf;
                if (typeof data16 === "string") {
                    if (func2(data16) > 64) {
                        const err54 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err54];
                        }
                        else {
                            vErrors.push(err54);
                        }
                        errors++;
                    }
                    if (func2(data16) < 1) {
                        const err55 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err55];
                        }
                        else {
                            vErrors.push(err55);
                        }
                        errors++;
                    }
                }
                else {
                    const err56 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err56];
                    }
                    else {
                        vErrors.push(err56);
                    }
                    errors++;
                }
            }
            if (data14.businessToday !== undefined) {
                let data17 = data14.businessToday;
                if (typeof data17 === "string") {
                    if (!pattern4.test(data17)) {
                        const err57 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err57];
                        }
                        else {
                            vErrors.push(err57);
                        }
                        errors++;
                    }
                }
                else {
                    const err58 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err58];
                    }
                    else {
                        vErrors.push(err58);
                    }
                    errors++;
                }
            }
            if (data14.timeZone !== undefined) {
                let data18 = data14.timeZone;
                if (typeof data18 === "string") {
                    if (func2(data18) > 64) {
                        const err59 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err59];
                        }
                        else {
                            vErrors.push(err59);
                        }
                        errors++;
                    }
                    if (func2(data18) < 1) {
                        const err60 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err60];
                        }
                        else {
                            vErrors.push(err60);
                        }
                        errors++;
                    }
                }
                else {
                    const err61 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err61];
                    }
                    else {
                        vErrors.push(err61);
                    }
                    errors++;
                }
            }
            if (data14.dataRevision !== undefined) {
                let data19 = data14.dataRevision;
                if (typeof data19 === "string") {
                    if (!pattern2.test(data19)) {
                        const err62 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err62];
                        }
                        else {
                            vErrors.push(err62);
                        }
                        errors++;
                    }
                }
                else {
                    const err63 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err63];
                    }
                    else {
                        vErrors.push(err63);
                    }
                    errors++;
                }
            }
        }
        else {
            const err64 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err64];
            }
            else {
                vErrors.push(err64);
            }
            errors++;
        }
    }
}
else {
    const err65 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
        vErrors = [err65];
    }
    else {
        vErrors.push(err65);
    }
    errors++;
} validate32.errors = vErrors; return errors === 0; }
export const validateLedgerBulkPreviewEnvelope = validate33;
const schema34 = { "$id": "https://saldo.local/schemas/ledger-bulk-preview-envelope.json", "$schema": "http://json-schema.org/draft-07/schema#", "title": "LedgerBulkPreviewEnvelope", "type": "object", "additionalProperties": false, "required": ["data", "meta"], "properties": { "data": { "type": "object", "additionalProperties": false, "required": ["id", "action", "businessToday", "expiresAt", "entryIds", "rows", "impact"], "properties": { "id": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "action": { "type": "string", "enum": ["bulk.pay", "bulk.categorize", "bulk.cancel"] }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "expiresAt": { "type": "string", "minLength": 1, "maxLength": 64 }, "entryIds": { "type": "array", "minItems": 1, "maxItems": 500, "items": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } }, "rows": { "type": "array", "minItems": 1, "maxItems": 500, "items": { "type": "object", "additionalProperties": false, "required": ["entryId", "revision", "accountId", "accountKind", "type", "signedMinor", "currency", "description", "dueDate", "paid", "categoryId"], "properties": { "entryId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "revision": { "type": "string", "pattern": "^[1-9][0-9]*$" }, "accountId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "accountKind": { "type": "string", "enum": ["cash", "card"] }, "type": { "type": "string", "enum": ["income", "expense"] }, "signedMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "description": { "type": "string", "minLength": 1, "maxLength": 500 }, "dueDate": { "type": ["string", "null"], "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "paid": { "type": ["boolean", "null"] }, "categoryId": { "type": ["string", "null"], "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } } } }, "impact": { "type": "object", "additionalProperties": false, "required": ["count", "paidCount", "cancelledCount", "categorisedCount", "changedCount", "categoryId", "paidDate", "accounts"], "properties": { "count": { "type": "integer", "minimum": 0, "maximum": 500 }, "paidCount": { "type": "integer", "minimum": 0, "maximum": 500 }, "cancelledCount": { "type": "integer", "minimum": 0, "maximum": 500 }, "categorisedCount": { "type": "integer", "minimum": 0, "maximum": 500 }, "changedCount": { "type": "integer", "minimum": 0, "maximum": 500 }, "categoryId": { "type": ["string", "null"], "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "paidDate": { "type": ["string", "null"], "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "accounts": { "type": "array", "maxItems": 500, "items": { "type": "object", "additionalProperties": false, "required": ["accountId", "currency", "deltaMinor"], "properties": { "accountId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "deltaMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" } } } } } } } }, "meta": { "type": "object", "additionalProperties": false, "required": ["requestId", "asOf", "businessToday", "timeZone", "dataRevision"], "properties": { "requestId": { "type": "string", "minLength": 1, "maxLength": 64 }, "asOf": { "type": "string", "minLength": 1, "maxLength": 64 }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "timeZone": { "type": "string", "minLength": 1, "maxLength": 64 }, "dataRevision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } } } };
function validate33(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="https://saldo.local/schemas/ledger-bulk-preview-envelope.json" */ ; let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.data === undefined) {
        const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property '" + "data" + "'" };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
    }
    if (data.meta === undefined) {
        const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "meta" }, message: "must have required property '" + "meta" + "'" };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    for (const key0 in data) {
        if (!((key0 === "data") || (key0 === "meta"))) {
            const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.data !== undefined) {
        let data0 = data.data;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.id === undefined) {
                const err3 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "id" }, message: "must have required property '" + "id" + "'" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
            if (data0.action === undefined) {
                const err4 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "action" }, message: "must have required property '" + "action" + "'" };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
            if (data0.businessToday === undefined) {
                const err5 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
            }
            if (data0.expiresAt === undefined) {
                const err6 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "expiresAt" }, message: "must have required property '" + "expiresAt" + "'" };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
            }
            if (data0.entryIds === undefined) {
                const err7 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "entryIds" }, message: "must have required property '" + "entryIds" + "'" };
                if (vErrors === null) {
                    vErrors = [err7];
                }
                else {
                    vErrors.push(err7);
                }
                errors++;
            }
            if (data0.rows === undefined) {
                const err8 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "rows" }, message: "must have required property '" + "rows" + "'" };
                if (vErrors === null) {
                    vErrors = [err8];
                }
                else {
                    vErrors.push(err8);
                }
                errors++;
            }
            if (data0.impact === undefined) {
                const err9 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "impact" }, message: "must have required property '" + "impact" + "'" };
                if (vErrors === null) {
                    vErrors = [err9];
                }
                else {
                    vErrors.push(err9);
                }
                errors++;
            }
            for (const key1 in data0) {
                if (!(((((((key1 === "id") || (key1 === "action")) || (key1 === "businessToday")) || (key1 === "expiresAt")) || (key1 === "entryIds")) || (key1 === "rows")) || (key1 === "impact"))) {
                    const err10 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err10];
                    }
                    else {
                        vErrors.push(err10);
                    }
                    errors++;
                }
            }
            if (data0.id !== undefined) {
                let data1 = data0.id;
                if (typeof data1 === "string") {
                    if (!pattern0.test(data1)) {
                        const err11 = { instancePath: instancePath + "/data/id", schemaPath: "#/properties/data/properties/id/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err11];
                        }
                        else {
                            vErrors.push(err11);
                        }
                        errors++;
                    }
                }
                else {
                    const err12 = { instancePath: instancePath + "/data/id", schemaPath: "#/properties/data/properties/id/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err12];
                    }
                    else {
                        vErrors.push(err12);
                    }
                    errors++;
                }
            }
            if (data0.action !== undefined) {
                let data2 = data0.action;
                if (typeof data2 !== "string") {
                    const err13 = { instancePath: instancePath + "/data/action", schemaPath: "#/properties/data/properties/action/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err13];
                    }
                    else {
                        vErrors.push(err13);
                    }
                    errors++;
                }
                if (!(((data2 === "bulk.pay") || (data2 === "bulk.categorize")) || (data2 === "bulk.cancel"))) {
                    const err14 = { instancePath: instancePath + "/data/action", schemaPath: "#/properties/data/properties/action/enum", keyword: "enum", params: { allowedValues: schema34.properties.data.properties.action.enum }, message: "must be equal to one of the allowed values" };
                    if (vErrors === null) {
                        vErrors = [err14];
                    }
                    else {
                        vErrors.push(err14);
                    }
                    errors++;
                }
            }
            if (data0.businessToday !== undefined) {
                let data3 = data0.businessToday;
                if (typeof data3 === "string") {
                    if (!pattern4.test(data3)) {
                        const err15 = { instancePath: instancePath + "/data/businessToday", schemaPath: "#/properties/data/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err15];
                        }
                        else {
                            vErrors.push(err15);
                        }
                        errors++;
                    }
                }
                else {
                    const err16 = { instancePath: instancePath + "/data/businessToday", schemaPath: "#/properties/data/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err16];
                    }
                    else {
                        vErrors.push(err16);
                    }
                    errors++;
                }
            }
            if (data0.expiresAt !== undefined) {
                let data4 = data0.expiresAt;
                if (typeof data4 === "string") {
                    if (func2(data4) > 64) {
                        const err17 = { instancePath: instancePath + "/data/expiresAt", schemaPath: "#/properties/data/properties/expiresAt/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err17];
                        }
                        else {
                            vErrors.push(err17);
                        }
                        errors++;
                    }
                    if (func2(data4) < 1) {
                        const err18 = { instancePath: instancePath + "/data/expiresAt", schemaPath: "#/properties/data/properties/expiresAt/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err18];
                        }
                        else {
                            vErrors.push(err18);
                        }
                        errors++;
                    }
                }
                else {
                    const err19 = { instancePath: instancePath + "/data/expiresAt", schemaPath: "#/properties/data/properties/expiresAt/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err19];
                    }
                    else {
                        vErrors.push(err19);
                    }
                    errors++;
                }
            }
            if (data0.entryIds !== undefined) {
                let data5 = data0.entryIds;
                if (Array.isArray(data5)) {
                    if (data5.length > 500) {
                        const err20 = { instancePath: instancePath + "/data/entryIds", schemaPath: "#/properties/data/properties/entryIds/maxItems", keyword: "maxItems", params: { limit: 500 }, message: "must NOT have more than 500 items" };
                        if (vErrors === null) {
                            vErrors = [err20];
                        }
                        else {
                            vErrors.push(err20);
                        }
                        errors++;
                    }
                    if (data5.length < 1) {
                        const err21 = { instancePath: instancePath + "/data/entryIds", schemaPath: "#/properties/data/properties/entryIds/minItems", keyword: "minItems", params: { limit: 1 }, message: "must NOT have fewer than 1 items" };
                        if (vErrors === null) {
                            vErrors = [err21];
                        }
                        else {
                            vErrors.push(err21);
                        }
                        errors++;
                    }
                    const len0 = data5.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                        let data6 = data5[i0];
                        if (typeof data6 === "string") {
                            if (!pattern0.test(data6)) {
                                const err22 = { instancePath: instancePath + "/data/entryIds/" + i0, schemaPath: "#/properties/data/properties/entryIds/items/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err22];
                                }
                                else {
                                    vErrors.push(err22);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err23 = { instancePath: instancePath + "/data/entryIds/" + i0, schemaPath: "#/properties/data/properties/entryIds/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err23];
                            }
                            else {
                                vErrors.push(err23);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err24 = { instancePath: instancePath + "/data/entryIds", schemaPath: "#/properties/data/properties/entryIds/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err24];
                    }
                    else {
                        vErrors.push(err24);
                    }
                    errors++;
                }
            }
            if (data0.rows !== undefined) {
                let data7 = data0.rows;
                if (Array.isArray(data7)) {
                    if (data7.length > 500) {
                        const err25 = { instancePath: instancePath + "/data/rows", schemaPath: "#/properties/data/properties/rows/maxItems", keyword: "maxItems", params: { limit: 500 }, message: "must NOT have more than 500 items" };
                        if (vErrors === null) {
                            vErrors = [err25];
                        }
                        else {
                            vErrors.push(err25);
                        }
                        errors++;
                    }
                    if (data7.length < 1) {
                        const err26 = { instancePath: instancePath + "/data/rows", schemaPath: "#/properties/data/properties/rows/minItems", keyword: "minItems", params: { limit: 1 }, message: "must NOT have fewer than 1 items" };
                        if (vErrors === null) {
                            vErrors = [err26];
                        }
                        else {
                            vErrors.push(err26);
                        }
                        errors++;
                    }
                    const len1 = data7.length;
                    for (let i1 = 0; i1 < len1; i1++) {
                        let data8 = data7[i1];
                        if (data8 && typeof data8 == "object" && !Array.isArray(data8)) {
                            if (data8.entryId === undefined) {
                                const err27 = { instancePath: instancePath + "/data/rows/" + i1, schemaPath: "#/properties/data/properties/rows/items/required", keyword: "required", params: { missingProperty: "entryId" }, message: "must have required property '" + "entryId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err27];
                                }
                                else {
                                    vErrors.push(err27);
                                }
                                errors++;
                            }
                            if (data8.revision === undefined) {
                                const err28 = { instancePath: instancePath + "/data/rows/" + i1, schemaPath: "#/properties/data/properties/rows/items/required", keyword: "required", params: { missingProperty: "revision" }, message: "must have required property '" + "revision" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err28];
                                }
                                else {
                                    vErrors.push(err28);
                                }
                                errors++;
                            }
                            if (data8.accountId === undefined) {
                                const err29 = { instancePath: instancePath + "/data/rows/" + i1, schemaPath: "#/properties/data/properties/rows/items/required", keyword: "required", params: { missingProperty: "accountId" }, message: "must have required property '" + "accountId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err29];
                                }
                                else {
                                    vErrors.push(err29);
                                }
                                errors++;
                            }
                            if (data8.accountKind === undefined) {
                                const err30 = { instancePath: instancePath + "/data/rows/" + i1, schemaPath: "#/properties/data/properties/rows/items/required", keyword: "required", params: { missingProperty: "accountKind" }, message: "must have required property '" + "accountKind" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err30];
                                }
                                else {
                                    vErrors.push(err30);
                                }
                                errors++;
                            }
                            if (data8.type === undefined) {
                                const err31 = { instancePath: instancePath + "/data/rows/" + i1, schemaPath: "#/properties/data/properties/rows/items/required", keyword: "required", params: { missingProperty: "type" }, message: "must have required property '" + "type" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err31];
                                }
                                else {
                                    vErrors.push(err31);
                                }
                                errors++;
                            }
                            if (data8.signedMinor === undefined) {
                                const err32 = { instancePath: instancePath + "/data/rows/" + i1, schemaPath: "#/properties/data/properties/rows/items/required", keyword: "required", params: { missingProperty: "signedMinor" }, message: "must have required property '" + "signedMinor" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err32];
                                }
                                else {
                                    vErrors.push(err32);
                                }
                                errors++;
                            }
                            if (data8.currency === undefined) {
                                const err33 = { instancePath: instancePath + "/data/rows/" + i1, schemaPath: "#/properties/data/properties/rows/items/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err33];
                                }
                                else {
                                    vErrors.push(err33);
                                }
                                errors++;
                            }
                            if (data8.description === undefined) {
                                const err34 = { instancePath: instancePath + "/data/rows/" + i1, schemaPath: "#/properties/data/properties/rows/items/required", keyword: "required", params: { missingProperty: "description" }, message: "must have required property '" + "description" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err34];
                                }
                                else {
                                    vErrors.push(err34);
                                }
                                errors++;
                            }
                            if (data8.dueDate === undefined) {
                                const err35 = { instancePath: instancePath + "/data/rows/" + i1, schemaPath: "#/properties/data/properties/rows/items/required", keyword: "required", params: { missingProperty: "dueDate" }, message: "must have required property '" + "dueDate" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err35];
                                }
                                else {
                                    vErrors.push(err35);
                                }
                                errors++;
                            }
                            if (data8.paid === undefined) {
                                const err36 = { instancePath: instancePath + "/data/rows/" + i1, schemaPath: "#/properties/data/properties/rows/items/required", keyword: "required", params: { missingProperty: "paid" }, message: "must have required property '" + "paid" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err36];
                                }
                                else {
                                    vErrors.push(err36);
                                }
                                errors++;
                            }
                            if (data8.categoryId === undefined) {
                                const err37 = { instancePath: instancePath + "/data/rows/" + i1, schemaPath: "#/properties/data/properties/rows/items/required", keyword: "required", params: { missingProperty: "categoryId" }, message: "must have required property '" + "categoryId" + "'" };
                                if (vErrors === null) {
                                    vErrors = [err37];
                                }
                                else {
                                    vErrors.push(err37);
                                }
                                errors++;
                            }
                            for (const key2 in data8) {
                                if (!(func35.call(schema34.properties.data.properties.rows.items.properties, key2))) {
                                    const err38 = { instancePath: instancePath + "/data/rows/" + i1, schemaPath: "#/properties/data/properties/rows/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                                    if (vErrors === null) {
                                        vErrors = [err38];
                                    }
                                    else {
                                        vErrors.push(err38);
                                    }
                                    errors++;
                                }
                            }
                            if (data8.entryId !== undefined) {
                                let data9 = data8.entryId;
                                if (typeof data9 === "string") {
                                    if (!pattern0.test(data9)) {
                                        const err39 = { instancePath: instancePath + "/data/rows/" + i1 + "/entryId", schemaPath: "#/properties/data/properties/rows/items/properties/entryId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err39];
                                        }
                                        else {
                                            vErrors.push(err39);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err40 = { instancePath: instancePath + "/data/rows/" + i1 + "/entryId", schemaPath: "#/properties/data/properties/rows/items/properties/entryId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err40];
                                    }
                                    else {
                                        vErrors.push(err40);
                                    }
                                    errors++;
                                }
                            }
                            if (data8.revision !== undefined) {
                                let data10 = data8.revision;
                                if (typeof data10 === "string") {
                                    if (!pattern2.test(data10)) {
                                        const err41 = { instancePath: instancePath + "/data/rows/" + i1 + "/revision", schemaPath: "#/properties/data/properties/rows/items/properties/revision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err41];
                                        }
                                        else {
                                            vErrors.push(err41);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err42 = { instancePath: instancePath + "/data/rows/" + i1 + "/revision", schemaPath: "#/properties/data/properties/rows/items/properties/revision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err42];
                                    }
                                    else {
                                        vErrors.push(err42);
                                    }
                                    errors++;
                                }
                            }
                            if (data8.accountId !== undefined) {
                                let data11 = data8.accountId;
                                if (typeof data11 === "string") {
                                    if (!pattern0.test(data11)) {
                                        const err43 = { instancePath: instancePath + "/data/rows/" + i1 + "/accountId", schemaPath: "#/properties/data/properties/rows/items/properties/accountId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err43];
                                        }
                                        else {
                                            vErrors.push(err43);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err44 = { instancePath: instancePath + "/data/rows/" + i1 + "/accountId", schemaPath: "#/properties/data/properties/rows/items/properties/accountId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err44];
                                    }
                                    else {
                                        vErrors.push(err44);
                                    }
                                    errors++;
                                }
                            }
                            if (data8.accountKind !== undefined) {
                                let data12 = data8.accountKind;
                                if (typeof data12 !== "string") {
                                    const err45 = { instancePath: instancePath + "/data/rows/" + i1 + "/accountKind", schemaPath: "#/properties/data/properties/rows/items/properties/accountKind/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err45];
                                    }
                                    else {
                                        vErrors.push(err45);
                                    }
                                    errors++;
                                }
                                if (!((data12 === "cash") || (data12 === "card"))) {
                                    const err46 = { instancePath: instancePath + "/data/rows/" + i1 + "/accountKind", schemaPath: "#/properties/data/properties/rows/items/properties/accountKind/enum", keyword: "enum", params: { allowedValues: schema34.properties.data.properties.rows.items.properties.accountKind.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err46];
                                    }
                                    else {
                                        vErrors.push(err46);
                                    }
                                    errors++;
                                }
                            }
                            if (data8.type !== undefined) {
                                let data13 = data8.type;
                                if (typeof data13 !== "string") {
                                    const err47 = { instancePath: instancePath + "/data/rows/" + i1 + "/type", schemaPath: "#/properties/data/properties/rows/items/properties/type/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err47];
                                    }
                                    else {
                                        vErrors.push(err47);
                                    }
                                    errors++;
                                }
                                if (!((data13 === "income") || (data13 === "expense"))) {
                                    const err48 = { instancePath: instancePath + "/data/rows/" + i1 + "/type", schemaPath: "#/properties/data/properties/rows/items/properties/type/enum", keyword: "enum", params: { allowedValues: schema34.properties.data.properties.rows.items.properties.type.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err48];
                                    }
                                    else {
                                        vErrors.push(err48);
                                    }
                                    errors++;
                                }
                            }
                            if (data8.signedMinor !== undefined) {
                                let data14 = data8.signedMinor;
                                if (typeof data14 === "string") {
                                    if (!pattern3.test(data14)) {
                                        const err49 = { instancePath: instancePath + "/data/rows/" + i1 + "/signedMinor", schemaPath: "#/properties/data/properties/rows/items/properties/signedMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err49];
                                        }
                                        else {
                                            vErrors.push(err49);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err50 = { instancePath: instancePath + "/data/rows/" + i1 + "/signedMinor", schemaPath: "#/properties/data/properties/rows/items/properties/signedMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err50];
                                    }
                                    else {
                                        vErrors.push(err50);
                                    }
                                    errors++;
                                }
                            }
                            if (data8.currency !== undefined) {
                                let data15 = data8.currency;
                                if (typeof data15 !== "string") {
                                    const err51 = { instancePath: instancePath + "/data/rows/" + i1 + "/currency", schemaPath: "#/properties/data/properties/rows/items/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err51];
                                    }
                                    else {
                                        vErrors.push(err51);
                                    }
                                    errors++;
                                }
                                if (!(((data15 === "BRL") || (data15 === "CAD")) || (data15 === "USD"))) {
                                    const err52 = { instancePath: instancePath + "/data/rows/" + i1 + "/currency", schemaPath: "#/properties/data/properties/rows/items/properties/currency/enum", keyword: "enum", params: { allowedValues: schema34.properties.data.properties.rows.items.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                                    if (vErrors === null) {
                                        vErrors = [err52];
                                    }
                                    else {
                                        vErrors.push(err52);
                                    }
                                    errors++;
                                }
                            }
                            if (data8.description !== undefined) {
                                let data16 = data8.description;
                                if (typeof data16 === "string") {
                                    if (func2(data16) > 500) {
                                        const err53 = { instancePath: instancePath + "/data/rows/" + i1 + "/description", schemaPath: "#/properties/data/properties/rows/items/properties/description/maxLength", keyword: "maxLength", params: { limit: 500 }, message: "must NOT have more than 500 characters" };
                                        if (vErrors === null) {
                                            vErrors = [err53];
                                        }
                                        else {
                                            vErrors.push(err53);
                                        }
                                        errors++;
                                    }
                                    if (func2(data16) < 1) {
                                        const err54 = { instancePath: instancePath + "/data/rows/" + i1 + "/description", schemaPath: "#/properties/data/properties/rows/items/properties/description/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                                        if (vErrors === null) {
                                            vErrors = [err54];
                                        }
                                        else {
                                            vErrors.push(err54);
                                        }
                                        errors++;
                                    }
                                }
                                else {
                                    const err55 = { instancePath: instancePath + "/data/rows/" + i1 + "/description", schemaPath: "#/properties/data/properties/rows/items/properties/description/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                    if (vErrors === null) {
                                        vErrors = [err55];
                                    }
                                    else {
                                        vErrors.push(err55);
                                    }
                                    errors++;
                                }
                            }
                            if (data8.dueDate !== undefined) {
                                let data17 = data8.dueDate;
                                if ((typeof data17 !== "string") && (data17 !== null)) {
                                    const err56 = { instancePath: instancePath + "/data/rows/" + i1 + "/dueDate", schemaPath: "#/properties/data/properties/rows/items/properties/dueDate/type", keyword: "type", params: { type: schema34.properties.data.properties.rows.items.properties.dueDate.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err56];
                                    }
                                    else {
                                        vErrors.push(err56);
                                    }
                                    errors++;
                                }
                                if (typeof data17 === "string") {
                                    if (!pattern4.test(data17)) {
                                        const err57 = { instancePath: instancePath + "/data/rows/" + i1 + "/dueDate", schemaPath: "#/properties/data/properties/rows/items/properties/dueDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err57];
                                        }
                                        else {
                                            vErrors.push(err57);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            if (data8.paid !== undefined) {
                                let data18 = data8.paid;
                                if ((typeof data18 !== "boolean") && (data18 !== null)) {
                                    const err58 = { instancePath: instancePath + "/data/rows/" + i1 + "/paid", schemaPath: "#/properties/data/properties/rows/items/properties/paid/type", keyword: "type", params: { type: schema34.properties.data.properties.rows.items.properties.paid.type }, message: "must be boolean,null" };
                                    if (vErrors === null) {
                                        vErrors = [err58];
                                    }
                                    else {
                                        vErrors.push(err58);
                                    }
                                    errors++;
                                }
                            }
                            if (data8.categoryId !== undefined) {
                                let data19 = data8.categoryId;
                                if ((typeof data19 !== "string") && (data19 !== null)) {
                                    const err59 = { instancePath: instancePath + "/data/rows/" + i1 + "/categoryId", schemaPath: "#/properties/data/properties/rows/items/properties/categoryId/type", keyword: "type", params: { type: schema34.properties.data.properties.rows.items.properties.categoryId.type }, message: "must be string,null" };
                                    if (vErrors === null) {
                                        vErrors = [err59];
                                    }
                                    else {
                                        vErrors.push(err59);
                                    }
                                    errors++;
                                }
                                if (typeof data19 === "string") {
                                    if (!pattern0.test(data19)) {
                                        const err60 = { instancePath: instancePath + "/data/rows/" + i1 + "/categoryId", schemaPath: "#/properties/data/properties/rows/items/properties/categoryId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                        if (vErrors === null) {
                                            vErrors = [err60];
                                        }
                                        else {
                                            vErrors.push(err60);
                                        }
                                        errors++;
                                    }
                                }
                            }
                        }
                        else {
                            const err61 = { instancePath: instancePath + "/data/rows/" + i1, schemaPath: "#/properties/data/properties/rows/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                            if (vErrors === null) {
                                vErrors = [err61];
                            }
                            else {
                                vErrors.push(err61);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err62 = { instancePath: instancePath + "/data/rows", schemaPath: "#/properties/data/properties/rows/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err62];
                    }
                    else {
                        vErrors.push(err62);
                    }
                    errors++;
                }
            }
            if (data0.impact !== undefined) {
                let data20 = data0.impact;
                if (data20 && typeof data20 == "object" && !Array.isArray(data20)) {
                    if (data20.count === undefined) {
                        const err63 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/required", keyword: "required", params: { missingProperty: "count" }, message: "must have required property '" + "count" + "'" };
                        if (vErrors === null) {
                            vErrors = [err63];
                        }
                        else {
                            vErrors.push(err63);
                        }
                        errors++;
                    }
                    if (data20.paidCount === undefined) {
                        const err64 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/required", keyword: "required", params: { missingProperty: "paidCount" }, message: "must have required property '" + "paidCount" + "'" };
                        if (vErrors === null) {
                            vErrors = [err64];
                        }
                        else {
                            vErrors.push(err64);
                        }
                        errors++;
                    }
                    if (data20.cancelledCount === undefined) {
                        const err65 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/required", keyword: "required", params: { missingProperty: "cancelledCount" }, message: "must have required property '" + "cancelledCount" + "'" };
                        if (vErrors === null) {
                            vErrors = [err65];
                        }
                        else {
                            vErrors.push(err65);
                        }
                        errors++;
                    }
                    if (data20.categorisedCount === undefined) {
                        const err66 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/required", keyword: "required", params: { missingProperty: "categorisedCount" }, message: "must have required property '" + "categorisedCount" + "'" };
                        if (vErrors === null) {
                            vErrors = [err66];
                        }
                        else {
                            vErrors.push(err66);
                        }
                        errors++;
                    }
                    if (data20.changedCount === undefined) {
                        const err67 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/required", keyword: "required", params: { missingProperty: "changedCount" }, message: "must have required property '" + "changedCount" + "'" };
                        if (vErrors === null) {
                            vErrors = [err67];
                        }
                        else {
                            vErrors.push(err67);
                        }
                        errors++;
                    }
                    if (data20.categoryId === undefined) {
                        const err68 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/required", keyword: "required", params: { missingProperty: "categoryId" }, message: "must have required property '" + "categoryId" + "'" };
                        if (vErrors === null) {
                            vErrors = [err68];
                        }
                        else {
                            vErrors.push(err68);
                        }
                        errors++;
                    }
                    if (data20.paidDate === undefined) {
                        const err69 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/required", keyword: "required", params: { missingProperty: "paidDate" }, message: "must have required property '" + "paidDate" + "'" };
                        if (vErrors === null) {
                            vErrors = [err69];
                        }
                        else {
                            vErrors.push(err69);
                        }
                        errors++;
                    }
                    if (data20.accounts === undefined) {
                        const err70 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/required", keyword: "required", params: { missingProperty: "accounts" }, message: "must have required property '" + "accounts" + "'" };
                        if (vErrors === null) {
                            vErrors = [err70];
                        }
                        else {
                            vErrors.push(err70);
                        }
                        errors++;
                    }
                    for (const key3 in data20) {
                        if (!((((((((key3 === "count") || (key3 === "paidCount")) || (key3 === "cancelledCount")) || (key3 === "categorisedCount")) || (key3 === "changedCount")) || (key3 === "categoryId")) || (key3 === "paidDate")) || (key3 === "accounts"))) {
                            const err71 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                                vErrors = [err71];
                            }
                            else {
                                vErrors.push(err71);
                            }
                            errors++;
                        }
                    }
                    if (data20.count !== undefined) {
                        let data21 = data20.count;
                        if (!(((typeof data21 == "number") && (!(data21 % 1) && !isNaN(data21))) && (isFinite(data21)))) {
                            const err72 = { instancePath: instancePath + "/data/impact/count", schemaPath: "#/properties/data/properties/impact/properties/count/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                                vErrors = [err72];
                            }
                            else {
                                vErrors.push(err72);
                            }
                            errors++;
                        }
                        if ((typeof data21 == "number") && (isFinite(data21))) {
                            if (data21 > 500 || isNaN(data21)) {
                                const err73 = { instancePath: instancePath + "/data/impact/count", schemaPath: "#/properties/data/properties/impact/properties/count/maximum", keyword: "maximum", params: { comparison: "<=", limit: 500 }, message: "must be <= 500" };
                                if (vErrors === null) {
                                    vErrors = [err73];
                                }
                                else {
                                    vErrors.push(err73);
                                }
                                errors++;
                            }
                            if (data21 < 0 || isNaN(data21)) {
                                const err74 = { instancePath: instancePath + "/data/impact/count", schemaPath: "#/properties/data/properties/impact/properties/count/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                                if (vErrors === null) {
                                    vErrors = [err74];
                                }
                                else {
                                    vErrors.push(err74);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data20.paidCount !== undefined) {
                        let data22 = data20.paidCount;
                        if (!(((typeof data22 == "number") && (!(data22 % 1) && !isNaN(data22))) && (isFinite(data22)))) {
                            const err75 = { instancePath: instancePath + "/data/impact/paidCount", schemaPath: "#/properties/data/properties/impact/properties/paidCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                                vErrors = [err75];
                            }
                            else {
                                vErrors.push(err75);
                            }
                            errors++;
                        }
                        if ((typeof data22 == "number") && (isFinite(data22))) {
                            if (data22 > 500 || isNaN(data22)) {
                                const err76 = { instancePath: instancePath + "/data/impact/paidCount", schemaPath: "#/properties/data/properties/impact/properties/paidCount/maximum", keyword: "maximum", params: { comparison: "<=", limit: 500 }, message: "must be <= 500" };
                                if (vErrors === null) {
                                    vErrors = [err76];
                                }
                                else {
                                    vErrors.push(err76);
                                }
                                errors++;
                            }
                            if (data22 < 0 || isNaN(data22)) {
                                const err77 = { instancePath: instancePath + "/data/impact/paidCount", schemaPath: "#/properties/data/properties/impact/properties/paidCount/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                                if (vErrors === null) {
                                    vErrors = [err77];
                                }
                                else {
                                    vErrors.push(err77);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data20.cancelledCount !== undefined) {
                        let data23 = data20.cancelledCount;
                        if (!(((typeof data23 == "number") && (!(data23 % 1) && !isNaN(data23))) && (isFinite(data23)))) {
                            const err78 = { instancePath: instancePath + "/data/impact/cancelledCount", schemaPath: "#/properties/data/properties/impact/properties/cancelledCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                                vErrors = [err78];
                            }
                            else {
                                vErrors.push(err78);
                            }
                            errors++;
                        }
                        if ((typeof data23 == "number") && (isFinite(data23))) {
                            if (data23 > 500 || isNaN(data23)) {
                                const err79 = { instancePath: instancePath + "/data/impact/cancelledCount", schemaPath: "#/properties/data/properties/impact/properties/cancelledCount/maximum", keyword: "maximum", params: { comparison: "<=", limit: 500 }, message: "must be <= 500" };
                                if (vErrors === null) {
                                    vErrors = [err79];
                                }
                                else {
                                    vErrors.push(err79);
                                }
                                errors++;
                            }
                            if (data23 < 0 || isNaN(data23)) {
                                const err80 = { instancePath: instancePath + "/data/impact/cancelledCount", schemaPath: "#/properties/data/properties/impact/properties/cancelledCount/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                                if (vErrors === null) {
                                    vErrors = [err80];
                                }
                                else {
                                    vErrors.push(err80);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data20.categorisedCount !== undefined) {
                        let data24 = data20.categorisedCount;
                        if (!(((typeof data24 == "number") && (!(data24 % 1) && !isNaN(data24))) && (isFinite(data24)))) {
                            const err81 = { instancePath: instancePath + "/data/impact/categorisedCount", schemaPath: "#/properties/data/properties/impact/properties/categorisedCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                                vErrors = [err81];
                            }
                            else {
                                vErrors.push(err81);
                            }
                            errors++;
                        }
                        if ((typeof data24 == "number") && (isFinite(data24))) {
                            if (data24 > 500 || isNaN(data24)) {
                                const err82 = { instancePath: instancePath + "/data/impact/categorisedCount", schemaPath: "#/properties/data/properties/impact/properties/categorisedCount/maximum", keyword: "maximum", params: { comparison: "<=", limit: 500 }, message: "must be <= 500" };
                                if (vErrors === null) {
                                    vErrors = [err82];
                                }
                                else {
                                    vErrors.push(err82);
                                }
                                errors++;
                            }
                            if (data24 < 0 || isNaN(data24)) {
                                const err83 = { instancePath: instancePath + "/data/impact/categorisedCount", schemaPath: "#/properties/data/properties/impact/properties/categorisedCount/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                                if (vErrors === null) {
                                    vErrors = [err83];
                                }
                                else {
                                    vErrors.push(err83);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data20.changedCount !== undefined) {
                        let data25 = data20.changedCount;
                        if (!(((typeof data25 == "number") && (!(data25 % 1) && !isNaN(data25))) && (isFinite(data25)))) {
                            const err84 = { instancePath: instancePath + "/data/impact/changedCount", schemaPath: "#/properties/data/properties/impact/properties/changedCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                                vErrors = [err84];
                            }
                            else {
                                vErrors.push(err84);
                            }
                            errors++;
                        }
                        if ((typeof data25 == "number") && (isFinite(data25))) {
                            if (data25 > 500 || isNaN(data25)) {
                                const err85 = { instancePath: instancePath + "/data/impact/changedCount", schemaPath: "#/properties/data/properties/impact/properties/changedCount/maximum", keyword: "maximum", params: { comparison: "<=", limit: 500 }, message: "must be <= 500" };
                                if (vErrors === null) {
                                    vErrors = [err85];
                                }
                                else {
                                    vErrors.push(err85);
                                }
                                errors++;
                            }
                            if (data25 < 0 || isNaN(data25)) {
                                const err86 = { instancePath: instancePath + "/data/impact/changedCount", schemaPath: "#/properties/data/properties/impact/properties/changedCount/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                                if (vErrors === null) {
                                    vErrors = [err86];
                                }
                                else {
                                    vErrors.push(err86);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data20.categoryId !== undefined) {
                        let data26 = data20.categoryId;
                        if ((typeof data26 !== "string") && (data26 !== null)) {
                            const err87 = { instancePath: instancePath + "/data/impact/categoryId", schemaPath: "#/properties/data/properties/impact/properties/categoryId/type", keyword: "type", params: { type: schema34.properties.data.properties.impact.properties.categoryId.type }, message: "must be string,null" };
                            if (vErrors === null) {
                                vErrors = [err87];
                            }
                            else {
                                vErrors.push(err87);
                            }
                            errors++;
                        }
                        if (typeof data26 === "string") {
                            if (!pattern0.test(data26)) {
                                const err88 = { instancePath: instancePath + "/data/impact/categoryId", schemaPath: "#/properties/data/properties/impact/properties/categoryId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err88];
                                }
                                else {
                                    vErrors.push(err88);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data20.paidDate !== undefined) {
                        let data27 = data20.paidDate;
                        if ((typeof data27 !== "string") && (data27 !== null)) {
                            const err89 = { instancePath: instancePath + "/data/impact/paidDate", schemaPath: "#/properties/data/properties/impact/properties/paidDate/type", keyword: "type", params: { type: schema34.properties.data.properties.impact.properties.paidDate.type }, message: "must be string,null" };
                            if (vErrors === null) {
                                vErrors = [err89];
                            }
                            else {
                                vErrors.push(err89);
                            }
                            errors++;
                        }
                        if (typeof data27 === "string") {
                            if (!pattern4.test(data27)) {
                                const err90 = { instancePath: instancePath + "/data/impact/paidDate", schemaPath: "#/properties/data/properties/impact/properties/paidDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err90];
                                }
                                else {
                                    vErrors.push(err90);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data20.accounts !== undefined) {
                        let data28 = data20.accounts;
                        if (Array.isArray(data28)) {
                            if (data28.length > 500) {
                                const err91 = { instancePath: instancePath + "/data/impact/accounts", schemaPath: "#/properties/data/properties/impact/properties/accounts/maxItems", keyword: "maxItems", params: { limit: 500 }, message: "must NOT have more than 500 items" };
                                if (vErrors === null) {
                                    vErrors = [err91];
                                }
                                else {
                                    vErrors.push(err91);
                                }
                                errors++;
                            }
                            const len2 = data28.length;
                            for (let i2 = 0; i2 < len2; i2++) {
                                let data29 = data28[i2];
                                if (data29 && typeof data29 == "object" && !Array.isArray(data29)) {
                                    if (data29.accountId === undefined) {
                                        const err92 = { instancePath: instancePath + "/data/impact/accounts/" + i2, schemaPath: "#/properties/data/properties/impact/properties/accounts/items/required", keyword: "required", params: { missingProperty: "accountId" }, message: "must have required property '" + "accountId" + "'" };
                                        if (vErrors === null) {
                                            vErrors = [err92];
                                        }
                                        else {
                                            vErrors.push(err92);
                                        }
                                        errors++;
                                    }
                                    if (data29.currency === undefined) {
                                        const err93 = { instancePath: instancePath + "/data/impact/accounts/" + i2, schemaPath: "#/properties/data/properties/impact/properties/accounts/items/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                                        if (vErrors === null) {
                                            vErrors = [err93];
                                        }
                                        else {
                                            vErrors.push(err93);
                                        }
                                        errors++;
                                    }
                                    if (data29.deltaMinor === undefined) {
                                        const err94 = { instancePath: instancePath + "/data/impact/accounts/" + i2, schemaPath: "#/properties/data/properties/impact/properties/accounts/items/required", keyword: "required", params: { missingProperty: "deltaMinor" }, message: "must have required property '" + "deltaMinor" + "'" };
                                        if (vErrors === null) {
                                            vErrors = [err94];
                                        }
                                        else {
                                            vErrors.push(err94);
                                        }
                                        errors++;
                                    }
                                    for (const key4 in data29) {
                                        if (!(((key4 === "accountId") || (key4 === "currency")) || (key4 === "deltaMinor"))) {
                                            const err95 = { instancePath: instancePath + "/data/impact/accounts/" + i2, schemaPath: "#/properties/data/properties/impact/properties/accounts/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key4 }, message: "must NOT have additional properties" };
                                            if (vErrors === null) {
                                                vErrors = [err95];
                                            }
                                            else {
                                                vErrors.push(err95);
                                            }
                                            errors++;
                                        }
                                    }
                                    if (data29.accountId !== undefined) {
                                        let data30 = data29.accountId;
                                        if (typeof data30 === "string") {
                                            if (!pattern0.test(data30)) {
                                                const err96 = { instancePath: instancePath + "/data/impact/accounts/" + i2 + "/accountId", schemaPath: "#/properties/data/properties/impact/properties/accounts/items/properties/accountId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                                if (vErrors === null) {
                                                    vErrors = [err96];
                                                }
                                                else {
                                                    vErrors.push(err96);
                                                }
                                                errors++;
                                            }
                                        }
                                        else {
                                            const err97 = { instancePath: instancePath + "/data/impact/accounts/" + i2 + "/accountId", schemaPath: "#/properties/data/properties/impact/properties/accounts/items/properties/accountId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                            if (vErrors === null) {
                                                vErrors = [err97];
                                            }
                                            else {
                                                vErrors.push(err97);
                                            }
                                            errors++;
                                        }
                                    }
                                    if (data29.currency !== undefined) {
                                        let data31 = data29.currency;
                                        if (typeof data31 !== "string") {
                                            const err98 = { instancePath: instancePath + "/data/impact/accounts/" + i2 + "/currency", schemaPath: "#/properties/data/properties/impact/properties/accounts/items/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                            if (vErrors === null) {
                                                vErrors = [err98];
                                            }
                                            else {
                                                vErrors.push(err98);
                                            }
                                            errors++;
                                        }
                                        if (!(((data31 === "BRL") || (data31 === "CAD")) || (data31 === "USD"))) {
                                            const err99 = { instancePath: instancePath + "/data/impact/accounts/" + i2 + "/currency", schemaPath: "#/properties/data/properties/impact/properties/accounts/items/properties/currency/enum", keyword: "enum", params: { allowedValues: schema34.properties.data.properties.impact.properties.accounts.items.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                                            if (vErrors === null) {
                                                vErrors = [err99];
                                            }
                                            else {
                                                vErrors.push(err99);
                                            }
                                            errors++;
                                        }
                                    }
                                    if (data29.deltaMinor !== undefined) {
                                        let data32 = data29.deltaMinor;
                                        if (typeof data32 === "string") {
                                            if (!pattern3.test(data32)) {
                                                const err100 = { instancePath: instancePath + "/data/impact/accounts/" + i2 + "/deltaMinor", schemaPath: "#/properties/data/properties/impact/properties/accounts/items/properties/deltaMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                                if (vErrors === null) {
                                                    vErrors = [err100];
                                                }
                                                else {
                                                    vErrors.push(err100);
                                                }
                                                errors++;
                                            }
                                        }
                                        else {
                                            const err101 = { instancePath: instancePath + "/data/impact/accounts/" + i2 + "/deltaMinor", schemaPath: "#/properties/data/properties/impact/properties/accounts/items/properties/deltaMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                            if (vErrors === null) {
                                                vErrors = [err101];
                                            }
                                            else {
                                                vErrors.push(err101);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                                else {
                                    const err102 = { instancePath: instancePath + "/data/impact/accounts/" + i2, schemaPath: "#/properties/data/properties/impact/properties/accounts/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                    if (vErrors === null) {
                                        vErrors = [err102];
                                    }
                                    else {
                                        vErrors.push(err102);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err103 = { instancePath: instancePath + "/data/impact/accounts", schemaPath: "#/properties/data/properties/impact/properties/accounts/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                            if (vErrors === null) {
                                vErrors = [err103];
                            }
                            else {
                                vErrors.push(err103);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err104 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                        vErrors = [err104];
                    }
                    else {
                        vErrors.push(err104);
                    }
                    errors++;
                }
            }
        }
        else {
            const err105 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err105];
            }
            else {
                vErrors.push(err105);
            }
            errors++;
        }
    }
    if (data.meta !== undefined) {
        let data33 = data.meta;
        if (data33 && typeof data33 == "object" && !Array.isArray(data33)) {
            if (data33.requestId === undefined) {
                const err106 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "requestId" }, message: "must have required property '" + "requestId" + "'" };
                if (vErrors === null) {
                    vErrors = [err106];
                }
                else {
                    vErrors.push(err106);
                }
                errors++;
            }
            if (data33.asOf === undefined) {
                const err107 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "asOf" }, message: "must have required property '" + "asOf" + "'" };
                if (vErrors === null) {
                    vErrors = [err107];
                }
                else {
                    vErrors.push(err107);
                }
                errors++;
            }
            if (data33.businessToday === undefined) {
                const err108 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err108];
                }
                else {
                    vErrors.push(err108);
                }
                errors++;
            }
            if (data33.timeZone === undefined) {
                const err109 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "timeZone" }, message: "must have required property '" + "timeZone" + "'" };
                if (vErrors === null) {
                    vErrors = [err109];
                }
                else {
                    vErrors.push(err109);
                }
                errors++;
            }
            if (data33.dataRevision === undefined) {
                const err110 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "dataRevision" }, message: "must have required property '" + "dataRevision" + "'" };
                if (vErrors === null) {
                    vErrors = [err110];
                }
                else {
                    vErrors.push(err110);
                }
                errors++;
            }
            for (const key5 in data33) {
                if (!(((((key5 === "requestId") || (key5 === "asOf")) || (key5 === "businessToday")) || (key5 === "timeZone")) || (key5 === "dataRevision"))) {
                    const err111 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key5 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err111];
                    }
                    else {
                        vErrors.push(err111);
                    }
                    errors++;
                }
            }
            if (data33.requestId !== undefined) {
                let data34 = data33.requestId;
                if (typeof data34 === "string") {
                    if (func2(data34) > 64) {
                        const err112 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err112];
                        }
                        else {
                            vErrors.push(err112);
                        }
                        errors++;
                    }
                    if (func2(data34) < 1) {
                        const err113 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err113];
                        }
                        else {
                            vErrors.push(err113);
                        }
                        errors++;
                    }
                }
                else {
                    const err114 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err114];
                    }
                    else {
                        vErrors.push(err114);
                    }
                    errors++;
                }
            }
            if (data33.asOf !== undefined) {
                let data35 = data33.asOf;
                if (typeof data35 === "string") {
                    if (func2(data35) > 64) {
                        const err115 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err115];
                        }
                        else {
                            vErrors.push(err115);
                        }
                        errors++;
                    }
                    if (func2(data35) < 1) {
                        const err116 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err116];
                        }
                        else {
                            vErrors.push(err116);
                        }
                        errors++;
                    }
                }
                else {
                    const err117 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err117];
                    }
                    else {
                        vErrors.push(err117);
                    }
                    errors++;
                }
            }
            if (data33.businessToday !== undefined) {
                let data36 = data33.businessToday;
                if (typeof data36 === "string") {
                    if (!pattern4.test(data36)) {
                        const err118 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err118];
                        }
                        else {
                            vErrors.push(err118);
                        }
                        errors++;
                    }
                }
                else {
                    const err119 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err119];
                    }
                    else {
                        vErrors.push(err119);
                    }
                    errors++;
                }
            }
            if (data33.timeZone !== undefined) {
                let data37 = data33.timeZone;
                if (typeof data37 === "string") {
                    if (func2(data37) > 64) {
                        const err120 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err120];
                        }
                        else {
                            vErrors.push(err120);
                        }
                        errors++;
                    }
                    if (func2(data37) < 1) {
                        const err121 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err121];
                        }
                        else {
                            vErrors.push(err121);
                        }
                        errors++;
                    }
                }
                else {
                    const err122 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err122];
                    }
                    else {
                        vErrors.push(err122);
                    }
                    errors++;
                }
            }
            if (data33.dataRevision !== undefined) {
                let data38 = data33.dataRevision;
                if (typeof data38 === "string") {
                    if (!pattern2.test(data38)) {
                        const err123 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err123];
                        }
                        else {
                            vErrors.push(err123);
                        }
                        errors++;
                    }
                }
                else {
                    const err124 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err124];
                    }
                    else {
                        vErrors.push(err124);
                    }
                    errors++;
                }
            }
        }
        else {
            const err125 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err125];
            }
            else {
                vErrors.push(err125);
            }
            errors++;
        }
    }
}
else {
    const err126 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
        vErrors = [err126];
    }
    else {
        vErrors.push(err126);
    }
    errors++;
} validate33.errors = vErrors; return errors === 0; }
export const validateLedgerBulkResultEnvelope = validate34;
const schema35 = { "$id": "https://saldo.local/schemas/ledger-bulk-result-envelope.json", "$schema": "http://json-schema.org/draft-07/schema#", "title": "LedgerBulkResultEnvelope", "type": "object", "additionalProperties": false, "required": ["data", "meta"], "properties": { "data": { "type": "object", "additionalProperties": false, "required": ["entryIds", "count", "impact"], "properties": { "entryIds": { "type": "array", "minItems": 1, "maxItems": 500, "items": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" } }, "count": { "type": "integer", "minimum": 0, "maximum": 500 }, "impact": { "type": "object", "additionalProperties": false, "required": ["count", "paidCount", "cancelledCount", "categorisedCount", "changedCount", "categoryId", "paidDate", "accounts"], "properties": { "count": { "type": "integer", "minimum": 0, "maximum": 500 }, "paidCount": { "type": "integer", "minimum": 0, "maximum": 500 }, "cancelledCount": { "type": "integer", "minimum": 0, "maximum": 500 }, "categorisedCount": { "type": "integer", "minimum": 0, "maximum": 500 }, "changedCount": { "type": "integer", "minimum": 0, "maximum": 500 }, "categoryId": { "type": ["string", "null"], "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "paidDate": { "type": ["string", "null"], "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "accounts": { "type": "array", "maxItems": 500, "items": { "type": "object", "additionalProperties": false, "required": ["accountId", "currency", "deltaMinor"], "properties": { "accountId": { "type": "string", "pattern": "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, "currency": { "type": "string", "enum": ["BRL", "CAD", "USD"] }, "deltaMinor": { "type": "string", "pattern": "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" } } } } } } } }, "meta": { "type": "object", "additionalProperties": false, "required": ["requestId", "asOf", "businessToday", "timeZone", "dataRevision"], "properties": { "requestId": { "type": "string", "minLength": 1, "maxLength": 64 }, "asOf": { "type": "string", "minLength": 1, "maxLength": 64 }, "businessToday": { "type": "string", "pattern": "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, "timeZone": { "type": "string", "minLength": 1, "maxLength": 64 }, "dataRevision": { "type": "string", "pattern": "^[1-9][0-9]*$" } } } } };
function validate34(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { /*# sourceURL="https://saldo.local/schemas/ledger-bulk-result-envelope.json" */ ; let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.data === undefined) {
        const err0 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "data" }, message: "must have required property '" + "data" + "'" };
        if (vErrors === null) {
            vErrors = [err0];
        }
        else {
            vErrors.push(err0);
        }
        errors++;
    }
    if (data.meta === undefined) {
        const err1 = { instancePath, schemaPath: "#/required", keyword: "required", params: { missingProperty: "meta" }, message: "must have required property '" + "meta" + "'" };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
    }
    for (const key0 in data) {
        if (!((key0 === "data") || (key0 === "meta"))) {
            const err2 = { instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties" };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.data !== undefined) {
        let data0 = data.data;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.entryIds === undefined) {
                const err3 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "entryIds" }, message: "must have required property '" + "entryIds" + "'" };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
            }
            if (data0.count === undefined) {
                const err4 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "count" }, message: "must have required property '" + "count" + "'" };
                if (vErrors === null) {
                    vErrors = [err4];
                }
                else {
                    vErrors.push(err4);
                }
                errors++;
            }
            if (data0.impact === undefined) {
                const err5 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/required", keyword: "required", params: { missingProperty: "impact" }, message: "must have required property '" + "impact" + "'" };
                if (vErrors === null) {
                    vErrors = [err5];
                }
                else {
                    vErrors.push(err5);
                }
                errors++;
            }
            for (const key1 in data0) {
                if (!(((key1 === "entryIds") || (key1 === "count")) || (key1 === "impact"))) {
                    const err6 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key1 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err6];
                    }
                    else {
                        vErrors.push(err6);
                    }
                    errors++;
                }
            }
            if (data0.entryIds !== undefined) {
                let data1 = data0.entryIds;
                if (Array.isArray(data1)) {
                    if (data1.length > 500) {
                        const err7 = { instancePath: instancePath + "/data/entryIds", schemaPath: "#/properties/data/properties/entryIds/maxItems", keyword: "maxItems", params: { limit: 500 }, message: "must NOT have more than 500 items" };
                        if (vErrors === null) {
                            vErrors = [err7];
                        }
                        else {
                            vErrors.push(err7);
                        }
                        errors++;
                    }
                    if (data1.length < 1) {
                        const err8 = { instancePath: instancePath + "/data/entryIds", schemaPath: "#/properties/data/properties/entryIds/minItems", keyword: "minItems", params: { limit: 1 }, message: "must NOT have fewer than 1 items" };
                        if (vErrors === null) {
                            vErrors = [err8];
                        }
                        else {
                            vErrors.push(err8);
                        }
                        errors++;
                    }
                    const len0 = data1.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                        let data2 = data1[i0];
                        if (typeof data2 === "string") {
                            if (!pattern0.test(data2)) {
                                const err9 = { instancePath: instancePath + "/data/entryIds/" + i0, schemaPath: "#/properties/data/properties/entryIds/items/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err9];
                                }
                                else {
                                    vErrors.push(err9);
                                }
                                errors++;
                            }
                        }
                        else {
                            const err10 = { instancePath: instancePath + "/data/entryIds/" + i0, schemaPath: "#/properties/data/properties/entryIds/items/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                            if (vErrors === null) {
                                vErrors = [err10];
                            }
                            else {
                                vErrors.push(err10);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err11 = { instancePath: instancePath + "/data/entryIds", schemaPath: "#/properties/data/properties/entryIds/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                    if (vErrors === null) {
                        vErrors = [err11];
                    }
                    else {
                        vErrors.push(err11);
                    }
                    errors++;
                }
            }
            if (data0.count !== undefined) {
                let data3 = data0.count;
                if (!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))) {
                    const err12 = { instancePath: instancePath + "/data/count", schemaPath: "#/properties/data/properties/count/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                    if (vErrors === null) {
                        vErrors = [err12];
                    }
                    else {
                        vErrors.push(err12);
                    }
                    errors++;
                }
                if ((typeof data3 == "number") && (isFinite(data3))) {
                    if (data3 > 500 || isNaN(data3)) {
                        const err13 = { instancePath: instancePath + "/data/count", schemaPath: "#/properties/data/properties/count/maximum", keyword: "maximum", params: { comparison: "<=", limit: 500 }, message: "must be <= 500" };
                        if (vErrors === null) {
                            vErrors = [err13];
                        }
                        else {
                            vErrors.push(err13);
                        }
                        errors++;
                    }
                    if (data3 < 0 || isNaN(data3)) {
                        const err14 = { instancePath: instancePath + "/data/count", schemaPath: "#/properties/data/properties/count/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                        if (vErrors === null) {
                            vErrors = [err14];
                        }
                        else {
                            vErrors.push(err14);
                        }
                        errors++;
                    }
                }
            }
            if (data0.impact !== undefined) {
                let data4 = data0.impact;
                if (data4 && typeof data4 == "object" && !Array.isArray(data4)) {
                    if (data4.count === undefined) {
                        const err15 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/required", keyword: "required", params: { missingProperty: "count" }, message: "must have required property '" + "count" + "'" };
                        if (vErrors === null) {
                            vErrors = [err15];
                        }
                        else {
                            vErrors.push(err15);
                        }
                        errors++;
                    }
                    if (data4.paidCount === undefined) {
                        const err16 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/required", keyword: "required", params: { missingProperty: "paidCount" }, message: "must have required property '" + "paidCount" + "'" };
                        if (vErrors === null) {
                            vErrors = [err16];
                        }
                        else {
                            vErrors.push(err16);
                        }
                        errors++;
                    }
                    if (data4.cancelledCount === undefined) {
                        const err17 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/required", keyword: "required", params: { missingProperty: "cancelledCount" }, message: "must have required property '" + "cancelledCount" + "'" };
                        if (vErrors === null) {
                            vErrors = [err17];
                        }
                        else {
                            vErrors.push(err17);
                        }
                        errors++;
                    }
                    if (data4.categorisedCount === undefined) {
                        const err18 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/required", keyword: "required", params: { missingProperty: "categorisedCount" }, message: "must have required property '" + "categorisedCount" + "'" };
                        if (vErrors === null) {
                            vErrors = [err18];
                        }
                        else {
                            vErrors.push(err18);
                        }
                        errors++;
                    }
                    if (data4.changedCount === undefined) {
                        const err19 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/required", keyword: "required", params: { missingProperty: "changedCount" }, message: "must have required property '" + "changedCount" + "'" };
                        if (vErrors === null) {
                            vErrors = [err19];
                        }
                        else {
                            vErrors.push(err19);
                        }
                        errors++;
                    }
                    if (data4.categoryId === undefined) {
                        const err20 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/required", keyword: "required", params: { missingProperty: "categoryId" }, message: "must have required property '" + "categoryId" + "'" };
                        if (vErrors === null) {
                            vErrors = [err20];
                        }
                        else {
                            vErrors.push(err20);
                        }
                        errors++;
                    }
                    if (data4.paidDate === undefined) {
                        const err21 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/required", keyword: "required", params: { missingProperty: "paidDate" }, message: "must have required property '" + "paidDate" + "'" };
                        if (vErrors === null) {
                            vErrors = [err21];
                        }
                        else {
                            vErrors.push(err21);
                        }
                        errors++;
                    }
                    if (data4.accounts === undefined) {
                        const err22 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/required", keyword: "required", params: { missingProperty: "accounts" }, message: "must have required property '" + "accounts" + "'" };
                        if (vErrors === null) {
                            vErrors = [err22];
                        }
                        else {
                            vErrors.push(err22);
                        }
                        errors++;
                    }
                    for (const key2 in data4) {
                        if (!((((((((key2 === "count") || (key2 === "paidCount")) || (key2 === "cancelledCount")) || (key2 === "categorisedCount")) || (key2 === "changedCount")) || (key2 === "categoryId")) || (key2 === "paidDate")) || (key2 === "accounts"))) {
                            const err23 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key2 }, message: "must NOT have additional properties" };
                            if (vErrors === null) {
                                vErrors = [err23];
                            }
                            else {
                                vErrors.push(err23);
                            }
                            errors++;
                        }
                    }
                    if (data4.count !== undefined) {
                        let data5 = data4.count;
                        if (!(((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5))) && (isFinite(data5)))) {
                            const err24 = { instancePath: instancePath + "/data/impact/count", schemaPath: "#/properties/data/properties/impact/properties/count/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                                vErrors = [err24];
                            }
                            else {
                                vErrors.push(err24);
                            }
                            errors++;
                        }
                        if ((typeof data5 == "number") && (isFinite(data5))) {
                            if (data5 > 500 || isNaN(data5)) {
                                const err25 = { instancePath: instancePath + "/data/impact/count", schemaPath: "#/properties/data/properties/impact/properties/count/maximum", keyword: "maximum", params: { comparison: "<=", limit: 500 }, message: "must be <= 500" };
                                if (vErrors === null) {
                                    vErrors = [err25];
                                }
                                else {
                                    vErrors.push(err25);
                                }
                                errors++;
                            }
                            if (data5 < 0 || isNaN(data5)) {
                                const err26 = { instancePath: instancePath + "/data/impact/count", schemaPath: "#/properties/data/properties/impact/properties/count/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                                if (vErrors === null) {
                                    vErrors = [err26];
                                }
                                else {
                                    vErrors.push(err26);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data4.paidCount !== undefined) {
                        let data6 = data4.paidCount;
                        if (!(((typeof data6 == "number") && (!(data6 % 1) && !isNaN(data6))) && (isFinite(data6)))) {
                            const err27 = { instancePath: instancePath + "/data/impact/paidCount", schemaPath: "#/properties/data/properties/impact/properties/paidCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                                vErrors = [err27];
                            }
                            else {
                                vErrors.push(err27);
                            }
                            errors++;
                        }
                        if ((typeof data6 == "number") && (isFinite(data6))) {
                            if (data6 > 500 || isNaN(data6)) {
                                const err28 = { instancePath: instancePath + "/data/impact/paidCount", schemaPath: "#/properties/data/properties/impact/properties/paidCount/maximum", keyword: "maximum", params: { comparison: "<=", limit: 500 }, message: "must be <= 500" };
                                if (vErrors === null) {
                                    vErrors = [err28];
                                }
                                else {
                                    vErrors.push(err28);
                                }
                                errors++;
                            }
                            if (data6 < 0 || isNaN(data6)) {
                                const err29 = { instancePath: instancePath + "/data/impact/paidCount", schemaPath: "#/properties/data/properties/impact/properties/paidCount/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                                if (vErrors === null) {
                                    vErrors = [err29];
                                }
                                else {
                                    vErrors.push(err29);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data4.cancelledCount !== undefined) {
                        let data7 = data4.cancelledCount;
                        if (!(((typeof data7 == "number") && (!(data7 % 1) && !isNaN(data7))) && (isFinite(data7)))) {
                            const err30 = { instancePath: instancePath + "/data/impact/cancelledCount", schemaPath: "#/properties/data/properties/impact/properties/cancelledCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                                vErrors = [err30];
                            }
                            else {
                                vErrors.push(err30);
                            }
                            errors++;
                        }
                        if ((typeof data7 == "number") && (isFinite(data7))) {
                            if (data7 > 500 || isNaN(data7)) {
                                const err31 = { instancePath: instancePath + "/data/impact/cancelledCount", schemaPath: "#/properties/data/properties/impact/properties/cancelledCount/maximum", keyword: "maximum", params: { comparison: "<=", limit: 500 }, message: "must be <= 500" };
                                if (vErrors === null) {
                                    vErrors = [err31];
                                }
                                else {
                                    vErrors.push(err31);
                                }
                                errors++;
                            }
                            if (data7 < 0 || isNaN(data7)) {
                                const err32 = { instancePath: instancePath + "/data/impact/cancelledCount", schemaPath: "#/properties/data/properties/impact/properties/cancelledCount/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                                if (vErrors === null) {
                                    vErrors = [err32];
                                }
                                else {
                                    vErrors.push(err32);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data4.categorisedCount !== undefined) {
                        let data8 = data4.categorisedCount;
                        if (!(((typeof data8 == "number") && (!(data8 % 1) && !isNaN(data8))) && (isFinite(data8)))) {
                            const err33 = { instancePath: instancePath + "/data/impact/categorisedCount", schemaPath: "#/properties/data/properties/impact/properties/categorisedCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                                vErrors = [err33];
                            }
                            else {
                                vErrors.push(err33);
                            }
                            errors++;
                        }
                        if ((typeof data8 == "number") && (isFinite(data8))) {
                            if (data8 > 500 || isNaN(data8)) {
                                const err34 = { instancePath: instancePath + "/data/impact/categorisedCount", schemaPath: "#/properties/data/properties/impact/properties/categorisedCount/maximum", keyword: "maximum", params: { comparison: "<=", limit: 500 }, message: "must be <= 500" };
                                if (vErrors === null) {
                                    vErrors = [err34];
                                }
                                else {
                                    vErrors.push(err34);
                                }
                                errors++;
                            }
                            if (data8 < 0 || isNaN(data8)) {
                                const err35 = { instancePath: instancePath + "/data/impact/categorisedCount", schemaPath: "#/properties/data/properties/impact/properties/categorisedCount/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                                if (vErrors === null) {
                                    vErrors = [err35];
                                }
                                else {
                                    vErrors.push(err35);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data4.changedCount !== undefined) {
                        let data9 = data4.changedCount;
                        if (!(((typeof data9 == "number") && (!(data9 % 1) && !isNaN(data9))) && (isFinite(data9)))) {
                            const err36 = { instancePath: instancePath + "/data/impact/changedCount", schemaPath: "#/properties/data/properties/impact/properties/changedCount/type", keyword: "type", params: { type: "integer" }, message: "must be integer" };
                            if (vErrors === null) {
                                vErrors = [err36];
                            }
                            else {
                                vErrors.push(err36);
                            }
                            errors++;
                        }
                        if ((typeof data9 == "number") && (isFinite(data9))) {
                            if (data9 > 500 || isNaN(data9)) {
                                const err37 = { instancePath: instancePath + "/data/impact/changedCount", schemaPath: "#/properties/data/properties/impact/properties/changedCount/maximum", keyword: "maximum", params: { comparison: "<=", limit: 500 }, message: "must be <= 500" };
                                if (vErrors === null) {
                                    vErrors = [err37];
                                }
                                else {
                                    vErrors.push(err37);
                                }
                                errors++;
                            }
                            if (data9 < 0 || isNaN(data9)) {
                                const err38 = { instancePath: instancePath + "/data/impact/changedCount", schemaPath: "#/properties/data/properties/impact/properties/changedCount/minimum", keyword: "minimum", params: { comparison: ">=", limit: 0 }, message: "must be >= 0" };
                                if (vErrors === null) {
                                    vErrors = [err38];
                                }
                                else {
                                    vErrors.push(err38);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data4.categoryId !== undefined) {
                        let data10 = data4.categoryId;
                        if ((typeof data10 !== "string") && (data10 !== null)) {
                            const err39 = { instancePath: instancePath + "/data/impact/categoryId", schemaPath: "#/properties/data/properties/impact/properties/categoryId/type", keyword: "type", params: { type: schema35.properties.data.properties.impact.properties.categoryId.type }, message: "must be string,null" };
                            if (vErrors === null) {
                                vErrors = [err39];
                            }
                            else {
                                vErrors.push(err39);
                            }
                            errors++;
                        }
                        if (typeof data10 === "string") {
                            if (!pattern0.test(data10)) {
                                const err40 = { instancePath: instancePath + "/data/impact/categoryId", schemaPath: "#/properties/data/properties/impact/properties/categoryId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err40];
                                }
                                else {
                                    vErrors.push(err40);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data4.paidDate !== undefined) {
                        let data11 = data4.paidDate;
                        if ((typeof data11 !== "string") && (data11 !== null)) {
                            const err41 = { instancePath: instancePath + "/data/impact/paidDate", schemaPath: "#/properties/data/properties/impact/properties/paidDate/type", keyword: "type", params: { type: schema35.properties.data.properties.impact.properties.paidDate.type }, message: "must be string,null" };
                            if (vErrors === null) {
                                vErrors = [err41];
                            }
                            else {
                                vErrors.push(err41);
                            }
                            errors++;
                        }
                        if (typeof data11 === "string") {
                            if (!pattern4.test(data11)) {
                                const err42 = { instancePath: instancePath + "/data/impact/paidDate", schemaPath: "#/properties/data/properties/impact/properties/paidDate/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                                if (vErrors === null) {
                                    vErrors = [err42];
                                }
                                else {
                                    vErrors.push(err42);
                                }
                                errors++;
                            }
                        }
                    }
                    if (data4.accounts !== undefined) {
                        let data12 = data4.accounts;
                        if (Array.isArray(data12)) {
                            if (data12.length > 500) {
                                const err43 = { instancePath: instancePath + "/data/impact/accounts", schemaPath: "#/properties/data/properties/impact/properties/accounts/maxItems", keyword: "maxItems", params: { limit: 500 }, message: "must NOT have more than 500 items" };
                                if (vErrors === null) {
                                    vErrors = [err43];
                                }
                                else {
                                    vErrors.push(err43);
                                }
                                errors++;
                            }
                            const len1 = data12.length;
                            for (let i1 = 0; i1 < len1; i1++) {
                                let data13 = data12[i1];
                                if (data13 && typeof data13 == "object" && !Array.isArray(data13)) {
                                    if (data13.accountId === undefined) {
                                        const err44 = { instancePath: instancePath + "/data/impact/accounts/" + i1, schemaPath: "#/properties/data/properties/impact/properties/accounts/items/required", keyword: "required", params: { missingProperty: "accountId" }, message: "must have required property '" + "accountId" + "'" };
                                        if (vErrors === null) {
                                            vErrors = [err44];
                                        }
                                        else {
                                            vErrors.push(err44);
                                        }
                                        errors++;
                                    }
                                    if (data13.currency === undefined) {
                                        const err45 = { instancePath: instancePath + "/data/impact/accounts/" + i1, schemaPath: "#/properties/data/properties/impact/properties/accounts/items/required", keyword: "required", params: { missingProperty: "currency" }, message: "must have required property '" + "currency" + "'" };
                                        if (vErrors === null) {
                                            vErrors = [err45];
                                        }
                                        else {
                                            vErrors.push(err45);
                                        }
                                        errors++;
                                    }
                                    if (data13.deltaMinor === undefined) {
                                        const err46 = { instancePath: instancePath + "/data/impact/accounts/" + i1, schemaPath: "#/properties/data/properties/impact/properties/accounts/items/required", keyword: "required", params: { missingProperty: "deltaMinor" }, message: "must have required property '" + "deltaMinor" + "'" };
                                        if (vErrors === null) {
                                            vErrors = [err46];
                                        }
                                        else {
                                            vErrors.push(err46);
                                        }
                                        errors++;
                                    }
                                    for (const key3 in data13) {
                                        if (!(((key3 === "accountId") || (key3 === "currency")) || (key3 === "deltaMinor"))) {
                                            const err47 = { instancePath: instancePath + "/data/impact/accounts/" + i1, schemaPath: "#/properties/data/properties/impact/properties/accounts/items/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key3 }, message: "must NOT have additional properties" };
                                            if (vErrors === null) {
                                                vErrors = [err47];
                                            }
                                            else {
                                                vErrors.push(err47);
                                            }
                                            errors++;
                                        }
                                    }
                                    if (data13.accountId !== undefined) {
                                        let data14 = data13.accountId;
                                        if (typeof data14 === "string") {
                                            if (!pattern0.test(data14)) {
                                                const err48 = { instancePath: instancePath + "/data/impact/accounts/" + i1 + "/accountId", schemaPath: "#/properties/data/properties/impact/properties/accounts/items/properties/accountId/pattern", keyword: "pattern", params: { pattern: "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" }, message: "must match pattern \"" + "^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$" + "\"" };
                                                if (vErrors === null) {
                                                    vErrors = [err48];
                                                }
                                                else {
                                                    vErrors.push(err48);
                                                }
                                                errors++;
                                            }
                                        }
                                        else {
                                            const err49 = { instancePath: instancePath + "/data/impact/accounts/" + i1 + "/accountId", schemaPath: "#/properties/data/properties/impact/properties/accounts/items/properties/accountId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                            if (vErrors === null) {
                                                vErrors = [err49];
                                            }
                                            else {
                                                vErrors.push(err49);
                                            }
                                            errors++;
                                        }
                                    }
                                    if (data13.currency !== undefined) {
                                        let data15 = data13.currency;
                                        if (typeof data15 !== "string") {
                                            const err50 = { instancePath: instancePath + "/data/impact/accounts/" + i1 + "/currency", schemaPath: "#/properties/data/properties/impact/properties/accounts/items/properties/currency/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                            if (vErrors === null) {
                                                vErrors = [err50];
                                            }
                                            else {
                                                vErrors.push(err50);
                                            }
                                            errors++;
                                        }
                                        if (!(((data15 === "BRL") || (data15 === "CAD")) || (data15 === "USD"))) {
                                            const err51 = { instancePath: instancePath + "/data/impact/accounts/" + i1 + "/currency", schemaPath: "#/properties/data/properties/impact/properties/accounts/items/properties/currency/enum", keyword: "enum", params: { allowedValues: schema35.properties.data.properties.impact.properties.accounts.items.properties.currency.enum }, message: "must be equal to one of the allowed values" };
                                            if (vErrors === null) {
                                                vErrors = [err51];
                                            }
                                            else {
                                                vErrors.push(err51);
                                            }
                                            errors++;
                                        }
                                    }
                                    if (data13.deltaMinor !== undefined) {
                                        let data16 = data13.deltaMinor;
                                        if (typeof data16 === "string") {
                                            if (!pattern3.test(data16)) {
                                                const err52 = { instancePath: instancePath + "/data/impact/accounts/" + i1 + "/deltaMinor", schemaPath: "#/properties/data/properties/impact/properties/accounts/items/properties/deltaMinor/pattern", keyword: "pattern", params: { pattern: "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" }, message: "must match pattern \"" + "^(?:0|[1-9][0-9]*|-[1-9][0-9]*)$" + "\"" };
                                                if (vErrors === null) {
                                                    vErrors = [err52];
                                                }
                                                else {
                                                    vErrors.push(err52);
                                                }
                                                errors++;
                                            }
                                        }
                                        else {
                                            const err53 = { instancePath: instancePath + "/data/impact/accounts/" + i1 + "/deltaMinor", schemaPath: "#/properties/data/properties/impact/properties/accounts/items/properties/deltaMinor/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                                            if (vErrors === null) {
                                                vErrors = [err53];
                                            }
                                            else {
                                                vErrors.push(err53);
                                            }
                                            errors++;
                                        }
                                    }
                                }
                                else {
                                    const err54 = { instancePath: instancePath + "/data/impact/accounts/" + i1, schemaPath: "#/properties/data/properties/impact/properties/accounts/items/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                                    if (vErrors === null) {
                                        vErrors = [err54];
                                    }
                                    else {
                                        vErrors.push(err54);
                                    }
                                    errors++;
                                }
                            }
                        }
                        else {
                            const err55 = { instancePath: instancePath + "/data/impact/accounts", schemaPath: "#/properties/data/properties/impact/properties/accounts/type", keyword: "type", params: { type: "array" }, message: "must be array" };
                            if (vErrors === null) {
                                vErrors = [err55];
                            }
                            else {
                                vErrors.push(err55);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err56 = { instancePath: instancePath + "/data/impact", schemaPath: "#/properties/data/properties/impact/type", keyword: "type", params: { type: "object" }, message: "must be object" };
                    if (vErrors === null) {
                        vErrors = [err56];
                    }
                    else {
                        vErrors.push(err56);
                    }
                    errors++;
                }
            }
        }
        else {
            const err57 = { instancePath: instancePath + "/data", schemaPath: "#/properties/data/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err57];
            }
            else {
                vErrors.push(err57);
            }
            errors++;
        }
    }
    if (data.meta !== undefined) {
        let data17 = data.meta;
        if (data17 && typeof data17 == "object" && !Array.isArray(data17)) {
            if (data17.requestId === undefined) {
                const err58 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "requestId" }, message: "must have required property '" + "requestId" + "'" };
                if (vErrors === null) {
                    vErrors = [err58];
                }
                else {
                    vErrors.push(err58);
                }
                errors++;
            }
            if (data17.asOf === undefined) {
                const err59 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "asOf" }, message: "must have required property '" + "asOf" + "'" };
                if (vErrors === null) {
                    vErrors = [err59];
                }
                else {
                    vErrors.push(err59);
                }
                errors++;
            }
            if (data17.businessToday === undefined) {
                const err60 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "businessToday" }, message: "must have required property '" + "businessToday" + "'" };
                if (vErrors === null) {
                    vErrors = [err60];
                }
                else {
                    vErrors.push(err60);
                }
                errors++;
            }
            if (data17.timeZone === undefined) {
                const err61 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "timeZone" }, message: "must have required property '" + "timeZone" + "'" };
                if (vErrors === null) {
                    vErrors = [err61];
                }
                else {
                    vErrors.push(err61);
                }
                errors++;
            }
            if (data17.dataRevision === undefined) {
                const err62 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/required", keyword: "required", params: { missingProperty: "dataRevision" }, message: "must have required property '" + "dataRevision" + "'" };
                if (vErrors === null) {
                    vErrors = [err62];
                }
                else {
                    vErrors.push(err62);
                }
                errors++;
            }
            for (const key4 in data17) {
                if (!(((((key4 === "requestId") || (key4 === "asOf")) || (key4 === "businessToday")) || (key4 === "timeZone")) || (key4 === "dataRevision"))) {
                    const err63 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key4 }, message: "must NOT have additional properties" };
                    if (vErrors === null) {
                        vErrors = [err63];
                    }
                    else {
                        vErrors.push(err63);
                    }
                    errors++;
                }
            }
            if (data17.requestId !== undefined) {
                let data18 = data17.requestId;
                if (typeof data18 === "string") {
                    if (func2(data18) > 64) {
                        const err64 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err64];
                        }
                        else {
                            vErrors.push(err64);
                        }
                        errors++;
                    }
                    if (func2(data18) < 1) {
                        const err65 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err65];
                        }
                        else {
                            vErrors.push(err65);
                        }
                        errors++;
                    }
                }
                else {
                    const err66 = { instancePath: instancePath + "/meta/requestId", schemaPath: "#/properties/meta/properties/requestId/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err66];
                    }
                    else {
                        vErrors.push(err66);
                    }
                    errors++;
                }
            }
            if (data17.asOf !== undefined) {
                let data19 = data17.asOf;
                if (typeof data19 === "string") {
                    if (func2(data19) > 64) {
                        const err67 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err67];
                        }
                        else {
                            vErrors.push(err67);
                        }
                        errors++;
                    }
                    if (func2(data19) < 1) {
                        const err68 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err68];
                        }
                        else {
                            vErrors.push(err68);
                        }
                        errors++;
                    }
                }
                else {
                    const err69 = { instancePath: instancePath + "/meta/asOf", schemaPath: "#/properties/meta/properties/asOf/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err69];
                    }
                    else {
                        vErrors.push(err69);
                    }
                    errors++;
                }
            }
            if (data17.businessToday !== undefined) {
                let data20 = data17.businessToday;
                if (typeof data20 === "string") {
                    if (!pattern4.test(data20)) {
                        const err70 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/pattern", keyword: "pattern", params: { pattern: "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" }, message: "must match pattern \"" + "^(?:19|20|21)[0-9]{2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[12][0-9]|3[01])$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err70];
                        }
                        else {
                            vErrors.push(err70);
                        }
                        errors++;
                    }
                }
                else {
                    const err71 = { instancePath: instancePath + "/meta/businessToday", schemaPath: "#/properties/meta/properties/businessToday/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err71];
                    }
                    else {
                        vErrors.push(err71);
                    }
                    errors++;
                }
            }
            if (data17.timeZone !== undefined) {
                let data21 = data17.timeZone;
                if (typeof data21 === "string") {
                    if (func2(data21) > 64) {
                        const err72 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/maxLength", keyword: "maxLength", params: { limit: 64 }, message: "must NOT have more than 64 characters" };
                        if (vErrors === null) {
                            vErrors = [err72];
                        }
                        else {
                            vErrors.push(err72);
                        }
                        errors++;
                    }
                    if (func2(data21) < 1) {
                        const err73 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/minLength", keyword: "minLength", params: { limit: 1 }, message: "must NOT have fewer than 1 characters" };
                        if (vErrors === null) {
                            vErrors = [err73];
                        }
                        else {
                            vErrors.push(err73);
                        }
                        errors++;
                    }
                }
                else {
                    const err74 = { instancePath: instancePath + "/meta/timeZone", schemaPath: "#/properties/meta/properties/timeZone/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err74];
                    }
                    else {
                        vErrors.push(err74);
                    }
                    errors++;
                }
            }
            if (data17.dataRevision !== undefined) {
                let data22 = data17.dataRevision;
                if (typeof data22 === "string") {
                    if (!pattern2.test(data22)) {
                        const err75 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/pattern", keyword: "pattern", params: { pattern: "^[1-9][0-9]*$" }, message: "must match pattern \"" + "^[1-9][0-9]*$" + "\"" };
                        if (vErrors === null) {
                            vErrors = [err75];
                        }
                        else {
                            vErrors.push(err75);
                        }
                        errors++;
                    }
                }
                else {
                    const err76 = { instancePath: instancePath + "/meta/dataRevision", schemaPath: "#/properties/meta/properties/dataRevision/type", keyword: "type", params: { type: "string" }, message: "must be string" };
                    if (vErrors === null) {
                        vErrors = [err76];
                    }
                    else {
                        vErrors.push(err76);
                    }
                    errors++;
                }
            }
        }
        else {
            const err77 = { instancePath: instancePath + "/meta", schemaPath: "#/properties/meta/type", keyword: "type", params: { type: "object" }, message: "must be object" };
            if (vErrors === null) {
                vErrors = [err77];
            }
            else {
                vErrors.push(err77);
            }
            errors++;
        }
    }
}
else {
    const err78 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object" };
    if (vErrors === null) {
        vErrors = [err78];
    }
    else {
        vErrors.push(err78);
    }
    errors++;
} validate34.errors = vErrors; return errors === 0; }
//# sourceMappingURL=validators.js.map